var Cc = { exports: {} }, Hn = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pf;
function av() {
  if (Pf) return Hn;
  Pf = 1;
  var r = Symbol.for("react.transitional.element"), x = Symbol.for("react.fragment");
  function m(o, b, M) {
    var p = null;
    if (M !== void 0 && (p = "" + M), b.key !== void 0 && (p = "" + b.key), "key" in b) {
      M = {};
      for (var E in b)
        E !== "key" && (M[E] = b[E]);
    } else M = b;
    return b = M.ref, {
      $$typeof: r,
      type: o,
      key: p,
      ref: b !== void 0 ? b : null,
      props: M
    };
  }
  return Hn.Fragment = x, Hn.jsx = m, Hn.jsxs = m, Hn;
}
var em;
function tv() {
  return em || (em = 1, Cc.exports = av()), Cc.exports;
}
var i = tv(), _c = { exports: {} }, J = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var am;
function lv() {
  if (am) return J;
  am = 1;
  var r = Symbol.for("react.transitional.element"), x = Symbol.for("react.portal"), m = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), M = Symbol.for("react.consumer"), p = Symbol.for("react.context"), E = Symbol.for("react.forward_ref"), A = Symbol.for("react.suspense"), S = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), _ = Symbol.for("react.activity"), k = Symbol.iterator;
  function L(h) {
    return h === null || typeof h != "object" ? null : (h = k && h[k] || h["@@iterator"], typeof h == "function" ? h : null);
  }
  var ne = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, ce = Object.assign, ve = {};
  function I(h, D, C) {
    this.props = h, this.context = D, this.refs = ve, this.updater = C || ne;
  }
  I.prototype.isReactComponent = {}, I.prototype.setState = function(h, D) {
    if (typeof h != "object" && typeof h != "function" && h != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, h, D, "setState");
  }, I.prototype.forceUpdate = function(h) {
    this.updater.enqueueForceUpdate(this, h, "forceUpdate");
  };
  function ee() {
  }
  ee.prototype = I.prototype;
  function oe(h, D, C) {
    this.props = h, this.context = D, this.refs = ve, this.updater = C || ne;
  }
  var Me = oe.prototype = new ee();
  Me.constructor = oe, ce(Me, I.prototype), Me.isPureReactComponent = !0;
  var w = Array.isArray;
  function H() {
  }
  var Y = { H: null, A: null, T: null, S: null }, Le = Object.prototype.hasOwnProperty;
  function na(h, D, C) {
    var G = C.ref;
    return {
      $$typeof: r,
      type: h,
      key: D,
      ref: G !== void 0 ? G : null,
      props: C
    };
  }
  function Ha(h, D) {
    return na(h.type, D, h.props);
  }
  function We(h) {
    return typeof h == "object" && h !== null && h.$$typeof === r;
  }
  function Ye(h) {
    var D = { "=": "=0", ":": "=2" };
    return "$" + h.replace(/[=:]/g, function(C) {
      return D[C];
    });
  }
  var Rt = /\/+/g;
  function Ba(h, D) {
    return typeof h == "object" && h !== null && h.key != null ? Ye("" + h.key) : D.toString(36);
  }
  function Na(h) {
    switch (h.status) {
      case "fulfilled":
        return h.value;
      case "rejected":
        throw h.reason;
      default:
        switch (typeof h.status == "string" ? h.then(H, H) : (h.status = "pending", h.then(
          function(D) {
            h.status === "pending" && (h.status = "fulfilled", h.value = D);
          },
          function(D) {
            h.status === "pending" && (h.status = "rejected", h.reason = D);
          }
        )), h.status) {
          case "fulfilled":
            return h.value;
          case "rejected":
            throw h.reason;
        }
    }
    throw h;
  }
  function T(h, D, C, G, $) {
    var ae = typeof h;
    (ae === "undefined" || ae === "boolean") && (h = null);
    var me = !1;
    if (h === null) me = !0;
    else
      switch (ae) {
        case "bigint":
        case "string":
        case "number":
          me = !0;
          break;
        case "object":
          switch (h.$$typeof) {
            case r:
            case x:
              me = !0;
              break;
            case q:
              return me = h._init, T(
                me(h._payload),
                D,
                C,
                G,
                $
              );
          }
      }
    if (me)
      return $ = $(h), me = G === "" ? "." + Ba(h, 0) : G, w($) ? (C = "", me != null && (C = me.replace(Rt, "$&/") + "/"), T($, D, C, "", function(Ql) {
        return Ql;
      })) : $ != null && (We($) && ($ = Ha(
        $,
        C + ($.key == null || h && h.key === $.key ? "" : ("" + $.key).replace(
          Rt,
          "$&/"
        ) + "/") + me
      )), D.push($)), 1;
    me = 0;
    var Je = G === "" ? "." : G + ":";
    if (w(h))
      for (var Re = 0; Re < h.length; Re++)
        G = h[Re], ae = Je + Ba(G, Re), me += T(
          G,
          D,
          C,
          ae,
          $
        );
    else if (Re = L(h), typeof Re == "function")
      for (h = Re.call(h), Re = 0; !(G = h.next()).done; )
        G = G.value, ae = Je + Ba(G, Re++), me += T(
          G,
          D,
          C,
          ae,
          $
        );
    else if (ae === "object") {
      if (typeof h.then == "function")
        return T(
          Na(h),
          D,
          C,
          G,
          $
        );
      throw D = String(h), Error(
        "Objects are not valid as a React child (found: " + (D === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : D) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return me;
  }
  function U(h, D, C) {
    if (h == null) return h;
    var G = [], $ = 0;
    return T(h, G, "", "", function(ae) {
      return D.call(C, ae, $++);
    }), G;
  }
  function K(h) {
    if (h._status === -1) {
      var D = h._result;
      D = D(), D.then(
        function(C) {
          (h._status === 0 || h._status === -1) && (h._status = 1, h._result = C);
        },
        function(C) {
          (h._status === 0 || h._status === -1) && (h._status = 2, h._result = C);
        }
      ), h._status === -1 && (h._status = 0, h._result = D);
    }
    if (h._status === 1) return h._result.default;
    throw h._result;
  }
  var ye = typeof reportError == "function" ? reportError : function(h) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var D = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof h == "object" && h !== null && typeof h.message == "string" ? String(h.message) : String(h),
        error: h
      });
      if (!window.dispatchEvent(D)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", h);
      return;
    }
    console.error(h);
  }, be = {
    map: U,
    forEach: function(h, D, C) {
      U(
        h,
        function() {
          D.apply(this, arguments);
        },
        C
      );
    },
    count: function(h) {
      var D = 0;
      return U(h, function() {
        D++;
      }), D;
    },
    toArray: function(h) {
      return U(h, function(D) {
        return D;
      }) || [];
    },
    only: function(h) {
      if (!We(h))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return h;
    }
  };
  return J.Activity = _, J.Children = be, J.Component = I, J.Fragment = m, J.Profiler = b, J.PureComponent = oe, J.StrictMode = o, J.Suspense = A, J.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Y, J.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(h) {
      return Y.H.useMemoCache(h);
    }
  }, J.cache = function(h) {
    return function() {
      return h.apply(null, arguments);
    };
  }, J.cacheSignal = function() {
    return null;
  }, J.cloneElement = function(h, D, C) {
    if (h == null)
      throw Error(
        "The argument must be a React element, but you passed " + h + "."
      );
    var G = ce({}, h.props), $ = h.key;
    if (D != null)
      for (ae in D.key !== void 0 && ($ = "" + D.key), D)
        !Le.call(D, ae) || ae === "key" || ae === "__self" || ae === "__source" || ae === "ref" && D.ref === void 0 || (G[ae] = D[ae]);
    var ae = arguments.length - 2;
    if (ae === 1) G.children = C;
    else if (1 < ae) {
      for (var me = Array(ae), Je = 0; Je < ae; Je++)
        me[Je] = arguments[Je + 2];
      G.children = me;
    }
    return na(h.type, $, G);
  }, J.createContext = function(h) {
    return h = {
      $$typeof: p,
      _currentValue: h,
      _currentValue2: h,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, h.Provider = h, h.Consumer = {
      $$typeof: M,
      _context: h
    }, h;
  }, J.createElement = function(h, D, C) {
    var G, $ = {}, ae = null;
    if (D != null)
      for (G in D.key !== void 0 && (ae = "" + D.key), D)
        Le.call(D, G) && G !== "key" && G !== "__self" && G !== "__source" && ($[G] = D[G]);
    var me = arguments.length - 2;
    if (me === 1) $.children = C;
    else if (1 < me) {
      for (var Je = Array(me), Re = 0; Re < me; Re++)
        Je[Re] = arguments[Re + 2];
      $.children = Je;
    }
    if (h && h.defaultProps)
      for (G in me = h.defaultProps, me)
        $[G] === void 0 && ($[G] = me[G]);
    return na(h, ae, $);
  }, J.createRef = function() {
    return { current: null };
  }, J.forwardRef = function(h) {
    return { $$typeof: E, render: h };
  }, J.isValidElement = We, J.lazy = function(h) {
    return {
      $$typeof: q,
      _payload: { _status: -1, _result: h },
      _init: K
    };
  }, J.memo = function(h, D) {
    return {
      $$typeof: S,
      type: h,
      compare: D === void 0 ? null : D
    };
  }, J.startTransition = function(h) {
    var D = Y.T, C = {};
    Y.T = C;
    try {
      var G = h(), $ = Y.S;
      $ !== null && $(C, G), typeof G == "object" && G !== null && typeof G.then == "function" && G.then(H, ye);
    } catch (ae) {
      ye(ae);
    } finally {
      D !== null && C.types !== null && (D.types = C.types), Y.T = D;
    }
  }, J.unstable_useCacheRefresh = function() {
    return Y.H.useCacheRefresh();
  }, J.use = function(h) {
    return Y.H.use(h);
  }, J.useActionState = function(h, D, C) {
    return Y.H.useActionState(h, D, C);
  }, J.useCallback = function(h, D) {
    return Y.H.useCallback(h, D);
  }, J.useContext = function(h) {
    return Y.H.useContext(h);
  }, J.useDebugValue = function() {
  }, J.useDeferredValue = function(h, D) {
    return Y.H.useDeferredValue(h, D);
  }, J.useEffect = function(h, D) {
    return Y.H.useEffect(h, D);
  }, J.useEffectEvent = function(h) {
    return Y.H.useEffectEvent(h);
  }, J.useId = function() {
    return Y.H.useId();
  }, J.useImperativeHandle = function(h, D, C) {
    return Y.H.useImperativeHandle(h, D, C);
  }, J.useInsertionEffect = function(h, D) {
    return Y.H.useInsertionEffect(h, D);
  }, J.useLayoutEffect = function(h, D) {
    return Y.H.useLayoutEffect(h, D);
  }, J.useMemo = function(h, D) {
    return Y.H.useMemo(h, D);
  }, J.useOptimistic = function(h, D) {
    return Y.H.useOptimistic(h, D);
  }, J.useReducer = function(h, D, C) {
    return Y.H.useReducer(h, D, C);
  }, J.useRef = function(h) {
    return Y.H.useRef(h);
  }, J.useState = function(h) {
    return Y.H.useState(h);
  }, J.useSyncExternalStore = function(h, D, C) {
    return Y.H.useSyncExternalStore(
      h,
      D,
      C
    );
  }, J.useTransition = function() {
    return Y.H.useTransition();
  }, J.version = "19.2.3", J;
}
var tm;
function Kc() {
  return tm || (tm = 1, _c.exports = lv()), _c.exports;
}
var V = Kc(), qc = { exports: {} }, Bn = {}, Hc = { exports: {} }, Bc = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lm;
function nv() {
  return lm || (lm = 1, (function(r) {
    function x(T, U) {
      var K = T.length;
      T.push(U);
      e: for (; 0 < K; ) {
        var ye = K - 1 >>> 1, be = T[ye];
        if (0 < b(be, U))
          T[ye] = U, T[K] = be, K = ye;
        else break e;
      }
    }
    function m(T) {
      return T.length === 0 ? null : T[0];
    }
    function o(T) {
      if (T.length === 0) return null;
      var U = T[0], K = T.pop();
      if (K !== U) {
        T[0] = K;
        e: for (var ye = 0, be = T.length, h = be >>> 1; ye < h; ) {
          var D = 2 * (ye + 1) - 1, C = T[D], G = D + 1, $ = T[G];
          if (0 > b(C, K))
            G < be && 0 > b($, C) ? (T[ye] = $, T[G] = K, ye = G) : (T[ye] = C, T[D] = K, ye = D);
          else if (G < be && 0 > b($, K))
            T[ye] = $, T[G] = K, ye = G;
          else break e;
        }
      }
      return U;
    }
    function b(T, U) {
      var K = T.sortIndex - U.sortIndex;
      return K !== 0 ? K : T.id - U.id;
    }
    if (r.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var M = performance;
      r.unstable_now = function() {
        return M.now();
      };
    } else {
      var p = Date, E = p.now();
      r.unstable_now = function() {
        return p.now() - E;
      };
    }
    var A = [], S = [], q = 1, _ = null, k = 3, L = !1, ne = !1, ce = !1, ve = !1, I = typeof setTimeout == "function" ? setTimeout : null, ee = typeof clearTimeout == "function" ? clearTimeout : null, oe = typeof setImmediate < "u" ? setImmediate : null;
    function Me(T) {
      for (var U = m(S); U !== null; ) {
        if (U.callback === null) o(S);
        else if (U.startTime <= T)
          o(S), U.sortIndex = U.expirationTime, x(A, U);
        else break;
        U = m(S);
      }
    }
    function w(T) {
      if (ce = !1, Me(T), !ne)
        if (m(A) !== null)
          ne = !0, H || (H = !0, Ye());
        else {
          var U = m(S);
          U !== null && Na(w, U.startTime - T);
        }
    }
    var H = !1, Y = -1, Le = 5, na = -1;
    function Ha() {
      return ve ? !0 : !(r.unstable_now() - na < Le);
    }
    function We() {
      if (ve = !1, H) {
        var T = r.unstable_now();
        na = T;
        var U = !0;
        try {
          e: {
            ne = !1, ce && (ce = !1, ee(Y), Y = -1), L = !0;
            var K = k;
            try {
              a: {
                for (Me(T), _ = m(A); _ !== null && !(_.expirationTime > T && Ha()); ) {
                  var ye = _.callback;
                  if (typeof ye == "function") {
                    _.callback = null, k = _.priorityLevel;
                    var be = ye(
                      _.expirationTime <= T
                    );
                    if (T = r.unstable_now(), typeof be == "function") {
                      _.callback = be, Me(T), U = !0;
                      break a;
                    }
                    _ === m(A) && o(A), Me(T);
                  } else o(A);
                  _ = m(A);
                }
                if (_ !== null) U = !0;
                else {
                  var h = m(S);
                  h !== null && Na(
                    w,
                    h.startTime - T
                  ), U = !1;
                }
              }
              break e;
            } finally {
              _ = null, k = K, L = !1;
            }
            U = void 0;
          }
        } finally {
          U ? Ye() : H = !1;
        }
      }
    }
    var Ye;
    if (typeof oe == "function")
      Ye = function() {
        oe(We);
      };
    else if (typeof MessageChannel < "u") {
      var Rt = new MessageChannel(), Ba = Rt.port2;
      Rt.port1.onmessage = We, Ye = function() {
        Ba.postMessage(null);
      };
    } else
      Ye = function() {
        I(We, 0);
      };
    function Na(T, U) {
      Y = I(function() {
        T(r.unstable_now());
      }, U);
    }
    r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(T) {
      T.callback = null;
    }, r.unstable_forceFrameRate = function(T) {
      0 > T || 125 < T ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Le = 0 < T ? Math.floor(1e3 / T) : 5;
    }, r.unstable_getCurrentPriorityLevel = function() {
      return k;
    }, r.unstable_next = function(T) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var U = 3;
          break;
        default:
          U = k;
      }
      var K = k;
      k = U;
      try {
        return T();
      } finally {
        k = K;
      }
    }, r.unstable_requestPaint = function() {
      ve = !0;
    }, r.unstable_runWithPriority = function(T, U) {
      switch (T) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          T = 3;
      }
      var K = k;
      k = T;
      try {
        return U();
      } finally {
        k = K;
      }
    }, r.unstable_scheduleCallback = function(T, U, K) {
      var ye = r.unstable_now();
      switch (typeof K == "object" && K !== null ? (K = K.delay, K = typeof K == "number" && 0 < K ? ye + K : ye) : K = ye, T) {
        case 1:
          var be = -1;
          break;
        case 2:
          be = 250;
          break;
        case 5:
          be = 1073741823;
          break;
        case 4:
          be = 1e4;
          break;
        default:
          be = 5e3;
      }
      return be = K + be, T = {
        id: q++,
        callback: U,
        priorityLevel: T,
        startTime: K,
        expirationTime: be,
        sortIndex: -1
      }, K > ye ? (T.sortIndex = K, x(S, T), m(A) === null && T === m(S) && (ce ? (ee(Y), Y = -1) : ce = !0, Na(w, K - ye))) : (T.sortIndex = be, x(A, T), ne || L || (ne = !0, H || (H = !0, Ye()))), T;
    }, r.unstable_shouldYield = Ha, r.unstable_wrapCallback = function(T) {
      var U = k;
      return function() {
        var K = k;
        k = U;
        try {
          return T.apply(this, arguments);
        } finally {
          k = K;
        }
      };
    };
  })(Bc)), Bc;
}
var nm;
function iv() {
  return nm || (nm = 1, Hc.exports = nv()), Hc.exports;
}
var Lc = { exports: {} }, Ke = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var im;
function sv() {
  if (im) return Ke;
  im = 1;
  var r = Kc();
  function x(A) {
    var S = "https://react.dev/errors/" + A;
    if (1 < arguments.length) {
      S += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var q = 2; q < arguments.length; q++)
        S += "&args[]=" + encodeURIComponent(arguments[q]);
    }
    return "Minified React error #" + A + "; visit " + S + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function m() {
  }
  var o = {
    d: {
      f: m,
      r: function() {
        throw Error(x(522));
      },
      D: m,
      C: m,
      L: m,
      m,
      X: m,
      S: m,
      M: m
    },
    p: 0,
    findDOMNode: null
  }, b = Symbol.for("react.portal");
  function M(A, S, q) {
    var _ = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: b,
      key: _ == null ? null : "" + _,
      children: A,
      containerInfo: S,
      implementation: q
    };
  }
  var p = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function E(A, S) {
    if (A === "font") return "";
    if (typeof S == "string")
      return S === "use-credentials" ? S : "";
  }
  return Ke.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = o, Ke.createPortal = function(A, S) {
    var q = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!S || S.nodeType !== 1 && S.nodeType !== 9 && S.nodeType !== 11)
      throw Error(x(299));
    return M(A, S, null, q);
  }, Ke.flushSync = function(A) {
    var S = p.T, q = o.p;
    try {
      if (p.T = null, o.p = 2, A) return A();
    } finally {
      p.T = S, o.p = q, o.d.f();
    }
  }, Ke.preconnect = function(A, S) {
    typeof A == "string" && (S ? (S = S.crossOrigin, S = typeof S == "string" ? S === "use-credentials" ? S : "" : void 0) : S = null, o.d.C(A, S));
  }, Ke.prefetchDNS = function(A) {
    typeof A == "string" && o.d.D(A);
  }, Ke.preinit = function(A, S) {
    if (typeof A == "string" && S && typeof S.as == "string") {
      var q = S.as, _ = E(q, S.crossOrigin), k = typeof S.integrity == "string" ? S.integrity : void 0, L = typeof S.fetchPriority == "string" ? S.fetchPriority : void 0;
      q === "style" ? o.d.S(
        A,
        typeof S.precedence == "string" ? S.precedence : void 0,
        {
          crossOrigin: _,
          integrity: k,
          fetchPriority: L
        }
      ) : q === "script" && o.d.X(A, {
        crossOrigin: _,
        integrity: k,
        fetchPriority: L,
        nonce: typeof S.nonce == "string" ? S.nonce : void 0
      });
    }
  }, Ke.preinitModule = function(A, S) {
    if (typeof A == "string")
      if (typeof S == "object" && S !== null) {
        if (S.as == null || S.as === "script") {
          var q = E(
            S.as,
            S.crossOrigin
          );
          o.d.M(A, {
            crossOrigin: q,
            integrity: typeof S.integrity == "string" ? S.integrity : void 0,
            nonce: typeof S.nonce == "string" ? S.nonce : void 0
          });
        }
      } else S == null && o.d.M(A);
  }, Ke.preload = function(A, S) {
    if (typeof A == "string" && typeof S == "object" && S !== null && typeof S.as == "string") {
      var q = S.as, _ = E(q, S.crossOrigin);
      o.d.L(A, q, {
        crossOrigin: _,
        integrity: typeof S.integrity == "string" ? S.integrity : void 0,
        nonce: typeof S.nonce == "string" ? S.nonce : void 0,
        type: typeof S.type == "string" ? S.type : void 0,
        fetchPriority: typeof S.fetchPriority == "string" ? S.fetchPriority : void 0,
        referrerPolicy: typeof S.referrerPolicy == "string" ? S.referrerPolicy : void 0,
        imageSrcSet: typeof S.imageSrcSet == "string" ? S.imageSrcSet : void 0,
        imageSizes: typeof S.imageSizes == "string" ? S.imageSizes : void 0,
        media: typeof S.media == "string" ? S.media : void 0
      });
    }
  }, Ke.preloadModule = function(A, S) {
    if (typeof A == "string")
      if (S) {
        var q = E(S.as, S.crossOrigin);
        o.d.m(A, {
          as: typeof S.as == "string" && S.as !== "script" ? S.as : void 0,
          crossOrigin: q,
          integrity: typeof S.integrity == "string" ? S.integrity : void 0
        });
      } else o.d.m(A);
  }, Ke.requestFormReset = function(A) {
    o.d.r(A);
  }, Ke.unstable_batchedUpdates = function(A, S) {
    return A(S);
  }, Ke.useFormState = function(A, S, q) {
    return p.H.useFormState(A, S, q);
  }, Ke.useFormStatus = function() {
    return p.H.useHostTransitionStatus();
  }, Ke.version = "19.2.3", Ke;
}
var sm;
function uv() {
  if (sm) return Lc.exports;
  sm = 1;
  function r() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
      } catch (x) {
        console.error(x);
      }
  }
  return r(), Lc.exports = sv(), Lc.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var um;
function cv() {
  if (um) return Bn;
  um = 1;
  var r = iv(), x = Kc(), m = uv();
  function o(e) {
    var a = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      a += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var t = 2; t < arguments.length; t++)
        a += "&args[]=" + encodeURIComponent(arguments[t]);
    }
    return "Minified React error #" + e + "; visit " + a + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function b(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function M(e) {
    var a = e, t = e;
    if (e.alternate) for (; a.return; ) a = a.return;
    else {
      e = a;
      do
        a = e, (a.flags & 4098) !== 0 && (t = a.return), e = a.return;
      while (e);
    }
    return a.tag === 3 ? t : null;
  }
  function p(e) {
    if (e.tag === 13) {
      var a = e.memoizedState;
      if (a === null && (e = e.alternate, e !== null && (a = e.memoizedState)), a !== null) return a.dehydrated;
    }
    return null;
  }
  function E(e) {
    if (e.tag === 31) {
      var a = e.memoizedState;
      if (a === null && (e = e.alternate, e !== null && (a = e.memoizedState)), a !== null) return a.dehydrated;
    }
    return null;
  }
  function A(e) {
    if (M(e) !== e)
      throw Error(o(188));
  }
  function S(e) {
    var a = e.alternate;
    if (!a) {
      if (a = M(e), a === null) throw Error(o(188));
      return a !== e ? null : e;
    }
    for (var t = e, l = a; ; ) {
      var n = t.return;
      if (n === null) break;
      var s = n.alternate;
      if (s === null) {
        if (l = n.return, l !== null) {
          t = l;
          continue;
        }
        break;
      }
      if (n.child === s.child) {
        for (s = n.child; s; ) {
          if (s === t) return A(n), e;
          if (s === l) return A(n), a;
          s = s.sibling;
        }
        throw Error(o(188));
      }
      if (t.return !== l.return) t = n, l = s;
      else {
        for (var u = !1, c = n.child; c; ) {
          if (c === t) {
            u = !0, t = n, l = s;
            break;
          }
          if (c === l) {
            u = !0, l = n, t = s;
            break;
          }
          c = c.sibling;
        }
        if (!u) {
          for (c = s.child; c; ) {
            if (c === t) {
              u = !0, t = s, l = n;
              break;
            }
            if (c === l) {
              u = !0, l = s, t = n;
              break;
            }
            c = c.sibling;
          }
          if (!u) throw Error(o(189));
        }
      }
      if (t.alternate !== l) throw Error(o(190));
    }
    if (t.tag !== 3) throw Error(o(188));
    return t.stateNode.current === t ? e : a;
  }
  function q(e) {
    var a = e.tag;
    if (a === 5 || a === 26 || a === 27 || a === 6) return e;
    for (e = e.child; e !== null; ) {
      if (a = q(e), a !== null) return a;
      e = e.sibling;
    }
    return null;
  }
  var _ = Object.assign, k = Symbol.for("react.element"), L = Symbol.for("react.transitional.element"), ne = Symbol.for("react.portal"), ce = Symbol.for("react.fragment"), ve = Symbol.for("react.strict_mode"), I = Symbol.for("react.profiler"), ee = Symbol.for("react.consumer"), oe = Symbol.for("react.context"), Me = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), H = Symbol.for("react.suspense_list"), Y = Symbol.for("react.memo"), Le = Symbol.for("react.lazy"), na = Symbol.for("react.activity"), Ha = Symbol.for("react.memo_cache_sentinel"), We = Symbol.iterator;
  function Ye(e) {
    return e === null || typeof e != "object" ? null : (e = We && e[We] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var Rt = Symbol.for("react.client.reference");
  function Ba(e) {
    if (e == null) return null;
    if (typeof e == "function")
      return e.$$typeof === Rt ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case ce:
        return "Fragment";
      case I:
        return "Profiler";
      case ve:
        return "StrictMode";
      case w:
        return "Suspense";
      case H:
        return "SuspenseList";
      case na:
        return "Activity";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case ne:
          return "Portal";
        case oe:
          return e.displayName || "Context";
        case ee:
          return (e._context.displayName || "Context") + ".Consumer";
        case Me:
          var a = e.render;
          return e = e.displayName, e || (e = a.displayName || a.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case Y:
          return a = e.displayName || null, a !== null ? a : Ba(e.type) || "Memo";
        case Le:
          a = e._payload, e = e._init;
          try {
            return Ba(e(a));
          } catch {
          }
      }
    return null;
  }
  var Na = Array.isArray, T = x.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, U = m.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ye = [], be = -1;
  function h(e) {
    return { current: e };
  }
  function D(e) {
    0 > be || (e.current = ye[be], ye[be] = null, be--);
  }
  function C(e, a) {
    be++, ye[be] = e.current, e.current = a;
  }
  var G = h(null), $ = h(null), ae = h(null), me = h(null);
  function Je(e, a) {
    switch (C(ae, a), C($, e), C(G, null), a.nodeType) {
      case 9:
      case 11:
        e = (e = a.documentElement) && (e = e.namespaceURI) ? Sf(e) : 0;
        break;
      default:
        if (e = a.tagName, a = a.namespaceURI)
          a = Sf(a), e = zf(a, e);
        else
          switch (e) {
            case "svg":
              e = 1;
              break;
            case "math":
              e = 2;
              break;
            default:
              e = 0;
          }
    }
    D(G), C(G, e);
  }
  function Re() {
    D(G), D($), D(ae);
  }
  function Ql(e) {
    e.memoizedState !== null && C(me, e);
    var a = G.current, t = zf(a, e.type);
    a !== t && (C($, e), C(G, t));
  }
  function Qn(e) {
    $.current === e && (D(G), D($)), me.current === e && (D(me), Un._currentValue = K);
  }
  var ps, Wc;
  function Dt(e) {
    if (ps === void 0)
      try {
        throw Error();
      } catch (t) {
        var a = t.stack.trim().match(/\n( *(at )?)/);
        ps = a && a[1] || "", Wc = -1 < t.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < t.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + ps + e + Wc;
  }
  var vs = !1;
  function ys(e, a) {
    if (!e || vs) return "";
    vs = !0;
    var t = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var l = {
        DetermineComponentFrameRoot: function() {
          try {
            if (a) {
              var R = function() {
                throw Error();
              };
              if (Object.defineProperty(R.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(R, []);
                } catch (z) {
                  var j = z;
                }
                Reflect.construct(e, [], R);
              } else {
                try {
                  R.call();
                } catch (z) {
                  j = z;
                }
                e.call(R.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (z) {
                j = z;
              }
              (R = e()) && typeof R.catch == "function" && R.catch(function() {
              });
            }
          } catch (z) {
            if (z && j && typeof z.stack == "string")
              return [z.stack, j.stack];
          }
          return [null, null];
        }
      };
      l.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var n = Object.getOwnPropertyDescriptor(
        l.DetermineComponentFrameRoot,
        "name"
      );
      n && n.configurable && Object.defineProperty(
        l.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var s = l.DetermineComponentFrameRoot(), u = s[0], c = s[1];
      if (u && c) {
        var d = u.split(`
`), g = c.split(`
`);
        for (n = l = 0; l < d.length && !d[l].includes("DetermineComponentFrameRoot"); )
          l++;
        for (; n < g.length && !g[n].includes(
          "DetermineComponentFrameRoot"
        ); )
          n++;
        if (l === d.length || n === g.length)
          for (l = d.length - 1, n = g.length - 1; 1 <= l && 0 <= n && d[l] !== g[n]; )
            n--;
        for (; 1 <= l && 0 <= n; l--, n--)
          if (d[l] !== g[n]) {
            if (l !== 1 || n !== 1)
              do
                if (l--, n--, 0 > n || d[l] !== g[n]) {
                  var N = `
` + d[l].replace(" at new ", " at ");
                  return e.displayName && N.includes("<anonymous>") && (N = N.replace("<anonymous>", e.displayName)), N;
                }
              while (1 <= l && 0 <= n);
            break;
          }
      }
    } finally {
      vs = !1, Error.prepareStackTrace = t;
    }
    return (t = e ? e.displayName || e.name : "") ? Dt(t) : "";
  }
  function Um(e, a) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return Dt(e.type);
      case 16:
        return Dt("Lazy");
      case 13:
        return e.child !== a && a !== null ? Dt("Suspense Fallback") : Dt("Suspense");
      case 19:
        return Dt("SuspenseList");
      case 0:
      case 15:
        return ys(e.type, !1);
      case 11:
        return ys(e.type.render, !1);
      case 1:
        return ys(e.type, !0);
      case 31:
        return Dt("Activity");
      default:
        return "";
    }
  }
  function Fc(e) {
    try {
      var a = "", t = null;
      do
        a += Um(e, t), t = e, e = e.return;
      while (e);
      return a;
    } catch (l) {
      return `
Error generating stack: ` + l.message + `
` + l.stack;
    }
  }
  var xs = Object.prototype.hasOwnProperty, gs = r.unstable_scheduleCallback, js = r.unstable_cancelCallback, Cm = r.unstable_shouldYield, _m = r.unstable_requestPaint, ia = r.unstable_now, qm = r.unstable_getCurrentPriorityLevel, Ic = r.unstable_ImmediatePriority, Pc = r.unstable_UserBlockingPriority, Xn = r.unstable_NormalPriority, Hm = r.unstable_LowPriority, eo = r.unstable_IdlePriority, Bm = r.log, Lm = r.unstable_setDisableYieldValue, Xl = null, sa = null;
  function tt(e) {
    if (typeof Bm == "function" && Lm(e), sa && typeof sa.setStrictMode == "function")
      try {
        sa.setStrictMode(Xl, e);
      } catch {
      }
  }
  var ua = Math.clz32 ? Math.clz32 : Vm, Ym = Math.log, Gm = Math.LN2;
  function Vm(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (Ym(e) / Gm | 0) | 0;
  }
  var Zn = 256, kn = 262144, wn = 4194304;
  function Ut(e) {
    var a = e & 42;
    if (a !== 0) return a;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function Kn(e, a, t) {
    var l = e.pendingLanes;
    if (l === 0) return 0;
    var n = 0, s = e.suspendedLanes, u = e.pingedLanes;
    e = e.warmLanes;
    var c = l & 134217727;
    return c !== 0 ? (l = c & ~s, l !== 0 ? n = Ut(l) : (u &= c, u !== 0 ? n = Ut(u) : t || (t = c & ~e, t !== 0 && (n = Ut(t))))) : (c = l & ~s, c !== 0 ? n = Ut(c) : u !== 0 ? n = Ut(u) : t || (t = l & ~e, t !== 0 && (n = Ut(t)))), n === 0 ? 0 : a !== 0 && a !== n && (a & s) === 0 && (s = n & -n, t = a & -a, s >= t || s === 32 && (t & 4194048) !== 0) ? a : n;
  }
  function Zl(e, a) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & a) === 0;
  }
  function Qm(e, a) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return a + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ao() {
    var e = wn;
    return wn <<= 1, (wn & 62914560) === 0 && (wn = 4194304), e;
  }
  function bs(e) {
    for (var a = [], t = 0; 31 > t; t++) a.push(e);
    return a;
  }
  function kl(e, a) {
    e.pendingLanes |= a, a !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
  }
  function Xm(e, a, t, l, n, s) {
    var u = e.pendingLanes;
    e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= t, e.entangledLanes &= t, e.errorRecoveryDisabledLanes &= t, e.shellSuspendCounter = 0;
    var c = e.entanglements, d = e.expirationTimes, g = e.hiddenUpdates;
    for (t = u & ~t; 0 < t; ) {
      var N = 31 - ua(t), R = 1 << N;
      c[N] = 0, d[N] = -1;
      var j = g[N];
      if (j !== null)
        for (g[N] = null, N = 0; N < j.length; N++) {
          var z = j[N];
          z !== null && (z.lane &= -536870913);
        }
      t &= ~R;
    }
    l !== 0 && to(e, l, 0), s !== 0 && n === 0 && e.tag !== 0 && (e.suspendedLanes |= s & ~(u & ~a));
  }
  function to(e, a, t) {
    e.pendingLanes |= a, e.suspendedLanes &= ~a;
    var l = 31 - ua(a);
    e.entangledLanes |= a, e.entanglements[l] = e.entanglements[l] | 1073741824 | t & 261930;
  }
  function lo(e, a) {
    var t = e.entangledLanes |= a;
    for (e = e.entanglements; t; ) {
      var l = 31 - ua(t), n = 1 << l;
      n & a | e[l] & a && (e[l] |= a), t &= ~n;
    }
  }
  function no(e, a) {
    var t = a & -a;
    return t = (t & 42) !== 0 ? 1 : Ss(t), (t & (e.suspendedLanes | a)) !== 0 ? 0 : t;
  }
  function Ss(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function zs(e) {
    return e &= -e, 2 < e ? 8 < e ? (e & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function io() {
    var e = U.p;
    return e !== 0 ? e : (e = window.event, e === void 0 ? 32 : wf(e.type));
  }
  function so(e, a) {
    var t = U.p;
    try {
      return U.p = e, a();
    } finally {
      U.p = t;
    }
  }
  var lt = Math.random().toString(36).slice(2), Qe = "__reactFiber$" + lt, Fe = "__reactProps$" + lt, It = "__reactContainer$" + lt, Es = "__reactEvents$" + lt, Zm = "__reactListeners$" + lt, km = "__reactHandles$" + lt, uo = "__reactResources$" + lt, wl = "__reactMarker$" + lt;
  function As(e) {
    delete e[Qe], delete e[Fe], delete e[Es], delete e[Zm], delete e[km];
  }
  function Pt(e) {
    var a = e[Qe];
    if (a) return a;
    for (var t = e.parentNode; t; ) {
      if (a = t[It] || t[Qe]) {
        if (t = a.alternate, a.child !== null || t !== null && t.child !== null)
          for (e = Rf(e); e !== null; ) {
            if (t = e[Qe]) return t;
            e = Rf(e);
          }
        return a;
      }
      e = t, t = e.parentNode;
    }
    return null;
  }
  function el(e) {
    if (e = e[Qe] || e[It]) {
      var a = e.tag;
      if (a === 5 || a === 6 || a === 13 || a === 31 || a === 26 || a === 27 || a === 3)
        return e;
    }
    return null;
  }
  function Kl(e) {
    var a = e.tag;
    if (a === 5 || a === 26 || a === 27 || a === 6) return e.stateNode;
    throw Error(o(33));
  }
  function al(e) {
    var a = e[uo];
    return a || (a = e[uo] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), a;
  }
  function Ge(e) {
    e[wl] = !0;
  }
  var co = /* @__PURE__ */ new Set(), oo = {};
  function Ct(e, a) {
    tl(e, a), tl(e + "Capture", a);
  }
  function tl(e, a) {
    for (oo[e] = a, e = 0; e < a.length; e++)
      co.add(a[e]);
  }
  var wm = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), ro = {}, fo = {};
  function Km(e) {
    return xs.call(fo, e) ? !0 : xs.call(ro, e) ? !1 : wm.test(e) ? fo[e] = !0 : (ro[e] = !0, !1);
  }
  function Jn(e, a, t) {
    if (Km(a))
      if (t === null) e.removeAttribute(a);
      else {
        switch (typeof t) {
          case "undefined":
          case "function":
          case "symbol":
            e.removeAttribute(a);
            return;
          case "boolean":
            var l = a.toLowerCase().slice(0, 5);
            if (l !== "data-" && l !== "aria-") {
              e.removeAttribute(a);
              return;
            }
        }
        e.setAttribute(a, "" + t);
      }
  }
  function $n(e, a, t) {
    if (t === null) e.removeAttribute(a);
    else {
      switch (typeof t) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(a);
          return;
      }
      e.setAttribute(a, "" + t);
    }
  }
  function La(e, a, t, l) {
    if (l === null) e.removeAttribute(t);
    else {
      switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(t);
          return;
      }
      e.setAttributeNS(a, t, "" + l);
    }
  }
  function pa(e) {
    switch (typeof e) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function mo(e) {
    var a = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
  }
  function Jm(e, a, t) {
    var l = Object.getOwnPropertyDescriptor(
      e.constructor.prototype,
      a
    );
    if (!e.hasOwnProperty(a) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var n = l.get, s = l.set;
      return Object.defineProperty(e, a, {
        configurable: !0,
        get: function() {
          return n.call(this);
        },
        set: function(u) {
          t = "" + u, s.call(this, u);
        }
      }), Object.defineProperty(e, a, {
        enumerable: l.enumerable
      }), {
        getValue: function() {
          return t;
        },
        setValue: function(u) {
          t = "" + u;
        },
        stopTracking: function() {
          e._valueTracker = null, delete e[a];
        }
      };
    }
  }
  function Ns(e) {
    if (!e._valueTracker) {
      var a = mo(e) ? "checked" : "value";
      e._valueTracker = Jm(
        e,
        a,
        "" + e[a]
      );
    }
  }
  function ho(e) {
    if (!e) return !1;
    var a = e._valueTracker;
    if (!a) return !0;
    var t = a.getValue(), l = "";
    return e && (l = mo(e) ? e.checked ? "true" : "false" : e.value), e = l, e !== t ? (a.setValue(e), !0) : !1;
  }
  function Wn(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var $m = /[\n"\\]/g;
  function va(e) {
    return e.replace(
      $m,
      function(a) {
        return "\\" + a.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Ts(e, a, t, l, n, s, u, c) {
    e.name = "", u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" ? e.type = u : e.removeAttribute("type"), a != null ? u === "number" ? (a === 0 && e.value === "" || e.value != a) && (e.value = "" + pa(a)) : e.value !== "" + pa(a) && (e.value = "" + pa(a)) : u !== "submit" && u !== "reset" || e.removeAttribute("value"), a != null ? Os(e, u, pa(a)) : t != null ? Os(e, u, pa(t)) : l != null && e.removeAttribute("value"), n == null && s != null && (e.defaultChecked = !!s), n != null && (e.checked = n && typeof n != "function" && typeof n != "symbol"), c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" ? e.name = "" + pa(c) : e.removeAttribute("name");
  }
  function po(e, a, t, l, n, s, u, c) {
    if (s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" && (e.type = s), a != null || t != null) {
      if (!(s !== "submit" && s !== "reset" || a != null)) {
        Ns(e);
        return;
      }
      t = t != null ? "" + pa(t) : "", a = a != null ? "" + pa(a) : t, c || a === e.value || (e.value = a), e.defaultValue = a;
    }
    l = l ?? n, l = typeof l != "function" && typeof l != "symbol" && !!l, e.checked = c ? e.checked : !!l, e.defaultChecked = !!l, u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && (e.name = u), Ns(e);
  }
  function Os(e, a, t) {
    a === "number" && Wn(e.ownerDocument) === e || e.defaultValue === "" + t || (e.defaultValue = "" + t);
  }
  function ll(e, a, t, l) {
    if (e = e.options, a) {
      a = {};
      for (var n = 0; n < t.length; n++)
        a["$" + t[n]] = !0;
      for (t = 0; t < e.length; t++)
        n = a.hasOwnProperty("$" + e[t].value), e[t].selected !== n && (e[t].selected = n), n && l && (e[t].defaultSelected = !0);
    } else {
      for (t = "" + pa(t), a = null, n = 0; n < e.length; n++) {
        if (e[n].value === t) {
          e[n].selected = !0, l && (e[n].defaultSelected = !0);
          return;
        }
        a !== null || e[n].disabled || (a = e[n]);
      }
      a !== null && (a.selected = !0);
    }
  }
  function vo(e, a, t) {
    if (a != null && (a = "" + pa(a), a !== e.value && (e.value = a), t == null)) {
      e.defaultValue !== a && (e.defaultValue = a);
      return;
    }
    e.defaultValue = t != null ? "" + pa(t) : "";
  }
  function yo(e, a, t, l) {
    if (a == null) {
      if (l != null) {
        if (t != null) throw Error(o(92));
        if (Na(l)) {
          if (1 < l.length) throw Error(o(93));
          l = l[0];
        }
        t = l;
      }
      t == null && (t = ""), a = t;
    }
    t = pa(a), e.defaultValue = t, l = e.textContent, l === t && l !== "" && l !== null && (e.value = l), Ns(e);
  }
  function nl(e, a) {
    if (a) {
      var t = e.firstChild;
      if (t && t === e.lastChild && t.nodeType === 3) {
        t.nodeValue = a;
        return;
      }
    }
    e.textContent = a;
  }
  var Wm = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function xo(e, a, t) {
    var l = a.indexOf("--") === 0;
    t == null || typeof t == "boolean" || t === "" ? l ? e.setProperty(a, "") : a === "float" ? e.cssFloat = "" : e[a] = "" : l ? e.setProperty(a, t) : typeof t != "number" || t === 0 || Wm.has(a) ? a === "float" ? e.cssFloat = t : e[a] = ("" + t).trim() : e[a] = t + "px";
  }
  function go(e, a, t) {
    if (a != null && typeof a != "object")
      throw Error(o(62));
    if (e = e.style, t != null) {
      for (var l in t)
        !t.hasOwnProperty(l) || a != null && a.hasOwnProperty(l) || (l.indexOf("--") === 0 ? e.setProperty(l, "") : l === "float" ? e.cssFloat = "" : e[l] = "");
      for (var n in a)
        l = a[n], a.hasOwnProperty(n) && t[n] !== l && xo(e, n, l);
    } else
      for (var s in a)
        a.hasOwnProperty(s) && xo(e, s, a[s]);
  }
  function Ms(e) {
    if (e.indexOf("-") === -1) return !1;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Fm = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Im = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Fn(e) {
    return Im.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
  }
  function Ya() {
  }
  var Rs = null;
  function Ds(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var il = null, sl = null;
  function jo(e) {
    var a = el(e);
    if (a && (e = a.stateNode)) {
      var t = e[Fe] || null;
      e: switch (e = a.stateNode, a.type) {
        case "input":
          if (Ts(
            e,
            t.value,
            t.defaultValue,
            t.defaultValue,
            t.checked,
            t.defaultChecked,
            t.type,
            t.name
          ), a = t.name, t.type === "radio" && a != null) {
            for (t = e; t.parentNode; ) t = t.parentNode;
            for (t = t.querySelectorAll(
              'input[name="' + va(
                "" + a
              ) + '"][type="radio"]'
            ), a = 0; a < t.length; a++) {
              var l = t[a];
              if (l !== e && l.form === e.form) {
                var n = l[Fe] || null;
                if (!n) throw Error(o(90));
                Ts(
                  l,
                  n.value,
                  n.defaultValue,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name
                );
              }
            }
            for (a = 0; a < t.length; a++)
              l = t[a], l.form === e.form && ho(l);
          }
          break e;
        case "textarea":
          vo(e, t.value, t.defaultValue);
          break e;
        case "select":
          a = t.value, a != null && ll(e, !!t.multiple, a, !1);
      }
    }
  }
  var Us = !1;
  function bo(e, a, t) {
    if (Us) return e(a, t);
    Us = !0;
    try {
      var l = e(a);
      return l;
    } finally {
      if (Us = !1, (il !== null || sl !== null) && (Li(), il && (a = il, e = sl, sl = il = null, jo(a), e)))
        for (a = 0; a < e.length; a++) jo(e[a]);
    }
  }
  function Jl(e, a) {
    var t = e.stateNode;
    if (t === null) return null;
    var l = t[Fe] || null;
    if (l === null) return null;
    t = l[a];
    e: switch (a) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (l = !l.disabled) || (e = e.type, l = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !l;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (t && typeof t != "function")
      throw Error(
        o(231, a, typeof t)
      );
    return t;
  }
  var Ga = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Cs = !1;
  if (Ga)
    try {
      var $l = {};
      Object.defineProperty($l, "passive", {
        get: function() {
          Cs = !0;
        }
      }), window.addEventListener("test", $l, $l), window.removeEventListener("test", $l, $l);
    } catch {
      Cs = !1;
    }
  var nt = null, _s = null, In = null;
  function So() {
    if (In) return In;
    var e, a = _s, t = a.length, l, n = "value" in nt ? nt.value : nt.textContent, s = n.length;
    for (e = 0; e < t && a[e] === n[e]; e++) ;
    var u = t - e;
    for (l = 1; l <= u && a[t - l] === n[s - l]; l++) ;
    return In = n.slice(e, 1 < l ? 1 - l : void 0);
  }
  function Pn(e) {
    var a = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && a === 13 && (e = 13)) : e = a, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function ei() {
    return !0;
  }
  function zo() {
    return !1;
  }
  function Ie(e) {
    function a(t, l, n, s, u) {
      this._reactName = t, this._targetInst = n, this.type = l, this.nativeEvent = s, this.target = u, this.currentTarget = null;
      for (var c in e)
        e.hasOwnProperty(c) && (t = e[c], this[c] = t ? t(s) : s[c]);
      return this.isDefaultPrevented = (s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1) ? ei : zo, this.isPropagationStopped = zo, this;
    }
    return _(a.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var t = this.nativeEvent;
        t && (t.preventDefault ? t.preventDefault() : typeof t.returnValue != "unknown" && (t.returnValue = !1), this.isDefaultPrevented = ei);
      },
      stopPropagation: function() {
        var t = this.nativeEvent;
        t && (t.stopPropagation ? t.stopPropagation() : typeof t.cancelBubble != "unknown" && (t.cancelBubble = !0), this.isPropagationStopped = ei);
      },
      persist: function() {
      },
      isPersistent: ei
    }), a;
  }
  var _t = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, ai = Ie(_t), Wl = _({}, _t, { view: 0, detail: 0 }), Pm = Ie(Wl), qs, Hs, Fl, ti = _({}, Wl, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Ls,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
      return "movementX" in e ? e.movementX : (e !== Fl && (Fl && e.type === "mousemove" ? (qs = e.screenX - Fl.screenX, Hs = e.screenY - Fl.screenY) : Hs = qs = 0, Fl = e), qs);
    },
    movementY: function(e) {
      return "movementY" in e ? e.movementY : Hs;
    }
  }), Eo = Ie(ti), eh = _({}, ti, { dataTransfer: 0 }), ah = Ie(eh), th = _({}, Wl, { relatedTarget: 0 }), Bs = Ie(th), lh = _({}, _t, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), nh = Ie(lh), ih = _({}, _t, {
    clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }), sh = Ie(ih), uh = _({}, _t, { data: 0 }), Ao = Ie(uh), ch = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, oh = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, rh = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function dh(e) {
    var a = this.nativeEvent;
    return a.getModifierState ? a.getModifierState(e) : (e = rh[e]) ? !!a[e] : !1;
  }
  function Ls() {
    return dh;
  }
  var fh = _({}, Wl, {
    key: function(e) {
      if (e.key) {
        var a = ch[e.key] || e.key;
        if (a !== "Unidentified") return a;
      }
      return e.type === "keypress" ? (e = Pn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? oh[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Ls,
    charCode: function(e) {
      return e.type === "keypress" ? Pn(e) : 0;
    },
    keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
      return e.type === "keypress" ? Pn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }), mh = Ie(fh), hh = _({}, ti, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), No = Ie(hh), ph = _({}, Wl, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Ls
  }), vh = Ie(ph), yh = _({}, _t, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), xh = Ie(yh), gh = _({}, ti, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), jh = Ie(gh), bh = _({}, _t, {
    newState: 0,
    oldState: 0
  }), Sh = Ie(bh), zh = [9, 13, 27, 32], Ys = Ga && "CompositionEvent" in window, Il = null;
  Ga && "documentMode" in document && (Il = document.documentMode);
  var Eh = Ga && "TextEvent" in window && !Il, To = Ga && (!Ys || Il && 8 < Il && 11 >= Il), Oo = " ", Mo = !1;
  function Ro(e, a) {
    switch (e) {
      case "keyup":
        return zh.indexOf(a.keyCode) !== -1;
      case "keydown":
        return a.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Do(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var ul = !1;
  function Ah(e, a) {
    switch (e) {
      case "compositionend":
        return Do(a);
      case "keypress":
        return a.which !== 32 ? null : (Mo = !0, Oo);
      case "textInput":
        return e = a.data, e === Oo && Mo ? null : e;
      default:
        return null;
    }
  }
  function Nh(e, a) {
    if (ul)
      return e === "compositionend" || !Ys && Ro(e, a) ? (e = So(), In = _s = nt = null, ul = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(a.ctrlKey || a.altKey || a.metaKey) || a.ctrlKey && a.altKey) {
          if (a.char && 1 < a.char.length)
            return a.char;
          if (a.which) return String.fromCharCode(a.which);
        }
        return null;
      case "compositionend":
        return To && a.locale !== "ko" ? null : a.data;
      default:
        return null;
    }
  }
  var Th = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Uo(e) {
    var a = e && e.nodeName && e.nodeName.toLowerCase();
    return a === "input" ? !!Th[e.type] : a === "textarea";
  }
  function Co(e, a, t, l) {
    il ? sl ? sl.push(l) : sl = [l] : il = l, a = ki(a, "onChange"), 0 < a.length && (t = new ai(
      "onChange",
      "change",
      null,
      t,
      l
    ), e.push({ event: t, listeners: a }));
  }
  var Pl = null, en = null;
  function Oh(e) {
    vf(e, 0);
  }
  function li(e) {
    var a = Kl(e);
    if (ho(a)) return e;
  }
  function _o(e, a) {
    if (e === "change") return a;
  }
  var qo = !1;
  if (Ga) {
    var Gs;
    if (Ga) {
      var Vs = "oninput" in document;
      if (!Vs) {
        var Ho = document.createElement("div");
        Ho.setAttribute("oninput", "return;"), Vs = typeof Ho.oninput == "function";
      }
      Gs = Vs;
    } else Gs = !1;
    qo = Gs && (!document.documentMode || 9 < document.documentMode);
  }
  function Bo() {
    Pl && (Pl.detachEvent("onpropertychange", Lo), en = Pl = null);
  }
  function Lo(e) {
    if (e.propertyName === "value" && li(en)) {
      var a = [];
      Co(
        a,
        en,
        e,
        Ds(e)
      ), bo(Oh, a);
    }
  }
  function Mh(e, a, t) {
    e === "focusin" ? (Bo(), Pl = a, en = t, Pl.attachEvent("onpropertychange", Lo)) : e === "focusout" && Bo();
  }
  function Rh(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return li(en);
  }
  function Dh(e, a) {
    if (e === "click") return li(a);
  }
  function Uh(e, a) {
    if (e === "input" || e === "change")
      return li(a);
  }
  function Ch(e, a) {
    return e === a && (e !== 0 || 1 / e === 1 / a) || e !== e && a !== a;
  }
  var ca = typeof Object.is == "function" ? Object.is : Ch;
  function an(e, a) {
    if (ca(e, a)) return !0;
    if (typeof e != "object" || e === null || typeof a != "object" || a === null)
      return !1;
    var t = Object.keys(e), l = Object.keys(a);
    if (t.length !== l.length) return !1;
    for (l = 0; l < t.length; l++) {
      var n = t[l];
      if (!xs.call(a, n) || !ca(e[n], a[n]))
        return !1;
    }
    return !0;
  }
  function Yo(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function Go(e, a) {
    var t = Yo(e);
    e = 0;
    for (var l; t; ) {
      if (t.nodeType === 3) {
        if (l = e + t.textContent.length, e <= a && l >= a)
          return { node: t, offset: a - e };
        e = l;
      }
      e: {
        for (; t; ) {
          if (t.nextSibling) {
            t = t.nextSibling;
            break e;
          }
          t = t.parentNode;
        }
        t = void 0;
      }
      t = Yo(t);
    }
  }
  function Vo(e, a) {
    return e && a ? e === a ? !0 : e && e.nodeType === 3 ? !1 : a && a.nodeType === 3 ? Vo(e, a.parentNode) : "contains" in e ? e.contains(a) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(a) & 16) : !1 : !1;
  }
  function Qo(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var a = Wn(e.document); a instanceof e.HTMLIFrameElement; ) {
      try {
        var t = typeof a.contentWindow.location.href == "string";
      } catch {
        t = !1;
      }
      if (t) e = a.contentWindow;
      else break;
      a = Wn(e.document);
    }
    return a;
  }
  function Qs(e) {
    var a = e && e.nodeName && e.nodeName.toLowerCase();
    return a && (a === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || a === "textarea" || e.contentEditable === "true");
  }
  var _h = Ga && "documentMode" in document && 11 >= document.documentMode, cl = null, Xs = null, tn = null, Zs = !1;
  function Xo(e, a, t) {
    var l = t.window === t ? t.document : t.nodeType === 9 ? t : t.ownerDocument;
    Zs || cl == null || cl !== Wn(l) || (l = cl, "selectionStart" in l && Qs(l) ? l = { start: l.selectionStart, end: l.selectionEnd } : (l = (l.ownerDocument && l.ownerDocument.defaultView || window).getSelection(), l = {
      anchorNode: l.anchorNode,
      anchorOffset: l.anchorOffset,
      focusNode: l.focusNode,
      focusOffset: l.focusOffset
    }), tn && an(tn, l) || (tn = l, l = ki(Xs, "onSelect"), 0 < l.length && (a = new ai(
      "onSelect",
      "select",
      null,
      a,
      t
    ), e.push({ event: a, listeners: l }), a.target = cl)));
  }
  function qt(e, a) {
    var t = {};
    return t[e.toLowerCase()] = a.toLowerCase(), t["Webkit" + e] = "webkit" + a, t["Moz" + e] = "moz" + a, t;
  }
  var ol = {
    animationend: qt("Animation", "AnimationEnd"),
    animationiteration: qt("Animation", "AnimationIteration"),
    animationstart: qt("Animation", "AnimationStart"),
    transitionrun: qt("Transition", "TransitionRun"),
    transitionstart: qt("Transition", "TransitionStart"),
    transitioncancel: qt("Transition", "TransitionCancel"),
    transitionend: qt("Transition", "TransitionEnd")
  }, ks = {}, Zo = {};
  Ga && (Zo = document.createElement("div").style, "AnimationEvent" in window || (delete ol.animationend.animation, delete ol.animationiteration.animation, delete ol.animationstart.animation), "TransitionEvent" in window || delete ol.transitionend.transition);
  function Ht(e) {
    if (ks[e]) return ks[e];
    if (!ol[e]) return e;
    var a = ol[e], t;
    for (t in a)
      if (a.hasOwnProperty(t) && t in Zo)
        return ks[e] = a[t];
    return e;
  }
  var ko = Ht("animationend"), wo = Ht("animationiteration"), Ko = Ht("animationstart"), qh = Ht("transitionrun"), Hh = Ht("transitionstart"), Bh = Ht("transitioncancel"), Jo = Ht("transitionend"), $o = /* @__PURE__ */ new Map(), ws = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  ws.push("scrollEnd");
  function Ta(e, a) {
    $o.set(e, a), Ct(a, [e]);
  }
  var ni = typeof reportError == "function" ? reportError : function(e) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var a = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(a)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", e);
      return;
    }
    console.error(e);
  }, ya = [], rl = 0, Ks = 0;
  function ii() {
    for (var e = rl, a = Ks = rl = 0; a < e; ) {
      var t = ya[a];
      ya[a++] = null;
      var l = ya[a];
      ya[a++] = null;
      var n = ya[a];
      ya[a++] = null;
      var s = ya[a];
      if (ya[a++] = null, l !== null && n !== null) {
        var u = l.pending;
        u === null ? n.next = n : (n.next = u.next, u.next = n), l.pending = n;
      }
      s !== 0 && Wo(t, n, s);
    }
  }
  function si(e, a, t, l) {
    ya[rl++] = e, ya[rl++] = a, ya[rl++] = t, ya[rl++] = l, Ks |= l, e.lanes |= l, e = e.alternate, e !== null && (e.lanes |= l);
  }
  function Js(e, a, t, l) {
    return si(e, a, t, l), ui(e);
  }
  function Bt(e, a) {
    return si(e, null, null, a), ui(e);
  }
  function Wo(e, a, t) {
    e.lanes |= t;
    var l = e.alternate;
    l !== null && (l.lanes |= t);
    for (var n = !1, s = e.return; s !== null; )
      s.childLanes |= t, l = s.alternate, l !== null && (l.childLanes |= t), s.tag === 22 && (e = s.stateNode, e === null || e._visibility & 1 || (n = !0)), e = s, s = s.return;
    return e.tag === 3 ? (s = e.stateNode, n && a !== null && (n = 31 - ua(t), e = s.hiddenUpdates, l = e[n], l === null ? e[n] = [a] : l.push(a), a.lane = t | 536870912), s) : null;
  }
  function ui(e) {
    if (50 < An)
      throw An = 0, lc = null, Error(o(185));
    for (var a = e.return; a !== null; )
      e = a, a = e.return;
    return e.tag === 3 ? e.stateNode : null;
  }
  var dl = {};
  function Lh(e, a, t, l) {
    this.tag = e, this.key = t, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = a, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function oa(e, a, t, l) {
    return new Lh(e, a, t, l);
  }
  function $s(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function Va(e, a) {
    var t = e.alternate;
    return t === null ? (t = oa(
      e.tag,
      a,
      e.key,
      e.mode
    ), t.elementType = e.elementType, t.type = e.type, t.stateNode = e.stateNode, t.alternate = e, e.alternate = t) : (t.pendingProps = a, t.type = e.type, t.flags = 0, t.subtreeFlags = 0, t.deletions = null), t.flags = e.flags & 65011712, t.childLanes = e.childLanes, t.lanes = e.lanes, t.child = e.child, t.memoizedProps = e.memoizedProps, t.memoizedState = e.memoizedState, t.updateQueue = e.updateQueue, a = e.dependencies, t.dependencies = a === null ? null : { lanes: a.lanes, firstContext: a.firstContext }, t.sibling = e.sibling, t.index = e.index, t.ref = e.ref, t.refCleanup = e.refCleanup, t;
  }
  function Fo(e, a) {
    e.flags &= 65011714;
    var t = e.alternate;
    return t === null ? (e.childLanes = 0, e.lanes = a, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = t.childLanes, e.lanes = t.lanes, e.child = t.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = t.memoizedProps, e.memoizedState = t.memoizedState, e.updateQueue = t.updateQueue, e.type = t.type, a = t.dependencies, e.dependencies = a === null ? null : {
      lanes: a.lanes,
      firstContext: a.firstContext
    }), e;
  }
  function ci(e, a, t, l, n, s) {
    var u = 0;
    if (l = e, typeof e == "function") $s(e) && (u = 1);
    else if (typeof e == "string")
      u = Xp(
        e,
        t,
        G.current
      ) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
    else
      e: switch (e) {
        case na:
          return e = oa(31, t, a, n), e.elementType = na, e.lanes = s, e;
        case ce:
          return Lt(t.children, n, s, a);
        case ve:
          u = 8, n |= 24;
          break;
        case I:
          return e = oa(12, t, a, n | 2), e.elementType = I, e.lanes = s, e;
        case w:
          return e = oa(13, t, a, n), e.elementType = w, e.lanes = s, e;
        case H:
          return e = oa(19, t, a, n), e.elementType = H, e.lanes = s, e;
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case oe:
                u = 10;
                break e;
              case ee:
                u = 9;
                break e;
              case Me:
                u = 11;
                break e;
              case Y:
                u = 14;
                break e;
              case Le:
                u = 16, l = null;
                break e;
            }
          u = 29, t = Error(
            o(130, e === null ? "null" : typeof e, "")
          ), l = null;
      }
    return a = oa(u, t, a, n), a.elementType = e, a.type = l, a.lanes = s, a;
  }
  function Lt(e, a, t, l) {
    return e = oa(7, e, l, a), e.lanes = t, e;
  }
  function Ws(e, a, t) {
    return e = oa(6, e, null, a), e.lanes = t, e;
  }
  function Io(e) {
    var a = oa(18, null, null, 0);
    return a.stateNode = e, a;
  }
  function Fs(e, a, t) {
    return a = oa(
      4,
      e.children !== null ? e.children : [],
      e.key,
      a
    ), a.lanes = t, a.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, a;
  }
  var Po = /* @__PURE__ */ new WeakMap();
  function xa(e, a) {
    if (typeof e == "object" && e !== null) {
      var t = Po.get(e);
      return t !== void 0 ? t : (a = {
        value: e,
        source: a,
        stack: Fc(a)
      }, Po.set(e, a), a);
    }
    return {
      value: e,
      source: a,
      stack: Fc(a)
    };
  }
  var fl = [], ml = 0, oi = null, ln = 0, ga = [], ja = 0, it = null, Da = 1, Ua = "";
  function Qa(e, a) {
    fl[ml++] = ln, fl[ml++] = oi, oi = e, ln = a;
  }
  function er(e, a, t) {
    ga[ja++] = Da, ga[ja++] = Ua, ga[ja++] = it, it = e;
    var l = Da;
    e = Ua;
    var n = 32 - ua(l) - 1;
    l &= ~(1 << n), t += 1;
    var s = 32 - ua(a) + n;
    if (30 < s) {
      var u = n - n % 5;
      s = (l & (1 << u) - 1).toString(32), l >>= u, n -= u, Da = 1 << 32 - ua(a) + n | t << n | l, Ua = s + e;
    } else
      Da = 1 << s | t << n | l, Ua = e;
  }
  function Is(e) {
    e.return !== null && (Qa(e, 1), er(e, 1, 0));
  }
  function Ps(e) {
    for (; e === oi; )
      oi = fl[--ml], fl[ml] = null, ln = fl[--ml], fl[ml] = null;
    for (; e === it; )
      it = ga[--ja], ga[ja] = null, Ua = ga[--ja], ga[ja] = null, Da = ga[--ja], ga[ja] = null;
  }
  function ar(e, a) {
    ga[ja++] = Da, ga[ja++] = Ua, ga[ja++] = it, Da = a.id, Ua = a.overflow, it = e;
  }
  var Xe = null, ze = null, ue = !1, st = null, ba = !1, eu = Error(o(519));
  function ut(e) {
    var a = Error(
      o(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw nn(xa(a, e)), eu;
  }
  function tr(e) {
    var a = e.stateNode, t = e.type, l = e.memoizedProps;
    switch (a[Qe] = e, a[Fe] = l, t) {
      case "dialog":
        le("cancel", a), le("close", a);
        break;
      case "iframe":
      case "object":
      case "embed":
        le("load", a);
        break;
      case "video":
      case "audio":
        for (t = 0; t < Tn.length; t++)
          le(Tn[t], a);
        break;
      case "source":
        le("error", a);
        break;
      case "img":
      case "image":
      case "link":
        le("error", a), le("load", a);
        break;
      case "details":
        le("toggle", a);
        break;
      case "input":
        le("invalid", a), po(
          a,
          l.value,
          l.defaultValue,
          l.checked,
          l.defaultChecked,
          l.type,
          l.name,
          !0
        );
        break;
      case "select":
        le("invalid", a);
        break;
      case "textarea":
        le("invalid", a), yo(a, l.value, l.defaultValue, l.children);
    }
    t = l.children, typeof t != "string" && typeof t != "number" && typeof t != "bigint" || a.textContent === "" + t || l.suppressHydrationWarning === !0 || jf(a.textContent, t) ? (l.popover != null && (le("beforetoggle", a), le("toggle", a)), l.onScroll != null && le("scroll", a), l.onScrollEnd != null && le("scrollend", a), l.onClick != null && (a.onclick = Ya), a = !0) : a = !1, a || ut(e, !0);
  }
  function lr(e) {
    for (Xe = e.return; Xe; )
      switch (Xe.tag) {
        case 5:
        case 31:
        case 13:
          ba = !1;
          return;
        case 27:
        case 3:
          ba = !0;
          return;
        default:
          Xe = Xe.return;
      }
  }
  function hl(e) {
    if (e !== Xe) return !1;
    if (!ue) return lr(e), ue = !0, !1;
    var a = e.tag, t;
    if ((t = a !== 3 && a !== 27) && ((t = a === 5) && (t = e.type, t = !(t !== "form" && t !== "button") || xc(e.type, e.memoizedProps)), t = !t), t && ze && ut(e), lr(e), a === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(317));
      ze = Mf(e);
    } else if (a === 31) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(317));
      ze = Mf(e);
    } else
      a === 27 ? (a = ze, bt(e.type) ? (e = zc, zc = null, ze = e) : ze = a) : ze = Xe ? za(e.stateNode.nextSibling) : null;
    return !0;
  }
  function Yt() {
    ze = Xe = null, ue = !1;
  }
  function au() {
    var e = st;
    return e !== null && (ta === null ? ta = e : ta.push.apply(
      ta,
      e
    ), st = null), e;
  }
  function nn(e) {
    st === null ? st = [e] : st.push(e);
  }
  var tu = h(null), Gt = null, Xa = null;
  function ct(e, a, t) {
    C(tu, a._currentValue), a._currentValue = t;
  }
  function Za(e) {
    e._currentValue = tu.current, D(tu);
  }
  function lu(e, a, t) {
    for (; e !== null; ) {
      var l = e.alternate;
      if ((e.childLanes & a) !== a ? (e.childLanes |= a, l !== null && (l.childLanes |= a)) : l !== null && (l.childLanes & a) !== a && (l.childLanes |= a), e === t) break;
      e = e.return;
    }
  }
  function nu(e, a, t, l) {
    var n = e.child;
    for (n !== null && (n.return = e); n !== null; ) {
      var s = n.dependencies;
      if (s !== null) {
        var u = n.child;
        s = s.firstContext;
        e: for (; s !== null; ) {
          var c = s;
          s = n;
          for (var d = 0; d < a.length; d++)
            if (c.context === a[d]) {
              s.lanes |= t, c = s.alternate, c !== null && (c.lanes |= t), lu(
                s.return,
                t,
                e
              ), l || (u = null);
              break e;
            }
          s = c.next;
        }
      } else if (n.tag === 18) {
        if (u = n.return, u === null) throw Error(o(341));
        u.lanes |= t, s = u.alternate, s !== null && (s.lanes |= t), lu(u, t, e), u = null;
      } else u = n.child;
      if (u !== null) u.return = n;
      else
        for (u = n; u !== null; ) {
          if (u === e) {
            u = null;
            break;
          }
          if (n = u.sibling, n !== null) {
            n.return = u.return, u = n;
            break;
          }
          u = u.return;
        }
      n = u;
    }
  }
  function pl(e, a, t, l) {
    e = null;
    for (var n = a, s = !1; n !== null; ) {
      if (!s) {
        if ((n.flags & 524288) !== 0) s = !0;
        else if ((n.flags & 262144) !== 0) break;
      }
      if (n.tag === 10) {
        var u = n.alternate;
        if (u === null) throw Error(o(387));
        if (u = u.memoizedProps, u !== null) {
          var c = n.type;
          ca(n.pendingProps.value, u.value) || (e !== null ? e.push(c) : e = [c]);
        }
      } else if (n === me.current) {
        if (u = n.alternate, u === null) throw Error(o(387));
        u.memoizedState.memoizedState !== n.memoizedState.memoizedState && (e !== null ? e.push(Un) : e = [Un]);
      }
      n = n.return;
    }
    e !== null && nu(
      a,
      e,
      t,
      l
    ), a.flags |= 262144;
  }
  function ri(e) {
    for (e = e.firstContext; e !== null; ) {
      if (!ca(
        e.context._currentValue,
        e.memoizedValue
      ))
        return !0;
      e = e.next;
    }
    return !1;
  }
  function Vt(e) {
    Gt = e, Xa = null, e = e.dependencies, e !== null && (e.firstContext = null);
  }
  function Ze(e) {
    return nr(Gt, e);
  }
  function di(e, a) {
    return Gt === null && Vt(e), nr(e, a);
  }
  function nr(e, a) {
    var t = a._currentValue;
    if (a = { context: a, memoizedValue: t, next: null }, Xa === null) {
      if (e === null) throw Error(o(308));
      Xa = a, e.dependencies = { lanes: 0, firstContext: a }, e.flags |= 524288;
    } else Xa = Xa.next = a;
    return t;
  }
  var Yh = typeof AbortController < "u" ? AbortController : function() {
    var e = [], a = this.signal = {
      aborted: !1,
      addEventListener: function(t, l) {
        e.push(l);
      }
    };
    this.abort = function() {
      a.aborted = !0, e.forEach(function(t) {
        return t();
      });
    };
  }, Gh = r.unstable_scheduleCallback, Vh = r.unstable_NormalPriority, Ce = {
    $$typeof: oe,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function iu() {
    return {
      controller: new Yh(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function sn(e) {
    e.refCount--, e.refCount === 0 && Gh(Vh, function() {
      e.controller.abort();
    });
  }
  var un = null, su = 0, vl = 0, yl = null;
  function Qh(e, a) {
    if (un === null) {
      var t = un = [];
      su = 0, vl = oc(), yl = {
        status: "pending",
        value: void 0,
        then: function(l) {
          t.push(l);
        }
      };
    }
    return su++, a.then(ir, ir), a;
  }
  function ir() {
    if (--su === 0 && un !== null) {
      yl !== null && (yl.status = "fulfilled");
      var e = un;
      un = null, vl = 0, yl = null;
      for (var a = 0; a < e.length; a++) (0, e[a])();
    }
  }
  function Xh(e, a) {
    var t = [], l = {
      status: "pending",
      value: null,
      reason: null,
      then: function(n) {
        t.push(n);
      }
    };
    return e.then(
      function() {
        l.status = "fulfilled", l.value = a;
        for (var n = 0; n < t.length; n++) (0, t[n])(a);
      },
      function(n) {
        for (l.status = "rejected", l.reason = n, n = 0; n < t.length; n++)
          (0, t[n])(void 0);
      }
    ), l;
  }
  var sr = T.S;
  T.S = function(e, a) {
    Xd = ia(), typeof a == "object" && a !== null && typeof a.then == "function" && Qh(e, a), sr !== null && sr(e, a);
  };
  var Qt = h(null);
  function uu() {
    var e = Qt.current;
    return e !== null ? e : Se.pooledCache;
  }
  function fi(e, a) {
    a === null ? C(Qt, Qt.current) : C(Qt, a.pool);
  }
  function ur() {
    var e = uu();
    return e === null ? null : { parent: Ce._currentValue, pool: e };
  }
  var xl = Error(o(460)), cu = Error(o(474)), mi = Error(o(542)), hi = { then: function() {
  } };
  function cr(e) {
    return e = e.status, e === "fulfilled" || e === "rejected";
  }
  function or(e, a, t) {
    switch (t = e[t], t === void 0 ? e.push(a) : t !== a && (a.then(Ya, Ya), a = t), a.status) {
      case "fulfilled":
        return a.value;
      case "rejected":
        throw e = a.reason, dr(e), e;
      default:
        if (typeof a.status == "string") a.then(Ya, Ya);
        else {
          if (e = Se, e !== null && 100 < e.shellSuspendCounter)
            throw Error(o(482));
          e = a, e.status = "pending", e.then(
            function(l) {
              if (a.status === "pending") {
                var n = a;
                n.status = "fulfilled", n.value = l;
              }
            },
            function(l) {
              if (a.status === "pending") {
                var n = a;
                n.status = "rejected", n.reason = l;
              }
            }
          );
        }
        switch (a.status) {
          case "fulfilled":
            return a.value;
          case "rejected":
            throw e = a.reason, dr(e), e;
        }
        throw Zt = a, xl;
    }
  }
  function Xt(e) {
    try {
      var a = e._init;
      return a(e._payload);
    } catch (t) {
      throw t !== null && typeof t == "object" && typeof t.then == "function" ? (Zt = t, xl) : t;
    }
  }
  var Zt = null;
  function rr() {
    if (Zt === null) throw Error(o(459));
    var e = Zt;
    return Zt = null, e;
  }
  function dr(e) {
    if (e === xl || e === mi)
      throw Error(o(483));
  }
  var gl = null, cn = 0;
  function pi(e) {
    var a = cn;
    return cn += 1, gl === null && (gl = []), or(gl, e, a);
  }
  function on(e, a) {
    a = a.props.ref, e.ref = a !== void 0 ? a : null;
  }
  function vi(e, a) {
    throw a.$$typeof === k ? Error(o(525)) : (e = Object.prototype.toString.call(a), Error(
      o(
        31,
        e === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : e
      )
    ));
  }
  function fr(e) {
    function a(v, f) {
      if (e) {
        var y = v.deletions;
        y === null ? (v.deletions = [f], v.flags |= 16) : y.push(f);
      }
    }
    function t(v, f) {
      if (!e) return null;
      for (; f !== null; )
        a(v, f), f = f.sibling;
      return null;
    }
    function l(v) {
      for (var f = /* @__PURE__ */ new Map(); v !== null; )
        v.key !== null ? f.set(v.key, v) : f.set(v.index, v), v = v.sibling;
      return f;
    }
    function n(v, f) {
      return v = Va(v, f), v.index = 0, v.sibling = null, v;
    }
    function s(v, f, y) {
      return v.index = y, e ? (y = v.alternate, y !== null ? (y = y.index, y < f ? (v.flags |= 67108866, f) : y) : (v.flags |= 67108866, f)) : (v.flags |= 1048576, f);
    }
    function u(v) {
      return e && v.alternate === null && (v.flags |= 67108866), v;
    }
    function c(v, f, y, O) {
      return f === null || f.tag !== 6 ? (f = Ws(y, v.mode, O), f.return = v, f) : (f = n(f, y), f.return = v, f);
    }
    function d(v, f, y, O) {
      var X = y.type;
      return X === ce ? N(
        v,
        f,
        y.props.children,
        O,
        y.key
      ) : f !== null && (f.elementType === X || typeof X == "object" && X !== null && X.$$typeof === Le && Xt(X) === f.type) ? (f = n(f, y.props), on(f, y), f.return = v, f) : (f = ci(
        y.type,
        y.key,
        y.props,
        null,
        v.mode,
        O
      ), on(f, y), f.return = v, f);
    }
    function g(v, f, y, O) {
      return f === null || f.tag !== 4 || f.stateNode.containerInfo !== y.containerInfo || f.stateNode.implementation !== y.implementation ? (f = Fs(y, v.mode, O), f.return = v, f) : (f = n(f, y.children || []), f.return = v, f);
    }
    function N(v, f, y, O, X) {
      return f === null || f.tag !== 7 ? (f = Lt(
        y,
        v.mode,
        O,
        X
      ), f.return = v, f) : (f = n(f, y), f.return = v, f);
    }
    function R(v, f, y) {
      if (typeof f == "string" && f !== "" || typeof f == "number" || typeof f == "bigint")
        return f = Ws(
          "" + f,
          v.mode,
          y
        ), f.return = v, f;
      if (typeof f == "object" && f !== null) {
        switch (f.$$typeof) {
          case L:
            return y = ci(
              f.type,
              f.key,
              f.props,
              null,
              v.mode,
              y
            ), on(y, f), y.return = v, y;
          case ne:
            return f = Fs(
              f,
              v.mode,
              y
            ), f.return = v, f;
          case Le:
            return f = Xt(f), R(v, f, y);
        }
        if (Na(f) || Ye(f))
          return f = Lt(
            f,
            v.mode,
            y,
            null
          ), f.return = v, f;
        if (typeof f.then == "function")
          return R(v, pi(f), y);
        if (f.$$typeof === oe)
          return R(
            v,
            di(v, f),
            y
          );
        vi(v, f);
      }
      return null;
    }
    function j(v, f, y, O) {
      var X = f !== null ? f.key : null;
      if (typeof y == "string" && y !== "" || typeof y == "number" || typeof y == "bigint")
        return X !== null ? null : c(v, f, "" + y, O);
      if (typeof y == "object" && y !== null) {
        switch (y.$$typeof) {
          case L:
            return y.key === X ? d(v, f, y, O) : null;
          case ne:
            return y.key === X ? g(v, f, y, O) : null;
          case Le:
            return y = Xt(y), j(v, f, y, O);
        }
        if (Na(y) || Ye(y))
          return X !== null ? null : N(v, f, y, O, null);
        if (typeof y.then == "function")
          return j(
            v,
            f,
            pi(y),
            O
          );
        if (y.$$typeof === oe)
          return j(
            v,
            f,
            di(v, y),
            O
          );
        vi(v, y);
      }
      return null;
    }
    function z(v, f, y, O, X) {
      if (typeof O == "string" && O !== "" || typeof O == "number" || typeof O == "bigint")
        return v = v.get(y) || null, c(f, v, "" + O, X);
      if (typeof O == "object" && O !== null) {
        switch (O.$$typeof) {
          case L:
            return v = v.get(
              O.key === null ? y : O.key
            ) || null, d(f, v, O, X);
          case ne:
            return v = v.get(
              O.key === null ? y : O.key
            ) || null, g(f, v, O, X);
          case Le:
            return O = Xt(O), z(
              v,
              f,
              y,
              O,
              X
            );
        }
        if (Na(O) || Ye(O))
          return v = v.get(y) || null, N(f, v, O, X, null);
        if (typeof O.then == "function")
          return z(
            v,
            f,
            y,
            pi(O),
            X
          );
        if (O.$$typeof === oe)
          return z(
            v,
            f,
            y,
            di(f, O),
            X
          );
        vi(f, O);
      }
      return null;
    }
    function B(v, f, y, O) {
      for (var X = null, re = null, Q = f, F = f = 0, se = null; Q !== null && F < y.length; F++) {
        Q.index > F ? (se = Q, Q = null) : se = Q.sibling;
        var de = j(
          v,
          Q,
          y[F],
          O
        );
        if (de === null) {
          Q === null && (Q = se);
          break;
        }
        e && Q && de.alternate === null && a(v, Q), f = s(de, f, F), re === null ? X = de : re.sibling = de, re = de, Q = se;
      }
      if (F === y.length)
        return t(v, Q), ue && Qa(v, F), X;
      if (Q === null) {
        for (; F < y.length; F++)
          Q = R(v, y[F], O), Q !== null && (f = s(
            Q,
            f,
            F
          ), re === null ? X = Q : re.sibling = Q, re = Q);
        return ue && Qa(v, F), X;
      }
      for (Q = l(Q); F < y.length; F++)
        se = z(
          Q,
          v,
          F,
          y[F],
          O
        ), se !== null && (e && se.alternate !== null && Q.delete(
          se.key === null ? F : se.key
        ), f = s(
          se,
          f,
          F
        ), re === null ? X = se : re.sibling = se, re = se);
      return e && Q.forEach(function(Nt) {
        return a(v, Nt);
      }), ue && Qa(v, F), X;
    }
    function Z(v, f, y, O) {
      if (y == null) throw Error(o(151));
      for (var X = null, re = null, Q = f, F = f = 0, se = null, de = y.next(); Q !== null && !de.done; F++, de = y.next()) {
        Q.index > F ? (se = Q, Q = null) : se = Q.sibling;
        var Nt = j(v, Q, de.value, O);
        if (Nt === null) {
          Q === null && (Q = se);
          break;
        }
        e && Q && Nt.alternate === null && a(v, Q), f = s(Nt, f, F), re === null ? X = Nt : re.sibling = Nt, re = Nt, Q = se;
      }
      if (de.done)
        return t(v, Q), ue && Qa(v, F), X;
      if (Q === null) {
        for (; !de.done; F++, de = y.next())
          de = R(v, de.value, O), de !== null && (f = s(de, f, F), re === null ? X = de : re.sibling = de, re = de);
        return ue && Qa(v, F), X;
      }
      for (Q = l(Q); !de.done; F++, de = y.next())
        de = z(Q, v, F, de.value, O), de !== null && (e && de.alternate !== null && Q.delete(de.key === null ? F : de.key), f = s(de, f, F), re === null ? X = de : re.sibling = de, re = de);
      return e && Q.forEach(function(ev) {
        return a(v, ev);
      }), ue && Qa(v, F), X;
    }
    function je(v, f, y, O) {
      if (typeof y == "object" && y !== null && y.type === ce && y.key === null && (y = y.props.children), typeof y == "object" && y !== null) {
        switch (y.$$typeof) {
          case L:
            e: {
              for (var X = y.key; f !== null; ) {
                if (f.key === X) {
                  if (X = y.type, X === ce) {
                    if (f.tag === 7) {
                      t(
                        v,
                        f.sibling
                      ), O = n(
                        f,
                        y.props.children
                      ), O.return = v, v = O;
                      break e;
                    }
                  } else if (f.elementType === X || typeof X == "object" && X !== null && X.$$typeof === Le && Xt(X) === f.type) {
                    t(
                      v,
                      f.sibling
                    ), O = n(f, y.props), on(O, y), O.return = v, v = O;
                    break e;
                  }
                  t(v, f);
                  break;
                } else a(v, f);
                f = f.sibling;
              }
              y.type === ce ? (O = Lt(
                y.props.children,
                v.mode,
                O,
                y.key
              ), O.return = v, v = O) : (O = ci(
                y.type,
                y.key,
                y.props,
                null,
                v.mode,
                O
              ), on(O, y), O.return = v, v = O);
            }
            return u(v);
          case ne:
            e: {
              for (X = y.key; f !== null; ) {
                if (f.key === X)
                  if (f.tag === 4 && f.stateNode.containerInfo === y.containerInfo && f.stateNode.implementation === y.implementation) {
                    t(
                      v,
                      f.sibling
                    ), O = n(f, y.children || []), O.return = v, v = O;
                    break e;
                  } else {
                    t(v, f);
                    break;
                  }
                else a(v, f);
                f = f.sibling;
              }
              O = Fs(y, v.mode, O), O.return = v, v = O;
            }
            return u(v);
          case Le:
            return y = Xt(y), je(
              v,
              f,
              y,
              O
            );
        }
        if (Na(y))
          return B(
            v,
            f,
            y,
            O
          );
        if (Ye(y)) {
          if (X = Ye(y), typeof X != "function") throw Error(o(150));
          return y = X.call(y), Z(
            v,
            f,
            y,
            O
          );
        }
        if (typeof y.then == "function")
          return je(
            v,
            f,
            pi(y),
            O
          );
        if (y.$$typeof === oe)
          return je(
            v,
            f,
            di(v, y),
            O
          );
        vi(v, y);
      }
      return typeof y == "string" && y !== "" || typeof y == "number" || typeof y == "bigint" ? (y = "" + y, f !== null && f.tag === 6 ? (t(v, f.sibling), O = n(f, y), O.return = v, v = O) : (t(v, f), O = Ws(y, v.mode, O), O.return = v, v = O), u(v)) : t(v, f);
    }
    return function(v, f, y, O) {
      try {
        cn = 0;
        var X = je(
          v,
          f,
          y,
          O
        );
        return gl = null, X;
      } catch (Q) {
        if (Q === xl || Q === mi) throw Q;
        var re = oa(29, Q, null, v.mode);
        return re.lanes = O, re.return = v, re;
      } finally {
      }
    };
  }
  var kt = fr(!0), mr = fr(!1), ot = !1;
  function ou(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function ru(e, a) {
    e = e.updateQueue, a.updateQueue === e && (a.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    });
  }
  function rt(e) {
    return { lane: e, tag: 0, payload: null, callback: null, next: null };
  }
  function dt(e, a, t) {
    var l = e.updateQueue;
    if (l === null) return null;
    if (l = l.shared, (fe & 2) !== 0) {
      var n = l.pending;
      return n === null ? a.next = a : (a.next = n.next, n.next = a), l.pending = a, a = ui(e), Wo(e, null, t), a;
    }
    return si(e, l, a, t), ui(e);
  }
  function rn(e, a, t) {
    if (a = a.updateQueue, a !== null && (a = a.shared, (t & 4194048) !== 0)) {
      var l = a.lanes;
      l &= e.pendingLanes, t |= l, a.lanes = t, lo(e, t);
    }
  }
  function du(e, a) {
    var t = e.updateQueue, l = e.alternate;
    if (l !== null && (l = l.updateQueue, t === l)) {
      var n = null, s = null;
      if (t = t.firstBaseUpdate, t !== null) {
        do {
          var u = {
            lane: t.lane,
            tag: t.tag,
            payload: t.payload,
            callback: null,
            next: null
          };
          s === null ? n = s = u : s = s.next = u, t = t.next;
        } while (t !== null);
        s === null ? n = s = a : s = s.next = a;
      } else n = s = a;
      t = {
        baseState: l.baseState,
        firstBaseUpdate: n,
        lastBaseUpdate: s,
        shared: l.shared,
        callbacks: l.callbacks
      }, e.updateQueue = t;
      return;
    }
    e = t.lastBaseUpdate, e === null ? t.firstBaseUpdate = a : e.next = a, t.lastBaseUpdate = a;
  }
  var fu = !1;
  function dn() {
    if (fu) {
      var e = yl;
      if (e !== null) throw e;
    }
  }
  function fn(e, a, t, l) {
    fu = !1;
    var n = e.updateQueue;
    ot = !1;
    var s = n.firstBaseUpdate, u = n.lastBaseUpdate, c = n.shared.pending;
    if (c !== null) {
      n.shared.pending = null;
      var d = c, g = d.next;
      d.next = null, u === null ? s = g : u.next = g, u = d;
      var N = e.alternate;
      N !== null && (N = N.updateQueue, c = N.lastBaseUpdate, c !== u && (c === null ? N.firstBaseUpdate = g : c.next = g, N.lastBaseUpdate = d));
    }
    if (s !== null) {
      var R = n.baseState;
      u = 0, N = g = d = null, c = s;
      do {
        var j = c.lane & -536870913, z = j !== c.lane;
        if (z ? (ie & j) === j : (l & j) === j) {
          j !== 0 && j === vl && (fu = !0), N !== null && (N = N.next = {
            lane: 0,
            tag: c.tag,
            payload: c.payload,
            callback: null,
            next: null
          });
          e: {
            var B = e, Z = c;
            j = a;
            var je = t;
            switch (Z.tag) {
              case 1:
                if (B = Z.payload, typeof B == "function") {
                  R = B.call(je, R, j);
                  break e;
                }
                R = B;
                break e;
              case 3:
                B.flags = B.flags & -65537 | 128;
              case 0:
                if (B = Z.payload, j = typeof B == "function" ? B.call(je, R, j) : B, j == null) break e;
                R = _({}, R, j);
                break e;
              case 2:
                ot = !0;
            }
          }
          j = c.callback, j !== null && (e.flags |= 64, z && (e.flags |= 8192), z = n.callbacks, z === null ? n.callbacks = [j] : z.push(j));
        } else
          z = {
            lane: j,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          }, N === null ? (g = N = z, d = R) : N = N.next = z, u |= j;
        if (c = c.next, c === null) {
          if (c = n.shared.pending, c === null)
            break;
          z = c, c = z.next, z.next = null, n.lastBaseUpdate = z, n.shared.pending = null;
        }
      } while (!0);
      N === null && (d = R), n.baseState = d, n.firstBaseUpdate = g, n.lastBaseUpdate = N, s === null && (n.shared.lanes = 0), vt |= u, e.lanes = u, e.memoizedState = R;
    }
  }
  function hr(e, a) {
    if (typeof e != "function")
      throw Error(o(191, e));
    e.call(a);
  }
  function pr(e, a) {
    var t = e.callbacks;
    if (t !== null)
      for (e.callbacks = null, e = 0; e < t.length; e++)
        hr(t[e], a);
  }
  var jl = h(null), yi = h(0);
  function vr(e, a) {
    e = Pa, C(yi, e), C(jl, a), Pa = e | a.baseLanes;
  }
  function mu() {
    C(yi, Pa), C(jl, jl.current);
  }
  function hu() {
    Pa = yi.current, D(jl), D(yi);
  }
  var ra = h(null), Sa = null;
  function ft(e) {
    var a = e.alternate;
    C(De, De.current & 1), C(ra, e), Sa === null && (a === null || jl.current !== null || a.memoizedState !== null) && (Sa = e);
  }
  function pu(e) {
    C(De, De.current), C(ra, e), Sa === null && (Sa = e);
  }
  function yr(e) {
    e.tag === 22 ? (C(De, De.current), C(ra, e), Sa === null && (Sa = e)) : mt();
  }
  function mt() {
    C(De, De.current), C(ra, ra.current);
  }
  function da(e) {
    D(ra), Sa === e && (Sa = null), D(De);
  }
  var De = h(0);
  function xi(e) {
    for (var a = e; a !== null; ) {
      if (a.tag === 13) {
        var t = a.memoizedState;
        if (t !== null && (t = t.dehydrated, t === null || bc(t) || Sc(t)))
          return a;
      } else if (a.tag === 19 && (a.memoizedProps.revealOrder === "forwards" || a.memoizedProps.revealOrder === "backwards" || a.memoizedProps.revealOrder === "unstable_legacy-backwards" || a.memoizedProps.revealOrder === "together")) {
        if ((a.flags & 128) !== 0) return a;
      } else if (a.child !== null) {
        a.child.return = a, a = a.child;
        continue;
      }
      if (a === e) break;
      for (; a.sibling === null; ) {
        if (a.return === null || a.return === e) return null;
        a = a.return;
      }
      a.sibling.return = a.return, a = a.sibling;
    }
    return null;
  }
  var ka = 0, W = null, xe = null, _e = null, gi = !1, bl = !1, wt = !1, ji = 0, mn = 0, Sl = null, Zh = 0;
  function Te() {
    throw Error(o(321));
  }
  function vu(e, a) {
    if (a === null) return !1;
    for (var t = 0; t < a.length && t < e.length; t++)
      if (!ca(e[t], a[t])) return !1;
    return !0;
  }
  function yu(e, a, t, l, n, s) {
    return ka = s, W = a, a.memoizedState = null, a.updateQueue = null, a.lanes = 0, T.H = e === null || e.memoizedState === null ? ed : Uu, wt = !1, s = t(l, n), wt = !1, bl && (s = gr(
      a,
      t,
      l,
      n
    )), xr(e), s;
  }
  function xr(e) {
    T.H = vn;
    var a = xe !== null && xe.next !== null;
    if (ka = 0, _e = xe = W = null, gi = !1, mn = 0, Sl = null, a) throw Error(o(300));
    e === null || qe || (e = e.dependencies, e !== null && ri(e) && (qe = !0));
  }
  function gr(e, a, t, l) {
    W = e;
    var n = 0;
    do {
      if (bl && (Sl = null), mn = 0, bl = !1, 25 <= n) throw Error(o(301));
      if (n += 1, _e = xe = null, e.updateQueue != null) {
        var s = e.updateQueue;
        s.lastEffect = null, s.events = null, s.stores = null, s.memoCache != null && (s.memoCache.index = 0);
      }
      T.H = ad, s = a(t, l);
    } while (bl);
    return s;
  }
  function kh() {
    var e = T.H, a = e.useState()[0];
    return a = typeof a.then == "function" ? hn(a) : a, e = e.useState()[0], (xe !== null ? xe.memoizedState : null) !== e && (W.flags |= 1024), a;
  }
  function xu() {
    var e = ji !== 0;
    return ji = 0, e;
  }
  function gu(e, a, t) {
    a.updateQueue = e.updateQueue, a.flags &= -2053, e.lanes &= ~t;
  }
  function ju(e) {
    if (gi) {
      for (e = e.memoizedState; e !== null; ) {
        var a = e.queue;
        a !== null && (a.pending = null), e = e.next;
      }
      gi = !1;
    }
    ka = 0, _e = xe = W = null, bl = !1, mn = ji = 0, Sl = null;
  }
  function $e() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return _e === null ? W.memoizedState = _e = e : _e = _e.next = e, _e;
  }
  function Ue() {
    if (xe === null) {
      var e = W.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = xe.next;
    var a = _e === null ? W.memoizedState : _e.next;
    if (a !== null)
      _e = a, xe = e;
    else {
      if (e === null)
        throw W.alternate === null ? Error(o(467)) : Error(o(310));
      xe = e, e = {
        memoizedState: xe.memoizedState,
        baseState: xe.baseState,
        baseQueue: xe.baseQueue,
        queue: xe.queue,
        next: null
      }, _e === null ? W.memoizedState = _e = e : _e = _e.next = e;
    }
    return _e;
  }
  function bi() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function hn(e) {
    var a = mn;
    return mn += 1, Sl === null && (Sl = []), e = or(Sl, e, a), a = W, (_e === null ? a.memoizedState : _e.next) === null && (a = a.alternate, T.H = a === null || a.memoizedState === null ? ed : Uu), e;
  }
  function Si(e) {
    if (e !== null && typeof e == "object") {
      if (typeof e.then == "function") return hn(e);
      if (e.$$typeof === oe) return Ze(e);
    }
    throw Error(o(438, String(e)));
  }
  function bu(e) {
    var a = null, t = W.updateQueue;
    if (t !== null && (a = t.memoCache), a == null) {
      var l = W.alternate;
      l !== null && (l = l.updateQueue, l !== null && (l = l.memoCache, l != null && (a = {
        data: l.data.map(function(n) {
          return n.slice();
        }),
        index: 0
      })));
    }
    if (a == null && (a = { data: [], index: 0 }), t === null && (t = bi(), W.updateQueue = t), t.memoCache = a, t = a.data[a.index], t === void 0)
      for (t = a.data[a.index] = Array(e), l = 0; l < e; l++)
        t[l] = Ha;
    return a.index++, t;
  }
  function wa(e, a) {
    return typeof a == "function" ? a(e) : a;
  }
  function zi(e) {
    var a = Ue();
    return Su(a, xe, e);
  }
  function Su(e, a, t) {
    var l = e.queue;
    if (l === null) throw Error(o(311));
    l.lastRenderedReducer = t;
    var n = e.baseQueue, s = l.pending;
    if (s !== null) {
      if (n !== null) {
        var u = n.next;
        n.next = s.next, s.next = u;
      }
      a.baseQueue = n = s, l.pending = null;
    }
    if (s = e.baseState, n === null) e.memoizedState = s;
    else {
      a = n.next;
      var c = u = null, d = null, g = a, N = !1;
      do {
        var R = g.lane & -536870913;
        if (R !== g.lane ? (ie & R) === R : (ka & R) === R) {
          var j = g.revertLane;
          if (j === 0)
            d !== null && (d = d.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: g.action,
              hasEagerState: g.hasEagerState,
              eagerState: g.eagerState,
              next: null
            }), R === vl && (N = !0);
          else if ((ka & j) === j) {
            g = g.next, j === vl && (N = !0);
            continue;
          } else
            R = {
              lane: 0,
              revertLane: g.revertLane,
              gesture: null,
              action: g.action,
              hasEagerState: g.hasEagerState,
              eagerState: g.eagerState,
              next: null
            }, d === null ? (c = d = R, u = s) : d = d.next = R, W.lanes |= j, vt |= j;
          R = g.action, wt && t(s, R), s = g.hasEagerState ? g.eagerState : t(s, R);
        } else
          j = {
            lane: R,
            revertLane: g.revertLane,
            gesture: g.gesture,
            action: g.action,
            hasEagerState: g.hasEagerState,
            eagerState: g.eagerState,
            next: null
          }, d === null ? (c = d = j, u = s) : d = d.next = j, W.lanes |= R, vt |= R;
        g = g.next;
      } while (g !== null && g !== a);
      if (d === null ? u = s : d.next = c, !ca(s, e.memoizedState) && (qe = !0, N && (t = yl, t !== null)))
        throw t;
      e.memoizedState = s, e.baseState = u, e.baseQueue = d, l.lastRenderedState = s;
    }
    return n === null && (l.lanes = 0), [e.memoizedState, l.dispatch];
  }
  function zu(e) {
    var a = Ue(), t = a.queue;
    if (t === null) throw Error(o(311));
    t.lastRenderedReducer = e;
    var l = t.dispatch, n = t.pending, s = a.memoizedState;
    if (n !== null) {
      t.pending = null;
      var u = n = n.next;
      do
        s = e(s, u.action), u = u.next;
      while (u !== n);
      ca(s, a.memoizedState) || (qe = !0), a.memoizedState = s, a.baseQueue === null && (a.baseState = s), t.lastRenderedState = s;
    }
    return [s, l];
  }
  function jr(e, a, t) {
    var l = W, n = Ue(), s = ue;
    if (s) {
      if (t === void 0) throw Error(o(407));
      t = t();
    } else t = a();
    var u = !ca(
      (xe || n).memoizedState,
      t
    );
    if (u && (n.memoizedState = t, qe = !0), n = n.queue, Nu(zr.bind(null, l, n, e), [
      e
    ]), n.getSnapshot !== a || u || _e !== null && _e.memoizedState.tag & 1) {
      if (l.flags |= 2048, zl(
        9,
        { destroy: void 0 },
        Sr.bind(
          null,
          l,
          n,
          t,
          a
        ),
        null
      ), Se === null) throw Error(o(349));
      s || (ka & 127) !== 0 || br(l, a, t);
    }
    return t;
  }
  function br(e, a, t) {
    e.flags |= 16384, e = { getSnapshot: a, value: t }, a = W.updateQueue, a === null ? (a = bi(), W.updateQueue = a, a.stores = [e]) : (t = a.stores, t === null ? a.stores = [e] : t.push(e));
  }
  function Sr(e, a, t, l) {
    a.value = t, a.getSnapshot = l, Er(a) && Ar(e);
  }
  function zr(e, a, t) {
    return t(function() {
      Er(a) && Ar(e);
    });
  }
  function Er(e) {
    var a = e.getSnapshot;
    e = e.value;
    try {
      var t = a();
      return !ca(e, t);
    } catch {
      return !0;
    }
  }
  function Ar(e) {
    var a = Bt(e, 2);
    a !== null && la(a, e, 2);
  }
  function Eu(e) {
    var a = $e();
    if (typeof e == "function") {
      var t = e;
      if (e = t(), wt) {
        tt(!0);
        try {
          t();
        } finally {
          tt(!1);
        }
      }
    }
    return a.memoizedState = a.baseState = e, a.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: wa,
      lastRenderedState: e
    }, a;
  }
  function Nr(e, a, t, l) {
    return e.baseState = t, Su(
      e,
      xe,
      typeof l == "function" ? l : wa
    );
  }
  function wh(e, a, t, l, n) {
    if (Ni(e)) throw Error(o(485));
    if (e = a.action, e !== null) {
      var s = {
        payload: n,
        action: e,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(u) {
          s.listeners.push(u);
        }
      };
      T.T !== null ? t(!0) : s.isTransition = !1, l(s), t = a.pending, t === null ? (s.next = a.pending = s, Tr(a, s)) : (s.next = t.next, a.pending = t.next = s);
    }
  }
  function Tr(e, a) {
    var t = a.action, l = a.payload, n = e.state;
    if (a.isTransition) {
      var s = T.T, u = {};
      T.T = u;
      try {
        var c = t(n, l), d = T.S;
        d !== null && d(u, c), Or(e, a, c);
      } catch (g) {
        Au(e, a, g);
      } finally {
        s !== null && u.types !== null && (s.types = u.types), T.T = s;
      }
    } else
      try {
        s = t(n, l), Or(e, a, s);
      } catch (g) {
        Au(e, a, g);
      }
  }
  function Or(e, a, t) {
    t !== null && typeof t == "object" && typeof t.then == "function" ? t.then(
      function(l) {
        Mr(e, a, l);
      },
      function(l) {
        return Au(e, a, l);
      }
    ) : Mr(e, a, t);
  }
  function Mr(e, a, t) {
    a.status = "fulfilled", a.value = t, Rr(a), e.state = t, a = e.pending, a !== null && (t = a.next, t === a ? e.pending = null : (t = t.next, a.next = t, Tr(e, t)));
  }
  function Au(e, a, t) {
    var l = e.pending;
    if (e.pending = null, l !== null) {
      l = l.next;
      do
        a.status = "rejected", a.reason = t, Rr(a), a = a.next;
      while (a !== l);
    }
    e.action = null;
  }
  function Rr(e) {
    e = e.listeners;
    for (var a = 0; a < e.length; a++) (0, e[a])();
  }
  function Dr(e, a) {
    return a;
  }
  function Ur(e, a) {
    if (ue) {
      var t = Se.formState;
      if (t !== null) {
        e: {
          var l = W;
          if (ue) {
            if (ze) {
              a: {
                for (var n = ze, s = ba; n.nodeType !== 8; ) {
                  if (!s) {
                    n = null;
                    break a;
                  }
                  if (n = za(
                    n.nextSibling
                  ), n === null) {
                    n = null;
                    break a;
                  }
                }
                s = n.data, n = s === "F!" || s === "F" ? n : null;
              }
              if (n) {
                ze = za(
                  n.nextSibling
                ), l = n.data === "F!";
                break e;
              }
            }
            ut(l);
          }
          l = !1;
        }
        l && (a = t[0]);
      }
    }
    return t = $e(), t.memoizedState = t.baseState = a, l = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Dr,
      lastRenderedState: a
    }, t.queue = l, t = Fr.bind(
      null,
      W,
      l
    ), l.dispatch = t, l = Eu(!1), s = Du.bind(
      null,
      W,
      !1,
      l.queue
    ), l = $e(), n = {
      state: a,
      dispatch: null,
      action: e,
      pending: null
    }, l.queue = n, t = wh.bind(
      null,
      W,
      n,
      s,
      t
    ), n.dispatch = t, l.memoizedState = e, [a, t, !1];
  }
  function Cr(e) {
    var a = Ue();
    return _r(a, xe, e);
  }
  function _r(e, a, t) {
    if (a = Su(
      e,
      a,
      Dr
    )[0], e = zi(wa)[0], typeof a == "object" && a !== null && typeof a.then == "function")
      try {
        var l = hn(a);
      } catch (u) {
        throw u === xl ? mi : u;
      }
    else l = a;
    a = Ue();
    var n = a.queue, s = n.dispatch;
    return t !== a.memoizedState && (W.flags |= 2048, zl(
      9,
      { destroy: void 0 },
      Kh.bind(null, n, t),
      null
    )), [l, s, e];
  }
  function Kh(e, a) {
    e.action = a;
  }
  function qr(e) {
    var a = Ue(), t = xe;
    if (t !== null)
      return _r(a, t, e);
    Ue(), a = a.memoizedState, t = Ue();
    var l = t.queue.dispatch;
    return t.memoizedState = e, [a, l, !1];
  }
  function zl(e, a, t, l) {
    return e = { tag: e, create: t, deps: l, inst: a, next: null }, a = W.updateQueue, a === null && (a = bi(), W.updateQueue = a), t = a.lastEffect, t === null ? a.lastEffect = e.next = e : (l = t.next, t.next = e, e.next = l, a.lastEffect = e), e;
  }
  function Hr() {
    return Ue().memoizedState;
  }
  function Ei(e, a, t, l) {
    var n = $e();
    W.flags |= e, n.memoizedState = zl(
      1 | a,
      { destroy: void 0 },
      t,
      l === void 0 ? null : l
    );
  }
  function Ai(e, a, t, l) {
    var n = Ue();
    l = l === void 0 ? null : l;
    var s = n.memoizedState.inst;
    xe !== null && l !== null && vu(l, xe.memoizedState.deps) ? n.memoizedState = zl(a, s, t, l) : (W.flags |= e, n.memoizedState = zl(
      1 | a,
      s,
      t,
      l
    ));
  }
  function Br(e, a) {
    Ei(8390656, 8, e, a);
  }
  function Nu(e, a) {
    Ai(2048, 8, e, a);
  }
  function Jh(e) {
    W.flags |= 4;
    var a = W.updateQueue;
    if (a === null)
      a = bi(), W.updateQueue = a, a.events = [e];
    else {
      var t = a.events;
      t === null ? a.events = [e] : t.push(e);
    }
  }
  function Lr(e) {
    var a = Ue().memoizedState;
    return Jh({ ref: a, nextImpl: e }), function() {
      if ((fe & 2) !== 0) throw Error(o(440));
      return a.impl.apply(void 0, arguments);
    };
  }
  function Yr(e, a) {
    return Ai(4, 2, e, a);
  }
  function Gr(e, a) {
    return Ai(4, 4, e, a);
  }
  function Vr(e, a) {
    if (typeof a == "function") {
      e = e();
      var t = a(e);
      return function() {
        typeof t == "function" ? t() : a(null);
      };
    }
    if (a != null)
      return e = e(), a.current = e, function() {
        a.current = null;
      };
  }
  function Qr(e, a, t) {
    t = t != null ? t.concat([e]) : null, Ai(4, 4, Vr.bind(null, a, e), t);
  }
  function Tu() {
  }
  function Xr(e, a) {
    var t = Ue();
    a = a === void 0 ? null : a;
    var l = t.memoizedState;
    return a !== null && vu(a, l[1]) ? l[0] : (t.memoizedState = [e, a], e);
  }
  function Zr(e, a) {
    var t = Ue();
    a = a === void 0 ? null : a;
    var l = t.memoizedState;
    if (a !== null && vu(a, l[1]))
      return l[0];
    if (l = e(), wt) {
      tt(!0);
      try {
        e();
      } finally {
        tt(!1);
      }
    }
    return t.memoizedState = [l, a], l;
  }
  function Ou(e, a, t) {
    return t === void 0 || (ka & 1073741824) !== 0 && (ie & 261930) === 0 ? e.memoizedState = a : (e.memoizedState = t, e = kd(), W.lanes |= e, vt |= e, t);
  }
  function kr(e, a, t, l) {
    return ca(t, a) ? t : jl.current !== null ? (e = Ou(e, t, l), ca(e, a) || (qe = !0), e) : (ka & 42) === 0 || (ka & 1073741824) !== 0 && (ie & 261930) === 0 ? (qe = !0, e.memoizedState = t) : (e = kd(), W.lanes |= e, vt |= e, a);
  }
  function wr(e, a, t, l, n) {
    var s = U.p;
    U.p = s !== 0 && 8 > s ? s : 8;
    var u = T.T, c = {};
    T.T = c, Du(e, !1, a, t);
    try {
      var d = n(), g = T.S;
      if (g !== null && g(c, d), d !== null && typeof d == "object" && typeof d.then == "function") {
        var N = Xh(
          d,
          l
        );
        pn(
          e,
          a,
          N,
          ha(e)
        );
      } else
        pn(
          e,
          a,
          l,
          ha(e)
        );
    } catch (R) {
      pn(
        e,
        a,
        { then: function() {
        }, status: "rejected", reason: R },
        ha()
      );
    } finally {
      U.p = s, u !== null && c.types !== null && (u.types = c.types), T.T = u;
    }
  }
  function $h() {
  }
  function Mu(e, a, t, l) {
    if (e.tag !== 5) throw Error(o(476));
    var n = Kr(e).queue;
    wr(
      e,
      n,
      a,
      K,
      t === null ? $h : function() {
        return Jr(e), t(l);
      }
    );
  }
  function Kr(e) {
    var a = e.memoizedState;
    if (a !== null) return a;
    a = {
      memoizedState: K,
      baseState: K,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: wa,
        lastRenderedState: K
      },
      next: null
    };
    var t = {};
    return a.next = {
      memoizedState: t,
      baseState: t,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: wa,
        lastRenderedState: t
      },
      next: null
    }, e.memoizedState = a, e = e.alternate, e !== null && (e.memoizedState = a), a;
  }
  function Jr(e) {
    var a = Kr(e);
    a.next === null && (a = e.alternate.memoizedState), pn(
      e,
      a.next.queue,
      {},
      ha()
    );
  }
  function Ru() {
    return Ze(Un);
  }
  function $r() {
    return Ue().memoizedState;
  }
  function Wr() {
    return Ue().memoizedState;
  }
  function Wh(e) {
    for (var a = e.return; a !== null; ) {
      switch (a.tag) {
        case 24:
        case 3:
          var t = ha();
          e = rt(t);
          var l = dt(a, e, t);
          l !== null && (la(l, a, t), rn(l, a, t)), a = { cache: iu() }, e.payload = a;
          return;
      }
      a = a.return;
    }
  }
  function Fh(e, a, t) {
    var l = ha();
    t = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: t,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Ni(e) ? Ir(a, t) : (t = Js(e, a, t, l), t !== null && (la(t, e, l), Pr(t, a, l)));
  }
  function Fr(e, a, t) {
    var l = ha();
    pn(e, a, t, l);
  }
  function pn(e, a, t, l) {
    var n = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: t,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Ni(e)) Ir(a, n);
    else {
      var s = e.alternate;
      if (e.lanes === 0 && (s === null || s.lanes === 0) && (s = a.lastRenderedReducer, s !== null))
        try {
          var u = a.lastRenderedState, c = s(u, t);
          if (n.hasEagerState = !0, n.eagerState = c, ca(c, u))
            return si(e, a, n, 0), Se === null && ii(), !1;
        } catch {
        } finally {
        }
      if (t = Js(e, a, n, l), t !== null)
        return la(t, e, l), Pr(t, a, l), !0;
    }
    return !1;
  }
  function Du(e, a, t, l) {
    if (l = {
      lane: 2,
      revertLane: oc(),
      gesture: null,
      action: l,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Ni(e)) {
      if (a) throw Error(o(479));
    } else
      a = Js(
        e,
        t,
        l,
        2
      ), a !== null && la(a, e, 2);
  }
  function Ni(e) {
    var a = e.alternate;
    return e === W || a !== null && a === W;
  }
  function Ir(e, a) {
    bl = gi = !0;
    var t = e.pending;
    t === null ? a.next = a : (a.next = t.next, t.next = a), e.pending = a;
  }
  function Pr(e, a, t) {
    if ((t & 4194048) !== 0) {
      var l = a.lanes;
      l &= e.pendingLanes, t |= l, a.lanes = t, lo(e, t);
    }
  }
  var vn = {
    readContext: Ze,
    use: Si,
    useCallback: Te,
    useContext: Te,
    useEffect: Te,
    useImperativeHandle: Te,
    useLayoutEffect: Te,
    useInsertionEffect: Te,
    useMemo: Te,
    useReducer: Te,
    useRef: Te,
    useState: Te,
    useDebugValue: Te,
    useDeferredValue: Te,
    useTransition: Te,
    useSyncExternalStore: Te,
    useId: Te,
    useHostTransitionStatus: Te,
    useFormState: Te,
    useActionState: Te,
    useOptimistic: Te,
    useMemoCache: Te,
    useCacheRefresh: Te
  };
  vn.useEffectEvent = Te;
  var ed = {
    readContext: Ze,
    use: Si,
    useCallback: function(e, a) {
      return $e().memoizedState = [
        e,
        a === void 0 ? null : a
      ], e;
    },
    useContext: Ze,
    useEffect: Br,
    useImperativeHandle: function(e, a, t) {
      t = t != null ? t.concat([e]) : null, Ei(
        4194308,
        4,
        Vr.bind(null, a, e),
        t
      );
    },
    useLayoutEffect: function(e, a) {
      return Ei(4194308, 4, e, a);
    },
    useInsertionEffect: function(e, a) {
      Ei(4, 2, e, a);
    },
    useMemo: function(e, a) {
      var t = $e();
      a = a === void 0 ? null : a;
      var l = e();
      if (wt) {
        tt(!0);
        try {
          e();
        } finally {
          tt(!1);
        }
      }
      return t.memoizedState = [l, a], l;
    },
    useReducer: function(e, a, t) {
      var l = $e();
      if (t !== void 0) {
        var n = t(a);
        if (wt) {
          tt(!0);
          try {
            t(a);
          } finally {
            tt(!1);
          }
        }
      } else n = a;
      return l.memoizedState = l.baseState = n, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: n
      }, l.queue = e, e = e.dispatch = Fh.bind(
        null,
        W,
        e
      ), [l.memoizedState, e];
    },
    useRef: function(e) {
      var a = $e();
      return e = { current: e }, a.memoizedState = e;
    },
    useState: function(e) {
      e = Eu(e);
      var a = e.queue, t = Fr.bind(null, W, a);
      return a.dispatch = t, [e.memoizedState, t];
    },
    useDebugValue: Tu,
    useDeferredValue: function(e, a) {
      var t = $e();
      return Ou(t, e, a);
    },
    useTransition: function() {
      var e = Eu(!1);
      return e = wr.bind(
        null,
        W,
        e.queue,
        !0,
        !1
      ), $e().memoizedState = e, [!1, e];
    },
    useSyncExternalStore: function(e, a, t) {
      var l = W, n = $e();
      if (ue) {
        if (t === void 0)
          throw Error(o(407));
        t = t();
      } else {
        if (t = a(), Se === null)
          throw Error(o(349));
        (ie & 127) !== 0 || br(l, a, t);
      }
      n.memoizedState = t;
      var s = { value: t, getSnapshot: a };
      return n.queue = s, Br(zr.bind(null, l, s, e), [
        e
      ]), l.flags |= 2048, zl(
        9,
        { destroy: void 0 },
        Sr.bind(
          null,
          l,
          s,
          t,
          a
        ),
        null
      ), t;
    },
    useId: function() {
      var e = $e(), a = Se.identifierPrefix;
      if (ue) {
        var t = Ua, l = Da;
        t = (l & ~(1 << 32 - ua(l) - 1)).toString(32) + t, a = "_" + a + "R_" + t, t = ji++, 0 < t && (a += "H" + t.toString(32)), a += "_";
      } else
        t = Zh++, a = "_" + a + "r_" + t.toString(32) + "_";
      return e.memoizedState = a;
    },
    useHostTransitionStatus: Ru,
    useFormState: Ur,
    useActionState: Ur,
    useOptimistic: function(e) {
      var a = $e();
      a.memoizedState = a.baseState = e;
      var t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return a.queue = t, a = Du.bind(
        null,
        W,
        !0,
        t
      ), t.dispatch = a, [e, a];
    },
    useMemoCache: bu,
    useCacheRefresh: function() {
      return $e().memoizedState = Wh.bind(
        null,
        W
      );
    },
    useEffectEvent: function(e) {
      var a = $e(), t = { impl: e };
      return a.memoizedState = t, function() {
        if ((fe & 2) !== 0)
          throw Error(o(440));
        return t.impl.apply(void 0, arguments);
      };
    }
  }, Uu = {
    readContext: Ze,
    use: Si,
    useCallback: Xr,
    useContext: Ze,
    useEffect: Nu,
    useImperativeHandle: Qr,
    useInsertionEffect: Yr,
    useLayoutEffect: Gr,
    useMemo: Zr,
    useReducer: zi,
    useRef: Hr,
    useState: function() {
      return zi(wa);
    },
    useDebugValue: Tu,
    useDeferredValue: function(e, a) {
      var t = Ue();
      return kr(
        t,
        xe.memoizedState,
        e,
        a
      );
    },
    useTransition: function() {
      var e = zi(wa)[0], a = Ue().memoizedState;
      return [
        typeof e == "boolean" ? e : hn(e),
        a
      ];
    },
    useSyncExternalStore: jr,
    useId: $r,
    useHostTransitionStatus: Ru,
    useFormState: Cr,
    useActionState: Cr,
    useOptimistic: function(e, a) {
      var t = Ue();
      return Nr(t, xe, e, a);
    },
    useMemoCache: bu,
    useCacheRefresh: Wr
  };
  Uu.useEffectEvent = Lr;
  var ad = {
    readContext: Ze,
    use: Si,
    useCallback: Xr,
    useContext: Ze,
    useEffect: Nu,
    useImperativeHandle: Qr,
    useInsertionEffect: Yr,
    useLayoutEffect: Gr,
    useMemo: Zr,
    useReducer: zu,
    useRef: Hr,
    useState: function() {
      return zu(wa);
    },
    useDebugValue: Tu,
    useDeferredValue: function(e, a) {
      var t = Ue();
      return xe === null ? Ou(t, e, a) : kr(
        t,
        xe.memoizedState,
        e,
        a
      );
    },
    useTransition: function() {
      var e = zu(wa)[0], a = Ue().memoizedState;
      return [
        typeof e == "boolean" ? e : hn(e),
        a
      ];
    },
    useSyncExternalStore: jr,
    useId: $r,
    useHostTransitionStatus: Ru,
    useFormState: qr,
    useActionState: qr,
    useOptimistic: function(e, a) {
      var t = Ue();
      return xe !== null ? Nr(t, xe, e, a) : (t.baseState = e, [e, t.queue.dispatch]);
    },
    useMemoCache: bu,
    useCacheRefresh: Wr
  };
  ad.useEffectEvent = Lr;
  function Cu(e, a, t, l) {
    a = e.memoizedState, t = t(l, a), t = t == null ? a : _({}, a, t), e.memoizedState = t, e.lanes === 0 && (e.updateQueue.baseState = t);
  }
  var _u = {
    enqueueSetState: function(e, a, t) {
      e = e._reactInternals;
      var l = ha(), n = rt(l);
      n.payload = a, t != null && (n.callback = t), a = dt(e, n, l), a !== null && (la(a, e, l), rn(a, e, l));
    },
    enqueueReplaceState: function(e, a, t) {
      e = e._reactInternals;
      var l = ha(), n = rt(l);
      n.tag = 1, n.payload = a, t != null && (n.callback = t), a = dt(e, n, l), a !== null && (la(a, e, l), rn(a, e, l));
    },
    enqueueForceUpdate: function(e, a) {
      e = e._reactInternals;
      var t = ha(), l = rt(t);
      l.tag = 2, a != null && (l.callback = a), a = dt(e, l, t), a !== null && (la(a, e, t), rn(a, e, t));
    }
  };
  function td(e, a, t, l, n, s, u) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(l, s, u) : a.prototype && a.prototype.isPureReactComponent ? !an(t, l) || !an(n, s) : !0;
  }
  function ld(e, a, t, l) {
    e = a.state, typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(t, l), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(t, l), a.state !== e && _u.enqueueReplaceState(a, a.state, null);
  }
  function Kt(e, a) {
    var t = a;
    if ("ref" in a) {
      t = {};
      for (var l in a)
        l !== "ref" && (t[l] = a[l]);
    }
    if (e = e.defaultProps) {
      t === a && (t = _({}, t));
      for (var n in e)
        t[n] === void 0 && (t[n] = e[n]);
    }
    return t;
  }
  function nd(e) {
    ni(e);
  }
  function id(e) {
    console.error(e);
  }
  function sd(e) {
    ni(e);
  }
  function Ti(e, a) {
    try {
      var t = e.onUncaughtError;
      t(a.value, { componentStack: a.stack });
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  function ud(e, a, t) {
    try {
      var l = e.onCaughtError;
      l(t.value, {
        componentStack: t.stack,
        errorBoundary: a.tag === 1 ? a.stateNode : null
      });
    } catch (n) {
      setTimeout(function() {
        throw n;
      });
    }
  }
  function qu(e, a, t) {
    return t = rt(t), t.tag = 3, t.payload = { element: null }, t.callback = function() {
      Ti(e, a);
    }, t;
  }
  function cd(e) {
    return e = rt(e), e.tag = 3, e;
  }
  function od(e, a, t, l) {
    var n = t.type.getDerivedStateFromError;
    if (typeof n == "function") {
      var s = l.value;
      e.payload = function() {
        return n(s);
      }, e.callback = function() {
        ud(a, t, l);
      };
    }
    var u = t.stateNode;
    u !== null && typeof u.componentDidCatch == "function" && (e.callback = function() {
      ud(a, t, l), typeof n != "function" && (yt === null ? yt = /* @__PURE__ */ new Set([this]) : yt.add(this));
      var c = l.stack;
      this.componentDidCatch(l.value, {
        componentStack: c !== null ? c : ""
      });
    });
  }
  function Ih(e, a, t, l, n) {
    if (t.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
      if (a = t.alternate, a !== null && pl(
        a,
        t,
        n,
        !0
      ), t = ra.current, t !== null) {
        switch (t.tag) {
          case 31:
          case 13:
            return Sa === null ? Yi() : t.alternate === null && Oe === 0 && (Oe = 3), t.flags &= -257, t.flags |= 65536, t.lanes = n, l === hi ? t.flags |= 16384 : (a = t.updateQueue, a === null ? t.updateQueue = /* @__PURE__ */ new Set([l]) : a.add(l), sc(e, l, n)), !1;
          case 22:
            return t.flags |= 65536, l === hi ? t.flags |= 16384 : (a = t.updateQueue, a === null ? (a = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([l])
            }, t.updateQueue = a) : (t = a.retryQueue, t === null ? a.retryQueue = /* @__PURE__ */ new Set([l]) : t.add(l)), sc(e, l, n)), !1;
        }
        throw Error(o(435, t.tag));
      }
      return sc(e, l, n), Yi(), !1;
    }
    if (ue)
      return a = ra.current, a !== null ? ((a.flags & 65536) === 0 && (a.flags |= 256), a.flags |= 65536, a.lanes = n, l !== eu && (e = Error(o(422), { cause: l }), nn(xa(e, t)))) : (l !== eu && (a = Error(o(423), {
        cause: l
      }), nn(
        xa(a, t)
      )), e = e.current.alternate, e.flags |= 65536, n &= -n, e.lanes |= n, l = xa(l, t), n = qu(
        e.stateNode,
        l,
        n
      ), du(e, n), Oe !== 4 && (Oe = 2)), !1;
    var s = Error(o(520), { cause: l });
    if (s = xa(s, t), En === null ? En = [s] : En.push(s), Oe !== 4 && (Oe = 2), a === null) return !0;
    l = xa(l, t), t = a;
    do {
      switch (t.tag) {
        case 3:
          return t.flags |= 65536, e = n & -n, t.lanes |= e, e = qu(t.stateNode, l, e), du(t, e), !1;
        case 1:
          if (a = t.type, s = t.stateNode, (t.flags & 128) === 0 && (typeof a.getDerivedStateFromError == "function" || s !== null && typeof s.componentDidCatch == "function" && (yt === null || !yt.has(s))))
            return t.flags |= 65536, n &= -n, t.lanes |= n, n = cd(n), od(
              n,
              e,
              t,
              l
            ), du(t, n), !1;
      }
      t = t.return;
    } while (t !== null);
    return !1;
  }
  var Hu = Error(o(461)), qe = !1;
  function ke(e, a, t, l) {
    a.child = e === null ? mr(a, null, t, l) : kt(
      a,
      e.child,
      t,
      l
    );
  }
  function rd(e, a, t, l, n) {
    t = t.render;
    var s = a.ref;
    if ("ref" in l) {
      var u = {};
      for (var c in l)
        c !== "ref" && (u[c] = l[c]);
    } else u = l;
    return Vt(a), l = yu(
      e,
      a,
      t,
      u,
      s,
      n
    ), c = xu(), e !== null && !qe ? (gu(e, a, n), Ka(e, a, n)) : (ue && c && Is(a), a.flags |= 1, ke(e, a, l, n), a.child);
  }
  function dd(e, a, t, l, n) {
    if (e === null) {
      var s = t.type;
      return typeof s == "function" && !$s(s) && s.defaultProps === void 0 && t.compare === null ? (a.tag = 15, a.type = s, fd(
        e,
        a,
        s,
        l,
        n
      )) : (e = ci(
        t.type,
        null,
        l,
        a,
        a.mode,
        n
      ), e.ref = a.ref, e.return = a, a.child = e);
    }
    if (s = e.child, !Zu(e, n)) {
      var u = s.memoizedProps;
      if (t = t.compare, t = t !== null ? t : an, t(u, l) && e.ref === a.ref)
        return Ka(e, a, n);
    }
    return a.flags |= 1, e = Va(s, l), e.ref = a.ref, e.return = a, a.child = e;
  }
  function fd(e, a, t, l, n) {
    if (e !== null) {
      var s = e.memoizedProps;
      if (an(s, l) && e.ref === a.ref)
        if (qe = !1, a.pendingProps = l = s, Zu(e, n))
          (e.flags & 131072) !== 0 && (qe = !0);
        else
          return a.lanes = e.lanes, Ka(e, a, n);
    }
    return Bu(
      e,
      a,
      t,
      l,
      n
    );
  }
  function md(e, a, t, l) {
    var n = l.children, s = e !== null ? e.memoizedState : null;
    if (e === null && a.stateNode === null && (a.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), l.mode === "hidden") {
      if ((a.flags & 128) !== 0) {
        if (s = s !== null ? s.baseLanes | t : t, e !== null) {
          for (l = a.child = e.child, n = 0; l !== null; )
            n = n | l.lanes | l.childLanes, l = l.sibling;
          l = n & ~s;
        } else l = 0, a.child = null;
        return hd(
          e,
          a,
          s,
          t,
          l
        );
      }
      if ((t & 536870912) !== 0)
        a.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && fi(
          a,
          s !== null ? s.cachePool : null
        ), s !== null ? vr(a, s) : mu(), yr(a);
      else
        return l = a.lanes = 536870912, hd(
          e,
          a,
          s !== null ? s.baseLanes | t : t,
          t,
          l
        );
    } else
      s !== null ? (fi(a, s.cachePool), vr(a, s), mt(), a.memoizedState = null) : (e !== null && fi(a, null), mu(), mt());
    return ke(e, a, n, t), a.child;
  }
  function yn(e, a) {
    return e !== null && e.tag === 22 || a.stateNode !== null || (a.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.sibling;
  }
  function hd(e, a, t, l, n) {
    var s = uu();
    return s = s === null ? null : { parent: Ce._currentValue, pool: s }, a.memoizedState = {
      baseLanes: t,
      cachePool: s
    }, e !== null && fi(a, null), mu(), yr(a), e !== null && pl(e, a, l, !0), a.childLanes = n, null;
  }
  function Oi(e, a) {
    return a = Ri(
      { mode: a.mode, children: a.children },
      e.mode
    ), a.ref = e.ref, e.child = a, a.return = e, a;
  }
  function pd(e, a, t) {
    return kt(a, e.child, null, t), e = Oi(a, a.pendingProps), e.flags |= 2, da(a), a.memoizedState = null, e;
  }
  function Ph(e, a, t) {
    var l = a.pendingProps, n = (a.flags & 128) !== 0;
    if (a.flags &= -129, e === null) {
      if (ue) {
        if (l.mode === "hidden")
          return e = Oi(a, l), a.lanes = 536870912, yn(null, e);
        if (pu(a), (e = ze) ? (e = Of(
          e,
          ba
        ), e = e !== null && e.data === "&" ? e : null, e !== null && (a.memoizedState = {
          dehydrated: e,
          treeContext: it !== null ? { id: Da, overflow: Ua } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, t = Io(e), t.return = a, a.child = t, Xe = a, ze = null)) : e = null, e === null) throw ut(a);
        return a.lanes = 536870912, null;
      }
      return Oi(a, l);
    }
    var s = e.memoizedState;
    if (s !== null) {
      var u = s.dehydrated;
      if (pu(a), n)
        if (a.flags & 256)
          a.flags &= -257, a = pd(
            e,
            a,
            t
          );
        else if (a.memoizedState !== null)
          a.child = e.child, a.flags |= 128, a = null;
        else throw Error(o(558));
      else if (qe || pl(e, a, t, !1), n = (t & e.childLanes) !== 0, qe || n) {
        if (l = Se, l !== null && (u = no(l, t), u !== 0 && u !== s.retryLane))
          throw s.retryLane = u, Bt(e, u), la(l, e, u), Hu;
        Yi(), a = pd(
          e,
          a,
          t
        );
      } else
        e = s.treeContext, ze = za(u.nextSibling), Xe = a, ue = !0, st = null, ba = !1, e !== null && ar(a, e), a = Oi(a, l), a.flags |= 4096;
      return a;
    }
    return e = Va(e.child, {
      mode: l.mode,
      children: l.children
    }), e.ref = a.ref, a.child = e, e.return = a, e;
  }
  function Mi(e, a) {
    var t = a.ref;
    if (t === null)
      e !== null && e.ref !== null && (a.flags |= 4194816);
    else {
      if (typeof t != "function" && typeof t != "object")
        throw Error(o(284));
      (e === null || e.ref !== t) && (a.flags |= 4194816);
    }
  }
  function Bu(e, a, t, l, n) {
    return Vt(a), t = yu(
      e,
      a,
      t,
      l,
      void 0,
      n
    ), l = xu(), e !== null && !qe ? (gu(e, a, n), Ka(e, a, n)) : (ue && l && Is(a), a.flags |= 1, ke(e, a, t, n), a.child);
  }
  function vd(e, a, t, l, n, s) {
    return Vt(a), a.updateQueue = null, t = gr(
      a,
      l,
      t,
      n
    ), xr(e), l = xu(), e !== null && !qe ? (gu(e, a, s), Ka(e, a, s)) : (ue && l && Is(a), a.flags |= 1, ke(e, a, t, s), a.child);
  }
  function yd(e, a, t, l, n) {
    if (Vt(a), a.stateNode === null) {
      var s = dl, u = t.contextType;
      typeof u == "object" && u !== null && (s = Ze(u)), s = new t(l, s), a.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, s.updater = _u, a.stateNode = s, s._reactInternals = a, s = a.stateNode, s.props = l, s.state = a.memoizedState, s.refs = {}, ou(a), u = t.contextType, s.context = typeof u == "object" && u !== null ? Ze(u) : dl, s.state = a.memoizedState, u = t.getDerivedStateFromProps, typeof u == "function" && (Cu(
        a,
        t,
        u,
        l
      ), s.state = a.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof s.getSnapshotBeforeUpdate == "function" || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (u = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), u !== s.state && _u.enqueueReplaceState(s, s.state, null), fn(a, l, s, n), dn(), s.state = a.memoizedState), typeof s.componentDidMount == "function" && (a.flags |= 4194308), l = !0;
    } else if (e === null) {
      s = a.stateNode;
      var c = a.memoizedProps, d = Kt(t, c);
      s.props = d;
      var g = s.context, N = t.contextType;
      u = dl, typeof N == "object" && N !== null && (u = Ze(N));
      var R = t.getDerivedStateFromProps;
      N = typeof R == "function" || typeof s.getSnapshotBeforeUpdate == "function", c = a.pendingProps !== c, N || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (c || g !== u) && ld(
        a,
        s,
        l,
        u
      ), ot = !1;
      var j = a.memoizedState;
      s.state = j, fn(a, l, s, n), dn(), g = a.memoizedState, c || j !== g || ot ? (typeof R == "function" && (Cu(
        a,
        t,
        R,
        l
      ), g = a.memoizedState), (d = ot || td(
        a,
        t,
        d,
        l,
        j,
        g,
        u
      )) ? (N || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount()), typeof s.componentDidMount == "function" && (a.flags |= 4194308)) : (typeof s.componentDidMount == "function" && (a.flags |= 4194308), a.memoizedProps = l, a.memoizedState = g), s.props = l, s.state = g, s.context = u, l = d) : (typeof s.componentDidMount == "function" && (a.flags |= 4194308), l = !1);
    } else {
      s = a.stateNode, ru(e, a), u = a.memoizedProps, N = Kt(t, u), s.props = N, R = a.pendingProps, j = s.context, g = t.contextType, d = dl, typeof g == "object" && g !== null && (d = Ze(g)), c = t.getDerivedStateFromProps, (g = typeof c == "function" || typeof s.getSnapshotBeforeUpdate == "function") || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (u !== R || j !== d) && ld(
        a,
        s,
        l,
        d
      ), ot = !1, j = a.memoizedState, s.state = j, fn(a, l, s, n), dn();
      var z = a.memoizedState;
      u !== R || j !== z || ot || e !== null && e.dependencies !== null && ri(e.dependencies) ? (typeof c == "function" && (Cu(
        a,
        t,
        c,
        l
      ), z = a.memoizedState), (N = ot || td(
        a,
        t,
        N,
        l,
        j,
        z,
        d
      ) || e !== null && e.dependencies !== null && ri(e.dependencies)) ? (g || typeof s.UNSAFE_componentWillUpdate != "function" && typeof s.componentWillUpdate != "function" || (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(l, z, d), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(
        l,
        z,
        d
      )), typeof s.componentDidUpdate == "function" && (a.flags |= 4), typeof s.getSnapshotBeforeUpdate == "function" && (a.flags |= 1024)) : (typeof s.componentDidUpdate != "function" || u === e.memoizedProps && j === e.memoizedState || (a.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && j === e.memoizedState || (a.flags |= 1024), a.memoizedProps = l, a.memoizedState = z), s.props = l, s.state = z, s.context = d, l = N) : (typeof s.componentDidUpdate != "function" || u === e.memoizedProps && j === e.memoizedState || (a.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && j === e.memoizedState || (a.flags |= 1024), l = !1);
    }
    return s = l, Mi(e, a), l = (a.flags & 128) !== 0, s || l ? (s = a.stateNode, t = l && typeof t.getDerivedStateFromError != "function" ? null : s.render(), a.flags |= 1, e !== null && l ? (a.child = kt(
      a,
      e.child,
      null,
      n
    ), a.child = kt(
      a,
      null,
      t,
      n
    )) : ke(e, a, t, n), a.memoizedState = s.state, e = a.child) : e = Ka(
      e,
      a,
      n
    ), e;
  }
  function xd(e, a, t, l) {
    return Yt(), a.flags |= 256, ke(e, a, t, l), a.child;
  }
  var Lu = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Yu(e) {
    return { baseLanes: e, cachePool: ur() };
  }
  function Gu(e, a, t) {
    return e = e !== null ? e.childLanes & ~t : 0, a && (e |= ma), e;
  }
  function gd(e, a, t) {
    var l = a.pendingProps, n = !1, s = (a.flags & 128) !== 0, u;
    if ((u = s) || (u = e !== null && e.memoizedState === null ? !1 : (De.current & 2) !== 0), u && (n = !0, a.flags &= -129), u = (a.flags & 32) !== 0, a.flags &= -33, e === null) {
      if (ue) {
        if (n ? ft(a) : mt(), (e = ze) ? (e = Of(
          e,
          ba
        ), e = e !== null && e.data !== "&" ? e : null, e !== null && (a.memoizedState = {
          dehydrated: e,
          treeContext: it !== null ? { id: Da, overflow: Ua } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, t = Io(e), t.return = a, a.child = t, Xe = a, ze = null)) : e = null, e === null) throw ut(a);
        return Sc(e) ? a.lanes = 32 : a.lanes = 536870912, null;
      }
      var c = l.children;
      return l = l.fallback, n ? (mt(), n = a.mode, c = Ri(
        { mode: "hidden", children: c },
        n
      ), l = Lt(
        l,
        n,
        t,
        null
      ), c.return = a, l.return = a, c.sibling = l, a.child = c, l = a.child, l.memoizedState = Yu(t), l.childLanes = Gu(
        e,
        u,
        t
      ), a.memoizedState = Lu, yn(null, l)) : (ft(a), Vu(a, c));
    }
    var d = e.memoizedState;
    if (d !== null && (c = d.dehydrated, c !== null)) {
      if (s)
        a.flags & 256 ? (ft(a), a.flags &= -257, a = Qu(
          e,
          a,
          t
        )) : a.memoizedState !== null ? (mt(), a.child = e.child, a.flags |= 128, a = null) : (mt(), c = l.fallback, n = a.mode, l = Ri(
          { mode: "visible", children: l.children },
          n
        ), c = Lt(
          c,
          n,
          t,
          null
        ), c.flags |= 2, l.return = a, c.return = a, l.sibling = c, a.child = l, kt(
          a,
          e.child,
          null,
          t
        ), l = a.child, l.memoizedState = Yu(t), l.childLanes = Gu(
          e,
          u,
          t
        ), a.memoizedState = Lu, a = yn(null, l));
      else if (ft(a), Sc(c)) {
        if (u = c.nextSibling && c.nextSibling.dataset, u) var g = u.dgst;
        u = g, l = Error(o(419)), l.stack = "", l.digest = u, nn({ value: l, source: null, stack: null }), a = Qu(
          e,
          a,
          t
        );
      } else if (qe || pl(e, a, t, !1), u = (t & e.childLanes) !== 0, qe || u) {
        if (u = Se, u !== null && (l = no(u, t), l !== 0 && l !== d.retryLane))
          throw d.retryLane = l, Bt(e, l), la(u, e, l), Hu;
        bc(c) || Yi(), a = Qu(
          e,
          a,
          t
        );
      } else
        bc(c) ? (a.flags |= 192, a.child = e.child, a = null) : (e = d.treeContext, ze = za(
          c.nextSibling
        ), Xe = a, ue = !0, st = null, ba = !1, e !== null && ar(a, e), a = Vu(
          a,
          l.children
        ), a.flags |= 4096);
      return a;
    }
    return n ? (mt(), c = l.fallback, n = a.mode, d = e.child, g = d.sibling, l = Va(d, {
      mode: "hidden",
      children: l.children
    }), l.subtreeFlags = d.subtreeFlags & 65011712, g !== null ? c = Va(
      g,
      c
    ) : (c = Lt(
      c,
      n,
      t,
      null
    ), c.flags |= 2), c.return = a, l.return = a, l.sibling = c, a.child = l, yn(null, l), l = a.child, c = e.child.memoizedState, c === null ? c = Yu(t) : (n = c.cachePool, n !== null ? (d = Ce._currentValue, n = n.parent !== d ? { parent: d, pool: d } : n) : n = ur(), c = {
      baseLanes: c.baseLanes | t,
      cachePool: n
    }), l.memoizedState = c, l.childLanes = Gu(
      e,
      u,
      t
    ), a.memoizedState = Lu, yn(e.child, l)) : (ft(a), t = e.child, e = t.sibling, t = Va(t, {
      mode: "visible",
      children: l.children
    }), t.return = a, t.sibling = null, e !== null && (u = a.deletions, u === null ? (a.deletions = [e], a.flags |= 16) : u.push(e)), a.child = t, a.memoizedState = null, t);
  }
  function Vu(e, a) {
    return a = Ri(
      { mode: "visible", children: a },
      e.mode
    ), a.return = e, e.child = a;
  }
  function Ri(e, a) {
    return e = oa(22, e, null, a), e.lanes = 0, e;
  }
  function Qu(e, a, t) {
    return kt(a, e.child, null, t), e = Vu(
      a,
      a.pendingProps.children
    ), e.flags |= 2, a.memoizedState = null, e;
  }
  function jd(e, a, t) {
    e.lanes |= a;
    var l = e.alternate;
    l !== null && (l.lanes |= a), lu(e.return, a, t);
  }
  function Xu(e, a, t, l, n, s) {
    var u = e.memoizedState;
    u === null ? e.memoizedState = {
      isBackwards: a,
      rendering: null,
      renderingStartTime: 0,
      last: l,
      tail: t,
      tailMode: n,
      treeForkCount: s
    } : (u.isBackwards = a, u.rendering = null, u.renderingStartTime = 0, u.last = l, u.tail = t, u.tailMode = n, u.treeForkCount = s);
  }
  function bd(e, a, t) {
    var l = a.pendingProps, n = l.revealOrder, s = l.tail;
    l = l.children;
    var u = De.current, c = (u & 2) !== 0;
    if (c ? (u = u & 1 | 2, a.flags |= 128) : u &= 1, C(De, u), ke(e, a, l, t), l = ue ? ln : 0, !c && e !== null && (e.flags & 128) !== 0)
      e: for (e = a.child; e !== null; ) {
        if (e.tag === 13)
          e.memoizedState !== null && jd(e, t, a);
        else if (e.tag === 19)
          jd(e, t, a);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === a) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === a)
            break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    switch (n) {
      case "forwards":
        for (t = a.child, n = null; t !== null; )
          e = t.alternate, e !== null && xi(e) === null && (n = t), t = t.sibling;
        t = n, t === null ? (n = a.child, a.child = null) : (n = t.sibling, t.sibling = null), Xu(
          a,
          !1,
          n,
          t,
          s,
          l
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (t = null, n = a.child, a.child = null; n !== null; ) {
          if (e = n.alternate, e !== null && xi(e) === null) {
            a.child = n;
            break;
          }
          e = n.sibling, n.sibling = t, t = n, n = e;
        }
        Xu(
          a,
          !0,
          t,
          null,
          s,
          l
        );
        break;
      case "together":
        Xu(
          a,
          !1,
          null,
          null,
          void 0,
          l
        );
        break;
      default:
        a.memoizedState = null;
    }
    return a.child;
  }
  function Ka(e, a, t) {
    if (e !== null && (a.dependencies = e.dependencies), vt |= a.lanes, (t & a.childLanes) === 0)
      if (e !== null) {
        if (pl(
          e,
          a,
          t,
          !1
        ), (t & a.childLanes) === 0)
          return null;
      } else return null;
    if (e !== null && a.child !== e.child)
      throw Error(o(153));
    if (a.child !== null) {
      for (e = a.child, t = Va(e, e.pendingProps), a.child = t, t.return = a; e.sibling !== null; )
        e = e.sibling, t = t.sibling = Va(e, e.pendingProps), t.return = a;
      t.sibling = null;
    }
    return a.child;
  }
  function Zu(e, a) {
    return (e.lanes & a) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && ri(e)));
  }
  function ep(e, a, t) {
    switch (a.tag) {
      case 3:
        Je(a, a.stateNode.containerInfo), ct(a, Ce, e.memoizedState.cache), Yt();
        break;
      case 27:
      case 5:
        Ql(a);
        break;
      case 4:
        Je(a, a.stateNode.containerInfo);
        break;
      case 10:
        ct(
          a,
          a.type,
          a.memoizedProps.value
        );
        break;
      case 31:
        if (a.memoizedState !== null)
          return a.flags |= 128, pu(a), null;
        break;
      case 13:
        var l = a.memoizedState;
        if (l !== null)
          return l.dehydrated !== null ? (ft(a), a.flags |= 128, null) : (t & a.child.childLanes) !== 0 ? gd(e, a, t) : (ft(a), e = Ka(
            e,
            a,
            t
          ), e !== null ? e.sibling : null);
        ft(a);
        break;
      case 19:
        var n = (e.flags & 128) !== 0;
        if (l = (t & a.childLanes) !== 0, l || (pl(
          e,
          a,
          t,
          !1
        ), l = (t & a.childLanes) !== 0), n) {
          if (l)
            return bd(
              e,
              a,
              t
            );
          a.flags |= 128;
        }
        if (n = a.memoizedState, n !== null && (n.rendering = null, n.tail = null, n.lastEffect = null), C(De, De.current), l) break;
        return null;
      case 22:
        return a.lanes = 0, md(
          e,
          a,
          t,
          a.pendingProps
        );
      case 24:
        ct(a, Ce, e.memoizedState.cache);
    }
    return Ka(e, a, t);
  }
  function Sd(e, a, t) {
    if (e !== null)
      if (e.memoizedProps !== a.pendingProps)
        qe = !0;
      else {
        if (!Zu(e, t) && (a.flags & 128) === 0)
          return qe = !1, ep(
            e,
            a,
            t
          );
        qe = (e.flags & 131072) !== 0;
      }
    else
      qe = !1, ue && (a.flags & 1048576) !== 0 && er(a, ln, a.index);
    switch (a.lanes = 0, a.tag) {
      case 16:
        e: {
          var l = a.pendingProps;
          if (e = Xt(a.elementType), a.type = e, typeof e == "function")
            $s(e) ? (l = Kt(e, l), a.tag = 1, a = yd(
              null,
              a,
              e,
              l,
              t
            )) : (a.tag = 0, a = Bu(
              null,
              a,
              e,
              l,
              t
            ));
          else {
            if (e != null) {
              var n = e.$$typeof;
              if (n === Me) {
                a.tag = 11, a = rd(
                  null,
                  a,
                  e,
                  l,
                  t
                );
                break e;
              } else if (n === Y) {
                a.tag = 14, a = dd(
                  null,
                  a,
                  e,
                  l,
                  t
                );
                break e;
              }
            }
            throw a = Ba(e) || e, Error(o(306, a, ""));
          }
        }
        return a;
      case 0:
        return Bu(
          e,
          a,
          a.type,
          a.pendingProps,
          t
        );
      case 1:
        return l = a.type, n = Kt(
          l,
          a.pendingProps
        ), yd(
          e,
          a,
          l,
          n,
          t
        );
      case 3:
        e: {
          if (Je(
            a,
            a.stateNode.containerInfo
          ), e === null) throw Error(o(387));
          l = a.pendingProps;
          var s = a.memoizedState;
          n = s.element, ru(e, a), fn(a, l, null, t);
          var u = a.memoizedState;
          if (l = u.cache, ct(a, Ce, l), l !== s.cache && nu(
            a,
            [Ce],
            t,
            !0
          ), dn(), l = u.element, s.isDehydrated)
            if (s = {
              element: l,
              isDehydrated: !1,
              cache: u.cache
            }, a.updateQueue.baseState = s, a.memoizedState = s, a.flags & 256) {
              a = xd(
                e,
                a,
                l,
                t
              );
              break e;
            } else if (l !== n) {
              n = xa(
                Error(o(424)),
                a
              ), nn(n), a = xd(
                e,
                a,
                l,
                t
              );
              break e;
            } else {
              switch (e = a.stateNode.containerInfo, e.nodeType) {
                case 9:
                  e = e.body;
                  break;
                default:
                  e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
              }
              for (ze = za(e.firstChild), Xe = a, ue = !0, st = null, ba = !0, t = mr(
                a,
                null,
                l,
                t
              ), a.child = t; t; )
                t.flags = t.flags & -3 | 4096, t = t.sibling;
            }
          else {
            if (Yt(), l === n) {
              a = Ka(
                e,
                a,
                t
              );
              break e;
            }
            ke(e, a, l, t);
          }
          a = a.child;
        }
        return a;
      case 26:
        return Mi(e, a), e === null ? (t = _f(
          a.type,
          null,
          a.pendingProps,
          null
        )) ? a.memoizedState = t : ue || (t = a.type, e = a.pendingProps, l = wi(
          ae.current
        ).createElement(t), l[Qe] = a, l[Fe] = e, we(l, t, e), Ge(l), a.stateNode = l) : a.memoizedState = _f(
          a.type,
          e.memoizedProps,
          a.pendingProps,
          e.memoizedState
        ), null;
      case 27:
        return Ql(a), e === null && ue && (l = a.stateNode = Df(
          a.type,
          a.pendingProps,
          ae.current
        ), Xe = a, ba = !0, n = ze, bt(a.type) ? (zc = n, ze = za(l.firstChild)) : ze = n), ke(
          e,
          a,
          a.pendingProps.children,
          t
        ), Mi(e, a), e === null && (a.flags |= 4194304), a.child;
      case 5:
        return e === null && ue && ((n = l = ze) && (l = Rp(
          l,
          a.type,
          a.pendingProps,
          ba
        ), l !== null ? (a.stateNode = l, Xe = a, ze = za(l.firstChild), ba = !1, n = !0) : n = !1), n || ut(a)), Ql(a), n = a.type, s = a.pendingProps, u = e !== null ? e.memoizedProps : null, l = s.children, xc(n, s) ? l = null : u !== null && xc(n, u) && (a.flags |= 32), a.memoizedState !== null && (n = yu(
          e,
          a,
          kh,
          null,
          null,
          t
        ), Un._currentValue = n), Mi(e, a), ke(e, a, l, t), a.child;
      case 6:
        return e === null && ue && ((e = t = ze) && (t = Dp(
          t,
          a.pendingProps,
          ba
        ), t !== null ? (a.stateNode = t, Xe = a, ze = null, e = !0) : e = !1), e || ut(a)), null;
      case 13:
        return gd(e, a, t);
      case 4:
        return Je(
          a,
          a.stateNode.containerInfo
        ), l = a.pendingProps, e === null ? a.child = kt(
          a,
          null,
          l,
          t
        ) : ke(e, a, l, t), a.child;
      case 11:
        return rd(
          e,
          a,
          a.type,
          a.pendingProps,
          t
        );
      case 7:
        return ke(
          e,
          a,
          a.pendingProps,
          t
        ), a.child;
      case 8:
        return ke(
          e,
          a,
          a.pendingProps.children,
          t
        ), a.child;
      case 12:
        return ke(
          e,
          a,
          a.pendingProps.children,
          t
        ), a.child;
      case 10:
        return l = a.pendingProps, ct(a, a.type, l.value), ke(e, a, l.children, t), a.child;
      case 9:
        return n = a.type._context, l = a.pendingProps.children, Vt(a), n = Ze(n), l = l(n), a.flags |= 1, ke(e, a, l, t), a.child;
      case 14:
        return dd(
          e,
          a,
          a.type,
          a.pendingProps,
          t
        );
      case 15:
        return fd(
          e,
          a,
          a.type,
          a.pendingProps,
          t
        );
      case 19:
        return bd(e, a, t);
      case 31:
        return Ph(e, a, t);
      case 22:
        return md(
          e,
          a,
          t,
          a.pendingProps
        );
      case 24:
        return Vt(a), l = Ze(Ce), e === null ? (n = uu(), n === null && (n = Se, s = iu(), n.pooledCache = s, s.refCount++, s !== null && (n.pooledCacheLanes |= t), n = s), a.memoizedState = { parent: l, cache: n }, ou(a), ct(a, Ce, n)) : ((e.lanes & t) !== 0 && (ru(e, a), fn(a, null, null, t), dn()), n = e.memoizedState, s = a.memoizedState, n.parent !== l ? (n = { parent: l, cache: l }, a.memoizedState = n, a.lanes === 0 && (a.memoizedState = a.updateQueue.baseState = n), ct(a, Ce, l)) : (l = s.cache, ct(a, Ce, l), l !== n.cache && nu(
          a,
          [Ce],
          t,
          !0
        ))), ke(
          e,
          a,
          a.pendingProps.children,
          t
        ), a.child;
      case 29:
        throw a.pendingProps;
    }
    throw Error(o(156, a.tag));
  }
  function Ja(e) {
    e.flags |= 4;
  }
  function ku(e, a, t, l, n) {
    if ((a = (e.mode & 32) !== 0) && (a = !1), a) {
      if (e.flags |= 16777216, (n & 335544128) === n)
        if (e.stateNode.complete) e.flags |= 8192;
        else if ($d()) e.flags |= 8192;
        else
          throw Zt = hi, cu;
    } else e.flags &= -16777217;
  }
  function zd(e, a) {
    if (a.type !== "stylesheet" || (a.state.loading & 4) !== 0)
      e.flags &= -16777217;
    else if (e.flags |= 16777216, !Yf(a))
      if ($d()) e.flags |= 8192;
      else
        throw Zt = hi, cu;
  }
  function Di(e, a) {
    a !== null && (e.flags |= 4), e.flags & 16384 && (a = e.tag !== 22 ? ao() : 536870912, e.lanes |= a, Tl |= a);
  }
  function xn(e, a) {
    if (!ue)
      switch (e.tailMode) {
        case "hidden":
          a = e.tail;
          for (var t = null; a !== null; )
            a.alternate !== null && (t = a), a = a.sibling;
          t === null ? e.tail = null : t.sibling = null;
          break;
        case "collapsed":
          t = e.tail;
          for (var l = null; t !== null; )
            t.alternate !== null && (l = t), t = t.sibling;
          l === null ? a || e.tail === null ? e.tail = null : e.tail.sibling = null : l.sibling = null;
      }
  }
  function Ee(e) {
    var a = e.alternate !== null && e.alternate.child === e.child, t = 0, l = 0;
    if (a)
      for (var n = e.child; n !== null; )
        t |= n.lanes | n.childLanes, l |= n.subtreeFlags & 65011712, l |= n.flags & 65011712, n.return = e, n = n.sibling;
    else
      for (n = e.child; n !== null; )
        t |= n.lanes | n.childLanes, l |= n.subtreeFlags, l |= n.flags, n.return = e, n = n.sibling;
    return e.subtreeFlags |= l, e.childLanes = t, a;
  }
  function ap(e, a, t) {
    var l = a.pendingProps;
    switch (Ps(a), a.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ee(a), null;
      case 1:
        return Ee(a), null;
      case 3:
        return t = a.stateNode, l = null, e !== null && (l = e.memoizedState.cache), a.memoizedState.cache !== l && (a.flags |= 2048), Za(Ce), Re(), t.pendingContext && (t.context = t.pendingContext, t.pendingContext = null), (e === null || e.child === null) && (hl(a) ? Ja(a) : e === null || e.memoizedState.isDehydrated && (a.flags & 256) === 0 || (a.flags |= 1024, au())), Ee(a), null;
      case 26:
        var n = a.type, s = a.memoizedState;
        return e === null ? (Ja(a), s !== null ? (Ee(a), zd(a, s)) : (Ee(a), ku(
          a,
          n,
          null,
          l,
          t
        ))) : s ? s !== e.memoizedState ? (Ja(a), Ee(a), zd(a, s)) : (Ee(a), a.flags &= -16777217) : (e = e.memoizedProps, e !== l && Ja(a), Ee(a), ku(
          a,
          n,
          e,
          l,
          t
        )), null;
      case 27:
        if (Qn(a), t = ae.current, n = a.type, e !== null && a.stateNode != null)
          e.memoizedProps !== l && Ja(a);
        else {
          if (!l) {
            if (a.stateNode === null)
              throw Error(o(166));
            return Ee(a), null;
          }
          e = G.current, hl(a) ? tr(a) : (e = Df(n, l, t), a.stateNode = e, Ja(a));
        }
        return Ee(a), null;
      case 5:
        if (Qn(a), n = a.type, e !== null && a.stateNode != null)
          e.memoizedProps !== l && Ja(a);
        else {
          if (!l) {
            if (a.stateNode === null)
              throw Error(o(166));
            return Ee(a), null;
          }
          if (s = G.current, hl(a))
            tr(a);
          else {
            var u = wi(
              ae.current
            );
            switch (s) {
              case 1:
                s = u.createElementNS(
                  "http://www.w3.org/2000/svg",
                  n
                );
                break;
              case 2:
                s = u.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  n
                );
                break;
              default:
                switch (n) {
                  case "svg":
                    s = u.createElementNS(
                      "http://www.w3.org/2000/svg",
                      n
                    );
                    break;
                  case "math":
                    s = u.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      n
                    );
                    break;
                  case "script":
                    s = u.createElement("div"), s.innerHTML = "<script><\/script>", s = s.removeChild(
                      s.firstChild
                    );
                    break;
                  case "select":
                    s = typeof l.is == "string" ? u.createElement("select", {
                      is: l.is
                    }) : u.createElement("select"), l.multiple ? s.multiple = !0 : l.size && (s.size = l.size);
                    break;
                  default:
                    s = typeof l.is == "string" ? u.createElement(n, { is: l.is }) : u.createElement(n);
                }
            }
            s[Qe] = a, s[Fe] = l;
            e: for (u = a.child; u !== null; ) {
              if (u.tag === 5 || u.tag === 6)
                s.appendChild(u.stateNode);
              else if (u.tag !== 4 && u.tag !== 27 && u.child !== null) {
                u.child.return = u, u = u.child;
                continue;
              }
              if (u === a) break e;
              for (; u.sibling === null; ) {
                if (u.return === null || u.return === a)
                  break e;
                u = u.return;
              }
              u.sibling.return = u.return, u = u.sibling;
            }
            a.stateNode = s;
            e: switch (we(s, n, l), n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                l = !!l.autoFocus;
                break e;
              case "img":
                l = !0;
                break e;
              default:
                l = !1;
            }
            l && Ja(a);
          }
        }
        return Ee(a), ku(
          a,
          a.type,
          e === null ? null : e.memoizedProps,
          a.pendingProps,
          t
        ), null;
      case 6:
        if (e && a.stateNode != null)
          e.memoizedProps !== l && Ja(a);
        else {
          if (typeof l != "string" && a.stateNode === null)
            throw Error(o(166));
          if (e = ae.current, hl(a)) {
            if (e = a.stateNode, t = a.memoizedProps, l = null, n = Xe, n !== null)
              switch (n.tag) {
                case 27:
                case 5:
                  l = n.memoizedProps;
              }
            e[Qe] = a, e = !!(e.nodeValue === t || l !== null && l.suppressHydrationWarning === !0 || jf(e.nodeValue, t)), e || ut(a, !0);
          } else
            e = wi(e).createTextNode(
              l
            ), e[Qe] = a, a.stateNode = e;
        }
        return Ee(a), null;
      case 31:
        if (t = a.memoizedState, e === null || e.memoizedState !== null) {
          if (l = hl(a), t !== null) {
            if (e === null) {
              if (!l) throw Error(o(318));
              if (e = a.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(557));
              e[Qe] = a;
            } else
              Yt(), (a.flags & 128) === 0 && (a.memoizedState = null), a.flags |= 4;
            Ee(a), e = !1;
          } else
            t = au(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = t), e = !0;
          if (!e)
            return a.flags & 256 ? (da(a), a) : (da(a), null);
          if ((a.flags & 128) !== 0)
            throw Error(o(558));
        }
        return Ee(a), null;
      case 13:
        if (l = a.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (n = hl(a), l !== null && l.dehydrated !== null) {
            if (e === null) {
              if (!n) throw Error(o(318));
              if (n = a.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(o(317));
              n[Qe] = a;
            } else
              Yt(), (a.flags & 128) === 0 && (a.memoizedState = null), a.flags |= 4;
            Ee(a), n = !1;
          } else
            n = au(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), n = !0;
          if (!n)
            return a.flags & 256 ? (da(a), a) : (da(a), null);
        }
        return da(a), (a.flags & 128) !== 0 ? (a.lanes = t, a) : (t = l !== null, e = e !== null && e.memoizedState !== null, t && (l = a.child, n = null, l.alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (n = l.alternate.memoizedState.cachePool.pool), s = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (s = l.memoizedState.cachePool.pool), s !== n && (l.flags |= 2048)), t !== e && t && (a.child.flags |= 8192), Di(a, a.updateQueue), Ee(a), null);
      case 4:
        return Re(), e === null && mc(a.stateNode.containerInfo), Ee(a), null;
      case 10:
        return Za(a.type), Ee(a), null;
      case 19:
        if (D(De), l = a.memoizedState, l === null) return Ee(a), null;
        if (n = (a.flags & 128) !== 0, s = l.rendering, s === null)
          if (n) xn(l, !1);
          else {
            if (Oe !== 0 || e !== null && (e.flags & 128) !== 0)
              for (e = a.child; e !== null; ) {
                if (s = xi(e), s !== null) {
                  for (a.flags |= 128, xn(l, !1), e = s.updateQueue, a.updateQueue = e, Di(a, e), a.subtreeFlags = 0, e = t, t = a.child; t !== null; )
                    Fo(t, e), t = t.sibling;
                  return C(
                    De,
                    De.current & 1 | 2
                  ), ue && Qa(a, l.treeForkCount), a.child;
                }
                e = e.sibling;
              }
            l.tail !== null && ia() > Hi && (a.flags |= 128, n = !0, xn(l, !1), a.lanes = 4194304);
          }
        else {
          if (!n)
            if (e = xi(s), e !== null) {
              if (a.flags |= 128, n = !0, e = e.updateQueue, a.updateQueue = e, Di(a, e), xn(l, !0), l.tail === null && l.tailMode === "hidden" && !s.alternate && !ue)
                return Ee(a), null;
            } else
              2 * ia() - l.renderingStartTime > Hi && t !== 536870912 && (a.flags |= 128, n = !0, xn(l, !1), a.lanes = 4194304);
          l.isBackwards ? (s.sibling = a.child, a.child = s) : (e = l.last, e !== null ? e.sibling = s : a.child = s, l.last = s);
        }
        return l.tail !== null ? (e = l.tail, l.rendering = e, l.tail = e.sibling, l.renderingStartTime = ia(), e.sibling = null, t = De.current, C(
          De,
          n ? t & 1 | 2 : t & 1
        ), ue && Qa(a, l.treeForkCount), e) : (Ee(a), null);
      case 22:
      case 23:
        return da(a), hu(), l = a.memoizedState !== null, e !== null ? e.memoizedState !== null !== l && (a.flags |= 8192) : l && (a.flags |= 8192), l ? (t & 536870912) !== 0 && (a.flags & 128) === 0 && (Ee(a), a.subtreeFlags & 6 && (a.flags |= 8192)) : Ee(a), t = a.updateQueue, t !== null && Di(a, t.retryQueue), t = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), l = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (l = a.memoizedState.cachePool.pool), l !== t && (a.flags |= 2048), e !== null && D(Qt), null;
      case 24:
        return t = null, e !== null && (t = e.memoizedState.cache), a.memoizedState.cache !== t && (a.flags |= 2048), Za(Ce), Ee(a), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(o(156, a.tag));
  }
  function tp(e, a) {
    switch (Ps(a), a.tag) {
      case 1:
        return e = a.flags, e & 65536 ? (a.flags = e & -65537 | 128, a) : null;
      case 3:
        return Za(Ce), Re(), e = a.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (a.flags = e & -65537 | 128, a) : null;
      case 26:
      case 27:
      case 5:
        return Qn(a), null;
      case 31:
        if (a.memoizedState !== null) {
          if (da(a), a.alternate === null)
            throw Error(o(340));
          Yt();
        }
        return e = a.flags, e & 65536 ? (a.flags = e & -65537 | 128, a) : null;
      case 13:
        if (da(a), e = a.memoizedState, e !== null && e.dehydrated !== null) {
          if (a.alternate === null)
            throw Error(o(340));
          Yt();
        }
        return e = a.flags, e & 65536 ? (a.flags = e & -65537 | 128, a) : null;
      case 19:
        return D(De), null;
      case 4:
        return Re(), null;
      case 10:
        return Za(a.type), null;
      case 22:
      case 23:
        return da(a), hu(), e !== null && D(Qt), e = a.flags, e & 65536 ? (a.flags = e & -65537 | 128, a) : null;
      case 24:
        return Za(Ce), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Ed(e, a) {
    switch (Ps(a), a.tag) {
      case 3:
        Za(Ce), Re();
        break;
      case 26:
      case 27:
      case 5:
        Qn(a);
        break;
      case 4:
        Re();
        break;
      case 31:
        a.memoizedState !== null && da(a);
        break;
      case 13:
        da(a);
        break;
      case 19:
        D(De);
        break;
      case 10:
        Za(a.type);
        break;
      case 22:
      case 23:
        da(a), hu(), e !== null && D(Qt);
        break;
      case 24:
        Za(Ce);
    }
  }
  function gn(e, a) {
    try {
      var t = a.updateQueue, l = t !== null ? t.lastEffect : null;
      if (l !== null) {
        var n = l.next;
        t = n;
        do {
          if ((t.tag & e) === e) {
            l = void 0;
            var s = t.create, u = t.inst;
            l = s(), u.destroy = l;
          }
          t = t.next;
        } while (t !== n);
      }
    } catch (c) {
      pe(a, a.return, c);
    }
  }
  function ht(e, a, t) {
    try {
      var l = a.updateQueue, n = l !== null ? l.lastEffect : null;
      if (n !== null) {
        var s = n.next;
        l = s;
        do {
          if ((l.tag & e) === e) {
            var u = l.inst, c = u.destroy;
            if (c !== void 0) {
              u.destroy = void 0, n = a;
              var d = t, g = c;
              try {
                g();
              } catch (N) {
                pe(
                  n,
                  d,
                  N
                );
              }
            }
          }
          l = l.next;
        } while (l !== s);
      }
    } catch (N) {
      pe(a, a.return, N);
    }
  }
  function Ad(e) {
    var a = e.updateQueue;
    if (a !== null) {
      var t = e.stateNode;
      try {
        pr(a, t);
      } catch (l) {
        pe(e, e.return, l);
      }
    }
  }
  function Nd(e, a, t) {
    t.props = Kt(
      e.type,
      e.memoizedProps
    ), t.state = e.memoizedState;
    try {
      t.componentWillUnmount();
    } catch (l) {
      pe(e, a, l);
    }
  }
  function jn(e, a) {
    try {
      var t = e.ref;
      if (t !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var l = e.stateNode;
            break;
          case 30:
            l = e.stateNode;
            break;
          default:
            l = e.stateNode;
        }
        typeof t == "function" ? e.refCleanup = t(l) : t.current = l;
      }
    } catch (n) {
      pe(e, a, n);
    }
  }
  function Ca(e, a) {
    var t = e.ref, l = e.refCleanup;
    if (t !== null)
      if (typeof l == "function")
        try {
          l();
        } catch (n) {
          pe(e, a, n);
        } finally {
          e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
        }
      else if (typeof t == "function")
        try {
          t(null);
        } catch (n) {
          pe(e, a, n);
        }
      else t.current = null;
  }
  function Td(e) {
    var a = e.type, t = e.memoizedProps, l = e.stateNode;
    try {
      e: switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          t.autoFocus && l.focus();
          break e;
        case "img":
          t.src ? l.src = t.src : t.srcSet && (l.srcset = t.srcSet);
      }
    } catch (n) {
      pe(e, e.return, n);
    }
  }
  function wu(e, a, t) {
    try {
      var l = e.stateNode;
      Ep(l, e.type, t, a), l[Fe] = a;
    } catch (n) {
      pe(e, e.return, n);
    }
  }
  function Od(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && bt(e.type) || e.tag === 4;
  }
  function Ku(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || Od(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.tag === 27 && bt(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function Ju(e, a, t) {
    var l = e.tag;
    if (l === 5 || l === 6)
      e = e.stateNode, a ? (t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t).insertBefore(e, a) : (a = t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t, a.appendChild(e), t = t._reactRootContainer, t != null || a.onclick !== null || (a.onclick = Ya));
    else if (l !== 4 && (l === 27 && bt(e.type) && (t = e.stateNode, a = null), e = e.child, e !== null))
      for (Ju(e, a, t), e = e.sibling; e !== null; )
        Ju(e, a, t), e = e.sibling;
  }
  function Ui(e, a, t) {
    var l = e.tag;
    if (l === 5 || l === 6)
      e = e.stateNode, a ? t.insertBefore(e, a) : t.appendChild(e);
    else if (l !== 4 && (l === 27 && bt(e.type) && (t = e.stateNode), e = e.child, e !== null))
      for (Ui(e, a, t), e = e.sibling; e !== null; )
        Ui(e, a, t), e = e.sibling;
  }
  function Md(e) {
    var a = e.stateNode, t = e.memoizedProps;
    try {
      for (var l = e.type, n = a.attributes; n.length; )
        a.removeAttributeNode(n[0]);
      we(a, l, t), a[Qe] = e, a[Fe] = t;
    } catch (s) {
      pe(e, e.return, s);
    }
  }
  var $a = !1, He = !1, $u = !1, Rd = typeof WeakSet == "function" ? WeakSet : Set, Ve = null;
  function lp(e, a) {
    if (e = e.containerInfo, vc = Pi, e = Qo(e), Qs(e)) {
      if ("selectionStart" in e)
        var t = {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      else
        e: {
          t = (t = e.ownerDocument) && t.defaultView || window;
          var l = t.getSelection && t.getSelection();
          if (l && l.rangeCount !== 0) {
            t = l.anchorNode;
            var n = l.anchorOffset, s = l.focusNode;
            l = l.focusOffset;
            try {
              t.nodeType, s.nodeType;
            } catch {
              t = null;
              break e;
            }
            var u = 0, c = -1, d = -1, g = 0, N = 0, R = e, j = null;
            a: for (; ; ) {
              for (var z; R !== t || n !== 0 && R.nodeType !== 3 || (c = u + n), R !== s || l !== 0 && R.nodeType !== 3 || (d = u + l), R.nodeType === 3 && (u += R.nodeValue.length), (z = R.firstChild) !== null; )
                j = R, R = z;
              for (; ; ) {
                if (R === e) break a;
                if (j === t && ++g === n && (c = u), j === s && ++N === l && (d = u), (z = R.nextSibling) !== null) break;
                R = j, j = R.parentNode;
              }
              R = z;
            }
            t = c === -1 || d === -1 ? null : { start: c, end: d };
          } else t = null;
        }
      t = t || { start: 0, end: 0 };
    } else t = null;
    for (yc = { focusedElem: e, selectionRange: t }, Pi = !1, Ve = a; Ve !== null; )
      if (a = Ve, e = a.child, (a.subtreeFlags & 1028) !== 0 && e !== null)
        e.return = a, Ve = e;
      else
        for (; Ve !== null; ) {
          switch (a = Ve, s = a.alternate, e = a.flags, a.tag) {
            case 0:
              if ((e & 4) !== 0 && (e = a.updateQueue, e = e !== null ? e.events : null, e !== null))
                for (t = 0; t < e.length; t++)
                  n = e[t], n.ref.impl = n.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((e & 1024) !== 0 && s !== null) {
                e = void 0, t = a, n = s.memoizedProps, s = s.memoizedState, l = t.stateNode;
                try {
                  var B = Kt(
                    t.type,
                    n
                  );
                  e = l.getSnapshotBeforeUpdate(
                    B,
                    s
                  ), l.__reactInternalSnapshotBeforeUpdate = e;
                } catch (Z) {
                  pe(
                    t,
                    t.return,
                    Z
                  );
                }
              }
              break;
            case 3:
              if ((e & 1024) !== 0) {
                if (e = a.stateNode.containerInfo, t = e.nodeType, t === 9)
                  jc(e);
                else if (t === 1)
                  switch (e.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      jc(e);
                      break;
                    default:
                      e.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((e & 1024) !== 0) throw Error(o(163));
          }
          if (e = a.sibling, e !== null) {
            e.return = a.return, Ve = e;
            break;
          }
          Ve = a.return;
        }
  }
  function Dd(e, a, t) {
    var l = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Fa(e, t), l & 4 && gn(5, t);
        break;
      case 1:
        if (Fa(e, t), l & 4)
          if (e = t.stateNode, a === null)
            try {
              e.componentDidMount();
            } catch (u) {
              pe(t, t.return, u);
            }
          else {
            var n = Kt(
              t.type,
              a.memoizedProps
            );
            a = a.memoizedState;
            try {
              e.componentDidUpdate(
                n,
                a,
                e.__reactInternalSnapshotBeforeUpdate
              );
            } catch (u) {
              pe(
                t,
                t.return,
                u
              );
            }
          }
        l & 64 && Ad(t), l & 512 && jn(t, t.return);
        break;
      case 3:
        if (Fa(e, t), l & 64 && (e = t.updateQueue, e !== null)) {
          if (a = null, t.child !== null)
            switch (t.child.tag) {
              case 27:
              case 5:
                a = t.child.stateNode;
                break;
              case 1:
                a = t.child.stateNode;
            }
          try {
            pr(e, a);
          } catch (u) {
            pe(t, t.return, u);
          }
        }
        break;
      case 27:
        a === null && l & 4 && Md(t);
      case 26:
      case 5:
        Fa(e, t), a === null && l & 4 && Td(t), l & 512 && jn(t, t.return);
        break;
      case 12:
        Fa(e, t);
        break;
      case 31:
        Fa(e, t), l & 4 && _d(e, t);
        break;
      case 13:
        Fa(e, t), l & 4 && qd(e, t), l & 64 && (e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null && (t = fp.bind(
          null,
          t
        ), Up(e, t))));
        break;
      case 22:
        if (l = t.memoizedState !== null || $a, !l) {
          a = a !== null && a.memoizedState !== null || He, n = $a;
          var s = He;
          $a = l, (He = a) && !s ? Ia(
            e,
            t,
            (t.subtreeFlags & 8772) !== 0
          ) : Fa(e, t), $a = n, He = s;
        }
        break;
      case 30:
        break;
      default:
        Fa(e, t);
    }
  }
  function Ud(e) {
    var a = e.alternate;
    a !== null && (e.alternate = null, Ud(a)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (a = e.stateNode, a !== null && As(a)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  var Ae = null, Pe = !1;
  function Wa(e, a, t) {
    for (t = t.child; t !== null; )
      Cd(e, a, t), t = t.sibling;
  }
  function Cd(e, a, t) {
    if (sa && typeof sa.onCommitFiberUnmount == "function")
      try {
        sa.onCommitFiberUnmount(Xl, t);
      } catch {
      }
    switch (t.tag) {
      case 26:
        He || Ca(t, a), Wa(
          e,
          a,
          t
        ), t.memoizedState ? t.memoizedState.count-- : t.stateNode && (t = t.stateNode, t.parentNode.removeChild(t));
        break;
      case 27:
        He || Ca(t, a);
        var l = Ae, n = Pe;
        bt(t.type) && (Ae = t.stateNode, Pe = !1), Wa(
          e,
          a,
          t
        ), Mn(t.stateNode), Ae = l, Pe = n;
        break;
      case 5:
        He || Ca(t, a);
      case 6:
        if (l = Ae, n = Pe, Ae = null, Wa(
          e,
          a,
          t
        ), Ae = l, Pe = n, Ae !== null)
          if (Pe)
            try {
              (Ae.nodeType === 9 ? Ae.body : Ae.nodeName === "HTML" ? Ae.ownerDocument.body : Ae).removeChild(t.stateNode);
            } catch (s) {
              pe(
                t,
                a,
                s
              );
            }
          else
            try {
              Ae.removeChild(t.stateNode);
            } catch (s) {
              pe(
                t,
                a,
                s
              );
            }
        break;
      case 18:
        Ae !== null && (Pe ? (e = Ae, Nf(
          e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
          t.stateNode
        ), ql(e)) : Nf(Ae, t.stateNode));
        break;
      case 4:
        l = Ae, n = Pe, Ae = t.stateNode.containerInfo, Pe = !0, Wa(
          e,
          a,
          t
        ), Ae = l, Pe = n;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        ht(2, t, a), He || ht(4, t, a), Wa(
          e,
          a,
          t
        );
        break;
      case 1:
        He || (Ca(t, a), l = t.stateNode, typeof l.componentWillUnmount == "function" && Nd(
          t,
          a,
          l
        )), Wa(
          e,
          a,
          t
        );
        break;
      case 21:
        Wa(
          e,
          a,
          t
        );
        break;
      case 22:
        He = (l = He) || t.memoizedState !== null, Wa(
          e,
          a,
          t
        ), He = l;
        break;
      default:
        Wa(
          e,
          a,
          t
        );
    }
  }
  function _d(e, a) {
    if (a.memoizedState === null && (e = a.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        ql(e);
      } catch (t) {
        pe(a, a.return, t);
      }
    }
  }
  function qd(e, a) {
    if (a.memoizedState === null && (e = a.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
      try {
        ql(e);
      } catch (t) {
        pe(a, a.return, t);
      }
  }
  function np(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var a = e.stateNode;
        return a === null && (a = e.stateNode = new Rd()), a;
      case 22:
        return e = e.stateNode, a = e._retryCache, a === null && (a = e._retryCache = new Rd()), a;
      default:
        throw Error(o(435, e.tag));
    }
  }
  function Ci(e, a) {
    var t = np(e);
    a.forEach(function(l) {
      if (!t.has(l)) {
        t.add(l);
        var n = mp.bind(null, e, l);
        l.then(n, n);
      }
    });
  }
  function ea(e, a) {
    var t = a.deletions;
    if (t !== null)
      for (var l = 0; l < t.length; l++) {
        var n = t[l], s = e, u = a, c = u;
        e: for (; c !== null; ) {
          switch (c.tag) {
            case 27:
              if (bt(c.type)) {
                Ae = c.stateNode, Pe = !1;
                break e;
              }
              break;
            case 5:
              Ae = c.stateNode, Pe = !1;
              break e;
            case 3:
            case 4:
              Ae = c.stateNode.containerInfo, Pe = !0;
              break e;
          }
          c = c.return;
        }
        if (Ae === null) throw Error(o(160));
        Cd(s, u, n), Ae = null, Pe = !1, s = n.alternate, s !== null && (s.return = null), n.return = null;
      }
    if (a.subtreeFlags & 13886)
      for (a = a.child; a !== null; )
        Hd(a, e), a = a.sibling;
  }
  var Oa = null;
  function Hd(e, a) {
    var t = e.alternate, l = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ea(a, e), aa(e), l & 4 && (ht(3, e, e.return), gn(3, e), ht(5, e, e.return));
        break;
      case 1:
        ea(a, e), aa(e), l & 512 && (He || t === null || Ca(t, t.return)), l & 64 && $a && (e = e.updateQueue, e !== null && (l = e.callbacks, l !== null && (t = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = t === null ? l : t.concat(l))));
        break;
      case 26:
        var n = Oa;
        if (ea(a, e), aa(e), l & 512 && (He || t === null || Ca(t, t.return)), l & 4) {
          var s = t !== null ? t.memoizedState : null;
          if (l = e.memoizedState, t === null)
            if (l === null)
              if (e.stateNode === null) {
                e: {
                  l = e.type, t = e.memoizedProps, n = n.ownerDocument || n;
                  a: switch (l) {
                    case "title":
                      s = n.getElementsByTagName("title")[0], (!s || s[wl] || s[Qe] || s.namespaceURI === "http://www.w3.org/2000/svg" || s.hasAttribute("itemprop")) && (s = n.createElement(l), n.head.insertBefore(
                        s,
                        n.querySelector("head > title")
                      )), we(s, l, t), s[Qe] = e, Ge(s), l = s;
                      break e;
                    case "link":
                      var u = Bf(
                        "link",
                        "href",
                        n
                      ).get(l + (t.href || ""));
                      if (u) {
                        for (var c = 0; c < u.length; c++)
                          if (s = u[c], s.getAttribute("href") === (t.href == null || t.href === "" ? null : t.href) && s.getAttribute("rel") === (t.rel == null ? null : t.rel) && s.getAttribute("title") === (t.title == null ? null : t.title) && s.getAttribute("crossorigin") === (t.crossOrigin == null ? null : t.crossOrigin)) {
                            u.splice(c, 1);
                            break a;
                          }
                      }
                      s = n.createElement(l), we(s, l, t), n.head.appendChild(s);
                      break;
                    case "meta":
                      if (u = Bf(
                        "meta",
                        "content",
                        n
                      ).get(l + (t.content || ""))) {
                        for (c = 0; c < u.length; c++)
                          if (s = u[c], s.getAttribute("content") === (t.content == null ? null : "" + t.content) && s.getAttribute("name") === (t.name == null ? null : t.name) && s.getAttribute("property") === (t.property == null ? null : t.property) && s.getAttribute("http-equiv") === (t.httpEquiv == null ? null : t.httpEquiv) && s.getAttribute("charset") === (t.charSet == null ? null : t.charSet)) {
                            u.splice(c, 1);
                            break a;
                          }
                      }
                      s = n.createElement(l), we(s, l, t), n.head.appendChild(s);
                      break;
                    default:
                      throw Error(o(468, l));
                  }
                  s[Qe] = e, Ge(s), l = s;
                }
                e.stateNode = l;
              } else
                Lf(
                  n,
                  e.type,
                  e.stateNode
                );
            else
              e.stateNode = Hf(
                n,
                l,
                e.memoizedProps
              );
          else
            s !== l ? (s === null ? t.stateNode !== null && (t = t.stateNode, t.parentNode.removeChild(t)) : s.count--, l === null ? Lf(
              n,
              e.type,
              e.stateNode
            ) : Hf(
              n,
              l,
              e.memoizedProps
            )) : l === null && e.stateNode !== null && wu(
              e,
              e.memoizedProps,
              t.memoizedProps
            );
        }
        break;
      case 27:
        ea(a, e), aa(e), l & 512 && (He || t === null || Ca(t, t.return)), t !== null && l & 4 && wu(
          e,
          e.memoizedProps,
          t.memoizedProps
        );
        break;
      case 5:
        if (ea(a, e), aa(e), l & 512 && (He || t === null || Ca(t, t.return)), e.flags & 32) {
          n = e.stateNode;
          try {
            nl(n, "");
          } catch (B) {
            pe(e, e.return, B);
          }
        }
        l & 4 && e.stateNode != null && (n = e.memoizedProps, wu(
          e,
          n,
          t !== null ? t.memoizedProps : n
        )), l & 1024 && ($u = !0);
        break;
      case 6:
        if (ea(a, e), aa(e), l & 4) {
          if (e.stateNode === null)
            throw Error(o(162));
          l = e.memoizedProps, t = e.stateNode;
          try {
            t.nodeValue = l;
          } catch (B) {
            pe(e, e.return, B);
          }
        }
        break;
      case 3:
        if ($i = null, n = Oa, Oa = Ki(a.containerInfo), ea(a, e), Oa = n, aa(e), l & 4 && t !== null && t.memoizedState.isDehydrated)
          try {
            ql(a.containerInfo);
          } catch (B) {
            pe(e, e.return, B);
          }
        $u && ($u = !1, Bd(e));
        break;
      case 4:
        l = Oa, Oa = Ki(
          e.stateNode.containerInfo
        ), ea(a, e), aa(e), Oa = l;
        break;
      case 12:
        ea(a, e), aa(e);
        break;
      case 31:
        ea(a, e), aa(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, Ci(e, l)));
        break;
      case 13:
        ea(a, e), aa(e), e.child.flags & 8192 && e.memoizedState !== null != (t !== null && t.memoizedState !== null) && (qi = ia()), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, Ci(e, l)));
        break;
      case 22:
        n = e.memoizedState !== null;
        var d = t !== null && t.memoizedState !== null, g = $a, N = He;
        if ($a = g || n, He = N || d, ea(a, e), He = N, $a = g, aa(e), l & 8192)
          e: for (a = e.stateNode, a._visibility = n ? a._visibility & -2 : a._visibility | 1, n && (t === null || d || $a || He || Jt(e)), t = null, a = e; ; ) {
            if (a.tag === 5 || a.tag === 26) {
              if (t === null) {
                d = t = a;
                try {
                  if (s = d.stateNode, n)
                    u = s.style, typeof u.setProperty == "function" ? u.setProperty("display", "none", "important") : u.display = "none";
                  else {
                    c = d.stateNode;
                    var R = d.memoizedProps.style, j = R != null && R.hasOwnProperty("display") ? R.display : null;
                    c.style.display = j == null || typeof j == "boolean" ? "" : ("" + j).trim();
                  }
                } catch (B) {
                  pe(d, d.return, B);
                }
              }
            } else if (a.tag === 6) {
              if (t === null) {
                d = a;
                try {
                  d.stateNode.nodeValue = n ? "" : d.memoizedProps;
                } catch (B) {
                  pe(d, d.return, B);
                }
              }
            } else if (a.tag === 18) {
              if (t === null) {
                d = a;
                try {
                  var z = d.stateNode;
                  n ? Tf(z, !0) : Tf(d.stateNode, !1);
                } catch (B) {
                  pe(d, d.return, B);
                }
              }
            } else if ((a.tag !== 22 && a.tag !== 23 || a.memoizedState === null || a === e) && a.child !== null) {
              a.child.return = a, a = a.child;
              continue;
            }
            if (a === e) break e;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === e) break e;
              t === a && (t = null), a = a.return;
            }
            t === a && (t = null), a.sibling.return = a.return, a = a.sibling;
          }
        l & 4 && (l = e.updateQueue, l !== null && (t = l.retryQueue, t !== null && (l.retryQueue = null, Ci(e, t))));
        break;
      case 19:
        ea(a, e), aa(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, Ci(e, l)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        ea(a, e), aa(e);
    }
  }
  function aa(e) {
    var a = e.flags;
    if (a & 2) {
      try {
        for (var t, l = e.return; l !== null; ) {
          if (Od(l)) {
            t = l;
            break;
          }
          l = l.return;
        }
        if (t == null) throw Error(o(160));
        switch (t.tag) {
          case 27:
            var n = t.stateNode, s = Ku(e);
            Ui(e, s, n);
            break;
          case 5:
            var u = t.stateNode;
            t.flags & 32 && (nl(u, ""), t.flags &= -33);
            var c = Ku(e);
            Ui(e, c, u);
            break;
          case 3:
          case 4:
            var d = t.stateNode.containerInfo, g = Ku(e);
            Ju(
              e,
              g,
              d
            );
            break;
          default:
            throw Error(o(161));
        }
      } catch (N) {
        pe(e, e.return, N);
      }
      e.flags &= -3;
    }
    a & 4096 && (e.flags &= -4097);
  }
  function Bd(e) {
    if (e.subtreeFlags & 1024)
      for (e = e.child; e !== null; ) {
        var a = e;
        Bd(a), a.tag === 5 && a.flags & 1024 && a.stateNode.reset(), e = e.sibling;
      }
  }
  function Fa(e, a) {
    if (a.subtreeFlags & 8772)
      for (a = a.child; a !== null; )
        Dd(e, a.alternate, a), a = a.sibling;
  }
  function Jt(e) {
    for (e = e.child; e !== null; ) {
      var a = e;
      switch (a.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ht(4, a, a.return), Jt(a);
          break;
        case 1:
          Ca(a, a.return);
          var t = a.stateNode;
          typeof t.componentWillUnmount == "function" && Nd(
            a,
            a.return,
            t
          ), Jt(a);
          break;
        case 27:
          Mn(a.stateNode);
        case 26:
        case 5:
          Ca(a, a.return), Jt(a);
          break;
        case 22:
          a.memoizedState === null && Jt(a);
          break;
        case 30:
          Jt(a);
          break;
        default:
          Jt(a);
      }
      e = e.sibling;
    }
  }
  function Ia(e, a, t) {
    for (t = t && (a.subtreeFlags & 8772) !== 0, a = a.child; a !== null; ) {
      var l = a.alternate, n = e, s = a, u = s.flags;
      switch (s.tag) {
        case 0:
        case 11:
        case 15:
          Ia(
            n,
            s,
            t
          ), gn(4, s);
          break;
        case 1:
          if (Ia(
            n,
            s,
            t
          ), l = s, n = l.stateNode, typeof n.componentDidMount == "function")
            try {
              n.componentDidMount();
            } catch (g) {
              pe(l, l.return, g);
            }
          if (l = s, n = l.updateQueue, n !== null) {
            var c = l.stateNode;
            try {
              var d = n.shared.hiddenCallbacks;
              if (d !== null)
                for (n.shared.hiddenCallbacks = null, n = 0; n < d.length; n++)
                  hr(d[n], c);
            } catch (g) {
              pe(l, l.return, g);
            }
          }
          t && u & 64 && Ad(s), jn(s, s.return);
          break;
        case 27:
          Md(s);
        case 26:
        case 5:
          Ia(
            n,
            s,
            t
          ), t && l === null && u & 4 && Td(s), jn(s, s.return);
          break;
        case 12:
          Ia(
            n,
            s,
            t
          );
          break;
        case 31:
          Ia(
            n,
            s,
            t
          ), t && u & 4 && _d(n, s);
          break;
        case 13:
          Ia(
            n,
            s,
            t
          ), t && u & 4 && qd(n, s);
          break;
        case 22:
          s.memoizedState === null && Ia(
            n,
            s,
            t
          ), jn(s, s.return);
          break;
        case 30:
          break;
        default:
          Ia(
            n,
            s,
            t
          );
      }
      a = a.sibling;
    }
  }
  function Wu(e, a) {
    var t = null;
    e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), e = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (e = a.memoizedState.cachePool.pool), e !== t && (e != null && e.refCount++, t != null && sn(t));
  }
  function Fu(e, a) {
    e = null, a.alternate !== null && (e = a.alternate.memoizedState.cache), a = a.memoizedState.cache, a !== e && (a.refCount++, e != null && sn(e));
  }
  function Ma(e, a, t, l) {
    if (a.subtreeFlags & 10256)
      for (a = a.child; a !== null; )
        Ld(
          e,
          a,
          t,
          l
        ), a = a.sibling;
  }
  function Ld(e, a, t, l) {
    var n = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        Ma(
          e,
          a,
          t,
          l
        ), n & 2048 && gn(9, a);
        break;
      case 1:
        Ma(
          e,
          a,
          t,
          l
        );
        break;
      case 3:
        Ma(
          e,
          a,
          t,
          l
        ), n & 2048 && (e = null, a.alternate !== null && (e = a.alternate.memoizedState.cache), a = a.memoizedState.cache, a !== e && (a.refCount++, e != null && sn(e)));
        break;
      case 12:
        if (n & 2048) {
          Ma(
            e,
            a,
            t,
            l
          ), e = a.stateNode;
          try {
            var s = a.memoizedProps, u = s.id, c = s.onPostCommit;
            typeof c == "function" && c(
              u,
              a.alternate === null ? "mount" : "update",
              e.passiveEffectDuration,
              -0
            );
          } catch (d) {
            pe(a, a.return, d);
          }
        } else
          Ma(
            e,
            a,
            t,
            l
          );
        break;
      case 31:
        Ma(
          e,
          a,
          t,
          l
        );
        break;
      case 13:
        Ma(
          e,
          a,
          t,
          l
        );
        break;
      case 23:
        break;
      case 22:
        s = a.stateNode, u = a.alternate, a.memoizedState !== null ? s._visibility & 2 ? Ma(
          e,
          a,
          t,
          l
        ) : bn(e, a) : s._visibility & 2 ? Ma(
          e,
          a,
          t,
          l
        ) : (s._visibility |= 2, El(
          e,
          a,
          t,
          l,
          (a.subtreeFlags & 10256) !== 0 || !1
        )), n & 2048 && Wu(u, a);
        break;
      case 24:
        Ma(
          e,
          a,
          t,
          l
        ), n & 2048 && Fu(a.alternate, a);
        break;
      default:
        Ma(
          e,
          a,
          t,
          l
        );
    }
  }
  function El(e, a, t, l, n) {
    for (n = n && ((a.subtreeFlags & 10256) !== 0 || !1), a = a.child; a !== null; ) {
      var s = e, u = a, c = t, d = l, g = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          El(
            s,
            u,
            c,
            d,
            n
          ), gn(8, u);
          break;
        case 23:
          break;
        case 22:
          var N = u.stateNode;
          u.memoizedState !== null ? N._visibility & 2 ? El(
            s,
            u,
            c,
            d,
            n
          ) : bn(
            s,
            u
          ) : (N._visibility |= 2, El(
            s,
            u,
            c,
            d,
            n
          )), n && g & 2048 && Wu(
            u.alternate,
            u
          );
          break;
        case 24:
          El(
            s,
            u,
            c,
            d,
            n
          ), n && g & 2048 && Fu(u.alternate, u);
          break;
        default:
          El(
            s,
            u,
            c,
            d,
            n
          );
      }
      a = a.sibling;
    }
  }
  function bn(e, a) {
    if (a.subtreeFlags & 10256)
      for (a = a.child; a !== null; ) {
        var t = e, l = a, n = l.flags;
        switch (l.tag) {
          case 22:
            bn(t, l), n & 2048 && Wu(
              l.alternate,
              l
            );
            break;
          case 24:
            bn(t, l), n & 2048 && Fu(l.alternate, l);
            break;
          default:
            bn(t, l);
        }
        a = a.sibling;
      }
  }
  var Sn = 8192;
  function Al(e, a, t) {
    if (e.subtreeFlags & Sn)
      for (e = e.child; e !== null; )
        Yd(
          e,
          a,
          t
        ), e = e.sibling;
  }
  function Yd(e, a, t) {
    switch (e.tag) {
      case 26:
        Al(
          e,
          a,
          t
        ), e.flags & Sn && e.memoizedState !== null && Zp(
          t,
          Oa,
          e.memoizedState,
          e.memoizedProps
        );
        break;
      case 5:
        Al(
          e,
          a,
          t
        );
        break;
      case 3:
      case 4:
        var l = Oa;
        Oa = Ki(e.stateNode.containerInfo), Al(
          e,
          a,
          t
        ), Oa = l;
        break;
      case 22:
        e.memoizedState === null && (l = e.alternate, l !== null && l.memoizedState !== null ? (l = Sn, Sn = 16777216, Al(
          e,
          a,
          t
        ), Sn = l) : Al(
          e,
          a,
          t
        ));
        break;
      default:
        Al(
          e,
          a,
          t
        );
    }
  }
  function Gd(e) {
    var a = e.alternate;
    if (a !== null && (e = a.child, e !== null)) {
      a.child = null;
      do
        a = e.sibling, e.sibling = null, e = a;
      while (e !== null);
    }
  }
  function zn(e) {
    var a = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (a !== null)
        for (var t = 0; t < a.length; t++) {
          var l = a[t];
          Ve = l, Qd(
            l,
            e
          );
        }
      Gd(e);
    }
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        Vd(e), e = e.sibling;
  }
  function Vd(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        zn(e), e.flags & 2048 && ht(9, e, e.return);
        break;
      case 3:
        zn(e);
        break;
      case 12:
        zn(e);
        break;
      case 22:
        var a = e.stateNode;
        e.memoizedState !== null && a._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (a._visibility &= -3, _i(e)) : zn(e);
        break;
      default:
        zn(e);
    }
  }
  function _i(e) {
    var a = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (a !== null)
        for (var t = 0; t < a.length; t++) {
          var l = a[t];
          Ve = l, Qd(
            l,
            e
          );
        }
      Gd(e);
    }
    for (e = e.child; e !== null; ) {
      switch (a = e, a.tag) {
        case 0:
        case 11:
        case 15:
          ht(8, a, a.return), _i(a);
          break;
        case 22:
          t = a.stateNode, t._visibility & 2 && (t._visibility &= -3, _i(a));
          break;
        default:
          _i(a);
      }
      e = e.sibling;
    }
  }
  function Qd(e, a) {
    for (; Ve !== null; ) {
      var t = Ve;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          ht(8, t, a);
          break;
        case 23:
        case 22:
          if (t.memoizedState !== null && t.memoizedState.cachePool !== null) {
            var l = t.memoizedState.cachePool.pool;
            l != null && l.refCount++;
          }
          break;
        case 24:
          sn(t.memoizedState.cache);
      }
      if (l = t.child, l !== null) l.return = t, Ve = l;
      else
        e: for (t = e; Ve !== null; ) {
          l = Ve;
          var n = l.sibling, s = l.return;
          if (Ud(l), l === t) {
            Ve = null;
            break e;
          }
          if (n !== null) {
            n.return = s, Ve = n;
            break e;
          }
          Ve = s;
        }
    }
  }
  var ip = {
    getCacheForType: function(e) {
      var a = Ze(Ce), t = a.data.get(e);
      return t === void 0 && (t = e(), a.data.set(e, t)), t;
    },
    cacheSignal: function() {
      return Ze(Ce).controller.signal;
    }
  }, sp = typeof WeakMap == "function" ? WeakMap : Map, fe = 0, Se = null, te = null, ie = 0, he = 0, fa = null, pt = !1, Nl = !1, Iu = !1, Pa = 0, Oe = 0, vt = 0, $t = 0, Pu = 0, ma = 0, Tl = 0, En = null, ta = null, ec = !1, qi = 0, Xd = 0, Hi = 1 / 0, Bi = null, yt = null, Be = 0, xt = null, Ol = null, et = 0, ac = 0, tc = null, Zd = null, An = 0, lc = null;
  function ha() {
    return (fe & 2) !== 0 && ie !== 0 ? ie & -ie : T.T !== null ? oc() : io();
  }
  function kd() {
    if (ma === 0)
      if ((ie & 536870912) === 0 || ue) {
        var e = kn;
        kn <<= 1, (kn & 3932160) === 0 && (kn = 262144), ma = e;
      } else ma = 536870912;
    return e = ra.current, e !== null && (e.flags |= 32), ma;
  }
  function la(e, a, t) {
    (e === Se && (he === 2 || he === 9) || e.cancelPendingCommit !== null) && (Ml(e, 0), gt(
      e,
      ie,
      ma,
      !1
    )), kl(e, t), ((fe & 2) === 0 || e !== Se) && (e === Se && ((fe & 2) === 0 && ($t |= t), Oe === 4 && gt(
      e,
      ie,
      ma,
      !1
    )), _a(e));
  }
  function wd(e, a, t) {
    if ((fe & 6) !== 0) throw Error(o(327));
    var l = !t && (a & 127) === 0 && (a & e.expiredLanes) === 0 || Zl(e, a), n = l ? op(e, a) : ic(e, a, !0), s = l;
    do {
      if (n === 0) {
        Nl && !l && gt(e, a, 0, !1);
        break;
      } else {
        if (t = e.current.alternate, s && !up(t)) {
          n = ic(e, a, !1), s = !1;
          continue;
        }
        if (n === 2) {
          if (s = a, e.errorRecoveryDisabledLanes & s)
            var u = 0;
          else
            u = e.pendingLanes & -536870913, u = u !== 0 ? u : u & 536870912 ? 536870912 : 0;
          if (u !== 0) {
            a = u;
            e: {
              var c = e;
              n = En;
              var d = c.current.memoizedState.isDehydrated;
              if (d && (Ml(c, u).flags |= 256), u = ic(
                c,
                u,
                !1
              ), u !== 2) {
                if (Iu && !d) {
                  c.errorRecoveryDisabledLanes |= s, $t |= s, n = 4;
                  break e;
                }
                s = ta, ta = n, s !== null && (ta === null ? ta = s : ta.push.apply(
                  ta,
                  s
                ));
              }
              n = u;
            }
            if (s = !1, n !== 2) continue;
          }
        }
        if (n === 1) {
          Ml(e, 0), gt(e, a, 0, !0);
          break;
        }
        e: {
          switch (l = e, s = n, s) {
            case 0:
            case 1:
              throw Error(o(345));
            case 4:
              if ((a & 4194048) !== a) break;
            case 6:
              gt(
                l,
                a,
                ma,
                !pt
              );
              break e;
            case 2:
              ta = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(o(329));
          }
          if ((a & 62914560) === a && (n = qi + 300 - ia(), 10 < n)) {
            if (gt(
              l,
              a,
              ma,
              !pt
            ), Kn(l, 0, !0) !== 0) break e;
            et = a, l.timeoutHandle = Ef(
              Kd.bind(
                null,
                l,
                t,
                ta,
                Bi,
                ec,
                a,
                ma,
                $t,
                Tl,
                pt,
                s,
                "Throttled",
                -0,
                0
              ),
              n
            );
            break e;
          }
          Kd(
            l,
            t,
            ta,
            Bi,
            ec,
            a,
            ma,
            $t,
            Tl,
            pt,
            s,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    _a(e);
  }
  function Kd(e, a, t, l, n, s, u, c, d, g, N, R, j, z) {
    if (e.timeoutHandle = -1, R = a.subtreeFlags, R & 8192 || (R & 16785408) === 16785408) {
      R = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Ya
      }, Yd(
        a,
        s,
        R
      );
      var B = (s & 62914560) === s ? qi - ia() : (s & 4194048) === s ? Xd - ia() : 0;
      if (B = kp(
        R,
        B
      ), B !== null) {
        et = s, e.cancelPendingCommit = B(
          af.bind(
            null,
            e,
            a,
            s,
            t,
            l,
            n,
            u,
            c,
            d,
            N,
            R,
            null,
            j,
            z
          )
        ), gt(e, s, u, !g);
        return;
      }
    }
    af(
      e,
      a,
      s,
      t,
      l,
      n,
      u,
      c,
      d
    );
  }
  function up(e) {
    for (var a = e; ; ) {
      var t = a.tag;
      if ((t === 0 || t === 11 || t === 15) && a.flags & 16384 && (t = a.updateQueue, t !== null && (t = t.stores, t !== null)))
        for (var l = 0; l < t.length; l++) {
          var n = t[l], s = n.getSnapshot;
          n = n.value;
          try {
            if (!ca(s(), n)) return !1;
          } catch {
            return !1;
          }
        }
      if (t = a.child, a.subtreeFlags & 16384 && t !== null)
        t.return = a, a = t;
      else {
        if (a === e) break;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e) return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
    }
    return !0;
  }
  function gt(e, a, t, l) {
    a &= ~Pu, a &= ~$t, e.suspendedLanes |= a, e.pingedLanes &= ~a, l && (e.warmLanes |= a), l = e.expirationTimes;
    for (var n = a; 0 < n; ) {
      var s = 31 - ua(n), u = 1 << s;
      l[s] = -1, n &= ~u;
    }
    t !== 0 && to(e, t, a);
  }
  function Li() {
    return (fe & 6) === 0 ? (Nn(0), !1) : !0;
  }
  function nc() {
    if (te !== null) {
      if (he === 0)
        var e = te.return;
      else
        e = te, Xa = Gt = null, ju(e), gl = null, cn = 0, e = te;
      for (; e !== null; )
        Ed(e.alternate, e), e = e.return;
      te = null;
    }
  }
  function Ml(e, a) {
    var t = e.timeoutHandle;
    t !== -1 && (e.timeoutHandle = -1, Tp(t)), t = e.cancelPendingCommit, t !== null && (e.cancelPendingCommit = null, t()), et = 0, nc(), Se = e, te = t = Va(e.current, null), ie = a, he = 0, fa = null, pt = !1, Nl = Zl(e, a), Iu = !1, Tl = ma = Pu = $t = vt = Oe = 0, ta = En = null, ec = !1, (a & 8) !== 0 && (a |= a & 32);
    var l = e.entangledLanes;
    if (l !== 0)
      for (e = e.entanglements, l &= a; 0 < l; ) {
        var n = 31 - ua(l), s = 1 << n;
        a |= e[n], l &= ~s;
      }
    return Pa = a, ii(), t;
  }
  function Jd(e, a) {
    W = null, T.H = vn, a === xl || a === mi ? (a = rr(), he = 3) : a === cu ? (a = rr(), he = 4) : he = a === Hu ? 8 : a !== null && typeof a == "object" && typeof a.then == "function" ? 6 : 1, fa = a, te === null && (Oe = 1, Ti(
      e,
      xa(a, e.current)
    ));
  }
  function $d() {
    var e = ra.current;
    return e === null ? !0 : (ie & 4194048) === ie ? Sa === null : (ie & 62914560) === ie || (ie & 536870912) !== 0 ? e === Sa : !1;
  }
  function Wd() {
    var e = T.H;
    return T.H = vn, e === null ? vn : e;
  }
  function Fd() {
    var e = T.A;
    return T.A = ip, e;
  }
  function Yi() {
    Oe = 4, pt || (ie & 4194048) !== ie && ra.current !== null || (Nl = !0), (vt & 134217727) === 0 && ($t & 134217727) === 0 || Se === null || gt(
      Se,
      ie,
      ma,
      !1
    );
  }
  function ic(e, a, t) {
    var l = fe;
    fe |= 2;
    var n = Wd(), s = Fd();
    (Se !== e || ie !== a) && (Bi = null, Ml(e, a)), a = !1;
    var u = Oe;
    e: do
      try {
        if (he !== 0 && te !== null) {
          var c = te, d = fa;
          switch (he) {
            case 8:
              nc(), u = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              ra.current === null && (a = !0);
              var g = he;
              if (he = 0, fa = null, Rl(e, c, d, g), t && Nl) {
                u = 0;
                break e;
              }
              break;
            default:
              g = he, he = 0, fa = null, Rl(e, c, d, g);
          }
        }
        cp(), u = Oe;
        break;
      } catch (N) {
        Jd(e, N);
      }
    while (!0);
    return a && e.shellSuspendCounter++, Xa = Gt = null, fe = l, T.H = n, T.A = s, te === null && (Se = null, ie = 0, ii()), u;
  }
  function cp() {
    for (; te !== null; ) Id(te);
  }
  function op(e, a) {
    var t = fe;
    fe |= 2;
    var l = Wd(), n = Fd();
    Se !== e || ie !== a ? (Bi = null, Hi = ia() + 500, Ml(e, a)) : Nl = Zl(
      e,
      a
    );
    e: do
      try {
        if (he !== 0 && te !== null) {
          a = te;
          var s = fa;
          a: switch (he) {
            case 1:
              he = 0, fa = null, Rl(e, a, s, 1);
              break;
            case 2:
            case 9:
              if (cr(s)) {
                he = 0, fa = null, Pd(a);
                break;
              }
              a = function() {
                he !== 2 && he !== 9 || Se !== e || (he = 7), _a(e);
              }, s.then(a, a);
              break e;
            case 3:
              he = 7;
              break e;
            case 4:
              he = 5;
              break e;
            case 7:
              cr(s) ? (he = 0, fa = null, Pd(a)) : (he = 0, fa = null, Rl(e, a, s, 7));
              break;
            case 5:
              var u = null;
              switch (te.tag) {
                case 26:
                  u = te.memoizedState;
                case 5:
                case 27:
                  var c = te;
                  if (u ? Yf(u) : c.stateNode.complete) {
                    he = 0, fa = null;
                    var d = c.sibling;
                    if (d !== null) te = d;
                    else {
                      var g = c.return;
                      g !== null ? (te = g, Gi(g)) : te = null;
                    }
                    break a;
                  }
              }
              he = 0, fa = null, Rl(e, a, s, 5);
              break;
            case 6:
              he = 0, fa = null, Rl(e, a, s, 6);
              break;
            case 8:
              nc(), Oe = 6;
              break e;
            default:
              throw Error(o(462));
          }
        }
        rp();
        break;
      } catch (N) {
        Jd(e, N);
      }
    while (!0);
    return Xa = Gt = null, T.H = l, T.A = n, fe = t, te !== null ? 0 : (Se = null, ie = 0, ii(), Oe);
  }
  function rp() {
    for (; te !== null && !Cm(); )
      Id(te);
  }
  function Id(e) {
    var a = Sd(e.alternate, e, Pa);
    e.memoizedProps = e.pendingProps, a === null ? Gi(e) : te = a;
  }
  function Pd(e) {
    var a = e, t = a.alternate;
    switch (a.tag) {
      case 15:
      case 0:
        a = vd(
          t,
          a,
          a.pendingProps,
          a.type,
          void 0,
          ie
        );
        break;
      case 11:
        a = vd(
          t,
          a,
          a.pendingProps,
          a.type.render,
          a.ref,
          ie
        );
        break;
      case 5:
        ju(a);
      default:
        Ed(t, a), a = te = Fo(a, Pa), a = Sd(t, a, Pa);
    }
    e.memoizedProps = e.pendingProps, a === null ? Gi(e) : te = a;
  }
  function Rl(e, a, t, l) {
    Xa = Gt = null, ju(a), gl = null, cn = 0;
    var n = a.return;
    try {
      if (Ih(
        e,
        n,
        a,
        t,
        ie
      )) {
        Oe = 1, Ti(
          e,
          xa(t, e.current)
        ), te = null;
        return;
      }
    } catch (s) {
      if (n !== null) throw te = n, s;
      Oe = 1, Ti(
        e,
        xa(t, e.current)
      ), te = null;
      return;
    }
    a.flags & 32768 ? (ue || l === 1 ? e = !0 : Nl || (ie & 536870912) !== 0 ? e = !1 : (pt = e = !0, (l === 2 || l === 9 || l === 3 || l === 6) && (l = ra.current, l !== null && l.tag === 13 && (l.flags |= 16384))), ef(a, e)) : Gi(a);
  }
  function Gi(e) {
    var a = e;
    do {
      if ((a.flags & 32768) !== 0) {
        ef(
          a,
          pt
        );
        return;
      }
      e = a.return;
      var t = ap(
        a.alternate,
        a,
        Pa
      );
      if (t !== null) {
        te = t;
        return;
      }
      if (a = a.sibling, a !== null) {
        te = a;
        return;
      }
      te = a = e;
    } while (a !== null);
    Oe === 0 && (Oe = 5);
  }
  function ef(e, a) {
    do {
      var t = tp(e.alternate, e);
      if (t !== null) {
        t.flags &= 32767, te = t;
        return;
      }
      if (t = e.return, t !== null && (t.flags |= 32768, t.subtreeFlags = 0, t.deletions = null), !a && (e = e.sibling, e !== null)) {
        te = e;
        return;
      }
      te = e = t;
    } while (e !== null);
    Oe = 6, te = null;
  }
  function af(e, a, t, l, n, s, u, c, d) {
    e.cancelPendingCommit = null;
    do
      Vi();
    while (Be !== 0);
    if ((fe & 6) !== 0) throw Error(o(327));
    if (a !== null) {
      if (a === e.current) throw Error(o(177));
      if (s = a.lanes | a.childLanes, s |= Ks, Xm(
        e,
        t,
        s,
        u,
        c,
        d
      ), e === Se && (te = Se = null, ie = 0), Ol = a, xt = e, et = t, ac = s, tc = n, Zd = l, (a.subtreeFlags & 10256) !== 0 || (a.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, hp(Xn, function() {
        return uf(), null;
      })) : (e.callbackNode = null, e.callbackPriority = 0), l = (a.flags & 13878) !== 0, (a.subtreeFlags & 13878) !== 0 || l) {
        l = T.T, T.T = null, n = U.p, U.p = 2, u = fe, fe |= 4;
        try {
          lp(e, a, t);
        } finally {
          fe = u, U.p = n, T.T = l;
        }
      }
      Be = 1, tf(), lf(), nf();
    }
  }
  function tf() {
    if (Be === 1) {
      Be = 0;
      var e = xt, a = Ol, t = (a.flags & 13878) !== 0;
      if ((a.subtreeFlags & 13878) !== 0 || t) {
        t = T.T, T.T = null;
        var l = U.p;
        U.p = 2;
        var n = fe;
        fe |= 4;
        try {
          Hd(a, e);
          var s = yc, u = Qo(e.containerInfo), c = s.focusedElem, d = s.selectionRange;
          if (u !== c && c && c.ownerDocument && Vo(
            c.ownerDocument.documentElement,
            c
          )) {
            if (d !== null && Qs(c)) {
              var g = d.start, N = d.end;
              if (N === void 0 && (N = g), "selectionStart" in c)
                c.selectionStart = g, c.selectionEnd = Math.min(
                  N,
                  c.value.length
                );
              else {
                var R = c.ownerDocument || document, j = R && R.defaultView || window;
                if (j.getSelection) {
                  var z = j.getSelection(), B = c.textContent.length, Z = Math.min(d.start, B), je = d.end === void 0 ? Z : Math.min(d.end, B);
                  !z.extend && Z > je && (u = je, je = Z, Z = u);
                  var v = Go(
                    c,
                    Z
                  ), f = Go(
                    c,
                    je
                  );
                  if (v && f && (z.rangeCount !== 1 || z.anchorNode !== v.node || z.anchorOffset !== v.offset || z.focusNode !== f.node || z.focusOffset !== f.offset)) {
                    var y = R.createRange();
                    y.setStart(v.node, v.offset), z.removeAllRanges(), Z > je ? (z.addRange(y), z.extend(f.node, f.offset)) : (y.setEnd(f.node, f.offset), z.addRange(y));
                  }
                }
              }
            }
            for (R = [], z = c; z = z.parentNode; )
              z.nodeType === 1 && R.push({
                element: z,
                left: z.scrollLeft,
                top: z.scrollTop
              });
            for (typeof c.focus == "function" && c.focus(), c = 0; c < R.length; c++) {
              var O = R[c];
              O.element.scrollLeft = O.left, O.element.scrollTop = O.top;
            }
          }
          Pi = !!vc, yc = vc = null;
        } finally {
          fe = n, U.p = l, T.T = t;
        }
      }
      e.current = a, Be = 2;
    }
  }
  function lf() {
    if (Be === 2) {
      Be = 0;
      var e = xt, a = Ol, t = (a.flags & 8772) !== 0;
      if ((a.subtreeFlags & 8772) !== 0 || t) {
        t = T.T, T.T = null;
        var l = U.p;
        U.p = 2;
        var n = fe;
        fe |= 4;
        try {
          Dd(e, a.alternate, a);
        } finally {
          fe = n, U.p = l, T.T = t;
        }
      }
      Be = 3;
    }
  }
  function nf() {
    if (Be === 4 || Be === 3) {
      Be = 0, _m();
      var e = xt, a = Ol, t = et, l = Zd;
      (a.subtreeFlags & 10256) !== 0 || (a.flags & 10256) !== 0 ? Be = 5 : (Be = 0, Ol = xt = null, sf(e, e.pendingLanes));
      var n = e.pendingLanes;
      if (n === 0 && (yt = null), zs(t), a = a.stateNode, sa && typeof sa.onCommitFiberRoot == "function")
        try {
          sa.onCommitFiberRoot(
            Xl,
            a,
            void 0,
            (a.current.flags & 128) === 128
          );
        } catch {
        }
      if (l !== null) {
        a = T.T, n = U.p, U.p = 2, T.T = null;
        try {
          for (var s = e.onRecoverableError, u = 0; u < l.length; u++) {
            var c = l[u];
            s(c.value, {
              componentStack: c.stack
            });
          }
        } finally {
          T.T = a, U.p = n;
        }
      }
      (et & 3) !== 0 && Vi(), _a(e), n = e.pendingLanes, (t & 261930) !== 0 && (n & 42) !== 0 ? e === lc ? An++ : (An = 0, lc = e) : An = 0, Nn(0);
    }
  }
  function sf(e, a) {
    (e.pooledCacheLanes &= a) === 0 && (a = e.pooledCache, a != null && (e.pooledCache = null, sn(a)));
  }
  function Vi() {
    return tf(), lf(), nf(), uf();
  }
  function uf() {
    if (Be !== 5) return !1;
    var e = xt, a = ac;
    ac = 0;
    var t = zs(et), l = T.T, n = U.p;
    try {
      U.p = 32 > t ? 32 : t, T.T = null, t = tc, tc = null;
      var s = xt, u = et;
      if (Be = 0, Ol = xt = null, et = 0, (fe & 6) !== 0) throw Error(o(331));
      var c = fe;
      if (fe |= 4, Vd(s.current), Ld(
        s,
        s.current,
        u,
        t
      ), fe = c, Nn(0, !1), sa && typeof sa.onPostCommitFiberRoot == "function")
        try {
          sa.onPostCommitFiberRoot(Xl, s);
        } catch {
        }
      return !0;
    } finally {
      U.p = n, T.T = l, sf(e, a);
    }
  }
  function cf(e, a, t) {
    a = xa(t, a), a = qu(e.stateNode, a, 2), e = dt(e, a, 2), e !== null && (kl(e, 2), _a(e));
  }
  function pe(e, a, t) {
    if (e.tag === 3)
      cf(e, e, t);
    else
      for (; a !== null; ) {
        if (a.tag === 3) {
          cf(
            a,
            e,
            t
          );
          break;
        } else if (a.tag === 1) {
          var l = a.stateNode;
          if (typeof a.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (yt === null || !yt.has(l))) {
            e = xa(t, e), t = cd(2), l = dt(a, t, 2), l !== null && (od(
              t,
              l,
              a,
              e
            ), kl(l, 2), _a(l));
            break;
          }
        }
        a = a.return;
      }
  }
  function sc(e, a, t) {
    var l = e.pingCache;
    if (l === null) {
      l = e.pingCache = new sp();
      var n = /* @__PURE__ */ new Set();
      l.set(a, n);
    } else
      n = l.get(a), n === void 0 && (n = /* @__PURE__ */ new Set(), l.set(a, n));
    n.has(t) || (Iu = !0, n.add(t), e = dp.bind(null, e, a, t), a.then(e, e));
  }
  function dp(e, a, t) {
    var l = e.pingCache;
    l !== null && l.delete(a), e.pingedLanes |= e.suspendedLanes & t, e.warmLanes &= ~t, Se === e && (ie & t) === t && (Oe === 4 || Oe === 3 && (ie & 62914560) === ie && 300 > ia() - qi ? (fe & 2) === 0 && Ml(e, 0) : Pu |= t, Tl === ie && (Tl = 0)), _a(e);
  }
  function of(e, a) {
    a === 0 && (a = ao()), e = Bt(e, a), e !== null && (kl(e, a), _a(e));
  }
  function fp(e) {
    var a = e.memoizedState, t = 0;
    a !== null && (t = a.retryLane), of(e, t);
  }
  function mp(e, a) {
    var t = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var l = e.stateNode, n = e.memoizedState;
        n !== null && (t = n.retryLane);
        break;
      case 19:
        l = e.stateNode;
        break;
      case 22:
        l = e.stateNode._retryCache;
        break;
      default:
        throw Error(o(314));
    }
    l !== null && l.delete(a), of(e, t);
  }
  function hp(e, a) {
    return gs(e, a);
  }
  var Qi = null, Dl = null, uc = !1, Xi = !1, cc = !1, jt = 0;
  function _a(e) {
    e !== Dl && e.next === null && (Dl === null ? Qi = Dl = e : Dl = Dl.next = e), Xi = !0, uc || (uc = !0, vp());
  }
  function Nn(e, a) {
    if (!cc && Xi) {
      cc = !0;
      do
        for (var t = !1, l = Qi; l !== null; ) {
          if (e !== 0) {
            var n = l.pendingLanes;
            if (n === 0) var s = 0;
            else {
              var u = l.suspendedLanes, c = l.pingedLanes;
              s = (1 << 31 - ua(42 | e) + 1) - 1, s &= n & ~(u & ~c), s = s & 201326741 ? s & 201326741 | 1 : s ? s | 2 : 0;
            }
            s !== 0 && (t = !0, mf(l, s));
          } else
            s = ie, s = Kn(
              l,
              l === Se ? s : 0,
              l.cancelPendingCommit !== null || l.timeoutHandle !== -1
            ), (s & 3) === 0 || Zl(l, s) || (t = !0, mf(l, s));
          l = l.next;
        }
      while (t);
      cc = !1;
    }
  }
  function pp() {
    rf();
  }
  function rf() {
    Xi = uc = !1;
    var e = 0;
    jt !== 0 && Np() && (e = jt);
    for (var a = ia(), t = null, l = Qi; l !== null; ) {
      var n = l.next, s = df(l, a);
      s === 0 ? (l.next = null, t === null ? Qi = n : t.next = n, n === null && (Dl = t)) : (t = l, (e !== 0 || (s & 3) !== 0) && (Xi = !0)), l = n;
    }
    Be !== 0 && Be !== 5 || Nn(e), jt !== 0 && (jt = 0);
  }
  function df(e, a) {
    for (var t = e.suspendedLanes, l = e.pingedLanes, n = e.expirationTimes, s = e.pendingLanes & -62914561; 0 < s; ) {
      var u = 31 - ua(s), c = 1 << u, d = n[u];
      d === -1 ? ((c & t) === 0 || (c & l) !== 0) && (n[u] = Qm(c, a)) : d <= a && (e.expiredLanes |= c), s &= ~c;
    }
    if (a = Se, t = ie, t = Kn(
      e,
      e === a ? t : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), l = e.callbackNode, t === 0 || e === a && (he === 2 || he === 9) || e.cancelPendingCommit !== null)
      return l !== null && l !== null && js(l), e.callbackNode = null, e.callbackPriority = 0;
    if ((t & 3) === 0 || Zl(e, t)) {
      if (a = t & -t, a === e.callbackPriority) return a;
      switch (l !== null && js(l), zs(t)) {
        case 2:
        case 8:
          t = Pc;
          break;
        case 32:
          t = Xn;
          break;
        case 268435456:
          t = eo;
          break;
        default:
          t = Xn;
      }
      return l = ff.bind(null, e), t = gs(t, l), e.callbackPriority = a, e.callbackNode = t, a;
    }
    return l !== null && l !== null && js(l), e.callbackPriority = 2, e.callbackNode = null, 2;
  }
  function ff(e, a) {
    if (Be !== 0 && Be !== 5)
      return e.callbackNode = null, e.callbackPriority = 0, null;
    var t = e.callbackNode;
    if (Vi() && e.callbackNode !== t)
      return null;
    var l = ie;
    return l = Kn(
      e,
      e === Se ? l : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), l === 0 ? null : (wd(e, l, a), df(e, ia()), e.callbackNode != null && e.callbackNode === t ? ff.bind(null, e) : null);
  }
  function mf(e, a) {
    if (Vi()) return null;
    wd(e, a, !0);
  }
  function vp() {
    Op(function() {
      (fe & 6) !== 0 ? gs(
        Ic,
        pp
      ) : rf();
    });
  }
  function oc() {
    if (jt === 0) {
      var e = vl;
      e === 0 && (e = Zn, Zn <<= 1, (Zn & 261888) === 0 && (Zn = 256)), jt = e;
    }
    return jt;
  }
  function hf(e) {
    return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Fn("" + e);
  }
  function pf(e, a) {
    var t = a.ownerDocument.createElement("input");
    return t.name = a.name, t.value = a.value, e.id && t.setAttribute("form", e.id), a.parentNode.insertBefore(t, a), e = new FormData(e), t.parentNode.removeChild(t), e;
  }
  function yp(e, a, t, l, n) {
    if (a === "submit" && t && t.stateNode === n) {
      var s = hf(
        (n[Fe] || null).action
      ), u = l.submitter;
      u && (a = (a = u[Fe] || null) ? hf(a.formAction) : u.getAttribute("formAction"), a !== null && (s = a, u = null));
      var c = new ai(
        "action",
        "action",
        null,
        l,
        n
      );
      e.push({
        event: c,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (l.defaultPrevented) {
                if (jt !== 0) {
                  var d = u ? pf(n, u) : new FormData(n);
                  Mu(
                    t,
                    {
                      pending: !0,
                      data: d,
                      method: n.method,
                      action: s
                    },
                    null,
                    d
                  );
                }
              } else
                typeof s == "function" && (c.preventDefault(), d = u ? pf(n, u) : new FormData(n), Mu(
                  t,
                  {
                    pending: !0,
                    data: d,
                    method: n.method,
                    action: s
                  },
                  s,
                  d
                ));
            },
            currentTarget: n
          }
        ]
      });
    }
  }
  for (var rc = 0; rc < ws.length; rc++) {
    var dc = ws[rc], xp = dc.toLowerCase(), gp = dc[0].toUpperCase() + dc.slice(1);
    Ta(
      xp,
      "on" + gp
    );
  }
  Ta(ko, "onAnimationEnd"), Ta(wo, "onAnimationIteration"), Ta(Ko, "onAnimationStart"), Ta("dblclick", "onDoubleClick"), Ta("focusin", "onFocus"), Ta("focusout", "onBlur"), Ta(qh, "onTransitionRun"), Ta(Hh, "onTransitionStart"), Ta(Bh, "onTransitionCancel"), Ta(Jo, "onTransitionEnd"), tl("onMouseEnter", ["mouseout", "mouseover"]), tl("onMouseLeave", ["mouseout", "mouseover"]), tl("onPointerEnter", ["pointerout", "pointerover"]), tl("onPointerLeave", ["pointerout", "pointerover"]), Ct(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Ct(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Ct("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Ct(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Ct(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Ct(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Tn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), jp = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Tn)
  );
  function vf(e, a) {
    a = (a & 4) !== 0;
    for (var t = 0; t < e.length; t++) {
      var l = e[t], n = l.event;
      l = l.listeners;
      e: {
        var s = void 0;
        if (a)
          for (var u = l.length - 1; 0 <= u; u--) {
            var c = l[u], d = c.instance, g = c.currentTarget;
            if (c = c.listener, d !== s && n.isPropagationStopped())
              break e;
            s = c, n.currentTarget = g;
            try {
              s(n);
            } catch (N) {
              ni(N);
            }
            n.currentTarget = null, s = d;
          }
        else
          for (u = 0; u < l.length; u++) {
            if (c = l[u], d = c.instance, g = c.currentTarget, c = c.listener, d !== s && n.isPropagationStopped())
              break e;
            s = c, n.currentTarget = g;
            try {
              s(n);
            } catch (N) {
              ni(N);
            }
            n.currentTarget = null, s = d;
          }
      }
    }
  }
  function le(e, a) {
    var t = a[Es];
    t === void 0 && (t = a[Es] = /* @__PURE__ */ new Set());
    var l = e + "__bubble";
    t.has(l) || (yf(a, e, 2, !1), t.add(l));
  }
  function fc(e, a, t) {
    var l = 0;
    a && (l |= 4), yf(
      t,
      e,
      l,
      a
    );
  }
  var Zi = "_reactListening" + Math.random().toString(36).slice(2);
  function mc(e) {
    if (!e[Zi]) {
      e[Zi] = !0, co.forEach(function(t) {
        t !== "selectionchange" && (jp.has(t) || fc(t, !1, e), fc(t, !0, e));
      });
      var a = e.nodeType === 9 ? e : e.ownerDocument;
      a === null || a[Zi] || (a[Zi] = !0, fc("selectionchange", !1, a));
    }
  }
  function yf(e, a, t, l) {
    switch (wf(a)) {
      case 2:
        var n = Jp;
        break;
      case 8:
        n = $p;
        break;
      default:
        n = Oc;
    }
    t = n.bind(
      null,
      a,
      t,
      e
    ), n = void 0, !Cs || a !== "touchstart" && a !== "touchmove" && a !== "wheel" || (n = !0), l ? n !== void 0 ? e.addEventListener(a, t, {
      capture: !0,
      passive: n
    }) : e.addEventListener(a, t, !0) : n !== void 0 ? e.addEventListener(a, t, {
      passive: n
    }) : e.addEventListener(a, t, !1);
  }
  function hc(e, a, t, l, n) {
    var s = l;
    if ((a & 1) === 0 && (a & 2) === 0 && l !== null)
      e: for (; ; ) {
        if (l === null) return;
        var u = l.tag;
        if (u === 3 || u === 4) {
          var c = l.stateNode.containerInfo;
          if (c === n) break;
          if (u === 4)
            for (u = l.return; u !== null; ) {
              var d = u.tag;
              if ((d === 3 || d === 4) && u.stateNode.containerInfo === n)
                return;
              u = u.return;
            }
          for (; c !== null; ) {
            if (u = Pt(c), u === null) return;
            if (d = u.tag, d === 5 || d === 6 || d === 26 || d === 27) {
              l = s = u;
              continue e;
            }
            c = c.parentNode;
          }
        }
        l = l.return;
      }
    bo(function() {
      var g = s, N = Ds(t), R = [];
      e: {
        var j = $o.get(e);
        if (j !== void 0) {
          var z = ai, B = e;
          switch (e) {
            case "keypress":
              if (Pn(t) === 0) break e;
            case "keydown":
            case "keyup":
              z = mh;
              break;
            case "focusin":
              B = "focus", z = Bs;
              break;
            case "focusout":
              B = "blur", z = Bs;
              break;
            case "beforeblur":
            case "afterblur":
              z = Bs;
              break;
            case "click":
              if (t.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              z = Eo;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              z = ah;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              z = vh;
              break;
            case ko:
            case wo:
            case Ko:
              z = nh;
              break;
            case Jo:
              z = xh;
              break;
            case "scroll":
            case "scrollend":
              z = Pm;
              break;
            case "wheel":
              z = jh;
              break;
            case "copy":
            case "cut":
            case "paste":
              z = sh;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              z = No;
              break;
            case "toggle":
            case "beforetoggle":
              z = Sh;
          }
          var Z = (a & 4) !== 0, je = !Z && (e === "scroll" || e === "scrollend"), v = Z ? j !== null ? j + "Capture" : null : j;
          Z = [];
          for (var f = g, y; f !== null; ) {
            var O = f;
            if (y = O.stateNode, O = O.tag, O !== 5 && O !== 26 && O !== 27 || y === null || v === null || (O = Jl(f, v), O != null && Z.push(
              On(f, O, y)
            )), je) break;
            f = f.return;
          }
          0 < Z.length && (j = new z(
            j,
            B,
            null,
            t,
            N
          ), R.push({ event: j, listeners: Z }));
        }
      }
      if ((a & 7) === 0) {
        e: {
          if (j = e === "mouseover" || e === "pointerover", z = e === "mouseout" || e === "pointerout", j && t !== Rs && (B = t.relatedTarget || t.fromElement) && (Pt(B) || B[It]))
            break e;
          if ((z || j) && (j = N.window === N ? N : (j = N.ownerDocument) ? j.defaultView || j.parentWindow : window, z ? (B = t.relatedTarget || t.toElement, z = g, B = B ? Pt(B) : null, B !== null && (je = M(B), Z = B.tag, B !== je || Z !== 5 && Z !== 27 && Z !== 6) && (B = null)) : (z = null, B = g), z !== B)) {
            if (Z = Eo, O = "onMouseLeave", v = "onMouseEnter", f = "mouse", (e === "pointerout" || e === "pointerover") && (Z = No, O = "onPointerLeave", v = "onPointerEnter", f = "pointer"), je = z == null ? j : Kl(z), y = B == null ? j : Kl(B), j = new Z(
              O,
              f + "leave",
              z,
              t,
              N
            ), j.target = je, j.relatedTarget = y, O = null, Pt(N) === g && (Z = new Z(
              v,
              f + "enter",
              B,
              t,
              N
            ), Z.target = y, Z.relatedTarget = je, O = Z), je = O, z && B)
              a: {
                for (Z = bp, v = z, f = B, y = 0, O = v; O; O = Z(O))
                  y++;
                O = 0;
                for (var X = f; X; X = Z(X))
                  O++;
                for (; 0 < y - O; )
                  v = Z(v), y--;
                for (; 0 < O - y; )
                  f = Z(f), O--;
                for (; y--; ) {
                  if (v === f || f !== null && v === f.alternate) {
                    Z = v;
                    break a;
                  }
                  v = Z(v), f = Z(f);
                }
                Z = null;
              }
            else Z = null;
            z !== null && xf(
              R,
              j,
              z,
              Z,
              !1
            ), B !== null && je !== null && xf(
              R,
              je,
              B,
              Z,
              !0
            );
          }
        }
        e: {
          if (j = g ? Kl(g) : window, z = j.nodeName && j.nodeName.toLowerCase(), z === "select" || z === "input" && j.type === "file")
            var re = _o;
          else if (Uo(j))
            if (qo)
              re = Uh;
            else {
              re = Rh;
              var Q = Mh;
            }
          else
            z = j.nodeName, !z || z.toLowerCase() !== "input" || j.type !== "checkbox" && j.type !== "radio" ? g && Ms(g.elementType) && (re = _o) : re = Dh;
          if (re && (re = re(e, g))) {
            Co(
              R,
              re,
              t,
              N
            );
            break e;
          }
          Q && Q(e, j, g), e === "focusout" && g && j.type === "number" && g.memoizedProps.value != null && Os(j, "number", j.value);
        }
        switch (Q = g ? Kl(g) : window, e) {
          case "focusin":
            (Uo(Q) || Q.contentEditable === "true") && (cl = Q, Xs = g, tn = null);
            break;
          case "focusout":
            tn = Xs = cl = null;
            break;
          case "mousedown":
            Zs = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Zs = !1, Xo(R, t, N);
            break;
          case "selectionchange":
            if (_h) break;
          case "keydown":
          case "keyup":
            Xo(R, t, N);
        }
        var F;
        if (Ys)
          e: {
            switch (e) {
              case "compositionstart":
                var se = "onCompositionStart";
                break e;
              case "compositionend":
                se = "onCompositionEnd";
                break e;
              case "compositionupdate":
                se = "onCompositionUpdate";
                break e;
            }
            se = void 0;
          }
        else
          ul ? Ro(e, t) && (se = "onCompositionEnd") : e === "keydown" && t.keyCode === 229 && (se = "onCompositionStart");
        se && (To && t.locale !== "ko" && (ul || se !== "onCompositionStart" ? se === "onCompositionEnd" && ul && (F = So()) : (nt = N, _s = "value" in nt ? nt.value : nt.textContent, ul = !0)), Q = ki(g, se), 0 < Q.length && (se = new Ao(
          se,
          e,
          null,
          t,
          N
        ), R.push({ event: se, listeners: Q }), F ? se.data = F : (F = Do(t), F !== null && (se.data = F)))), (F = Eh ? Ah(e, t) : Nh(e, t)) && (se = ki(g, "onBeforeInput"), 0 < se.length && (Q = new Ao(
          "onBeforeInput",
          "beforeinput",
          null,
          t,
          N
        ), R.push({
          event: Q,
          listeners: se
        }), Q.data = F)), yp(
          R,
          e,
          g,
          t,
          N
        );
      }
      vf(R, a);
    });
  }
  function On(e, a, t) {
    return {
      instance: e,
      listener: a,
      currentTarget: t
    };
  }
  function ki(e, a) {
    for (var t = a + "Capture", l = []; e !== null; ) {
      var n = e, s = n.stateNode;
      if (n = n.tag, n !== 5 && n !== 26 && n !== 27 || s === null || (n = Jl(e, t), n != null && l.unshift(
        On(e, n, s)
      ), n = Jl(e, a), n != null && l.push(
        On(e, n, s)
      )), e.tag === 3) return l;
      e = e.return;
    }
    return [];
  }
  function bp(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function xf(e, a, t, l, n) {
    for (var s = a._reactName, u = []; t !== null && t !== l; ) {
      var c = t, d = c.alternate, g = c.stateNode;
      if (c = c.tag, d !== null && d === l) break;
      c !== 5 && c !== 26 && c !== 27 || g === null || (d = g, n ? (g = Jl(t, s), g != null && u.unshift(
        On(t, g, d)
      )) : n || (g = Jl(t, s), g != null && u.push(
        On(t, g, d)
      ))), t = t.return;
    }
    u.length !== 0 && e.push({ event: a, listeners: u });
  }
  var Sp = /\r\n?/g, zp = /\u0000|\uFFFD/g;
  function gf(e) {
    return (typeof e == "string" ? e : "" + e).replace(Sp, `
`).replace(zp, "");
  }
  function jf(e, a) {
    return a = gf(a), gf(e) === a;
  }
  function ge(e, a, t, l, n, s) {
    switch (t) {
      case "children":
        typeof l == "string" ? a === "body" || a === "textarea" && l === "" || nl(e, l) : (typeof l == "number" || typeof l == "bigint") && a !== "body" && nl(e, "" + l);
        break;
      case "className":
        $n(e, "class", l);
        break;
      case "tabIndex":
        $n(e, "tabindex", l);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        $n(e, t, l);
        break;
      case "style":
        go(e, l, s);
        break;
      case "data":
        if (a !== "object") {
          $n(e, "data", l);
          break;
        }
      case "src":
      case "href":
        if (l === "" && (a !== "a" || t !== "href")) {
          e.removeAttribute(t);
          break;
        }
        if (l == null || typeof l == "function" || typeof l == "symbol" || typeof l == "boolean") {
          e.removeAttribute(t);
          break;
        }
        l = Fn("" + l), e.setAttribute(t, l);
        break;
      case "action":
      case "formAction":
        if (typeof l == "function") {
          e.setAttribute(
            t,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof s == "function" && (t === "formAction" ? (a !== "input" && ge(e, a, "name", n.name, n, null), ge(
            e,
            a,
            "formEncType",
            n.formEncType,
            n,
            null
          ), ge(
            e,
            a,
            "formMethod",
            n.formMethod,
            n,
            null
          ), ge(
            e,
            a,
            "formTarget",
            n.formTarget,
            n,
            null
          )) : (ge(e, a, "encType", n.encType, n, null), ge(e, a, "method", n.method, n, null), ge(e, a, "target", n.target, n, null)));
        if (l == null || typeof l == "symbol" || typeof l == "boolean") {
          e.removeAttribute(t);
          break;
        }
        l = Fn("" + l), e.setAttribute(t, l);
        break;
      case "onClick":
        l != null && (e.onclick = Ya);
        break;
      case "onScroll":
        l != null && le("scroll", e);
        break;
      case "onScrollEnd":
        l != null && le("scrollend", e);
        break;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(o(61));
          if (t = l.__html, t != null) {
            if (n.children != null) throw Error(o(60));
            e.innerHTML = t;
          }
        }
        break;
      case "multiple":
        e.multiple = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "muted":
        e.muted = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (l == null || typeof l == "function" || typeof l == "boolean" || typeof l == "symbol") {
          e.removeAttribute("xlink:href");
          break;
        }
        t = Fn("" + l), e.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          t
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        l != null && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(t, "" + l) : e.removeAttribute(t);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        l && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(t, "") : e.removeAttribute(t);
        break;
      case "capture":
      case "download":
        l === !0 ? e.setAttribute(t, "") : l !== !1 && l != null && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(t, l) : e.removeAttribute(t);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        l != null && typeof l != "function" && typeof l != "symbol" && !isNaN(l) && 1 <= l ? e.setAttribute(t, l) : e.removeAttribute(t);
        break;
      case "rowSpan":
      case "start":
        l == null || typeof l == "function" || typeof l == "symbol" || isNaN(l) ? e.removeAttribute(t) : e.setAttribute(t, l);
        break;
      case "popover":
        le("beforetoggle", e), le("toggle", e), Jn(e, "popover", l);
        break;
      case "xlinkActuate":
        La(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          l
        );
        break;
      case "xlinkArcrole":
        La(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          l
        );
        break;
      case "xlinkRole":
        La(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          l
        );
        break;
      case "xlinkShow":
        La(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          l
        );
        break;
      case "xlinkTitle":
        La(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          l
        );
        break;
      case "xlinkType":
        La(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          l
        );
        break;
      case "xmlBase":
        La(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          l
        );
        break;
      case "xmlLang":
        La(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          l
        );
        break;
      case "xmlSpace":
        La(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          l
        );
        break;
      case "is":
        Jn(e, "is", l);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (t = Fm.get(t) || t, Jn(e, t, l));
    }
  }
  function pc(e, a, t, l, n, s) {
    switch (t) {
      case "style":
        go(e, l, s);
        break;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(o(61));
          if (t = l.__html, t != null) {
            if (n.children != null) throw Error(o(60));
            e.innerHTML = t;
          }
        }
        break;
      case "children":
        typeof l == "string" ? nl(e, l) : (typeof l == "number" || typeof l == "bigint") && nl(e, "" + l);
        break;
      case "onScroll":
        l != null && le("scroll", e);
        break;
      case "onScrollEnd":
        l != null && le("scrollend", e);
        break;
      case "onClick":
        l != null && (e.onclick = Ya);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!oo.hasOwnProperty(t))
          e: {
            if (t[0] === "o" && t[1] === "n" && (n = t.endsWith("Capture"), a = t.slice(2, n ? t.length - 7 : void 0), s = e[Fe] || null, s = s != null ? s[t] : null, typeof s == "function" && e.removeEventListener(a, s, n), typeof l == "function")) {
              typeof s != "function" && s !== null && (t in e ? e[t] = null : e.hasAttribute(t) && e.removeAttribute(t)), e.addEventListener(a, l, n);
              break e;
            }
            t in e ? e[t] = l : l === !0 ? e.setAttribute(t, "") : Jn(e, t, l);
          }
    }
  }
  function we(e, a, t) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        le("error", e), le("load", e);
        var l = !1, n = !1, s;
        for (s in t)
          if (t.hasOwnProperty(s)) {
            var u = t[s];
            if (u != null)
              switch (s) {
                case "src":
                  l = !0;
                  break;
                case "srcSet":
                  n = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(o(137, a));
                default:
                  ge(e, a, s, u, t, null);
              }
          }
        n && ge(e, a, "srcSet", t.srcSet, t, null), l && ge(e, a, "src", t.src, t, null);
        return;
      case "input":
        le("invalid", e);
        var c = s = u = n = null, d = null, g = null;
        for (l in t)
          if (t.hasOwnProperty(l)) {
            var N = t[l];
            if (N != null)
              switch (l) {
                case "name":
                  n = N;
                  break;
                case "type":
                  u = N;
                  break;
                case "checked":
                  d = N;
                  break;
                case "defaultChecked":
                  g = N;
                  break;
                case "value":
                  s = N;
                  break;
                case "defaultValue":
                  c = N;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (N != null)
                    throw Error(o(137, a));
                  break;
                default:
                  ge(e, a, l, N, t, null);
              }
          }
        po(
          e,
          s,
          c,
          d,
          g,
          u,
          n,
          !1
        );
        return;
      case "select":
        le("invalid", e), l = u = s = null;
        for (n in t)
          if (t.hasOwnProperty(n) && (c = t[n], c != null))
            switch (n) {
              case "value":
                s = c;
                break;
              case "defaultValue":
                u = c;
                break;
              case "multiple":
                l = c;
              default:
                ge(e, a, n, c, t, null);
            }
        a = s, t = u, e.multiple = !!l, a != null ? ll(e, !!l, a, !1) : t != null && ll(e, !!l, t, !0);
        return;
      case "textarea":
        le("invalid", e), s = n = l = null;
        for (u in t)
          if (t.hasOwnProperty(u) && (c = t[u], c != null))
            switch (u) {
              case "value":
                l = c;
                break;
              case "defaultValue":
                n = c;
                break;
              case "children":
                s = c;
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(o(91));
                break;
              default:
                ge(e, a, u, c, t, null);
            }
        yo(e, l, n, s);
        return;
      case "option":
        for (d in t)
          if (t.hasOwnProperty(d) && (l = t[d], l != null))
            switch (d) {
              case "selected":
                e.selected = l && typeof l != "function" && typeof l != "symbol";
                break;
              default:
                ge(e, a, d, l, t, null);
            }
        return;
      case "dialog":
        le("beforetoggle", e), le("toggle", e), le("cancel", e), le("close", e);
        break;
      case "iframe":
      case "object":
        le("load", e);
        break;
      case "video":
      case "audio":
        for (l = 0; l < Tn.length; l++)
          le(Tn[l], e);
        break;
      case "image":
        le("error", e), le("load", e);
        break;
      case "details":
        le("toggle", e);
        break;
      case "embed":
      case "source":
      case "link":
        le("error", e), le("load", e);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (g in t)
          if (t.hasOwnProperty(g) && (l = t[g], l != null))
            switch (g) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(o(137, a));
              default:
                ge(e, a, g, l, t, null);
            }
        return;
      default:
        if (Ms(a)) {
          for (N in t)
            t.hasOwnProperty(N) && (l = t[N], l !== void 0 && pc(
              e,
              a,
              N,
              l,
              t,
              void 0
            ));
          return;
        }
    }
    for (c in t)
      t.hasOwnProperty(c) && (l = t[c], l != null && ge(e, a, c, l, t, null));
  }
  function Ep(e, a, t, l) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var n = null, s = null, u = null, c = null, d = null, g = null, N = null;
        for (z in t) {
          var R = t[z];
          if (t.hasOwnProperty(z) && R != null)
            switch (z) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                d = R;
              default:
                l.hasOwnProperty(z) || ge(e, a, z, null, l, R);
            }
        }
        for (var j in l) {
          var z = l[j];
          if (R = t[j], l.hasOwnProperty(j) && (z != null || R != null))
            switch (j) {
              case "type":
                s = z;
                break;
              case "name":
                n = z;
                break;
              case "checked":
                g = z;
                break;
              case "defaultChecked":
                N = z;
                break;
              case "value":
                u = z;
                break;
              case "defaultValue":
                c = z;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (z != null)
                  throw Error(o(137, a));
                break;
              default:
                z !== R && ge(
                  e,
                  a,
                  j,
                  z,
                  l,
                  R
                );
            }
        }
        Ts(
          e,
          u,
          c,
          d,
          g,
          N,
          s,
          n
        );
        return;
      case "select":
        z = u = c = j = null;
        for (s in t)
          if (d = t[s], t.hasOwnProperty(s) && d != null)
            switch (s) {
              case "value":
                break;
              case "multiple":
                z = d;
              default:
                l.hasOwnProperty(s) || ge(
                  e,
                  a,
                  s,
                  null,
                  l,
                  d
                );
            }
        for (n in l)
          if (s = l[n], d = t[n], l.hasOwnProperty(n) && (s != null || d != null))
            switch (n) {
              case "value":
                j = s;
                break;
              case "defaultValue":
                c = s;
                break;
              case "multiple":
                u = s;
              default:
                s !== d && ge(
                  e,
                  a,
                  n,
                  s,
                  l,
                  d
                );
            }
        a = c, t = u, l = z, j != null ? ll(e, !!t, j, !1) : !!l != !!t && (a != null ? ll(e, !!t, a, !0) : ll(e, !!t, t ? [] : "", !1));
        return;
      case "textarea":
        z = j = null;
        for (c in t)
          if (n = t[c], t.hasOwnProperty(c) && n != null && !l.hasOwnProperty(c))
            switch (c) {
              case "value":
                break;
              case "children":
                break;
              default:
                ge(e, a, c, null, l, n);
            }
        for (u in l)
          if (n = l[u], s = t[u], l.hasOwnProperty(u) && (n != null || s != null))
            switch (u) {
              case "value":
                j = n;
                break;
              case "defaultValue":
                z = n;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (n != null) throw Error(o(91));
                break;
              default:
                n !== s && ge(e, a, u, n, l, s);
            }
        vo(e, j, z);
        return;
      case "option":
        for (var B in t)
          if (j = t[B], t.hasOwnProperty(B) && j != null && !l.hasOwnProperty(B))
            switch (B) {
              case "selected":
                e.selected = !1;
                break;
              default:
                ge(
                  e,
                  a,
                  B,
                  null,
                  l,
                  j
                );
            }
        for (d in l)
          if (j = l[d], z = t[d], l.hasOwnProperty(d) && j !== z && (j != null || z != null))
            switch (d) {
              case "selected":
                e.selected = j && typeof j != "function" && typeof j != "symbol";
                break;
              default:
                ge(
                  e,
                  a,
                  d,
                  j,
                  l,
                  z
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Z in t)
          j = t[Z], t.hasOwnProperty(Z) && j != null && !l.hasOwnProperty(Z) && ge(e, a, Z, null, l, j);
        for (g in l)
          if (j = l[g], z = t[g], l.hasOwnProperty(g) && j !== z && (j != null || z != null))
            switch (g) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (j != null)
                  throw Error(o(137, a));
                break;
              default:
                ge(
                  e,
                  a,
                  g,
                  j,
                  l,
                  z
                );
            }
        return;
      default:
        if (Ms(a)) {
          for (var je in t)
            j = t[je], t.hasOwnProperty(je) && j !== void 0 && !l.hasOwnProperty(je) && pc(
              e,
              a,
              je,
              void 0,
              l,
              j
            );
          for (N in l)
            j = l[N], z = t[N], !l.hasOwnProperty(N) || j === z || j === void 0 && z === void 0 || pc(
              e,
              a,
              N,
              j,
              l,
              z
            );
          return;
        }
    }
    for (var v in t)
      j = t[v], t.hasOwnProperty(v) && j != null && !l.hasOwnProperty(v) && ge(e, a, v, null, l, j);
    for (R in l)
      j = l[R], z = t[R], !l.hasOwnProperty(R) || j === z || j == null && z == null || ge(e, a, R, j, l, z);
  }
  function bf(e) {
    switch (e) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Ap() {
    if (typeof performance.getEntriesByType == "function") {
      for (var e = 0, a = 0, t = performance.getEntriesByType("resource"), l = 0; l < t.length; l++) {
        var n = t[l], s = n.transferSize, u = n.initiatorType, c = n.duration;
        if (s && c && bf(u)) {
          for (u = 0, c = n.responseEnd, l += 1; l < t.length; l++) {
            var d = t[l], g = d.startTime;
            if (g > c) break;
            var N = d.transferSize, R = d.initiatorType;
            N && bf(R) && (d = d.responseEnd, u += N * (d < c ? 1 : (c - g) / (d - g)));
          }
          if (--l, a += 8 * (s + u) / (n.duration / 1e3), e++, 10 < e) break;
        }
      }
      if (0 < e) return a / e / 1e6;
    }
    return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
  }
  var vc = null, yc = null;
  function wi(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function Sf(e) {
    switch (e) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function zf(e, a) {
    if (e === 0)
      switch (a) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return e === 1 && a === "foreignObject" ? 0 : e;
  }
  function xc(e, a) {
    return e === "textarea" || e === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.children == "bigint" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
  }
  var gc = null;
  function Np() {
    var e = window.event;
    return e && e.type === "popstate" ? e === gc ? !1 : (gc = e, !0) : (gc = null, !1);
  }
  var Ef = typeof setTimeout == "function" ? setTimeout : void 0, Tp = typeof clearTimeout == "function" ? clearTimeout : void 0, Af = typeof Promise == "function" ? Promise : void 0, Op = typeof queueMicrotask == "function" ? queueMicrotask : typeof Af < "u" ? function(e) {
    return Af.resolve(null).then(e).catch(Mp);
  } : Ef;
  function Mp(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function bt(e) {
    return e === "head";
  }
  function Nf(e, a) {
    var t = a, l = 0;
    do {
      var n = t.nextSibling;
      if (e.removeChild(t), n && n.nodeType === 8)
        if (t = n.data, t === "/$" || t === "/&") {
          if (l === 0) {
            e.removeChild(n), ql(a);
            return;
          }
          l--;
        } else if (t === "$" || t === "$?" || t === "$~" || t === "$!" || t === "&")
          l++;
        else if (t === "html")
          Mn(e.ownerDocument.documentElement);
        else if (t === "head") {
          t = e.ownerDocument.head, Mn(t);
          for (var s = t.firstChild; s; ) {
            var u = s.nextSibling, c = s.nodeName;
            s[wl] || c === "SCRIPT" || c === "STYLE" || c === "LINK" && s.rel.toLowerCase() === "stylesheet" || t.removeChild(s), s = u;
          }
        } else
          t === "body" && Mn(e.ownerDocument.body);
      t = n;
    } while (t);
    ql(a);
  }
  function Tf(e, a) {
    var t = e;
    e = 0;
    do {
      var l = t.nextSibling;
      if (t.nodeType === 1 ? a ? (t._stashedDisplay = t.style.display, t.style.display = "none") : (t.style.display = t._stashedDisplay || "", t.getAttribute("style") === "" && t.removeAttribute("style")) : t.nodeType === 3 && (a ? (t._stashedText = t.nodeValue, t.nodeValue = "") : t.nodeValue = t._stashedText || ""), l && l.nodeType === 8)
        if (t = l.data, t === "/$") {
          if (e === 0) break;
          e--;
        } else
          t !== "$" && t !== "$?" && t !== "$~" && t !== "$!" || e++;
      t = l;
    } while (t);
  }
  function jc(e) {
    var a = e.firstChild;
    for (a && a.nodeType === 10 && (a = a.nextSibling); a; ) {
      var t = a;
      switch (a = a.nextSibling, t.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          jc(t), As(t);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (t.rel.toLowerCase() === "stylesheet") continue;
      }
      e.removeChild(t);
    }
  }
  function Rp(e, a, t, l) {
    for (; e.nodeType === 1; ) {
      var n = t;
      if (e.nodeName.toLowerCase() !== a.toLowerCase()) {
        if (!l && (e.nodeName !== "INPUT" || e.type !== "hidden"))
          break;
      } else if (l) {
        if (!e[wl])
          switch (a) {
            case "meta":
              if (!e.hasAttribute("itemprop")) break;
              return e;
            case "link":
              if (s = e.getAttribute("rel"), s === "stylesheet" && e.hasAttribute("data-precedence"))
                break;
              if (s !== n.rel || e.getAttribute("href") !== (n.href == null || n.href === "" ? null : n.href) || e.getAttribute("crossorigin") !== (n.crossOrigin == null ? null : n.crossOrigin) || e.getAttribute("title") !== (n.title == null ? null : n.title))
                break;
              return e;
            case "style":
              if (e.hasAttribute("data-precedence")) break;
              return e;
            case "script":
              if (s = e.getAttribute("src"), (s !== (n.src == null ? null : n.src) || e.getAttribute("type") !== (n.type == null ? null : n.type) || e.getAttribute("crossorigin") !== (n.crossOrigin == null ? null : n.crossOrigin)) && s && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                break;
              return e;
            default:
              return e;
          }
      } else if (a === "input" && e.type === "hidden") {
        var s = n.name == null ? null : "" + n.name;
        if (n.type === "hidden" && e.getAttribute("name") === s)
          return e;
      } else return e;
      if (e = za(e.nextSibling), e === null) break;
    }
    return null;
  }
  function Dp(e, a, t) {
    if (a === "") return null;
    for (; e.nodeType !== 3; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = za(e.nextSibling), e === null)) return null;
    return e;
  }
  function Of(e, a) {
    for (; e.nodeType !== 8; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !a || (e = za(e.nextSibling), e === null)) return null;
    return e;
  }
  function bc(e) {
    return e.data === "$?" || e.data === "$~";
  }
  function Sc(e) {
    return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
  }
  function Up(e, a) {
    var t = e.ownerDocument;
    if (e.data === "$~") e._reactRetry = a;
    else if (e.data !== "$?" || t.readyState !== "loading")
      a();
    else {
      var l = function() {
        a(), t.removeEventListener("DOMContentLoaded", l);
      };
      t.addEventListener("DOMContentLoaded", l), e._reactRetry = l;
    }
  }
  function za(e) {
    for (; e != null; e = e.nextSibling) {
      var a = e.nodeType;
      if (a === 1 || a === 3) break;
      if (a === 8) {
        if (a = e.data, a === "$" || a === "$!" || a === "$?" || a === "$~" || a === "&" || a === "F!" || a === "F")
          break;
        if (a === "/$" || a === "/&") return null;
      }
    }
    return e;
  }
  var zc = null;
  function Mf(e) {
    e = e.nextSibling;
    for (var a = 0; e; ) {
      if (e.nodeType === 8) {
        var t = e.data;
        if (t === "/$" || t === "/&") {
          if (a === 0)
            return za(e.nextSibling);
          a--;
        } else
          t !== "$" && t !== "$!" && t !== "$?" && t !== "$~" && t !== "&" || a++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function Rf(e) {
    e = e.previousSibling;
    for (var a = 0; e; ) {
      if (e.nodeType === 8) {
        var t = e.data;
        if (t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&") {
          if (a === 0) return e;
          a--;
        } else t !== "/$" && t !== "/&" || a++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function Df(e, a, t) {
    switch (a = wi(t), e) {
      case "html":
        if (e = a.documentElement, !e) throw Error(o(452));
        return e;
      case "head":
        if (e = a.head, !e) throw Error(o(453));
        return e;
      case "body":
        if (e = a.body, !e) throw Error(o(454));
        return e;
      default:
        throw Error(o(451));
    }
  }
  function Mn(e) {
    for (var a = e.attributes; a.length; )
      e.removeAttributeNode(a[0]);
    As(e);
  }
  var Ea = /* @__PURE__ */ new Map(), Uf = /* @__PURE__ */ new Set();
  function Ki(e) {
    return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
  }
  var at = U.d;
  U.d = {
    f: Cp,
    r: _p,
    D: qp,
    C: Hp,
    L: Bp,
    m: Lp,
    X: Gp,
    S: Yp,
    M: Vp
  };
  function Cp() {
    var e = at.f(), a = Li();
    return e || a;
  }
  function _p(e) {
    var a = el(e);
    a !== null && a.tag === 5 && a.type === "form" ? Jr(a) : at.r(e);
  }
  var Ul = typeof document > "u" ? null : document;
  function Cf(e, a, t) {
    var l = Ul;
    if (l && typeof a == "string" && a) {
      var n = va(a);
      n = 'link[rel="' + e + '"][href="' + n + '"]', typeof t == "string" && (n += '[crossorigin="' + t + '"]'), Uf.has(n) || (Uf.add(n), e = { rel: e, crossOrigin: t, href: a }, l.querySelector(n) === null && (a = l.createElement("link"), we(a, "link", e), Ge(a), l.head.appendChild(a)));
    }
  }
  function qp(e) {
    at.D(e), Cf("dns-prefetch", e, null);
  }
  function Hp(e, a) {
    at.C(e, a), Cf("preconnect", e, a);
  }
  function Bp(e, a, t) {
    at.L(e, a, t);
    var l = Ul;
    if (l && e && a) {
      var n = 'link[rel="preload"][as="' + va(a) + '"]';
      a === "image" && t && t.imageSrcSet ? (n += '[imagesrcset="' + va(
        t.imageSrcSet
      ) + '"]', typeof t.imageSizes == "string" && (n += '[imagesizes="' + va(
        t.imageSizes
      ) + '"]')) : n += '[href="' + va(e) + '"]';
      var s = n;
      switch (a) {
        case "style":
          s = Cl(e);
          break;
        case "script":
          s = _l(e);
      }
      Ea.has(s) || (e = _(
        {
          rel: "preload",
          href: a === "image" && t && t.imageSrcSet ? void 0 : e,
          as: a
        },
        t
      ), Ea.set(s, e), l.querySelector(n) !== null || a === "style" && l.querySelector(Rn(s)) || a === "script" && l.querySelector(Dn(s)) || (a = l.createElement("link"), we(a, "link", e), Ge(a), l.head.appendChild(a)));
    }
  }
  function Lp(e, a) {
    at.m(e, a);
    var t = Ul;
    if (t && e) {
      var l = a && typeof a.as == "string" ? a.as : "script", n = 'link[rel="modulepreload"][as="' + va(l) + '"][href="' + va(e) + '"]', s = n;
      switch (l) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          s = _l(e);
      }
      if (!Ea.has(s) && (e = _({ rel: "modulepreload", href: e }, a), Ea.set(s, e), t.querySelector(n) === null)) {
        switch (l) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (t.querySelector(Dn(s)))
              return;
        }
        l = t.createElement("link"), we(l, "link", e), Ge(l), t.head.appendChild(l);
      }
    }
  }
  function Yp(e, a, t) {
    at.S(e, a, t);
    var l = Ul;
    if (l && e) {
      var n = al(l).hoistableStyles, s = Cl(e);
      a = a || "default";
      var u = n.get(s);
      if (!u) {
        var c = { loading: 0, preload: null };
        if (u = l.querySelector(
          Rn(s)
        ))
          c.loading = 5;
        else {
          e = _(
            { rel: "stylesheet", href: e, "data-precedence": a },
            t
          ), (t = Ea.get(s)) && Ec(e, t);
          var d = u = l.createElement("link");
          Ge(d), we(d, "link", e), d._p = new Promise(function(g, N) {
            d.onload = g, d.onerror = N;
          }), d.addEventListener("load", function() {
            c.loading |= 1;
          }), d.addEventListener("error", function() {
            c.loading |= 2;
          }), c.loading |= 4, Ji(u, a, l);
        }
        u = {
          type: "stylesheet",
          instance: u,
          count: 1,
          state: c
        }, n.set(s, u);
      }
    }
  }
  function Gp(e, a) {
    at.X(e, a);
    var t = Ul;
    if (t && e) {
      var l = al(t).hoistableScripts, n = _l(e), s = l.get(n);
      s || (s = t.querySelector(Dn(n)), s || (e = _({ src: e, async: !0 }, a), (a = Ea.get(n)) && Ac(e, a), s = t.createElement("script"), Ge(s), we(s, "link", e), t.head.appendChild(s)), s = {
        type: "script",
        instance: s,
        count: 1,
        state: null
      }, l.set(n, s));
    }
  }
  function Vp(e, a) {
    at.M(e, a);
    var t = Ul;
    if (t && e) {
      var l = al(t).hoistableScripts, n = _l(e), s = l.get(n);
      s || (s = t.querySelector(Dn(n)), s || (e = _({ src: e, async: !0, type: "module" }, a), (a = Ea.get(n)) && Ac(e, a), s = t.createElement("script"), Ge(s), we(s, "link", e), t.head.appendChild(s)), s = {
        type: "script",
        instance: s,
        count: 1,
        state: null
      }, l.set(n, s));
    }
  }
  function _f(e, a, t, l) {
    var n = (n = ae.current) ? Ki(n) : null;
    if (!n) throw Error(o(446));
    switch (e) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof t.precedence == "string" && typeof t.href == "string" ? (a = Cl(t.href), t = al(
          n
        ).hoistableStyles, l = t.get(a), l || (l = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, t.set(a, l)), l) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (t.rel === "stylesheet" && typeof t.href == "string" && typeof t.precedence == "string") {
          e = Cl(t.href);
          var s = al(
            n
          ).hoistableStyles, u = s.get(e);
          if (u || (n = n.ownerDocument || n, u = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, s.set(e, u), (s = n.querySelector(
            Rn(e)
          )) && !s._p && (u.instance = s, u.state.loading = 5), Ea.has(e) || (t = {
            rel: "preload",
            as: "style",
            href: t.href,
            crossOrigin: t.crossOrigin,
            integrity: t.integrity,
            media: t.media,
            hrefLang: t.hrefLang,
            referrerPolicy: t.referrerPolicy
          }, Ea.set(e, t), s || Qp(
            n,
            e,
            t,
            u.state
          ))), a && l === null)
            throw Error(o(528, ""));
          return u;
        }
        if (a && l !== null)
          throw Error(o(529, ""));
        return null;
      case "script":
        return a = t.async, t = t.src, typeof t == "string" && a && typeof a != "function" && typeof a != "symbol" ? (a = _l(t), t = al(
          n
        ).hoistableScripts, l = t.get(a), l || (l = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, t.set(a, l)), l) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(o(444, e));
    }
  }
  function Cl(e) {
    return 'href="' + va(e) + '"';
  }
  function Rn(e) {
    return 'link[rel="stylesheet"][' + e + "]";
  }
  function qf(e) {
    return _({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function Qp(e, a, t, l) {
    e.querySelector('link[rel="preload"][as="style"][' + a + "]") ? l.loading = 1 : (a = e.createElement("link"), l.preload = a, a.addEventListener("load", function() {
      return l.loading |= 1;
    }), a.addEventListener("error", function() {
      return l.loading |= 2;
    }), we(a, "link", t), Ge(a), e.head.appendChild(a));
  }
  function _l(e) {
    return '[src="' + va(e) + '"]';
  }
  function Dn(e) {
    return "script[async]" + e;
  }
  function Hf(e, a, t) {
    if (a.count++, a.instance === null)
      switch (a.type) {
        case "style":
          var l = e.querySelector(
            'style[data-href~="' + va(t.href) + '"]'
          );
          if (l)
            return a.instance = l, Ge(l), l;
          var n = _({}, t, {
            "data-href": t.href,
            "data-precedence": t.precedence,
            href: null,
            precedence: null
          });
          return l = (e.ownerDocument || e).createElement(
            "style"
          ), Ge(l), we(l, "style", n), Ji(l, t.precedence, e), a.instance = l;
        case "stylesheet":
          n = Cl(t.href);
          var s = e.querySelector(
            Rn(n)
          );
          if (s)
            return a.state.loading |= 4, a.instance = s, Ge(s), s;
          l = qf(t), (n = Ea.get(n)) && Ec(l, n), s = (e.ownerDocument || e).createElement("link"), Ge(s);
          var u = s;
          return u._p = new Promise(function(c, d) {
            u.onload = c, u.onerror = d;
          }), we(s, "link", l), a.state.loading |= 4, Ji(s, t.precedence, e), a.instance = s;
        case "script":
          return s = _l(t.src), (n = e.querySelector(
            Dn(s)
          )) ? (a.instance = n, Ge(n), n) : (l = t, (n = Ea.get(s)) && (l = _({}, t), Ac(l, n)), e = e.ownerDocument || e, n = e.createElement("script"), Ge(n), we(n, "link", l), e.head.appendChild(n), a.instance = n);
        case "void":
          return null;
        default:
          throw Error(o(443, a.type));
      }
    else
      a.type === "stylesheet" && (a.state.loading & 4) === 0 && (l = a.instance, a.state.loading |= 4, Ji(l, t.precedence, e));
    return a.instance;
  }
  function Ji(e, a, t) {
    for (var l = t.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), n = l.length ? l[l.length - 1] : null, s = n, u = 0; u < l.length; u++) {
      var c = l[u];
      if (c.dataset.precedence === a) s = c;
      else if (s !== n) break;
    }
    s ? s.parentNode.insertBefore(e, s.nextSibling) : (a = t.nodeType === 9 ? t.head : t, a.insertBefore(e, a.firstChild));
  }
  function Ec(e, a) {
    e.crossOrigin == null && (e.crossOrigin = a.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = a.referrerPolicy), e.title == null && (e.title = a.title);
  }
  function Ac(e, a) {
    e.crossOrigin == null && (e.crossOrigin = a.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = a.referrerPolicy), e.integrity == null && (e.integrity = a.integrity);
  }
  var $i = null;
  function Bf(e, a, t) {
    if ($i === null) {
      var l = /* @__PURE__ */ new Map(), n = $i = /* @__PURE__ */ new Map();
      n.set(t, l);
    } else
      n = $i, l = n.get(t), l || (l = /* @__PURE__ */ new Map(), n.set(t, l));
    if (l.has(e)) return l;
    for (l.set(e, null), t = t.getElementsByTagName(e), n = 0; n < t.length; n++) {
      var s = t[n];
      if (!(s[wl] || s[Qe] || e === "link" && s.getAttribute("rel") === "stylesheet") && s.namespaceURI !== "http://www.w3.org/2000/svg") {
        var u = s.getAttribute(a) || "";
        u = e + u;
        var c = l.get(u);
        c ? c.push(s) : l.set(u, [s]);
      }
    }
    return l;
  }
  function Lf(e, a, t) {
    e = e.ownerDocument || e, e.head.insertBefore(
      t,
      a === "title" ? e.querySelector("head > title") : null
    );
  }
  function Xp(e, a, t) {
    if (t === 1 || a.itemProp != null) return !1;
    switch (e) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof a.precedence != "string" || typeof a.href != "string" || a.href === "")
          break;
        return !0;
      case "link":
        if (typeof a.rel != "string" || typeof a.href != "string" || a.href === "" || a.onLoad || a.onError)
          break;
        switch (a.rel) {
          case "stylesheet":
            return e = a.disabled, typeof a.precedence == "string" && e == null;
          default:
            return !0;
        }
      case "script":
        if (a.async && typeof a.async != "function" && typeof a.async != "symbol" && !a.onLoad && !a.onError && a.src && typeof a.src == "string")
          return !0;
    }
    return !1;
  }
  function Yf(e) {
    return !(e.type === "stylesheet" && (e.state.loading & 3) === 0);
  }
  function Zp(e, a, t, l) {
    if (t.type === "stylesheet" && (typeof l.media != "string" || matchMedia(l.media).matches !== !1) && (t.state.loading & 4) === 0) {
      if (t.instance === null) {
        var n = Cl(l.href), s = a.querySelector(
          Rn(n)
        );
        if (s) {
          a = s._p, a !== null && typeof a == "object" && typeof a.then == "function" && (e.count++, e = Wi.bind(e), a.then(e, e)), t.state.loading |= 4, t.instance = s, Ge(s);
          return;
        }
        s = a.ownerDocument || a, l = qf(l), (n = Ea.get(n)) && Ec(l, n), s = s.createElement("link"), Ge(s);
        var u = s;
        u._p = new Promise(function(c, d) {
          u.onload = c, u.onerror = d;
        }), we(s, "link", l), t.instance = s;
      }
      e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(t, a), (a = t.state.preload) && (t.state.loading & 3) === 0 && (e.count++, t = Wi.bind(e), a.addEventListener("load", t), a.addEventListener("error", t));
    }
  }
  var Nc = 0;
  function kp(e, a) {
    return e.stylesheets && e.count === 0 && Ii(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(t) {
      var l = setTimeout(function() {
        if (e.stylesheets && Ii(e, e.stylesheets), e.unsuspend) {
          var s = e.unsuspend;
          e.unsuspend = null, s();
        }
      }, 6e4 + a);
      0 < e.imgBytes && Nc === 0 && (Nc = 62500 * Ap());
      var n = setTimeout(
        function() {
          if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Ii(e, e.stylesheets), e.unsuspend)) {
            var s = e.unsuspend;
            e.unsuspend = null, s();
          }
        },
        (e.imgBytes > Nc ? 50 : 800) + a
      );
      return e.unsuspend = t, function() {
        e.unsuspend = null, clearTimeout(l), clearTimeout(n);
      };
    } : null;
  }
  function Wi() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Ii(this, this.stylesheets);
      else if (this.unsuspend) {
        var e = this.unsuspend;
        this.unsuspend = null, e();
      }
    }
  }
  var Fi = null;
  function Ii(e, a) {
    e.stylesheets = null, e.unsuspend !== null && (e.count++, Fi = /* @__PURE__ */ new Map(), a.forEach(wp, e), Fi = null, Wi.call(e));
  }
  function wp(e, a) {
    if (!(a.state.loading & 4)) {
      var t = Fi.get(e);
      if (t) var l = t.get(null);
      else {
        t = /* @__PURE__ */ new Map(), Fi.set(e, t);
        for (var n = e.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), s = 0; s < n.length; s++) {
          var u = n[s];
          (u.nodeName === "LINK" || u.getAttribute("media") !== "not all") && (t.set(u.dataset.precedence, u), l = u);
        }
        l && t.set(null, l);
      }
      n = a.instance, u = n.getAttribute("data-precedence"), s = t.get(u) || l, s === l && t.set(null, n), t.set(u, n), this.count++, l = Wi.bind(this), n.addEventListener("load", l), n.addEventListener("error", l), s ? s.parentNode.insertBefore(n, s.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(n, e.firstChild)), a.state.loading |= 4;
    }
  }
  var Un = {
    $$typeof: oe,
    Provider: null,
    Consumer: null,
    _currentValue: K,
    _currentValue2: K,
    _threadCount: 0
  };
  function Kp(e, a, t, l, n, s, u, c, d) {
    this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = bs(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = bs(0), this.hiddenUpdates = bs(null), this.identifierPrefix = l, this.onUncaughtError = n, this.onCaughtError = s, this.onRecoverableError = u, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = d, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Gf(e, a, t, l, n, s, u, c, d, g, N, R) {
    return e = new Kp(
      e,
      a,
      t,
      u,
      d,
      g,
      N,
      R,
      c
    ), a = 1, s === !0 && (a |= 24), s = oa(3, null, null, a), e.current = s, s.stateNode = e, a = iu(), a.refCount++, e.pooledCache = a, a.refCount++, s.memoizedState = {
      element: l,
      isDehydrated: t,
      cache: a
    }, ou(s), e;
  }
  function Vf(e) {
    return e ? (e = dl, e) : dl;
  }
  function Qf(e, a, t, l, n, s) {
    n = Vf(n), l.context === null ? l.context = n : l.pendingContext = n, l = rt(a), l.payload = { element: t }, s = s === void 0 ? null : s, s !== null && (l.callback = s), t = dt(e, l, a), t !== null && (la(t, e, a), rn(t, e, a));
  }
  function Xf(e, a) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var t = e.retryLane;
      e.retryLane = t !== 0 && t < a ? t : a;
    }
  }
  function Tc(e, a) {
    Xf(e, a), (e = e.alternate) && Xf(e, a);
  }
  function Zf(e) {
    if (e.tag === 13 || e.tag === 31) {
      var a = Bt(e, 67108864);
      a !== null && la(a, e, 67108864), Tc(e, 67108864);
    }
  }
  function kf(e) {
    if (e.tag === 13 || e.tag === 31) {
      var a = ha();
      a = Ss(a);
      var t = Bt(e, a);
      t !== null && la(t, e, a), Tc(e, a);
    }
  }
  var Pi = !0;
  function Jp(e, a, t, l) {
    var n = T.T;
    T.T = null;
    var s = U.p;
    try {
      U.p = 2, Oc(e, a, t, l);
    } finally {
      U.p = s, T.T = n;
    }
  }
  function $p(e, a, t, l) {
    var n = T.T;
    T.T = null;
    var s = U.p;
    try {
      U.p = 8, Oc(e, a, t, l);
    } finally {
      U.p = s, T.T = n;
    }
  }
  function Oc(e, a, t, l) {
    if (Pi) {
      var n = Mc(l);
      if (n === null)
        hc(
          e,
          a,
          l,
          es,
          t
        ), Kf(e, l);
      else if (Fp(
        n,
        e,
        a,
        t,
        l
      ))
        l.stopPropagation();
      else if (Kf(e, l), a & 4 && -1 < Wp.indexOf(e)) {
        for (; n !== null; ) {
          var s = el(n);
          if (s !== null)
            switch (s.tag) {
              case 3:
                if (s = s.stateNode, s.current.memoizedState.isDehydrated) {
                  var u = Ut(s.pendingLanes);
                  if (u !== 0) {
                    var c = s;
                    for (c.pendingLanes |= 2, c.entangledLanes |= 2; u; ) {
                      var d = 1 << 31 - ua(u);
                      c.entanglements[1] |= d, u &= ~d;
                    }
                    _a(s), (fe & 6) === 0 && (Hi = ia() + 500, Nn(0));
                  }
                }
                break;
              case 31:
              case 13:
                c = Bt(s, 2), c !== null && la(c, s, 2), Li(), Tc(s, 2);
            }
          if (s = Mc(l), s === null && hc(
            e,
            a,
            l,
            es,
            t
          ), s === n) break;
          n = s;
        }
        n !== null && l.stopPropagation();
      } else
        hc(
          e,
          a,
          l,
          null,
          t
        );
    }
  }
  function Mc(e) {
    return e = Ds(e), Rc(e);
  }
  var es = null;
  function Rc(e) {
    if (es = null, e = Pt(e), e !== null) {
      var a = M(e);
      if (a === null) e = null;
      else {
        var t = a.tag;
        if (t === 13) {
          if (e = p(a), e !== null) return e;
          e = null;
        } else if (t === 31) {
          if (e = E(a), e !== null) return e;
          e = null;
        } else if (t === 3) {
          if (a.stateNode.current.memoizedState.isDehydrated)
            return a.tag === 3 ? a.stateNode.containerInfo : null;
          e = null;
        } else a !== e && (e = null);
      }
    }
    return es = e, null;
  }
  function wf(e) {
    switch (e) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (qm()) {
          case Ic:
            return 2;
          case Pc:
            return 8;
          case Xn:
          case Hm:
            return 32;
          case eo:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Dc = !1, St = null, zt = null, Et = null, Cn = /* @__PURE__ */ new Map(), _n = /* @__PURE__ */ new Map(), At = [], Wp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Kf(e, a) {
    switch (e) {
      case "focusin":
      case "focusout":
        St = null;
        break;
      case "dragenter":
      case "dragleave":
        zt = null;
        break;
      case "mouseover":
      case "mouseout":
        Et = null;
        break;
      case "pointerover":
      case "pointerout":
        Cn.delete(a.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        _n.delete(a.pointerId);
    }
  }
  function qn(e, a, t, l, n, s) {
    return e === null || e.nativeEvent !== s ? (e = {
      blockedOn: a,
      domEventName: t,
      eventSystemFlags: l,
      nativeEvent: s,
      targetContainers: [n]
    }, a !== null && (a = el(a), a !== null && Zf(a)), e) : (e.eventSystemFlags |= l, a = e.targetContainers, n !== null && a.indexOf(n) === -1 && a.push(n), e);
  }
  function Fp(e, a, t, l, n) {
    switch (a) {
      case "focusin":
        return St = qn(
          St,
          e,
          a,
          t,
          l,
          n
        ), !0;
      case "dragenter":
        return zt = qn(
          zt,
          e,
          a,
          t,
          l,
          n
        ), !0;
      case "mouseover":
        return Et = qn(
          Et,
          e,
          a,
          t,
          l,
          n
        ), !0;
      case "pointerover":
        var s = n.pointerId;
        return Cn.set(
          s,
          qn(
            Cn.get(s) || null,
            e,
            a,
            t,
            l,
            n
          )
        ), !0;
      case "gotpointercapture":
        return s = n.pointerId, _n.set(
          s,
          qn(
            _n.get(s) || null,
            e,
            a,
            t,
            l,
            n
          )
        ), !0;
    }
    return !1;
  }
  function Jf(e) {
    var a = Pt(e.target);
    if (a !== null) {
      var t = M(a);
      if (t !== null) {
        if (a = t.tag, a === 13) {
          if (a = p(t), a !== null) {
            e.blockedOn = a, so(e.priority, function() {
              kf(t);
            });
            return;
          }
        } else if (a === 31) {
          if (a = E(t), a !== null) {
            e.blockedOn = a, so(e.priority, function() {
              kf(t);
            });
            return;
          }
        } else if (a === 3 && t.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = t.tag === 3 ? t.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function as(e) {
    if (e.blockedOn !== null) return !1;
    for (var a = e.targetContainers; 0 < a.length; ) {
      var t = Mc(e.nativeEvent);
      if (t === null) {
        t = e.nativeEvent;
        var l = new t.constructor(
          t.type,
          t
        );
        Rs = l, t.target.dispatchEvent(l), Rs = null;
      } else
        return a = el(t), a !== null && Zf(a), e.blockedOn = t, !1;
      a.shift();
    }
    return !0;
  }
  function $f(e, a, t) {
    as(e) && t.delete(a);
  }
  function Ip() {
    Dc = !1, St !== null && as(St) && (St = null), zt !== null && as(zt) && (zt = null), Et !== null && as(Et) && (Et = null), Cn.forEach($f), _n.forEach($f);
  }
  function ts(e, a) {
    e.blockedOn === a && (e.blockedOn = null, Dc || (Dc = !0, r.unstable_scheduleCallback(
      r.unstable_NormalPriority,
      Ip
    )));
  }
  var ls = null;
  function Wf(e) {
    ls !== e && (ls = e, r.unstable_scheduleCallback(
      r.unstable_NormalPriority,
      function() {
        ls === e && (ls = null);
        for (var a = 0; a < e.length; a += 3) {
          var t = e[a], l = e[a + 1], n = e[a + 2];
          if (typeof l != "function") {
            if (Rc(l || t) === null)
              continue;
            break;
          }
          var s = el(t);
          s !== null && (e.splice(a, 3), a -= 3, Mu(
            s,
            {
              pending: !0,
              data: n,
              method: t.method,
              action: l
            },
            l,
            n
          ));
        }
      }
    ));
  }
  function ql(e) {
    function a(d) {
      return ts(d, e);
    }
    St !== null && ts(St, e), zt !== null && ts(zt, e), Et !== null && ts(Et, e), Cn.forEach(a), _n.forEach(a);
    for (var t = 0; t < At.length; t++) {
      var l = At[t];
      l.blockedOn === e && (l.blockedOn = null);
    }
    for (; 0 < At.length && (t = At[0], t.blockedOn === null); )
      Jf(t), t.blockedOn === null && At.shift();
    if (t = (e.ownerDocument || e).$$reactFormReplay, t != null)
      for (l = 0; l < t.length; l += 3) {
        var n = t[l], s = t[l + 1], u = n[Fe] || null;
        if (typeof s == "function")
          u || Wf(t);
        else if (u) {
          var c = null;
          if (s && s.hasAttribute("formAction")) {
            if (n = s, u = s[Fe] || null)
              c = u.formAction;
            else if (Rc(n) !== null) continue;
          } else c = u.action;
          typeof c == "function" ? t[l + 1] = c : (t.splice(l, 3), l -= 3), Wf(t);
        }
      }
  }
  function Ff() {
    function e(s) {
      s.canIntercept && s.info === "react-transition" && s.intercept({
        handler: function() {
          return new Promise(function(u) {
            return n = u;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function a() {
      n !== null && (n(), n = null), l || setTimeout(t, 20);
    }
    function t() {
      if (!l && !navigation.transition) {
        var s = navigation.currentEntry;
        s && s.url != null && navigation.navigate(s.url, {
          state: s.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var l = !1, n = null;
      return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", a), navigation.addEventListener("navigateerror", a), setTimeout(t, 100), function() {
        l = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", a), navigation.removeEventListener("navigateerror", a), n !== null && (n(), n = null);
      };
    }
  }
  function Uc(e) {
    this._internalRoot = e;
  }
  ns.prototype.render = Uc.prototype.render = function(e) {
    var a = this._internalRoot;
    if (a === null) throw Error(o(409));
    var t = a.current, l = ha();
    Qf(t, l, e, a, null, null);
  }, ns.prototype.unmount = Uc.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var a = e.containerInfo;
      Qf(e.current, 2, null, e, null, null), Li(), a[It] = null;
    }
  };
  function ns(e) {
    this._internalRoot = e;
  }
  ns.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var a = io();
      e = { blockedOn: null, target: e, priority: a };
      for (var t = 0; t < At.length && a !== 0 && a < At[t].priority; t++) ;
      At.splice(t, 0, e), t === 0 && Jf(e);
    }
  };
  var If = x.version;
  if (If !== "19.2.3")
    throw Error(
      o(
        527,
        If,
        "19.2.3"
      )
    );
  U.findDOMNode = function(e) {
    var a = e._reactInternals;
    if (a === void 0)
      throw typeof e.render == "function" ? Error(o(188)) : (e = Object.keys(e).join(","), Error(o(268, e)));
    return e = S(a), e = e !== null ? q(e) : null, e = e === null ? null : e.stateNode, e;
  };
  var Pp = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: T,
    reconcilerVersion: "19.2.3"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var is = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!is.isDisabled && is.supportsFiber)
      try {
        Xl = is.inject(
          Pp
        ), sa = is;
      } catch {
      }
  }
  return Bn.createRoot = function(e, a) {
    if (!b(e)) throw Error(o(299));
    var t = !1, l = "", n = nd, s = id, u = sd;
    return a != null && (a.unstable_strictMode === !0 && (t = !0), a.identifierPrefix !== void 0 && (l = a.identifierPrefix), a.onUncaughtError !== void 0 && (n = a.onUncaughtError), a.onCaughtError !== void 0 && (s = a.onCaughtError), a.onRecoverableError !== void 0 && (u = a.onRecoverableError)), a = Gf(
      e,
      1,
      !1,
      null,
      null,
      t,
      l,
      null,
      n,
      s,
      u,
      Ff
    ), e[It] = a.current, mc(e), new Uc(a);
  }, Bn.hydrateRoot = function(e, a, t) {
    if (!b(e)) throw Error(o(299));
    var l = !1, n = "", s = nd, u = id, c = sd, d = null;
    return t != null && (t.unstable_strictMode === !0 && (l = !0), t.identifierPrefix !== void 0 && (n = t.identifierPrefix), t.onUncaughtError !== void 0 && (s = t.onUncaughtError), t.onCaughtError !== void 0 && (u = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError), t.formState !== void 0 && (d = t.formState)), a = Gf(
      e,
      1,
      !0,
      a,
      t ?? null,
      l,
      n,
      d,
      s,
      u,
      c,
      Ff
    ), a.context = Vf(null), t = a.current, l = ha(), l = Ss(l), n = rt(l), n.callback = null, dt(t, n, l), t = l, a.current.lanes = t, kl(a, t), _a(a), e[It] = a.current, mc(e), new ns(a);
  }, Bn.version = "19.2.3", Bn;
}
var cm;
function ov() {
  if (cm) return qc.exports;
  cm = 1;
  function r() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
      } catch (x) {
        console.error(x);
      }
  }
  return r(), qc.exports = cv(), qc.exports;
}
var Qc = ov();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rv = (r) => r.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), jm = (...r) => r.filter((x, m, o) => !!x && x.trim() !== "" && o.indexOf(x) === m).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var dv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fv = V.forwardRef(
  ({
    color: r = "currentColor",
    size: x = 24,
    strokeWidth: m = 2,
    absoluteStrokeWidth: o,
    className: b = "",
    children: M,
    iconNode: p,
    ...E
  }, A) => V.createElement(
    "svg",
    {
      ref: A,
      ...dv,
      width: x,
      height: x,
      stroke: r,
      strokeWidth: o ? Number(m) * 24 / Number(x) : m,
      className: jm("lucide", b),
      ...E
    },
    [
      ...p.map(([S, q]) => V.createElement(S, q)),
      ...Array.isArray(M) ? M : [M]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P = (r, x) => {
  const m = V.forwardRef(
    ({ className: o, ...b }, M) => V.createElement(fv, {
      ref: M,
      iconNode: x,
      className: jm(`lucide-${rv(r)}`, o),
      ...b
    })
  );
  return m.displayName = `${r}`, m;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gl = P("Activity", [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bm = P("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mv = P("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ra = P("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ne = P("ArrowUpRight", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hv = P("Bluetooth", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pv = P("BookOpen", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ll = P("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xc = P("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qa = P("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jc = P("CircleHelp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vv = P("CloudRain", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yv = P("CloudSun", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xv = P("Cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sm = P("HeartPulse", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gv = P("History", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rs = P("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zm = P("MessageCircle", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jv = P("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vl = P("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bv = P("Package", [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["path", { d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7", key: "yx3hmr" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sv = P("Pencil", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zv = P("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hl = P("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ot = P("Ruler", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ev = P("ScanLine", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Av = P("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const om = P("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nv = P("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zc = P("ShoppingBag", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Em = P("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ds = P("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tv = P("Sunrise", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ov = P("Table2", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mv = P("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mt = P("Waves", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Am = P("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rv = P("ZoomIn", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dv = P("ZoomOut", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]), cs = [{
  id: "silver",
  name: "Prata",
  color: "#bec0bd",
  image: globalThis.rheoAsset("silver-hero.webp"),
  description: "Luz em cada detalhe."
}, {
  id: "gold",
  name: "Dourado",
  color: "#bfa26c",
  image: globalThis.rheoAsset("gold-hero.webp"),
  description: "Um toque de calor."
}, {
  id: "black",
  name: "Preto",
  color: "#333734",
  image: globalThis.rheoAsset("black-hero.webp"),
  description: "Presença sem excessos."
}], Yn = [{
  size: 7,
  cm: 5.44
}, {
  size: 8,
  cm: 5.7
}, {
  size: 9,
  cm: 5.95
}, {
  size: 10,
  cm: 6.21
}, {
  size: 11,
  cm: 6.46
}, {
  size: 12,
  cm: 6.72
}, {
  size: 13,
  cm: 6.97
}];
function Uv(r) {
  const x = String(r).trim().replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(x)) return null;
  const m = Number(x);
  return m < Yn[0].cm || m > Yn.at(-1).cm ? null : Yn.reduce((o, b) => Math.abs(b.cm - m) < Math.abs(o.cm - m) ? b : o);
}
function Ft({
  label: r,
  children: x,
  ...m
}) {
  return /* @__PURE__ */ i.jsx("button", { className: "icon-button", "aria-label": r, title: r, ...m, children: x });
}
function Yl({
  title: r,
  children: x,
  onClose: m,
  type: o = "",
  wide: b = !1
}) {
  const M = V.useRef(null);
  return V.useEffect(() => {
    const p = document.activeElement, E = document.body.style.overflow;
    return document.body.style.overflow = "hidden", M.current.showModal(), () => {
      var A;
      document.body.style.overflow = E, (A = p == null ? void 0 : p.focus) == null || A.call(p);
    };
  }, []), /* @__PURE__ */ i.jsx("dialog", { ref: M, className: `overlay ${o} ${b ? "wide" : ""}`, "aria-label": r, onCancel: (p) => {
    p.preventDefault(), m();
  }, onClick: (p) => {
    p.target === p.currentTarget && m();
  }, children: /* @__PURE__ */ i.jsxs("div", { className: "dialog-interior", children: [
    /* @__PURE__ */ i.jsxs("header", { className: "dialog-header", children: [
      /* @__PURE__ */ i.jsx("span", { children: r }),
      /* @__PURE__ */ i.jsx(Ft, { label: "Fechar", onClick: m, children: /* @__PURE__ */ i.jsx(Am, { size: 21 }) })
    ] }),
    x
  ] }) });
}
const Yc = [{
  id: "today",
  label: "Seu ritmo",
  icon: Mt,
  title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "Um número.",
    /* @__PURE__ */ i.jsx("br", {}),
    /* @__PURE__ */ i.jsx("em", { children: "Mais contexto." })
  ] }),
  text: "O Rheo Flow traduz tendências em uma leitura do dia. Para olhar para você antes de olhar para a próxima meta.",
  metric: "78",
  metricLabel: "RHEO FLOW",
  caption: "Em equilíbrio",
  image: "app-today.png"
}, {
  id: "sleep",
  label: "Seu sono",
  icon: Vl,
  title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "A noite conta.",
    /* @__PURE__ */ i.jsx("br", {}),
    /* @__PURE__ */ i.jsx("em", { children: "O dia sente." })
  ] }),
  text: "Duração, horários e evolução do sono, juntos em uma visão simples. Conheça o ritmo das suas noites.",
  metric: "7h 26",
  metricLabel: "TEMPO DE SONO",
  caption: "Uma noite de cada vez",
  image: "app-sleep.png"
}, {
  id: "activity",
  label: "Seu movimento",
  icon: Gl,
  title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "Cada passo.",
    /* @__PURE__ */ i.jsx("br", {}),
    /* @__PURE__ */ i.jsx("em", { children: "No seu tempo." })
  ] }),
  text: "Do movimento de todos os dias à sua próxima sessão. Uma visão da atividade que acompanha a sua rotina.",
  metric: "5.203",
  metricLabel: "PASSOS DO DIA",
  caption: "Movimento que se soma",
  image: "app-activity.png"
}], Gn = (r) => r.toLocaleString("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}), ss = [{
  label: "Envolver",
  title: "Envolva. Sem apertar.",
  image: "fit-wrap.webp",
  alt: "Uma tira de papel contorna a base do dedo, com as pontas sobrepostas.",
  caption: "Encostado na pele. Sem comprimir.",
  description: "Escolha o dedo em que pretende usar o anel. A medida deve ser feita nesse mesmo dedo.",
  instructions: ["Separe papel, caneta e régua. Corte uma tira com cerca de 0,5 cm de largura.", "Envolva a base do dedo com o papel reto, sem torcer nem apertar a pele."],
  tip: "Evite medir com as mãos muito frias ou logo depois de treinar. O volume do dedo pode variar."
}, {
  label: "Marcar",
  title: "Marque o encontro.",
  image: "fit-mark.webp",
  alt: "A ponta da caneta marca onde a extremidade do papel encontra a volta da tira no dedo.",
  caption: "Uma marca no encontro das pontas.",
  description: "Segure o papel no lugar. O ponto de encontro é o que define a volta completa do seu dedo.",
  instructions: ["Faça uma linha fina onde a ponta inicial encontra a outra parte da tira.", "Antes de abrir, confira se a volta de papel passa pela articulação sem forçar."],
  tip: "Não meça até a ponta que sobrou. Você vai usar só a distância da ponta inicial até a marca."
}, {
  label: "Medir",
  title: "Da ponta até a marca.",
  image: "fit-measure.webp",
  alt: "Papel aberto ao lado de uma régua física: a ponta no zero e a marca indicando o fim da medida.",
  caption: "Ponta no zero. Leitura na marca.",
  description: "Abra a tira e alinhe a ponta inicial ao zero de uma régua física. Leia a distância até a marca, em centímetros."
}];
function Cv({
  value: r
}) {
  const x = Number(r.trim().replace(",", ".")), m = r.trim() !== "" && Number.isFinite(x) && x > 0 && x <= 7, o = m ? x : 6.8, b = 24 + o * 40;
  return /* @__PURE__ */ i.jsxs("div", { className: "fit-diagram", children: [
    /* @__PURE__ */ i.jsxs("svg", { viewBox: "0 0 328 98", role: "img", "aria-label": `${m ? "Sua medida" : "Exemplo"}: da ponta no zero até a marca em ${Gn(o)} centímetros. Ilustração fora de escala.`, children: [
      /* @__PURE__ */ i.jsx("rect", { x: "24", y: "28", width: "280", height: "20", rx: "2", fill: "#fff" }),
      /* @__PURE__ */ i.jsx("rect", { x: "24", y: "28", width: o * 40, height: "20", fill: "#d9e2d1" }),
      /* @__PURE__ */ i.jsx("path", { d: "M24 21V72", stroke: "#5d7162", strokeDasharray: "2 3" }),
      /* @__PURE__ */ i.jsx("path", { d: `M${b} 23V72`, stroke: "#9c5337", strokeWidth: "2" }),
      /* @__PURE__ */ i.jsx("text", { x: "24", y: "15", textAnchor: "start", children: "zero" }),
      /* @__PURE__ */ i.jsxs("text", { x: Math.max(104, Math.min(b, 264)), y: "15", textAnchor: "middle", fill: "#8a432c", children: [
        Gn(o),
        " cm"
      ] }),
      Array.from({
        length: 71
      }, (M, p) => /* @__PURE__ */ i.jsx("line", { x1: 24 + p * 4, x2: 24 + p * 4, y1: "55", y2: p % 10 === 0 ? 69 : p % 5 === 0 ? 65 : 61, stroke: "#687168", strokeWidth: p % 10 === 0 ? 1.2 : 0.6 }, p)),
      Array.from({
        length: 8
      }, (M, p) => /* @__PURE__ */ i.jsx("text", { x: 24 + p * 40, y: "85", textAnchor: "middle", children: p }, p))
    ] }),
    /* @__PURE__ */ i.jsxs("small", { children: [
      m ? "Sua medida ilustrada" : "Exemplo de leitura",
      " · Não use a tela como régua."
    ] })
  ] });
}
function _v({
  onClose: r,
  onSelect: x
}) {
  const [m, o] = V.useState(0), [b, M] = V.useState(""), [p, E] = V.useState(void 0), [A, S] = V.useState(!1), [q, _] = V.useState(!1), k = V.useRef(null), L = V.useRef(null), ne = V.useRef(!1), ce = V.useRef(null), ve = ss[m];
  V.useEffect(() => {
    ss.forEach(({
      image: w
    }) => {
      const H = new Image();
      H.src = globalThis.rheoAsset(`${w}`);
    });
  }, []), V.useEffect(() => {
    var w, H;
    if (!ne.current) {
      ne.current = !0;
      return;
    }
    (w = k.current) == null || w.scrollTo({
      top: 0,
      behavior: "instant"
    }), (H = L.current) == null || H.focus({
      preventScroll: !0
    });
  }, [m, A]), V.useLayoutEffect(() => {
    var w, H;
    p && ((w = k.current) == null || w.scrollTo({
      top: 0,
      behavior: "instant"
    }), (H = L.current) == null || H.focus({
      preventScroll: !0
    }));
  }, [p]);
  const I = (w) => {
    _(!1), S(!1), o(w);
  }, ee = (w) => {
    var Y;
    w.preventDefault();
    const H = Uv(b);
    E(H), H || (Y = ce.current) == null || Y.focus({
      preventScroll: !0
    });
  }, oe = Number(b.trim().replace(",", ".")), Me = p && Math.abs(oe - p.cm) > 1e-3;
  return /* @__PURE__ */ i.jsx(Yl, { title: "Encontre seu tamanho", onClose: r, type: "fit-dialog", wide: !0, children: /* @__PURE__ */ i.jsxs("div", { className: "fit-layout", children: [
    /* @__PURE__ */ i.jsxs("aside", { className: "fit-visual", "aria-label": "Demonstração da medição", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "fit-visual-top", children: [
        /* @__PURE__ */ i.jsx("span", { children: "O SEU AJUSTE, PASSO A PASSO" }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          "0",
          m + 1,
          " / 03"
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: `fit-photo ${q ? "is-zoomed" : ""}`, children: [
        ss.map((w, H) => /* @__PURE__ */ i.jsx("img", { src: globalThis.rheoAsset(`${w.image}`), alt: H === m ? w.alt : "", "aria-hidden": H !== m, className: H === m ? "is-active" : "", width: "1200", height: "900" }, w.image)),
        /* @__PURE__ */ i.jsxs("span", { className: "fit-photo-tag", children: [
          "0",
          m + 1,
          " ",
          /* @__PURE__ */ i.jsx("span", { children: ve.label })
        ] }),
        /* @__PURE__ */ i.jsx("button", { className: "fit-photo-zoom", onClick: () => _(!q), "aria-pressed": q, "aria-label": q ? "Reduzir detalhe" : "Ampliar detalhe", title: q ? "Reduzir detalhe" : "Ampliar detalhe", children: q ? /* @__PURE__ */ i.jsx(Dv, { size: 19 }) : /* @__PURE__ */ i.jsx(Rv, { size: 19 }) })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "fit-caption", children: [
        /* @__PURE__ */ i.jsxs("span", { className: "fit-caption-index", children: [
          "0",
          m + 1
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: ve.caption })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "fit-materials", "aria-label": "Materiais necessários", children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Av, { size: 17 }),
          " Papel"
        ] }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Sv, { size: 17 }),
          " Caneta"
        ] }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Ot, { size: 17 }),
          " Régua"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "fit-workspace", children: [
      /* @__PURE__ */ i.jsx("nav", { className: "fit-progress", "aria-label": "Etapas de medição", children: ss.map((w, H) => /* @__PURE__ */ i.jsxs("button", { onClick: () => I(H), "aria-current": !A && m === H ? "step" : void 0, "aria-label": `Etapa ${H + 1}: ${w.label}`, children: [
        /* @__PURE__ */ i.jsx("span", { children: H < m ? /* @__PURE__ */ i.jsx(Ll, { size: 14 }) : `0${H + 1}` }),
        w.label
      ] }, w.label)) }),
      /* @__PURE__ */ i.jsx("div", { className: "fit-content", ref: k, children: A ? /* @__PURE__ */ i.jsxs("section", { className: "fit-stage", children: [
        /* @__PURE__ */ i.jsx("span", { className: "fit-eyebrow", children: "REFERÊNCIA EM CENTÍMETROS" }),
        /* @__PURE__ */ i.jsx("h2", { ref: L, tabIndex: -1, children: "Compare as medidas." }),
        /* @__PURE__ */ i.jsx("p", { children: "A circunferência é a volta completa do dedo, não a distância de um lado ao outro." }),
        /* @__PURE__ */ i.jsxs("table", { className: "fit-table", children: [
          /* @__PURE__ */ i.jsx("caption", { children: "Tabela ilustrativa. Ainda não validada pelo fornecedor." }),
          /* @__PURE__ */ i.jsx("thead", { children: /* @__PURE__ */ i.jsxs("tr", { children: [
            /* @__PURE__ */ i.jsx("th", { scope: "col", children: "Tamanho" }),
            /* @__PURE__ */ i.jsx("th", { scope: "col", children: "Circunferência" })
          ] }) }),
          /* @__PURE__ */ i.jsx("tbody", { children: Yn.map((w) => /* @__PURE__ */ i.jsxs("tr", { className: (p == null ? void 0 : p.size) === w.size ? "is-selected" : "", children: [
            /* @__PURE__ */ i.jsxs("th", { scope: "row", children: [
              w.size,
              (p == null ? void 0 : p.size) === w.size && /* @__PURE__ */ i.jsx(Ll, { size: 14, "aria-label": "Referência calculada" })
            ] }),
            /* @__PURE__ */ i.jsxs("td", { children: [
              Gn(w.cm),
              " cm"
            ] })
          ] }, w.size)) })
        ] })
      ] }) : /* @__PURE__ */ i.jsxs("section", { className: "fit-stage", children: [
        /* @__PURE__ */ i.jsx("span", { className: "fit-eyebrow", children: p && m === 2 ? "SUA REFERÊNCIA DE AJUSTE" : `PASSO 0${m + 1} DE 03` }),
        /* @__PURE__ */ i.jsx("h2", { ref: L, tabIndex: -1, children: p && m === 2 ? "Um ponto de partida." : ve.title }),
        m < 2 ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("p", { children: ve.description }),
          /* @__PURE__ */ i.jsx("ol", { className: "fit-instructions", children: ve.instructions.map((w, H) => /* @__PURE__ */ i.jsxs("li", { children: [
            /* @__PURE__ */ i.jsx("span", { children: H + 1 }),
            /* @__PURE__ */ i.jsx("p", { children: w })
          ] }, w)) }),
          /* @__PURE__ */ i.jsxs("div", { className: "fit-tip", children: [
            /* @__PURE__ */ i.jsx(Jc, { size: 18 }),
            /* @__PURE__ */ i.jsx("p", { children: ve.tip })
          ] })
        ] }) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          !p && /* @__PURE__ */ i.jsx("p", { children: ve.description }),
          p && /* @__PURE__ */ i.jsxs("div", { className: "size-result fit-result", role: "status", children: [
            /* @__PURE__ */ i.jsxs("div", { className: "fit-result-number", children: [
              /* @__PURE__ */ i.jsx("span", { children: "Tamanho de referência" }),
              /* @__PURE__ */ i.jsx("strong", { children: p.size })
            ] }),
            /* @__PURE__ */ i.jsxs("dl", { children: [
              /* @__PURE__ */ i.jsxs("div", { children: [
                /* @__PURE__ */ i.jsx("dt", { children: "Você mediu" }),
                /* @__PURE__ */ i.jsxs("dd", { children: [
                  Gn(oe),
                  " cm"
                ] })
              ] }),
              /* @__PURE__ */ i.jsxs("div", { children: [
                /* @__PURE__ */ i.jsx("dt", { children: "Referência da tabela" }),
                /* @__PURE__ */ i.jsxs("dd", { children: [
                  Gn(p.cm),
                  " cm"
                ] })
              ] })
            ] })
          ] }),
          p && /* @__PURE__ */ i.jsx("p", { className: "fit-result-note", children: Me ? "Sua medida fica entre referências. Este é o número mais próximo, não uma garantia de encaixe. Repita a medição antes de continuar." : "Repita a medição para conferir. O papel ajuda a estimar, mas não confirma o encaixe do anel." }),
          /* @__PURE__ */ i.jsxs("form", { id: "fit-measure-form", onSubmit: ee, noValidate: !0, children: [
            /* @__PURE__ */ i.jsx("label", { htmlFor: "fit-circumference", children: "Circunferência do dedo" }),
            /* @__PURE__ */ i.jsxs("div", { className: `fit-input ${p === null ? "has-error" : ""}`, children: [
              /* @__PURE__ */ i.jsx(Ot, { size: 20, "aria-hidden": "true" }),
              /* @__PURE__ */ i.jsx("input", { id: "fit-circumference", ref: ce, inputMode: "decimal", autoComplete: "off", placeholder: "Ex.: 5,95", maxLength: 8, value: b, onChange: (w) => {
                M(w.target.value), E(void 0);
              }, "aria-invalid": p === null, "aria-describedby": `fit-unit-note${p === null ? " fit-error" : ""}` }),
              /* @__PURE__ */ i.jsx("span", { children: "cm" })
            ] }),
            /* @__PURE__ */ i.jsx("small", { id: "fit-unit-note", children: "Volta completa do dedo · Faixa ilustrativa: 5,44 a 6,97 cm." }),
            p === null && /* @__PURE__ */ i.jsx("p", { id: "fit-error", role: "alert", className: "input-error", children: "Confira a medida em centímetros, entre 5,44 e 6,97. Não estimamos um tamanho fora dessa faixa." })
          ] }),
          !p && /* @__PURE__ */ i.jsx(Cv, { value: b })
        ] })
      ] }, m) }),
      /* @__PURE__ */ i.jsxs("footer", { className: "fit-footer", children: [
        /* @__PURE__ */ i.jsxs("div", { className: "fit-actions", children: [
          /* @__PURE__ */ i.jsx("button", { className: "fit-back", disabled: m === 0 && !A, onClick: () => A ? S(!1) : I(m - 1), "aria-label": A ? "Voltar ao guia" : "Etapa anterior", children: /* @__PURE__ */ i.jsx(mv, { size: 19 }) }),
          A ? /* @__PURE__ */ i.jsxs("button", { className: "fit-primary", onClick: () => S(!1), children: [
            "Voltar à medição ",
            /* @__PURE__ */ i.jsx(Ra, { size: 18 })
          ] }) : m < 2 ? /* @__PURE__ */ i.jsxs("button", { className: "fit-primary", onClick: () => I(m + 1), children: [
            "Continuar ",
            /* @__PURE__ */ i.jsx(Ra, { size: 18 })
          ] }) : p ? /* @__PURE__ */ i.jsxs("button", { className: "fit-primary", onClick: () => x(p.size), children: [
            "Usar na seleção ",
            /* @__PURE__ */ i.jsx(Ll, { size: 18 })
          ] }) : /* @__PURE__ */ i.jsxs("button", { className: "fit-primary", type: "submit", form: "fit-measure-form", "aria-label": "Ver tamanho de referência", children: [
            "Ver minha referência ",
            /* @__PURE__ */ i.jsx(Ra, { size: 18 })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "fit-footer-meta", children: [
          /* @__PURE__ */ i.jsx("span", { children: "Estimativa com papel" }),
          /* @__PURE__ */ i.jsxs("button", { "aria-expanded": A, onClick: () => S(!A), children: [
            /* @__PURE__ */ i.jsx(Ov, { size: 15 }),
            A ? "Fechar tabela" : "Ver tabela em centímetros"
          ] })
        ] }),
        /* @__PURE__ */ i.jsx("p", { className: "fit-disclaimer", children: "Tabela demonstrativa, ainda não validada pelo fornecedor. Não use para uma compra real. Confirme o ajuste com um medidor físico." })
      ] })
    ] })
  ] }) });
}
const qv = [0, 0, 0, 0, 0, 0, 265, 431, 1080, 385, 420, 710, 350, 605, 592, 365], rm = [50, 52, 53, 55, 51, 53, 55], dm = [83, 79, 74, 71, 82, 76, 78], fm = ["Leve", "Profundo", "Leve", "Profundo", "Leve", "REM", "Acordado", "Leve", "Profundo", "Leve", "REM", "Leve", "Acordado", "Leve", "Profundo", "Leve", "REM", "Leve", "Acordado", "REM", "Leve", "REM", "Acordado", "Leve"], kc = {
  Acordado: 22,
  REM: 86,
  Leve: 274,
  Profundo: 96
}, Hv = ["#eeeedd", "#dec1b8", "#adbca1", "#6e8778"], us = Object.keys(kc), mm = [{
  icon: vv,
  label: "Muito baixa"
}, {
  icon: xv,
  label: "Baixa"
}, {
  icon: yv,
  label: "Moderada"
}, {
  icon: ds,
  label: "Boa"
}, {
  icon: Tv,
  label: "Muito boa"
}], Bv = ["#dec1b8", "#e4b293", "#bbcbaf", "#e4b293", "#c3c1d6", "#bbcbaf"], Lv = ["Tempo de sono", "Passos do dia", "FC em repouso", "Rheo Flow", "Sua disposição", "Flow na semana"];
function fs({
  label: r,
  children: x
}) {
  return /* @__PURE__ */ i.jsx("svg", { className: "rv-plot", viewBox: "0 0 310 130", role: "img", "aria-label": r, children: x });
}
function Yv() {
  const r = Object.fromEntries(us.map((o) => [o, 0]));
  let x = 0;
  const m = fm.map((o) => {
    const b = fm.filter((E) => E === o).length, M = Math.floor(kc[o] / b) + (r[o]++ < kc[o] % b ? 1 : 0), p = {
      stage: o,
      from: x,
      minutes: M
    };
    return x += M, p;
  });
  return /* @__PURE__ */ i.jsxs(fs, { label: "Exemplo de fases do sono: 7 horas e 36 minutos de sono, 22 minutos acordado, das 22:48 às 06:46", children: [
    us.map((o, b) => /* @__PURE__ */ i.jsxs("g", { children: [
      /* @__PURE__ */ i.jsx("text", { x: "0", y: 18 + b * 26, children: o }),
      /* @__PURE__ */ i.jsx("line", { className: "rv-grid", x1: "52", x2: "310", y1: 15 + b * 26, y2: 15 + b * 26 })
    ] }, o)),
    m.map((o, b) => {
      const M = 52 + o.from / 478 * 258, p = o.minutes / 478 * 258, E = us.indexOf(o.stage), A = m[b + 1];
      return /* @__PURE__ */ i.jsxs("g", { className: "rv-segment", style: {
        "--delay": `${b * 35}ms`
      }, children: [
        A && /* @__PURE__ */ i.jsx("line", { x1: M + p, x2: M + p, y1: 15 + E * 26, y2: 15 + us.indexOf(A.stage) * 26, stroke: "#adbca1", opacity: ".4" }),
        /* @__PURE__ */ i.jsx("rect", { x: M, y: 9 + E * 26, width: p, height: "12", rx: "2", fill: Hv[E] })
      ] }, b);
    }),
    /* @__PURE__ */ i.jsx("text", { x: "52", y: "126", children: "22:48" }),
    /* @__PURE__ */ i.jsx("text", { x: "180", y: "126", textAnchor: "middle", children: "02:47" }),
    /* @__PURE__ */ i.jsx("text", { x: "310", y: "126", textAnchor: "end", children: "06:46" })
  ] });
}
function Gv() {
  return /* @__PURE__ */ i.jsxs(fs, { label: "Exemplo de movimento por hora, de 00h a 15h, total de 5.203 passos", children: [
    [25, 65, 105].map((r) => /* @__PURE__ */ i.jsx("line", { className: "rv-grid", x1: "0", x2: "310", y1: r, y2: r }, r)),
    qv.map((r, x) => /* @__PURE__ */ i.jsx("rect", { className: "rv-bar", style: {
      "--delay": `${x * 35}ms`
    }, x: x * 19.5 + 3, y: 105 - Math.max(2, r / 1080 * 90), width: "11", height: Math.max(2, r / 1080 * 90), rx: "2", fill: "currentColor", opacity: x === 8 ? 1 : r ? 0.65 : 0.15 }, x)),
    /* @__PURE__ */ i.jsx("text", { x: "0", y: "126", children: "00h" }),
    /* @__PURE__ */ i.jsx("text", { x: "118", y: "126", children: "06h" }),
    /* @__PURE__ */ i.jsx("text", { x: "235", y: "126", children: "12h" }),
    /* @__PURE__ */ i.jsx("text", { x: "310", y: "126", textAnchor: "end", children: "15h" })
  ] });
}
function hm({
  history: r = !1
}) {
  const x = r ? dm : rm, m = (b) => r ? 101 - (b - 65) * 4 : 101 - (b - 48) * 11, o = x.map((b, M) => `${12 + M * 47},${m(b)}`).join(" ");
  return /* @__PURE__ */ i.jsxs(fs, { label: r ? `Flow demonstrativo dos dias 9 a 15 de setembro: ${dm.join(", ")}` : `FC em repouso demonstrativa dos dias 9 a 15 de setembro: ${rm.join(", ")} bpm. Referência pessoal de 52 bpm.`, children: [
    [25, 65, 105].map((b) => /* @__PURE__ */ i.jsx("line", { className: "rv-grid", x1: "0", x2: "310", y1: b, y2: b }, b)),
    !r && /* @__PURE__ */ i.jsx("line", { x1: "0", x2: "310", y1: m(52), y2: m(52), stroke: "currentColor", opacity: ".4", strokeDasharray: "3 5" }),
    /* @__PURE__ */ i.jsx("polygon", { className: "rv-area", points: `12,106 ${o} 294,106`, fill: "currentColor", opacity: ".07" }),
    /* @__PURE__ */ i.jsx("polyline", { className: "rv-line", pathLength: "1", points: o, fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinejoin: "round", strokeLinecap: "round" }),
    x.map((b, M) => /* @__PURE__ */ i.jsxs("g", { className: "rv-segment", style: {
      "--delay": `${350 + M * 90}ms`
    }, children: [
      /* @__PURE__ */ i.jsx("circle", { cx: 12 + M * 47, cy: m(b), r: M === 6 ? 4 : 2, fill: M === 6 ? "#f0f3e9" : "currentColor" }),
      r && /* @__PURE__ */ i.jsx("text", { x: 12 + M * 47, y: m(b) - 10, textAnchor: "middle", children: b })
    ] }, M)),
    /* @__PURE__ */ i.jsx("text", { x: "3", y: "126", children: "09 set" }),
    /* @__PURE__ */ i.jsx("text", { x: "154", y: "126", textAnchor: "middle", children: "12 set" }),
    /* @__PURE__ */ i.jsx("text", { x: "305", y: "126", textAnchor: "end", children: "15 set" })
  ] });
}
function Vv() {
  return /* @__PURE__ */ i.jsxs(fs, { label: "Rheo Flow demonstrativo: 78 de 100. Sono 84, recuperação 71 e equilíbrio da atividade 80.", children: [
    Array.from({
      length: 41
    }, (r, x) => {
      const m = (150 + x * 6) * Math.PI / 180;
      return /* @__PURE__ */ i.jsx("line", { className: "rv-segment", style: {
        "--delay": `${x * 22}ms`
      }, x1: 155 + Math.cos(m) * 83, y1: 78 + Math.sin(m) * 83, x2: 155 + Math.cos(m) * (x % 5 === 0 ? 71 : 76), y2: 78 + Math.sin(m) * (x % 5 === 0 ? 71 : 76), stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", opacity: x / 40 <= 0.78 ? 1 : 0.18 }, x);
    }),
    /* @__PURE__ */ i.jsx("text", { className: "rv-flow-score", x: "155", y: "78", textAnchor: "middle", children: "78" }),
    /* @__PURE__ */ i.jsx("text", { x: "155", y: "98", textAnchor: "middle", children: "EM EQUILÍBRIO" })
  ] });
}
function Nm({
  index: r
}) {
  const x = V.useRef(null), [m, o] = V.useState(!1), [b, M] = V.useState(3);
  V.useEffect(() => {
    const E = new IntersectionObserver((A) => {
      A.some((S) => S.isIntersecting) && (o(!0), E.disconnect());
    }, {
      threshold: 0.3
    });
    return E.observe(x.current), () => E.disconnect();
  }, []);
  const p = [/* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "7",
    /* @__PURE__ */ i.jsx("span", { children: "h" }),
    " 36",
    /* @__PURE__ */ i.jsx("span", { children: "min" })
  ] }), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "5.203",
    /* @__PURE__ */ i.jsx("span", { children: " passos" })
  ] }), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "55",
    /* @__PURE__ */ i.jsx("span", { children: " bpm" })
  ] }), /* @__PURE__ */ i.jsx(i.Fragment, { children: "Seu dia, em contexto." }), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    b + 1,
    /* @__PURE__ */ i.jsx("span", { children: " / 5" })
  ] }), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "7",
    /* @__PURE__ */ i.jsx("span", { children: " dias" })
  ] })];
  return /* @__PURE__ */ i.jsxs("div", { ref: x, className: `rv-visual rv-${r}${m ? " is-visible" : ""}`, style: {
    "--rv-tone": Bv[r]
  }, children: [
    /* @__PURE__ */ i.jsxs("div", { className: "rv-readout", children: [
      /* @__PURE__ */ i.jsx("span", { children: Lv[r] }),
      /* @__PURE__ */ i.jsx("strong", { children: p[r] })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "rv-chart", children: [
      r === 0 && /* @__PURE__ */ i.jsx(Yv, {}),
      r === 1 && /* @__PURE__ */ i.jsx(Gv, {}),
      r === 2 && /* @__PURE__ */ i.jsx(hm, {}),
      r === 3 && /* @__PURE__ */ i.jsx(Vv, {}),
      r === 4 && /* @__PURE__ */ i.jsxs("div", { className: "rv-checkin", children: [
        /* @__PURE__ */ i.jsx("div", { className: "rv-moods", role: "group", "aria-label": "Disposição demonstrativa", children: mm.map(({
          icon: E,
          label: A
        }, S) => /* @__PURE__ */ i.jsx("button", { type: "button", title: A, "aria-label": A, "aria-pressed": b === S, onClick: () => M(S), children: /* @__PURE__ */ i.jsx(E, { size: 23, strokeWidth: 1.3 }) }, A)) }),
        /* @__PURE__ */ i.jsxs("div", { className: "rv-checkin-result", "aria-live": "polite", children: [
          /* @__PURE__ */ i.jsx(Ll, { size: 14 }),
          /* @__PURE__ */ i.jsxs("span", { children: [
            mm[b].label,
            " ",
            /* @__PURE__ */ i.jsx("span", { children: "· Seu check-in de exemplo" })
          ] })
        ] })
      ] }),
      r === 5 && /* @__PURE__ */ i.jsx(hm, { history: !0 })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "rv-caption", children: [
      r === 0 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx("i", { style: {
            background: "#dec1b8"
          } }),
          "REM 1h26"
        ] }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx("i", { style: {
            background: "#6e8778"
          } }),
          "Profundo 1h36"
        ] })
      ] }),
      r === 1 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("span", { children: "65% da meta" }),
        /* @__PURE__ */ i.jsx("span", { children: "Meta de 8.000" })
      ] }),
      r === 2 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("span", { children: "+3 bpm da referência" }),
        /* @__PURE__ */ i.jsx("span", { children: "Referência: 52" })
      ] }),
      r === 3 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("span", { children: "Sono 84" }),
        /* @__PURE__ */ i.jsx("span", { children: "Recuperação 71" }),
        /* @__PURE__ */ i.jsx("span", { children: "Atividade 80" })
      ] }),
      r === 4 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("span", { children: "Percepção pessoal" }),
        /* @__PURE__ */ i.jsx("span", { children: "Não medida pelo anel" })
      ] }),
      r === 5 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("span", { children: "Um dia de cada vez." }),
        /* @__PURE__ */ i.jsx("span", { children: "09–15 set" })
      ] })
    ] })
  ] });
}
const Bl = (r) => globalThis.rheoAsset(`${r}`), Aa = [{
  id: "sleep",
  name: "Sono",
  icon: Vl,
  image: "pdp-app-sleep.webp",
  title: "Sua noite conta uma história.",
  text: "Duração, horários e uma visão das noites anteriores. Uma forma de perceber a regularidade do descanso além de uma noite isolada.",
  note: "As fases exibidas são estimativas demonstrativas; dependem dos dados disponíveis no anel."
}, {
  id: "body",
  name: "Corpo",
  icon: Mt,
  image: "pdp-app-body.webp",
  title: "Seus sinais, em perspectiva.",
  text: "A proposta é comparar os sinais ao longo do tempo com a sua própria referência. Observar tendências, sem transformar uma oscilação em diagnóstico.",
  note: "VFC e índice de recuperação são conceitos em validação, não recursos confirmados."
}, {
  id: "today",
  name: "Hoje",
  icon: ds,
  image: "pdp-app-today.webp",
  title: "Um ponto de partida para o dia.",
  text: "O Rheo Flow reúne a proposta de sono, recuperação e movimento em um resumo. Primeiro, uma leitura clara. Depois, os detalhes que ajudam a entender o contexto.",
  note: "Flow é um índice conceitual da Rheo. A fórmula e as fontes ainda precisam ser validadas."
}, {
  id: "activity",
  name: "Atividade",
  icon: Gl,
  image: "pdp-app-activity.webp",
  title: "Todo movimento tem seu lugar.",
  text: "Uma caminhada, uma corrida ou o treino que você escolheu registrar. Metas, histórico e anotações para acompanhar sua rotina sem reduzir tudo a um número.",
  note: "O registro de treino não significa detecção automática da modalidade ou medição de desempenho esportivo."
}, {
  id: "care",
  name: "Care",
  icon: zm,
  image: "pdp-app-care.webp",
  title: "Os números não contam tudo.",
  text: "Um check-in sobre como você se sente acrescenta o que só você sabe sobre o seu dia. O diário e o histórico ajudam a levar esse contexto para a leitura da semana.",
  note: "Prévia de software, sem IA conectada ou atendimento profissional disponível."
}], Qv = [{
  icon: Vl,
  name: "Sono",
  title: "Enxergue a sua rotina de descanso.",
  text: "Horários, duração e histórico das noites em uma leitura organizada.",
  result: "Perceba a regularidade, não apenas a pontuação de uma noite.",
  status: "Leituras dependem da integração com o anel."
}, {
  icon: Gl,
  name: "Movimento",
  title: "Dê espaço aos pequenos avanços.",
  text: "Passos, metas pessoais e sessões de atividade registradas por você.",
  result: "Veja como o movimento se distribui ao longo dos dias.",
  status: "Passos e histórico do dispositivo em validação."
}, {
  icon: Sm,
  name: "Sinais do corpo",
  title: "Um número ganha sentido com contexto.",
  text: "Uma visão do histórico de frequência cardíaca e dos sinais disponíveis.",
  result: "Compare tendências com a sua rotina, sem conclusões isoladas.",
  status: "FC, SpO₂ e demais leituras dependem do modelo final."
}, {
  icon: Mt,
  name: "Rheo Flow",
  title: "Comece pelo que importa hoje.",
  text: "Um resumo proposto para conectar descanso, recuperação e atividade.",
  result: "Entenda os fatores por trás do índice e explore cada um deles.",
  status: "Índice conceitual. Não é uma medição direta do sensor."
}, {
  icon: pv,
  name: "Diário pessoal",
  title: "Como você se sente também importa.",
  text: "Check-ins, notas e percepção de esforço junto dos registros do dia.",
  result: "Acrescente sua experiência ao que aparece nos gráficos.",
  status: "Funcionalidade de software em desenvolvimento."
}, {
  icon: gv,
  name: "Histórico",
  title: "Olhe para a semana, não só para hoje.",
  text: "Compare seus registros em diferentes dias e acompanhe mudanças.",
  result: "Construa uma visão mais completa dos seus próprios hábitos.",
  status: "Visualizações e resumos demonstrativos nesta prévia."
}], Ln = [{
  id: "sleep",
  label: "Sono",
  icon: Vl,
  color: "#dec1b8",
  values: [394, 428, 452, 402, 456, 445, 456],
  max: 540,
  title: "Uma noite não define sua rotina.",
  summary: "5 de 7 noites acima de 7 horas",
  unit: "Duração do sono",
  text: "Neste exemplo, a duração variou ao longo da semana. O histórico coloca a noite mais curta em perspectiva, em vez de tratá-la como toda a sua rotina.",
  action: "Observe também os horários de dormir e como você se sente ao acordar.",
  format: (r) => `${Math.floor(r / 60)}h ${String(r % 60).padStart(2, "0")}min`
}, {
  id: "movement",
  label: "Movimento",
  icon: Gl,
  color: "#e4b293",
  values: [4100, 6320, 7850, 4800, 9240, 6100, 5203],
  max: 11e3,
  title: "A constância aparece no conjunto.",
  summary: "43.613 passos na semana",
  unit: "Passos registrados",
  text: "Dias mais ativos e dias mais tranquilos podem fazer parte da mesma semana. Nesta leitura, o objetivo é observar o conjunto, não transformar cada dia em uma competição.",
  action: "Compare com a sua própria meta e encontre momentos de movimento que caibam no seu dia.",
  format: (r) => `${r.toLocaleString("pt-BR")} passos`
}, {
  id: "checkin",
  label: "Check-in",
  icon: zm,
  color: "#bbcbaf",
  values: [2, 3, 2, 3, 4, 3, 4],
  max: 5,
  title: "O seu contexto faz parte da leitura.",
  summary: "7 dias com check-in",
  unit: "Disposição informada por você",
  text: "Como você se sentiu nem sempre cabe em um sensor. O check-in coloca sua percepção ao lado dos outros registros, sem deduzir emoções a partir dos batimentos.",
  action: "Uma nota curta sobre seu dia pode ajudar a lembrar o que estava acontecendo.",
  format: (r) => `${r} de 5 · Disposição`
}];
function Xv() {
  const [r, x] = V.useState(0), [m, o] = V.useState(6), b = Ln[r], M = (p, E = !1) => {
    var A;
    x(p), o(6), E && ((A = document.getElementById(`ps-insight-tab-${p}`)) == null || A.focus());
  };
  return /* @__PURE__ */ i.jsx("section", { className: "ps-insights", id: "pdp-insights", "aria-labelledby": "ps-insights-heading", children: /* @__PURE__ */ i.jsxs("div", { className: "r-container ps-insight-layout", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ps-insight-copy", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "DOS REGISTROS À VIDA REAL" }),
      /* @__PURE__ */ i.jsxs("h2", { className: "ps-title", id: "ps-insights-heading", children: [
        "Entender é",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "o próximo passo." })
      ] }),
      /* @__PURE__ */ i.jsx("p", { children: "A proposta do Rheo Care é transformar registros em uma leitura que faça sentido para você. Com contexto, linguagem clara e espaço para o que você sente." }),
      /* @__PURE__ */ i.jsx("div", { className: "ps-insight-tabs", role: "tablist", "aria-label": "Exemplos de insights", children: Ln.map((p, E) => /* @__PURE__ */ i.jsxs("button", { id: `ps-insight-tab-${E}`, role: "tab", "aria-selected": r === E, "aria-controls": "ps-insight-panel", tabIndex: r === E ? 0 : -1, onClick: () => M(E), onKeyDown: (A) => {
        ["ArrowRight", "ArrowLeft", "Home", "End"].includes(A.key) && (A.preventDefault(), M(A.key === "Home" ? 0 : A.key === "End" ? Ln.length - 1 : (E + (A.key === "ArrowRight" ? 1 : Ln.length - 1)) % Ln.length, !0));
      }, children: [
        /* @__PURE__ */ i.jsx(p.icon, { size: 17 }),
        p.label
      ] }, p.id)) }),
      /* @__PURE__ */ i.jsx("small", { children: "Exemplos ilustrativos. Não são dados reais nem recomendações médicas." })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "ps-insight-tool", id: "ps-insight-panel", role: "tabpanel", "aria-labelledby": `ps-insight-tab-${r}`, style: {
      "--insight-accent": b.color
    }, children: [
      /* @__PURE__ */ i.jsxs("header", { children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Mt, { size: 19 }),
          " RHEO CARE"
        ] }),
        /* @__PURE__ */ i.jsx("span", { children: "LEITURA ILUSTRATIVA" })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "ps-insight-readout", "aria-live": "polite", children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          b.unit,
          " · ",
          m + 9,
          " set"
        ] }),
        /* @__PURE__ */ i.jsx("strong", { children: b.format(b.values[m]) })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: "ps-bars", role: "group", "aria-label": `Histórico ilustrativo: ${b.label}`, children: b.values.map((p, E) => /* @__PURE__ */ i.jsxs("button", { "aria-label": `${E + 9} de setembro: ${b.format(p)}`, "aria-pressed": m === E, onClick: () => o(E), title: `${E + 9} set · ${b.format(p)}`, children: [
        /* @__PURE__ */ i.jsx("span", { className: "ps-bar-track", children: /* @__PURE__ */ i.jsx("span", { style: {
          height: `${p / b.max * 100}%`
        } }) }),
        /* @__PURE__ */ i.jsx("span", { children: E + 9 })
      ] }, E)) }),
      /* @__PURE__ */ i.jsxs("div", { className: "ps-insight-summary", children: [
        /* @__PURE__ */ i.jsx("span", { children: b.summary }),
        /* @__PURE__ */ i.jsx("span", { children: "9–15 SET" })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "ps-insight-message", children: [
        /* @__PURE__ */ i.jsx("h3", { children: b.title }),
        /* @__PURE__ */ i.jsx("p", { children: b.text }),
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx(Ne, { size: 18 }),
          /* @__PURE__ */ i.jsx("p", { children: b.action })
        ] })
      ] }, b.id)
    ] })
  ] }) });
}
function Tm({
  standalone: r = !1
}) {
  const [x, m] = V.useState(null), [o, b] = V.useState(2);
  V.useEffect(() => {
    const p = matchMedia("(max-width: 760px)"), E = () => {
      if (!p.matches) return;
      const A = document.getElementById("ps-phone-lineup"), S = document.getElementById("ps-phone-2");
      A && S && (A.scrollLeft = S.offsetLeft - (A.clientWidth - S.clientWidth) / 2, b(2));
    };
    return E(), p.addEventListener("change", E), () => p.removeEventListener("change", E);
  }, []);
  const M = (p) => {
    const E = Math.max(0, Math.min(Aa.length - 1, o + p));
    b(E);
    const A = document.getElementById("ps-phone-lineup"), S = document.getElementById(`ps-phone-${E}`);
    A && S && A.scrollTo({
      left: S.offsetLeft - A.offsetLeft - (A.clientWidth - S.clientWidth) / 2,
      behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
    });
  };
  return /* @__PURE__ */ i.jsxs("section", { className: "ps-app", id: "pdp-app", "aria-labelledby": "ps-app-heading", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "r-container ps-app-heading", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "O SEU DIA. POR INTEIRO." }),
      r ? /* @__PURE__ */ i.jsx("h1", { id: "ps-app-heading", children: "Aplicativo Rheo" }) : /* @__PURE__ */ i.jsxs("h2", { className: "ps-title", id: "ps-app-heading", children: [
        "Um anel no dedo.",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "Uma nova perspectiva na mão." })
      ] }),
      /* @__PURE__ */ i.jsxs("p", { children: [
        "O resumo de hoje. A noite que passou. O movimento que vem.",
        /* @__PURE__ */ i.jsx("br", {}),
        " Cinco olhares que se encontram em uma experiência só."
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("div", { className: "ps-app-lineup", id: "ps-phone-lineup", onScroll: (p) => {
      const E = p.currentTarget;
      if (E.scrollWidth <= E.clientWidth) return;
      const A = [...E.children].map((q) => q.offsetLeft - E.offsetLeft + q.offsetWidth / 2), S = E.scrollLeft + E.clientWidth / 2;
      b(A.reduce((q, _, k) => Math.abs(_ - S) < Math.abs(A[q] - S) ? k : q, 0));
    }, children: Aa.map((p, E) => /* @__PURE__ */ i.jsxs("figure", { id: `ps-phone-${E}`, className: `ps-phone-item phone-${p.id}`, children: [
      /* @__PURE__ */ i.jsxs("button", { className: "ps-phone", "aria-label": `Explorar tela ${p.name}`, onClick: () => m(E), children: [
        /* @__PURE__ */ i.jsx("img", { src: Bl(p.image), alt: `Aplicativo Rheo: tela ${p.name}`, width: "780", height: "1688", loading: "lazy" }),
        /* @__PURE__ */ i.jsx("span", { className: "ps-phone-zoom", children: /* @__PURE__ */ i.jsx(rs, { size: 15 }) })
      ] }),
      /* @__PURE__ */ i.jsxs("figcaption", { children: [
        /* @__PURE__ */ i.jsx(p.icon, { size: 16 }),
        /* @__PURE__ */ i.jsx("span", { children: p.name })
      ] })
    ] }, p.id)) }),
    /* @__PURE__ */ i.jsxs("div", { className: "ps-app-navigation", children: [
      /* @__PURE__ */ i.jsx("button", { "aria-label": "Tela anterior", disabled: o === 0, onClick: () => M(-1), children: /* @__PURE__ */ i.jsx(Xc, { size: 21 }) }),
      /* @__PURE__ */ i.jsxs("span", { children: [
        Aa[o].name,
        " ",
        /* @__PURE__ */ i.jsxs("span", { children: [
          "0",
          o + 1,
          " / 05"
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("button", { "aria-label": "Próxima tela", disabled: o === Aa.length - 1, onClick: () => M(1), children: /* @__PURE__ */ i.jsx(qa, { size: 21 }) })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "r-container ps-app-takeaways", children: [
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { children: "01" }),
        /* @__PURE__ */ i.jsx("h3", { children: "Comece pelo essencial." }),
        /* @__PURE__ */ i.jsx("p", { children: "Uma leitura do dia antes de entrar em cada detalhe." })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { children: "02" }),
        /* @__PURE__ */ i.jsx("h3", { children: "Entenda o que está por trás." }),
        /* @__PURE__ */ i.jsx("p", { children: "Histórico e contexto junto dos indicadores." })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { children: "03" }),
        /* @__PURE__ */ i.jsx("h3", { children: "Olhe para você." }),
        /* @__PURE__ */ i.jsx("p", { children: "Seu ritmo e seus registros, sem rankings com outras pessoas." })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("p", { className: "ps-app-note", children: "Aplicativo em desenvolvimento para iOS e Android. Telas e dados demonstrativos; índices e integração com o anel ainda em validação." }),
    x !== null && /* @__PURE__ */ i.jsx(Yl, { title: `Aplicativo Rheo · ${Aa[x].name}`, onClose: () => m(null), wide: !0, type: "ps-preview-dialog", children: /* @__PURE__ */ i.jsxs("div", { className: "ps-preview-body", children: [
      /* @__PURE__ */ i.jsx("img", { src: Bl(Aa[x].image), alt: `Tela completa de ${Aa[x].name}` }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "A EXPERIÊNCIA RHEO" }),
        /* @__PURE__ */ i.jsx("h2", { children: Aa[x].title }),
        /* @__PURE__ */ i.jsx("p", { children: Aa[x].text }),
        /* @__PURE__ */ i.jsx("small", { children: Aa[x].note }),
        /* @__PURE__ */ i.jsxs("div", { className: "ps-preview-nav", children: [
          /* @__PURE__ */ i.jsx("button", { "aria-label": "Tela anterior na prévia", disabled: x === 0, onClick: () => m(x - 1), children: /* @__PURE__ */ i.jsx(Xc, { size: 20 }) }),
          /* @__PURE__ */ i.jsxs("span", { children: [
            x + 1,
            " / ",
            Aa.length
          ] }),
          /* @__PURE__ */ i.jsx("button", { "aria-label": "Próxima tela na prévia", disabled: x === Aa.length - 1, onClick: () => m(x + 1), children: /* @__PURE__ */ i.jsx(qa, { size: 20 }) })
        ] })
      ] })
    ] }) })
  ] });
}
function Zv({
  onSize: r,
  finish: x
}) {
  return /* @__PURE__ */ i.jsxs("div", { className: "product-story", children: [
    /* @__PURE__ */ i.jsx("nav", { className: "ps-section-nav", "aria-label": "Explore o Rheo Ring", children: /* @__PURE__ */ i.jsxs("div", { className: "r-container", children: [
      /* @__PURE__ */ i.jsx("span", { children: "Rheo Ring" }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("a", { href: "#pdp-lifestyle", children: "Na sua vida" }),
        /* @__PURE__ */ i.jsx("a", { href: "#pdp-app", children: "Aplicativo" }),
        /* @__PURE__ */ i.jsx("a", { href: "#pdp-recursos", children: "Recursos" }),
        /* @__PURE__ */ i.jsx("a", { href: "#pdp-insights", children: "Insights" }),
        /* @__PURE__ */ i.jsx("a", { href: "#pdp-detalhes", children: "De perto" })
      ] }),
      /* @__PURE__ */ i.jsxs("a", { className: "ps-nav-buy", href: "#comprar", children: [
        "Escolher o meu ",
        /* @__PURE__ */ i.jsx(Ne, { size: 16 })
      ] })
    ] }) }),
    /* @__PURE__ */ i.jsxs("section", { className: "ps-lifestyle-opening", id: "pdp-lifestyle", "aria-labelledby": "ps-life-heading", children: [
      /* @__PURE__ */ i.jsx("img", { src: Bl("sport-life.webp"), alt: "Anel dourado no dedo de uma tenista, durante uma pausa na quadra", loading: "lazy", width: "2000", height: "1116" }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-container ps-life-copy", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "SAÚDE É UM JEITO DE VIVER." }),
        /* @__PURE__ */ i.jsxs("h2", { id: "ps-life-heading", children: [
          "Na quadra.",
          /* @__PURE__ */ i.jsx("br", {}),
          "Na pausa.",
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("em", { children: "Na sua vida." })
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: "Não é sobre viver em função dos números. É sobre ter mais contexto para os seus dias e mais presença nos momentos que importam." }),
        /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "#pdp-app", children: [
          "Conheça a experiência ",
          /* @__PURE__ */ i.jsx(bm, { size: 17 })
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("span", { className: "ps-life-caption", children: "RHEO RING / SAÚDE & LIFESTYLE" })
    ] }),
    /* @__PURE__ */ i.jsx(Tm, {}),
    /* @__PURE__ */ i.jsx("section", { className: "ps-resources", id: "pdp-recursos", "aria-labelledby": "ps-resources-heading", children: /* @__PURE__ */ i.jsxs("div", { className: "r-container", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ps-section-heading", children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "O QUE ISSO MUDA NO SEU OLHAR" }),
          /* @__PURE__ */ i.jsxs("h2", { className: "ps-title", id: "ps-resources-heading", children: [
            "Mais do que acompanhar.",
            /* @__PURE__ */ i.jsx("br", {}),
            /* @__PURE__ */ i.jsx("em", { children: "Começar a perceber." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: "Conheça a experiência que estamos construindo. Cada recurso conecta uma informação a uma pergunta da sua rotina." })
      ] }),
      /* @__PURE__ */ i.jsx("p", { className: "ps-resource-demo", children: "Prévia do aplicativo · gráficos e dados demonstrativos" }),
      /* @__PURE__ */ i.jsx("div", { className: "ps-resource-grid", children: Qv.map((m, o) => /* @__PURE__ */ i.jsxs("article", { children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ps-resource-icon", children: [
          /* @__PURE__ */ i.jsx(m.icon, { size: 26, strokeWidth: 1.3 }),
          /* @__PURE__ */ i.jsxs("span", { children: [
            "0",
            o + 1,
            " / ",
            m.name
          ] })
        ] }),
        /* @__PURE__ */ i.jsx(Nm, { index: o }),
        /* @__PURE__ */ i.jsx("h3", { children: m.title }),
        /* @__PURE__ */ i.jsx("p", { children: m.text }),
        /* @__PURE__ */ i.jsxs("div", { className: "ps-resource-return", children: [
          /* @__PURE__ */ i.jsx("span", { children: "PARA VOCÊ" }),
          /* @__PURE__ */ i.jsx("p", { children: m.result })
        ] }),
        /* @__PURE__ */ i.jsx("small", { children: m.status })
      ] }, m.name)) })
    ] }) }),
    /* @__PURE__ */ i.jsx(Xv, {}),
    /* @__PURE__ */ i.jsxs("section", { className: "ps-everyday", "aria-labelledby": "ps-everyday-heading", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "r-container ps-section-heading", children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "O RESTO DO DIA TAMBÉM CONTA." }),
          /* @__PURE__ */ i.jsxs("h2", { className: "ps-title", id: "ps-everyday-heading", children: [
            "Seu melhor ritmo",
            /* @__PURE__ */ i.jsx("br", {}),
            /* @__PURE__ */ i.jsx("em", { children: "não é sempre o mais rápido." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: "Há dias de ir mais longe. E dias em que o melhor encontro é com a calma. A Rheo nasce para fazer parte dos dois." })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "ps-everyday-photos", children: [
        /* @__PURE__ */ i.jsxs("figure", { children: [
          /* @__PURE__ */ i.jsx("img", { src: Bl("pdp-running-detail.webp"), alt: "Detalhe do anel dourado facetado na mão de uma corredora durante uma pausa na pista", loading: "lazy", width: "1600", height: "1986" }),
          /* @__PURE__ */ i.jsxs("figcaption", { children: [
            /* @__PURE__ */ i.jsx("span", { children: "01 / MOVIMENTO QUE É SEU" }),
            /* @__PURE__ */ i.jsx("h3", { children: "Um passo de cada vez." }),
            /* @__PURE__ */ i.jsx("p", { children: "Metas pessoais e registros para acompanhar a continuidade, não a comparação." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("figure", { children: [
          /* @__PURE__ */ i.jsx("img", { src: Bl("daily-life.webp"), alt: "Anel prata na mão durante uma pausa para o café depois do esporte", loading: "lazy", width: "1856", height: "2304" }),
          /* @__PURE__ */ i.jsxs("figcaption", { children: [
            /* @__PURE__ */ i.jsx("span", { children: "02 / A VIDA ENTRE OS TREINOS" }),
            /* @__PURE__ */ i.jsx("h3", { children: "Espaço para simplesmente estar." }),
            /* @__PURE__ */ i.jsx("p", { children: "Descanso, rotina e percepção pessoal também fazem parte da sua história." })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "ps-details", id: "pdp-detalhes", "aria-labelledby": "ps-details-heading", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ps-details-image", children: [
        /* @__PURE__ */ i.jsx("img", { src: Bl("ring-macro.webp"), alt: "Detalhe do acabamento prata e da face interna do anel de referência", loading: "lazy", width: "2000", height: "1116" }),
        /* @__PURE__ */ i.jsx("span", { children: "RHEO RING / UM OLHAR DE PERTO" })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "ps-details-copy", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "UM OBJETO. MUITAS POSSIBILIDADES." }),
        /* @__PURE__ */ i.jsxs("h2", { className: "ps-title", id: "ps-details-heading", children: [
          "Discreto no dedo.",
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("em", { children: "Presente na rotina." })
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: "O formato de um anel. A proposta de uma experiência que continua no aplicativo. Sem uma tela no pulso pedindo a sua atenção." }),
        /* @__PURE__ */ i.jsxs("dl", { children: [
          /* @__PURE__ */ i.jsxs("div", { children: [
            /* @__PURE__ */ i.jsxs("dt", { children: [
              /* @__PURE__ */ i.jsx(Sm, { size: 19 }),
              "Por dentro"
            ] }),
            /* @__PURE__ */ i.jsx("dd", { children: "Sensores ópticos e de movimento como ponto de partida para os registros disponíveis no modelo." })
          ] }),
          /* @__PURE__ */ i.jsxs("div", { children: [
            /* @__PURE__ */ i.jsxs("dt", { children: [
              /* @__PURE__ */ i.jsx(hv, { size: 19 }),
              "Em conexão"
            ] }),
            /* @__PURE__ */ i.jsx("dd", { children: "Integração própria por Bluetooth em desenvolvimento, com aplicativo planejado para iOS e Android." })
          ] }),
          /* @__PURE__ */ i.jsxs("div", { children: [
            /* @__PURE__ */ i.jsxs("dt", { children: [
              /* @__PURE__ */ i.jsx(Ot, { size: 19 }),
              "No seu ajuste"
            ] }),
            /* @__PURE__ */ i.jsx("dd", { children: "Três acabamentos e um guia visual para começar a encontrar seu tamanho." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("button", { className: "r-text-link", onClick: r, children: [
          "Encontrar meu ajuste ",
          /* @__PURE__ */ i.jsx(Ne, { size: 18 })
        ] }),
        /* @__PURE__ */ i.jsx("small", { children: "Imagem conceitual. Modelo, sensores, autonomia, resistência à água e recursos finais serão confirmados após os testes do produto. Não se destina a diagnóstico médico." })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("section", { className: "ps-closing", children: /* @__PURE__ */ i.jsxs("div", { className: "r-container", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "UM NOVO OLHAR COMEÇA EM VOCÊ." }),
      /* @__PURE__ */ i.jsxs("h2", { className: "ps-title", children: [
        "Encontre o seu ritmo.",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "Escolha o seu Rheo." })
      ] }),
      /* @__PURE__ */ i.jsxs("a", { className: "r-button r-button-light", href: "#comprar", children: [
        "Voltar à escolha ",
        /* @__PURE__ */ i.jsx(Ne, { size: 18 })
      ] }),
      /* @__PURE__ */ i.jsxs("p", { children: [
        x.name,
        " · ",
        "Coleção em desenvolvimento"
      ] })
    ] }) })
  ] });
}
function Om({
  triggerRef: r,
  finish: x,
  size: m,
  onConfigure: o,
  price: b,
  href: M
}) {
  const [p, E] = V.useState(!1);
  return V.useEffect(() => {
    let A = null;
    const S = () => {
      A = null;
      const k = r.current;
      k && E(k.getBoundingClientRect().bottom < 0);
    }, q = () => {
      A === null && (A = requestAnimationFrame(S));
    }, _ = new IntersectionObserver(q);
    return r.current && _.observe(r.current), window.addEventListener("scroll", q, {
      passive: !0
    }), window.addEventListener("resize", q), q(), () => {
      _.disconnect(), window.removeEventListener("scroll", q), window.removeEventListener("resize", q), A !== null && cancelAnimationFrame(A);
    };
  }, [r]), /* @__PURE__ */ i.jsx("aside", { className: `r-purchase-dock${p ? " is-visible" : ""}`, "aria-label": "Sua seleção do Rheo Ring", "aria-hidden": !p, inert: !p, children: /* @__PURE__ */ i.jsxs("div", { className: "r-container r-purchase-dock-inner", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "r-purchase-dock-product", children: [
      /* @__PURE__ */ i.jsx("img", { src: x.image, alt: "", width: "52", height: "52" }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("strong", { children: "Rheo Ring" }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          x.name,
          " ",
          /* @__PURE__ */ i.jsx("span", { "aria-hidden": "true", children: "·" }),
          " ",
          m ? `Tamanho ${m}` : "Escolha seu tamanho"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "r-purchase-dock-price", children: [
      /* @__PURE__ */ i.jsx("strong", { children: b || "Em breve" }),
      /* @__PURE__ */ i.jsx("span", { children: b ? "Preço do produto" : "Preço no lançamento" })
    ] }),
    M ? /* @__PURE__ */ i.jsxs("a", { href: M, className: "r-purchase-dock-action", children: [
      "Escolher meu anel ",
      /* @__PURE__ */ i.jsx(Ne, { size: 18, "aria-hidden": "true" })
    ] }) : /* @__PURE__ */ i.jsxs("button", { type: "button", onClick: o, className: "r-purchase-dock-action", children: [
      m ? "Revisar seleção" : "Escolher tamanho",
      /* @__PURE__ */ i.jsx(Ne, { size: 18, "aria-hidden": "true" })
    ] })
  ] }) });
}
const Wt = "/products/rheo-ring", ms = [{
  slug: "tamanho-e-ajuste",
  category: "Tamanhos",
  title: "Como encontrar o tamanho do seu anel",
  summary: "Medir em centímetros, entender a numeração e conferir o encaixe.",
  keywords: "aro medida medir papel régua dedo tamanho ajuste kit",
  sections: [{
    title: "Comece pela circunferência",
    text: "Envolva a base do dedo com uma tira estreita de papel, sem apertar. Marque onde as pontas se encontram, estenda a tira e meça da ponta até a marca. No guia, informe o valor em centímetros."
  }, {
    title: "O papel é uma estimativa",
    text: "Repita a medida em momentos diferentes e confira também a passagem pela articulação. O anel precisa ficar confortável. Uma medição com papel não substitui a prova com um medidor físico compatível com o modelo."
  }, {
    title: "A numeração não é o aro brasileiro",
    text: "Os números da coleção não devem ser convertidos automaticamente de outro anel. A tabela desta prévia é demonstrativa e será substituída pelas medidas verificadas do fornecedor antes de qualquer venda."
  }],
  action: {
    href: "/pages/guia-de-tamanho",
    label: "Ver o guia de tamanho"
  }
}, {
  slug: "aplicativo-e-conexao",
  category: "Aplicativo",
  title: "Aplicativo, celular e conexão com o anel",
  summary: "O que está previsto para iOS, Android e sincronização Bluetooth.",
  keywords: "app ios iphone android bluetooth conectar sincronizar SDK instalação download compatibilidade",
  sections: [{
    title: "Uma experiência própria",
    text: "O aplicativo Rheo está sendo desenvolvido para iOS e Android. A proposta é reunir o resumo do dia, sono, movimento, histórico e check-ins pessoais em uma experiência só."
  }, {
    title: "A conexão ainda está em validação",
    text: "A leitura do anel por Bluetooth depende do protocolo ou SDK do fabricante e de testes com o hardware final. Versões mínimas do sistema, rotina de sincronização e funcionamento em segundo plano ainda não estão confirmados."
  }, {
    title: "Onde baixar",
    text: "Ainda não há uma versão comercial do aplicativo publicada. As telas deste site são uma prévia interativa, com dados demonstrativos. Os links oficiais de instalação serão informados no lançamento."
  }],
  action: {
    href: "/pages/aplicativo",
    label: "Conhecer o aplicativo"
  }
}, {
  slug: "entrega-e-trocas",
  category: "Compras",
  title: "Entrega, rastreamento e troca de tamanho",
  summary: "O que será informado antes da abertura das vendas.",
  keywords: "pedido compra frete prazo envio rastreio rastrear devolução reembolso garantia troca pagamento",
  sections: [{
    title: "Ainda não estamos recebendo pedidos",
    text: "O carrinho desta prévia permite montar uma seleção, mas não realiza pagamento, reserva ou envio. Por isso, ainda não existem pedidos para rastrear neste site."
  }, {
    title: "Frete e prazo",
    text: "Regiões atendidas, transportadoras, custos e prazos serão informados antes da compra quando a operação comercial estiver disponível. Nenhum prazo de entrega é prometido nesta prévia."
  }, {
    title: "Trocas e atendimento",
    text: "O processo de troca de tamanho, devoluções, garantia e os canais oficiais de atendimento serão publicados antes do lançamento. Esta página não substitui as condições comerciais finais."
  }],
  action: {
    href: "/pages/ajuda-colecao-e-disponibilidade",
    label: "Ver o estágio da coleção"
  }
}, {
  slug: "dados-e-privacidade",
  category: "Aplicativo",
  title: "Seus dados nesta prévia",
  summary: "O que fica neste navegador e o que ainda não está conectado.",
  keywords: "dados privacidade segurança saude armazenamento local conta apagar excluir histórico sensor",
  sections: [{
    title: "O carrinho usa a Shopify",
    text: "Quando as vendas estiverem disponíveis, os itens do carrinho serão processados pela Shopify. As telas do aplicativo são demonstrativas e este site não recebe medições de saúde. A política comercial de privacidade será disponibilizada antes do lançamento."
  }, {
    title: "Os indicadores são exemplos",
    text: "Os gráficos e telas exibidos aqui não são leituras do seu corpo. Esta prévia não conecta um anel por Bluetooth, não recebe medições de saúde e não oferece atendimento por IA."
  }, {
    title: "Antes do aplicativo comercial",
    text: "A política de privacidade, as permissões solicitadas, o tratamento dos dados e as opções de exclusão serão definidos e apresentados antes do uso comercial. Não há cadastro ou envio de dados de saúde disponível nesta versão do site."
  }],
  action: {
    href: "/pages/aplicativo",
    label: "Explorar a experiência"
  }
}, {
  slug: "colecao-e-disponibilidade",
  category: "Compras",
  title: "Coleção, acabamentos e disponibilidade",
  summary: "Prata, dourado e preto. Uma coleção em preparação.",
  keywords: "preço lançamento disponivel cores cor prata dourado preto caixa estojo case carregador compra assinatura mensalidade band pulseira",
  sections: [{
    title: "Rheo Ring, coleção 01",
    text: "A prévia apresenta três acabamentos: prata, dourado e preto. O anel e um estojo de carregamento estão previstos para a coleção. Fotos, medidas e conteúdo da caixa serão conferidos com o lote final."
  }, {
    title: "Preço e disponibilidade",
    text: "Preço, data de lançamento, estoque, formas de pagamento e eventuais planos do aplicativo ainda não foram definidos. Você pode explorar o produto e montar sua seleção sem cobrança ou reserva."
  }, {
    title: "Uma marca que começa pelo anel",
    text: "O Rheo Ring é o primeiro produto em desenvolvimento. Outros dispositivos fazem parte da visão da marca, mas não são apresentados como produtos disponíveis para compra."
  }],
  action: {
    href: Wt,
    label: "Explorar o Rheo Ring"
  }
}, {
  slug: "recursos-e-indices",
  category: "Produto",
  title: "O que o anel mede e o que o app interpreta",
  summary: "A diferença entre leituras do dispositivo e índices da Rheo.",
  keywords: "sono frequência cardiaca batimentos spo2 passos sensores flow recuperação estresse precisão recursos funcionalidades indices",
  sections: [{
    title: "O ponto de partida é o hardware",
    text: "O projeto parte das informações de movimento, sono, frequência cardíaca e SpO₂ descritas pelo fornecedor. O acesso, a frequência de leitura e a qualidade desses dados ainda precisam ser validados no modelo final."
  }, {
    title: "Flow é um conceito de software",
    text: "O Rheo Flow propõe reunir sono, recuperação e movimento em um resumo. Ele não é uma medida direta de um sensor. Sua fórmula, as fontes necessárias e outros índices apresentados ainda estão em desenvolvimento."
  }, {
    title: "Contexto, sem diagnóstico",
    text: "Check-ins e anotações acrescentam a percepção pessoal aos registros. As telas não devem ser usadas para diagnóstico, decisão clínica ou avaliação de desempenho esportivo. Os valores desta prévia são demonstrativos."
  }],
  action: {
    href: "/pages/aplicativo",
    label: "Ver as telas do aplicativo"
  }
}];
({
  ...Object.fromEntries(ms.map((r) => [`/pages/ajuda-${r.slug}`, `${r.title} | Rheo`]))
});
const wc = (r) => globalThis.rheoAsset(`${r}`);
function hs({
  label: r,
  support: x = !1
}) {
  return /* @__PURE__ */ i.jsxs("nav", { className: "r-container ip-breadcrumb", "aria-label": "Caminho da página", children: [
    /* @__PURE__ */ i.jsx("a", { href: "/", children: "Rheo" }),
    /* @__PURE__ */ i.jsx(qa, { size: 12 }),
    x && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx("a", { href: "/pages/suporte", children: "Suporte" }),
      /* @__PURE__ */ i.jsx(qa, { size: 12 })
    ] }),
    /* @__PURE__ */ i.jsx("span", { "aria-current": "page", children: r })
  ] });
}
function $c({
  title: r,
  text: x,
  href: m = Wt,
  label: o = "Conhecer o Rheo Ring"
}) {
  return /* @__PURE__ */ i.jsx("section", { className: "ip-closing", children: /* @__PURE__ */ i.jsxs("div", { className: "r-container", children: [
    /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("h2", { children: r }),
      /* @__PURE__ */ i.jsx("p", { children: x })
    ] }),
    /* @__PURE__ */ i.jsxs("a", { className: "r-button r-button-light", href: m, children: [
      o,
      /* @__PURE__ */ i.jsx(Ne, { size: 18 })
    ] })
  ] }) });
}
function kv() {
  return /* @__PURE__ */ i.jsxs("div", { className: "information-page ip-application", children: [
    /* @__PURE__ */ i.jsx(hs, { label: "Aplicativo" }),
    /* @__PURE__ */ i.jsx(Tm, { standalone: !0 }),
    /* @__PURE__ */ i.jsx("section", { className: "ip-app-context", children: /* @__PURE__ */ i.jsxs("div", { className: "r-container", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ip-section-heading", children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "DA LEITURA AO CONTEXTO" }),
          /* @__PURE__ */ i.jsxs("h2", { children: [
            "O detalhe importa.",
            /* @__PURE__ */ i.jsx("br", {}),
            /* @__PURE__ */ i.jsx("em", { children: "O conjunto também." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: "Primeiro, uma visão do dia. Depois, espaço para entender cada informação e acrescentar o que só você sabe sobre sua rotina." })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: "ip-app-stories", children: [{
        index: 3,
        title: "Seu ponto de partida.",
        text: "O Flow é a proposta de uma leitura que reúne descanso, recuperação e atividade. Cada componente continua ao seu alcance.",
        note: "Índice conceitual, em validação."
      }, {
        index: 0,
        title: "Mais do que horas de sono.",
        text: "Horários, duração e histórico para colocar uma noite ao lado das anteriores. Uma forma de observar a regularidade.",
        note: "Fases e valores demonstrativos."
      }, {
        index: 4,
        title: "Você também faz parte dos dados.",
        text: "Um check-in sobre sua disposição traz a percepção pessoal para perto dos registros. Nem tudo que importa vem de um sensor.",
        note: "Check-in de exemplo, sem envio de dados."
      }].map((r) => /* @__PURE__ */ i.jsxs("article", { children: [
        /* @__PURE__ */ i.jsx(Nm, { index: r.index }),
        /* @__PURE__ */ i.jsx("h3", { children: r.title }),
        /* @__PURE__ */ i.jsx("p", { children: r.text }),
        /* @__PURE__ */ i.jsx("small", { children: r.note })
      ] }, r.index)) })
    ] }) }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-container ip-app-status", children: [
      /* @__PURE__ */ i.jsx(Em, { size: 28, strokeWidth: 1.2 }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "EM DESENVOLVIMENTO" }),
        /* @__PURE__ */ i.jsx("h2", { children: "Uma experiência para iOS e Android." }),
        /* @__PURE__ */ i.jsx("p", { children: "Conexão Bluetooth, versões compatíveis e recursos finais serão confirmados após os testes com o anel. Ainda não há um aplicativo comercial disponível para download." }),
        /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "/pages/ajuda-aplicativo-e-conexao", children: [
          "Sobre a conexão e a disponibilidade ",
          /* @__PURE__ */ i.jsx(Ne, { size: 16 })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("a", { className: "ip-privacy-link", href: "/pages/ajuda-dados-e-privacidade", children: [
        /* @__PURE__ */ i.jsx(Nv, { size: 21 }),
        "Seus dados nesta prévia",
        /* @__PURE__ */ i.jsx(Ra, { size: 17 })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx($c, { title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      "Uma pequena peça.",
      /* @__PURE__ */ i.jsx("br", {}),
      /* @__PURE__ */ i.jsx("em", { children: "Uma experiência inteira." })
    ] }), text: "Conheça o anel que dá início à coleção Rheo." })
  ] });
}
const pm = [{
  label: "Movimento",
  icon: Gl,
  image: "sport-life.webp",
  alt: "Anel dourado na mão de uma tenista, junto à raquete",
  title: "A vida acontece em movimento.",
  text: "Uma partida, uma caminhada, o treino que cabe no seu dia. A proposta da Rheo é acompanhar sua própria continuidade, sem transformar tudo em competição.",
  link: "Seu movimento no aplicativo"
}, {
  label: "Pausa",
  icon: ds,
  image: "daily-life.webp",
  alt: "Anel prata no dedo durante uma pausa para o café depois do esporte",
  title: "Nem todo progresso faz barulho.",
  text: "Uma conversa depois da quadra. Um café sem pressa. A vida entre um treino e outro também merece espaço no seu dia.",
  link: "Conheça o olhar da Rheo"
}, {
  label: "Seu ritmo",
  icon: Mt,
  image: "pdp-running-detail.webp",
  alt: "Anel dourado em primeiro plano na mão de uma corredora em uma pausa",
  title: "O seu ritmo não precisa ser o de ninguém.",
  text: "Dias intensos, dias leves. Registros e percepção pessoal podem conviver para contar uma história que é sua, não a de um ranking.",
  link: "Explore a experiência"
}];
function wv() {
  const [r, x] = V.useState(0), m = pm[r], o = (b) => {
    var M;
    x(b), (M = document.getElementById(`ip-moment-${b}`)) == null || M.focus();
  };
  return /* @__PURE__ */ i.jsxs("div", { className: "information-page ip-lifestyle", children: [
    /* @__PURE__ */ i.jsxs("section", { className: "ip-life-hero", children: [
      /* @__PURE__ */ i.jsx("img", { src: wc("daily-life.webp"), alt: "Rheo Ring prata em uma pausa depois da quadra", fetchPriority: "high" }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-container", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "SAÚDE. MOVIMENTO. VIDA." }),
        /* @__PURE__ */ i.jsx("h1", { children: "Viva Rheo." }),
        /* @__PURE__ */ i.jsxs("p", { children: [
          "Mais presença.",
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("em", { children: "No seu próprio ritmo." })
        ] }),
        /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "#momentos", children: [
          "Encontre seu momento ",
          /* @__PURE__ */ i.jsx(Ra, { size: 17 })
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("span", { className: "ip-life-footnote", children: "UM NOVO OLHAR PARA A VIDA QUE VOCÊ JÁ VIVE." })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-container ip-life-intro", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "É SOBRE VOCÊ." }),
      /* @__PURE__ */ i.jsxs("h2", { children: [
        "Tecnologia próxima.",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "Vida em primeiro plano." })
      ] }),
      /* @__PURE__ */ i.jsx("p", { children: "A Rheo nasce do encontro entre saúde e lifestyle. Um objeto que combina com você. Uma experiência que cabe na sua rotina. Informação para observar, não mais uma tela para ocupar o seu dia." })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { id: "momentos", className: "ip-moments", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "r-container ip-moment-nav", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "CADA DIA TEM SEU TOM." }),
        /* @__PURE__ */ i.jsx("div", { role: "tablist", "aria-label": "Momentos Rheo", children: pm.map((b, M) => /* @__PURE__ */ i.jsxs("button", { id: `ip-moment-${M}`, role: "tab", "aria-selected": r === M, "aria-controls": "ip-moment-panel", tabIndex: r === M ? 0 : -1, onClick: () => o(M), onKeyDown: (p) => {
          ["ArrowRight", "ArrowLeft", "Home", "End"].includes(p.key) && (p.preventDefault(), o(p.key === "Home" ? 0 : p.key === "End" ? 2 : (M + (p.key === "ArrowRight" ? 1 : 2)) % 3));
        }, children: [
          /* @__PURE__ */ i.jsx(b.icon, { size: 17 }),
          b.label
        ] }, b.label)) })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "ip-moment-panel", id: "ip-moment-panel", role: "tabpanel", "aria-labelledby": `ip-moment-${r}`, children: [
        /* @__PURE__ */ i.jsx("img", { src: wc(m.image), alt: m.alt }, m.image),
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsxs("span", { className: "r-kicker", children: [
            "0",
            r + 1,
            " / ",
            m.label.toLocaleUpperCase("pt-BR")
          ] }),
          /* @__PURE__ */ i.jsx("h2", { children: m.title }),
          /* @__PURE__ */ i.jsx("p", { children: m.text }),
          /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "/pages/aplicativo", children: [
            m.link,
            /* @__PURE__ */ i.jsx(Ne, { size: 17 })
          ] })
        ] }, m.title)
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("section", { className: "r-container ip-values", children: [{
      icon: ds,
      title: "Presença antes de performance.",
      text: "Uma vida não cabe em uma pontuação. O que você sente faz parte da leitura."
    }, {
      icon: Mt,
      title: "Sua referência é você.",
      text: "Uma experiência pensada para observar a própria rotina, sem comparação com outras pessoas."
    }, {
      icon: Vl,
      title: "Discrição, por princípio.",
      text: "O anel na mão. Os detalhes no aplicativo. O resto do tempo continua sendo seu."
    }].map((b) => /* @__PURE__ */ i.jsxs("article", { children: [
      /* @__PURE__ */ i.jsx(b.icon, { size: 26, strokeWidth: 1.2 }),
      /* @__PURE__ */ i.jsx("h3", { children: b.title }),
      /* @__PURE__ */ i.jsx("p", { children: b.text })
    ] }, b.title)) }),
    /* @__PURE__ */ i.jsx($c, { title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      "O começo cabe",
      /* @__PURE__ */ i.jsx("br", {}),
      /* @__PURE__ */ i.jsx("em", { children: "em um anel." })
    ] }), text: "Três acabamentos. Uma coleção em preparação." })
  ] });
}
function Kv({
  onSize: r
}) {
  return /* @__PURE__ */ i.jsxs("div", { className: "information-page ip-sizing", children: [
    /* @__PURE__ */ i.jsx(hs, { label: "Guia de tamanho" }),
    /* @__PURE__ */ i.jsxs("header", { className: "r-container ip-size-intro", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "UM DETALHE ESSENCIAL." }),
      /* @__PURE__ */ i.jsxs("h1", { children: [
        "Seu tamanho.",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "Seu ajuste." })
      ] }),
      /* @__PURE__ */ i.jsxs("p", { children: [
        "Comece com papel, uma caneta e uma régua.",
        /* @__PURE__ */ i.jsx("br", {}),
        "Uma medida em centímetros. Um passo de cada vez."
      ] }),
      /* @__PURE__ */ i.jsxs("button", { onClick: r, className: "r-button r-button-dark", children: [
        "Começar a medir",
        /* @__PURE__ */ i.jsx(Ot, { size: 18 })
      ] }),
      /* @__PURE__ */ i.jsx("small", { children: "A medição com papel é uma estimativa. A tabela desta prévia é demonstrativa." })
    ] }),
    /* @__PURE__ */ i.jsx("section", { className: "ip-size-steps r-container", "aria-label": "Etapas da medição", children: [{
      image: "fit-wrap.webp",
      title: "Envolva.",
      text: "Passe uma tira estreita de papel ao redor da base do dedo, sem apertar."
    }, {
      image: "fit-mark.webp",
      title: "Marque.",
      text: "Marque o encontro das pontas. Confira também a passagem pela articulação."
    }, {
      image: "fit-measure.webp",
      title: "Meça.",
      text: "Estenda a tira e meça da ponta até a marca. Use centímetros, não o diâmetro."
    }].map((x, m) => /* @__PURE__ */ i.jsxs("article", { children: [
      /* @__PURE__ */ i.jsx("img", { src: wc(x.image), alt: x.text, width: "1000", height: "1000" }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          "0",
          m + 1
        ] }),
        /* @__PURE__ */ i.jsx("h2", { children: x.title }),
        /* @__PURE__ */ i.jsx("p", { children: x.text })
      ] })
    ] }, x.title)) }),
    /* @__PURE__ */ i.jsxs("section", { className: "ip-size-notes r-container", children: [
      /* @__PURE__ */ i.jsx("h2", { children: "Antes de escolher." }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsxs("details", { open: !0, children: [
          /* @__PURE__ */ i.jsxs("summary", { children: [
            "Nem apertado. Nem solto.",
            /* @__PURE__ */ i.jsx(qa, { size: 17 })
          ] }),
          /* @__PURE__ */ i.jsx("p", { children: "O encaixe precisa ser confortável. Confira a passagem pela articulação e repita a medição em momentos diferentes. Um medidor físico compatível é a melhor forma de conferir o ajuste." })
        ] }),
        /* @__PURE__ */ i.jsxs("details", { children: [
          /* @__PURE__ */ i.jsxs("summary", { children: [
            "O número de outro anel pode ser diferente.",
            /* @__PURE__ */ i.jsx(qa, { size: 17 })
          ] }),
          /* @__PURE__ */ i.jsx("p", { children: "A numeração da coleção não equivale automaticamente ao aro brasileiro ou à numeração de outra marca. Aguarde a tabela validada do modelo antes de uma compra real." })
        ] }),
        /* @__PURE__ */ i.jsxs("details", { children: [
          /* @__PURE__ */ i.jsxs("summary", { children: [
            "E se eu ficar entre duas medidas?",
            /* @__PURE__ */ i.jsx(qa, { size: 17 })
          ] }),
          /* @__PURE__ */ i.jsx("p", { children: "Não trate a aproximação do papel como uma recomendação definitiva. Repita a medição e confirme o encaixe com um medidor físico do modelo. Nesta prévia, nenhum tamanho é uma indicação para compra." })
        ] }),
        /* @__PURE__ */ i.jsxs("button", { className: "r-text-link", onClick: r, children: [
          "Abrir guia interativo ",
          /* @__PURE__ */ i.jsx(Ne, { size: 17 })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx($c, { title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      "A escolha começa",
      /* @__PURE__ */ i.jsx("br", {}),
      /* @__PURE__ */ i.jsx("em", { children: "com você." })
    ] }), text: "Explore os acabamentos e monte sua seleção.", label: "Ver os acabamentos" })
  ] });
}
const vm = {
  Todos: Jc,
  Tamanhos: Ot,
  Aplicativo: Em,
  Compras: bv,
  Produto: Mt
}, ym = (r) => r.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("pt-BR");
function Jv() {
  const [r, x] = V.useState(() => new URLSearchParams(typeof window > "u" ? "" : window.location.search).get("q") || ""), [m, o] = V.useState(() => {
    const p = new URLSearchParams(typeof window > "u" ? "" : window.location.search).get("assunto");
    return Object.hasOwn(vm, p) ? p : "Todos";
  });
  V.useEffect(() => {
    const p = new URL(window.location.href);
    r ? p.searchParams.set("q", r) : p.searchParams.delete("q"), m !== "Todos" ? p.searchParams.set("assunto", m) : p.searchParams.delete("assunto"), history.replaceState(history.state, "", p);
  }, [r, m]);
  const b = ym(r).trim().split(/\s+/).filter(Boolean), M = ms.filter((p) => (m === "Todos" || p.category === m) && b.every((E) => ym(`${p.title} ${p.summary} ${p.keywords}`).includes(E)));
  return /* @__PURE__ */ i.jsxs("div", { className: "information-page ip-support", children: [
    /* @__PURE__ */ i.jsx(hs, { label: "Suporte" }),
    /* @__PURE__ */ i.jsxs("header", { className: "r-container ip-support-header", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "CENTRAL DE SUPORTE" }),
      /* @__PURE__ */ i.jsxs("h1", { children: [
        "Como podemos",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "ajudar?" })
      ] }),
      /* @__PURE__ */ i.jsx("p", { children: "Do primeiro ajuste aos detalhes da experiência Rheo." }),
      /* @__PURE__ */ i.jsxs("form", { role: "search", onSubmit: (p) => p.preventDefault(), children: [
        /* @__PURE__ */ i.jsx(om, { size: 20 }),
        /* @__PURE__ */ i.jsx("input", { "aria-label": "Buscar na central de suporte", value: r, onChange: (p) => x(p.target.value), placeholder: "Busque por tamanho, aplicativo, entrega...", type: "search" }),
        r && /* @__PURE__ */ i.jsx("button", { type: "button", "aria-label": "Limpar busca", title: "Limpar busca", onClick: () => x(""), children: /* @__PURE__ */ i.jsx(Am, { size: 17 }) })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-container ip-support-content", "aria-label": "Artigos de ajuda", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ip-categories", role: "group", "aria-label": "Filtrar assuntos", children: Object.entries(vm).map(([p, E]) => /* @__PURE__ */ i.jsxs("button", { "aria-pressed": m === p, onClick: () => o(p), children: [
        /* @__PURE__ */ i.jsx(E, { size: 19 }),
        /* @__PURE__ */ i.jsx("span", { children: p })
      ] }, p)) }),
      /* @__PURE__ */ i.jsxs("div", { className: "ip-results-heading", children: [
        /* @__PURE__ */ i.jsx("h2", { children: m === "Todos" ? "Encontre sua resposta." : m }),
        /* @__PURE__ */ i.jsxs("span", { role: "status", children: [
          M.length,
          " ",
          M.length === 1 ? "artigo" : "artigos"
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: "ip-help-list", children: M.map((p) => /* @__PURE__ */ i.jsxs("a", { href: `/pages/ajuda-${p.slug}`, children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("span", { children: p.category }),
          /* @__PURE__ */ i.jsx("h3", { children: p.title }),
          /* @__PURE__ */ i.jsx("p", { children: p.summary })
        ] }),
        /* @__PURE__ */ i.jsx(Ne, { size: 22 })
      ] }, p.slug)) }),
      !M.length && /* @__PURE__ */ i.jsxs("div", { className: "ip-empty", children: [
        /* @__PURE__ */ i.jsx(om, { size: 28, strokeWidth: 1.2 }),
        /* @__PURE__ */ i.jsx("h3", { children: "Nenhum artigo encontrado." }),
        /* @__PURE__ */ i.jsx("p", { children: "Tente outra palavra ou veja todos os assuntos." }),
        /* @__PURE__ */ i.jsxs("button", { className: "r-text-link", onClick: () => {
          x(""), o("Todos");
        }, children: [
          "Ver todos os artigos ",
          /* @__PURE__ */ i.jsx(Ra, { size: 17 })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "ip-support-foot r-container", children: [
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "ANTES DA PRIMEIRA ESCOLHA" }),
        /* @__PURE__ */ i.jsx("h2", { children: "Comece pelo ajuste." }),
        /* @__PURE__ */ i.jsx("p", { children: "Um guia visual, em centímetros, para entender a medição." }),
        /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "/pages/guia-de-tamanho", children: [
          "Encontrar meu tamanho ",
          /* @__PURE__ */ i.jsx(Ne, { size: 17 })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "UMA COLEÇÃO EM PREPARAÇÃO" }),
        /* @__PURE__ */ i.jsx("h2", { children: "Estamos no começo." }),
        /* @__PURE__ */ i.jsx("p", { children: "Vendas e atendimento comercial ainda não estão disponíveis. Os canais oficiais, prazos e condições serão publicados no lançamento." }),
        /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "/pages/ajuda-colecao-e-disponibilidade", children: [
          "Sobre a disponibilidade ",
          /* @__PURE__ */ i.jsx(Ne, { size: 17 })
        ] })
      ] })
    ] })
  ] });
}
function $v({
  article: r,
  onSize: x
}) {
  return /* @__PURE__ */ i.jsxs("div", { className: "information-page ip-article-page", children: [
    /* @__PURE__ */ i.jsx(hs, { support: !0, label: r.category }),
    /* @__PURE__ */ i.jsxs("div", { className: "r-container ip-article-layout", children: [
      /* @__PURE__ */ i.jsxs("aside", { children: [
        /* @__PURE__ */ i.jsxs("a", { href: "/pages/suporte", className: "r-text-link", children: [
          "Central de suporte ",
          /* @__PURE__ */ i.jsx(Ne, { size: 15 })
        ] }),
        /* @__PURE__ */ i.jsx("nav", { "aria-label": "Artigos relacionados", children: ms.map((m) => /* @__PURE__ */ i.jsxs("a", { href: `/pages/ajuda-${m.slug}`, "aria-current": m.slug === r.slug ? "page" : void 0, children: [
          m.title,
          /* @__PURE__ */ i.jsx(qa, { size: 14 })
        ] }, m.slug)) })
      ] }),
      /* @__PURE__ */ i.jsxs("article", { children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: r.category.toLocaleUpperCase("pt-BR") }),
        /* @__PURE__ */ i.jsx("h1", { children: r.title }),
        /* @__PURE__ */ i.jsx("p", { className: "ip-article-lead", children: r.summary }),
        r.sections.map((m) => /* @__PURE__ */ i.jsxs("section", { children: [
          /* @__PURE__ */ i.jsx("h2", { children: m.title }),
          /* @__PURE__ */ i.jsx("p", { children: m.text })
        ] }, m.title)),
        /* @__PURE__ */ i.jsxs("div", { className: "ip-article-action", children: [
          r.slug === "tamanho-e-ajuste" ? /* @__PURE__ */ i.jsxs("button", { className: "r-button r-button-dark", onClick: x, children: [
            "Abrir guia interativo",
            /* @__PURE__ */ i.jsx(Ot, { size: 18 })
          ] }) : /* @__PURE__ */ i.jsxs("a", { href: r.action.href, className: "r-button r-button-dark", children: [
            r.action.label,
            /* @__PURE__ */ i.jsx(Ne, { size: 17 })
          ] }),
          /* @__PURE__ */ i.jsx("span", { children: "Informações desta prévia · setembro de 2026" })
        ] }),
        /* @__PURE__ */ i.jsxs("a", { href: "/pages/suporte", className: "r-text-link", children: [
          "Voltar aos assuntos ",
          /* @__PURE__ */ i.jsx(Ra, { size: 17 })
        ] })
      ] })
    ] })
  ] });
}
function Wv() {
  return /* @__PURE__ */ i.jsxs("div", { className: "information-page ip-not-found r-container", children: [
    /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "404 / PÁGINA NÃO ENCONTRADA" }),
    /* @__PURE__ */ i.jsxs("h1", { children: [
      "Vamos encontrar",
      /* @__PURE__ */ i.jsx("br", {}),
      /* @__PURE__ */ i.jsx("em", { children: "outro caminho." })
    ] }),
    /* @__PURE__ */ i.jsx("p", { children: "Este endereço não corresponde a uma página da Rheo." }),
    /* @__PURE__ */ i.jsxs("a", { href: "/", className: "r-button r-button-dark", children: [
      "Voltar ao início",
      /* @__PURE__ */ i.jsx(Ra, { size: 18 })
    ] }),
    /* @__PURE__ */ i.jsxs("a", { className: "r-text-link", href: "/pages/suporte", children: [
      "Ir para o suporte ",
      /* @__PURE__ */ i.jsx(Ne, { size: 17 })
    ] })
  ] });
}
const Gc = [{
  label: "Acabamento",
  image: "silver-hero.webp",
  title: "Presença nos detalhes.",
  text: "Superfícies, reflexos e contornos. Um objeto pensado para fazer parte do que você veste.",
  alt: "Vista completa do anel prata e de seu acabamento externo"
}, {
  label: "Por dentro",
  image: "ring-macro.webp",
  title: "Um outro lado da história.",
  text: "No interior, os componentes que dão início à experiência. A integração e os recursos finais estão em validação.",
  alt: "Detalhe ampliado do interior escuro e das janelas dos sensores do anel"
}];
function Fv({
  onClose: r
}) {
  const [x, m] = V.useState(0), o = Gc[x];
  function b(M) {
    var p;
    m(M), (p = document.getElementById(`hero-view-${M}`)) == null || p.focus({
      preventScroll: !0
    });
  }
  return /* @__PURE__ */ i.jsxs(Yl, { title: "Rheo Ring de perto", type: "rh-detail-dialog", wide: !0, onClose: r, children: [
    /* @__PURE__ */ i.jsx("div", { className: "rh-detail-tabs", role: "tablist", "aria-label": "Vistas do anel", children: Gc.map((M, p) => /* @__PURE__ */ i.jsxs("button", { id: `hero-view-${p}`, role: "tab", "aria-selected": x === p, tabIndex: x === p ? 0 : -1, "aria-controls": "hero-detail-panel", onClick: () => b(p), onKeyDown: (E) => {
      ["ArrowLeft", "ArrowRight", "Home", "End"].includes(E.key) && (E.preventDefault(), b(E.key === "Home" ? 0 : E.key === "End" ? 1 : 1 - p));
    }, children: [
      p === 0 ? /* @__PURE__ */ i.jsx(rs, { size: 16 }) : /* @__PURE__ */ i.jsx(Ev, { size: 16 }),
      M.label
    ] }, M.label)) }),
    /* @__PURE__ */ i.jsxs("div", { id: "hero-detail-panel", role: "tabpanel", "aria-labelledby": `hero-view-${x}`, children: [
      /* @__PURE__ */ i.jsx("div", { className: "rh-detail-photo", children: Gc.map((M, p) => /* @__PURE__ */ i.jsx("img", { src: globalThis.rheoAsset(`${M.image}`), alt: M.alt, className: p === x ? "is-active" : "", "aria-hidden": p !== x }, M.image)) }),
      /* @__PURE__ */ i.jsxs("div", { className: "rh-detail-copy", children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("h2", { children: o.title }),
          /* @__PURE__ */ i.jsx("p", { children: o.text })
        ] }),
        /* @__PURE__ */ i.jsxs("a", { href: "/pages/rheo-ring", className: "r-text-link", children: [
          "Escolher meu Ring ",
          /* @__PURE__ */ i.jsx(Ne, { size: 17 })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("p", { className: "rh-detail-note", children: "Imagens conceituais. Aparência e componentes sujeitos à conferência com o produto final." })
  ] });
}
function Iv({
  onFilm: r,
  campaign: x = {},
  purchaseRef: m
}) {
  const [o, b] = V.useState(!1), M = V.useRef(null), p = V.useRef(null);
  return V.useEffect(() => {
    const E = matchMedia("(prefers-reduced-motion: no-preference) and (hover: hover) and (min-width: 961px)"), A = M.current;
    let S, q = !0, _ = 0, k = 0;
    const L = () => {
      cancelAnimationFrame(S), S = requestAnimationFrame(() => {
        var oe, Me;
        const ee = Math.min(24, Math.max(0, -A.getBoundingClientRect().top) * 0.06);
        (oe = p.current) == null || oe.style.setProperty("--rh-x", `${E.matches ? _ : 0}px`), (Me = p.current) == null || Me.style.setProperty("--rh-y", `${E.matches ? k + ee : 0}px`);
      });
    }, ne = (ee) => {
      if (!E.matches || !q) return;
      const oe = A.getBoundingClientRect();
      _ = ((ee.clientX - oe.left) / oe.width - 0.5) * -12, k = ((ee.clientY - oe.top) / oe.height - 0.5) * -8, L();
    }, ce = () => {
      _ = 0, k = 0, L();
    }, ve = () => {
      q && E.matches && L();
    }, I = new IntersectionObserver(([ee]) => {
      q = ee.isIntersecting;
    });
    return I.observe(A), A.addEventListener("pointermove", ne), A.addEventListener("pointerleave", ce), window.addEventListener("scroll", ve, {
      passive: !0
    }), E.addEventListener("change", ce), () => {
      cancelAnimationFrame(S), I.disconnect(), A.removeEventListener("pointermove", ne), A.removeEventListener("pointerleave", ce), window.removeEventListener("scroll", ve), E.removeEventListener("change", ce);
    };
  }, []), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs("section", { ref: M, className: "r-hero r-campaign", id: "anel", "aria-labelledby": "rh-heading", children: [
      /* @__PURE__ */ i.jsx("div", { className: "rh-stage", ref: p, children: /* @__PURE__ */ i.jsxs("picture", { children: [
        /* @__PURE__ */ i.jsx("source", { media: "(max-width: 960px)", srcSet: x.mobileImage || globalThis.rheoAsset("home-campaign-mobile.webp") }),
        /* @__PURE__ */ i.jsx("img", { className: "r-hero-image", src: x.desktopImage || globalThis.rheoAsset("home-campaign-desktop.webp"), alt: "Rheo Ring prata suspenso sobre uma quadra verde, com luz lateral revelando o acabamento e o interior do anel", fetchPriority: "high" })
      ] }) }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-hero-copy rh-copy", children: [
        /* @__PURE__ */ i.jsxs("span", { className: "r-kicker", children: [
          /* @__PURE__ */ i.jsx("span", { className: "rh-edition", children: "01" }),
          " ",
          x.eyebrow || "INTELIGÊNCIA QUE VESTE VOCÊ."
        ] }),
        /* @__PURE__ */ i.jsxs("h1", { id: "rh-heading", children: [
          "Rheo ",
          /* @__PURE__ */ i.jsx("em", { children: "Ring" })
        ] }),
        /* @__PURE__ */ i.jsxs("p", { className: "rh-statement", children: [
          "Viva o seu ",
          /* @__PURE__ */ i.jsx("em", { children: "ritmo." })
        ] }),
        /* @__PURE__ */ i.jsxs("p", { className: "rh-description", children: [
          x.lineOne || "Sono, movimento e recuperação.",
          /* @__PURE__ */ i.jsx("br", {}),
          x.lineTwo || "Uma nova perspectiva sobre você."
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "rh-actions", children: [
          /* @__PURE__ */ i.jsxs("a", { ref: m, className: "r-button r-button-light", href: "/pages/rheo-ring", children: [
            x.cta || "Encontre o seu",
            " ",
            /* @__PURE__ */ i.jsx(Ne, { size: 19 })
          ] }),
          /* @__PURE__ */ i.jsxs("a", { className: "rh-app-link", href: "/pages/rheo-ring", children: [
            "Conheça a experiência ",
            /* @__PURE__ */ i.jsx(Ra, { size: 16 })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "rh-finishes", children: [
          /* @__PURE__ */ i.jsxs("div", { "aria-label": "Explorar acabamentos", children: [
            /* @__PURE__ */ i.jsx("a", { className: "rh-swatch rh-silver", href: "/pages/rheo-ring", "aria-label": "Explorar acabamento prata", title: "Prata" }),
            /* @__PURE__ */ i.jsx("a", { className: "rh-swatch rh-gold", href: "/pages/rheo-ring", "aria-label": "Explorar acabamento dourado", title: "Dourado" }),
            /* @__PURE__ */ i.jsx("a", { className: "rh-swatch rh-black", href: "/pages/rheo-ring", "aria-label": "Explorar acabamento preto", title: "Preto" })
          ] }),
          /* @__PURE__ */ i.jsxs("span", { children: [
            "Três acabamentos.",
            /* @__PURE__ */ i.jsx("br", {}),
            /* @__PURE__ */ i.jsx("strong", { children: "O seu jeito de usar." })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("span", { className: "rh-caption", children: "RHEO RING / PRATA" }),
      /* @__PURE__ */ i.jsxs("button", { className: "rh-inspect", onClick: () => b(!0), "aria-label": "Explorar detalhes do anel", children: [
        /* @__PURE__ */ i.jsx("span", { children: /* @__PURE__ */ i.jsx(rs, { size: 17, strokeWidth: 1.4 }) }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          "Olhe de perto ",
          /* @__PURE__ */ i.jsx(Ne, { size: 13 })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-hero-bottom rh-bottom", children: [
        /* @__PURE__ */ i.jsxs("a", { href: "#de-perto", children: [
          /* @__PURE__ */ i.jsx(bm, { size: 15 }),
          " Pequeno no dedo. Presente na vida."
        ] }),
        /* @__PURE__ */ i.jsxs("button", { onClick: r, children: [
          /* @__PURE__ */ i.jsx("span", { className: "rh-play", children: /* @__PURE__ */ i.jsx(zv, { size: 13 }) }),
          " ",
          "Ver o filme ",
          /* @__PURE__ */ i.jsx("small", { children: "00:06" })
        ] })
      ] })
    ] }),
    o && /* @__PURE__ */ i.jsx(Fv, { onClose: () => b(!1) })
  ] });
}
const Vc = "/products/rheo-ring", Tt = (r) => globalThis.rheoAsset(`${r}`);
function Mm({
  onSize: r
}) {
  const x = [["Como escolher meu tamanho?", /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "Meça a circunferência do dedo em centímetros. O papel fornece uma estimativa; confira o encaixe com um medidor físico. A tabela desta prévia é ilustrativa e ainda depende de validação do fornecedor.",
    /* @__PURE__ */ i.jsxs("button", { className: "r-text-link", onClick: r, children: [
      "Abrir guia de tamanho ",
      /* @__PURE__ */ i.jsx(Ne, { size: 16 })
    ] })
  ] })], ["O que vem com o anel?", "Estamos preparando o anel, o estojo de carregamento e instruções em português. O conteúdo final será confirmado no lançamento."], ["O aplicativo funciona no meu celular?", "A experiência está sendo desenvolvida para iOS e Android. As telas são demonstrativas; integração Bluetooth, versões mínimas e recursos finais dependem da validação com o hardware."], ["Quando posso comprar o meu?", "Esta é uma prévia. Preço, disponibilidade, entrega e condições de troca serão informados no lançamento. O carrinho não realiza pedidos, reservas ou pagamentos."], ["Quais informações ele acompanha?", "O projeto parte de movimento, sono, frequência cardíaca e SpO₂, segundo a ficha do fornecedor. Recursos, precisão e índices derivados ainda serão validados no modelo final. O anel não é apresentado como dispositivo de diagnóstico."]];
  return /* @__PURE__ */ i.jsxs("section", { className: "r-faq r-container", id: "duvidas", children: [
    /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "PODE PERGUNTAR." }),
      /* @__PURE__ */ i.jsxs("h2", { children: [
        "Antes de fazer",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "parte de você." })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("div", { children: x.map(([m, o]) => /* @__PURE__ */ i.jsxs("details", { children: [
      /* @__PURE__ */ i.jsxs("summary", { children: [
        m,
        /* @__PURE__ */ i.jsx(Hl, { size: 18 })
      ] }),
      /* @__PURE__ */ i.jsx("div", { children: o })
    ] }, m)) })
  ] });
}
function Pv() {
  const [r, x] = V.useState(0), m = Yc[r], o = (b) => {
    var M;
    x(b), (M = document.getElementById(`r-app-tab-${b}`)) == null || M.focus({
      preventScroll: !0
    });
  };
  return /* @__PURE__ */ i.jsxs("section", { className: "r-experience", id: "experiencia", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "r-container r-app-intro", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "O ANEL É SÓ O COMEÇO." }),
      /* @__PURE__ */ i.jsxs("h2", { children: [
        "Seus sinais.",
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("em", { children: "Uma nova perspectiva." })
      ] }),
      /* @__PURE__ */ i.jsxs("p", { children: [
        "Do que você sente ao que começa a perceber.",
        /* @__PURE__ */ i.jsx("br", {}),
        "Um olhar para o seu sono, seu movimento e seu ritmo."
      ] })
    ] }),
    /* @__PURE__ */ i.jsx("div", { className: "r-app-tabs", role: "tablist", "aria-label": "Momentos no aplicativo", children: Yc.map((b, M) => /* @__PURE__ */ i.jsxs("button", { id: `r-app-tab-${M}`, role: "tab", "aria-selected": M === r, tabIndex: M === r ? 0 : -1, "aria-controls": "r-app-panel", onClick: () => o(M), onKeyDown: (p) => {
      ["ArrowLeft", "ArrowRight", "Home", "End"].includes(p.key) && (p.preventDefault(), o(p.key === "Home" ? 0 : p.key === "End" ? 2 : (M + (p.key === "ArrowRight" ? 1 : 2)) % 3));
    }, children: [
      /* @__PURE__ */ i.jsx(b.icon, { size: 17 }),
      b.label
    ] }, b.id)) }),
    /* @__PURE__ */ i.jsx("div", { className: "r-phone-lineup", children: Yc.map((b, M) => /* @__PURE__ */ i.jsx("div", { className: `r-app-phone ${M === r ? "selected" : ""}`, children: /* @__PURE__ */ i.jsx("img", { src: Tt(b.image), alt: `Aplicativo Rheo: ${b.label}`, loading: "lazy" }) }, b.id)) }),
    /* @__PURE__ */ i.jsxs("div", { className: "r-app-caption", id: "r-app-panel", role: "tabpanel", "aria-labelledby": `r-app-tab-${r}`, children: [
      /* @__PURE__ */ i.jsx("span", { children: m.metricLabel }),
      /* @__PURE__ */ i.jsx("p", { children: m.text })
    ] }),
    /* @__PURE__ */ i.jsx("p", { className: "r-app-disclaimer", children: "Telas conceituais · Dados demonstrativos · Planejado para iOS e Android" })
  ] });
}
function e1({
  onFilm: r,
  onSize: x,
  campaign: m,
  price: o
}) {
  const [b, M] = V.useState(0), p = V.useRef(null);
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(Iv, { onFilm: r, campaign: m, purchaseRef: p }),
    /* @__PURE__ */ null,
    /* @__PURE__ */ i.jsxs("div", { className: "r-product-nav", children: [
      /* @__PURE__ */ i.jsxs("span", { children: [
        "Rheo Ring ",
        /* @__PURE__ */ i.jsx("i", { children: "/ 01" })
      ] }),
      /* @__PURE__ */ i.jsxs("nav", { "aria-label": "Nesta página", children: [
        /* @__PURE__ */ i.jsx("a", { href: "#de-perto", children: "Design" }),
        /* @__PURE__ */ i.jsx("a", { href: "#vida", children: "Lifestyle" }),
        /* @__PURE__ */ i.jsx("a", { href: "#experiencia", children: "Aplicativo" })
      ] }),
      /* @__PURE__ */ i.jsxs("a", { href: "/pages/rheo-ring", children: [
        "Escolher o meu ",
        /* @__PURE__ */ i.jsx(Ne, { size: 15 })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-object-intro r-container", id: "de-perto", children: [
      /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "TECNOLOGIA QUE FAZ PARTE." }),
      /* @__PURE__ */ i.jsxs("h2", { children: [
        "Você vive.",
        /* @__PURE__ */ i.jsx("br", {}),
        "Ele acompanha ",
        /* @__PURE__ */ i.jsx("em", { children: "o ritmo." })
      ] }),
      /* @__PURE__ */ i.jsx("p", { children: "Um anel para os seus dias. Uma experiência para olhar mais de perto para você. Do primeiro movimento ao momento de desacelerar." }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-signals", children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Vl, { size: 18 }),
          " Suas noites"
        ] }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Gl, { size: 18 }),
          " Seu movimento"
        ] }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          /* @__PURE__ */ i.jsx(Mt, { size: 18 }),
          " Seu equilíbrio"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-macro-section", "aria-label": "Detalhes do anel", children: [
      /* @__PURE__ */ i.jsx("img", { src: Tt("ring-macro.webp"), alt: "Macro do aro prata e das janelas de sensores no interior do anel", loading: "lazy" }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-macro-title", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "UM OLHAR MAIS PRÓXIMO." }),
        /* @__PURE__ */ i.jsxs("h2", { children: [
          "Discreto por fora.",
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("em", { children: "Atento por dentro." })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-detail-note", children: [
        /* @__PURE__ */ i.jsx("div", { className: "r-detail-controls", children: ["Acabamento", "Interior"].map((E, A) => /* @__PURE__ */ i.jsxs("button", { "aria-pressed": A === b, onClick: () => M(A), children: [
          /* @__PURE__ */ i.jsxs("span", { children: [
            "0",
            A + 1
          ] }),
          E
        ] }, E)) }),
        /* @__PURE__ */ i.jsx("p", { children: b === 0 ? "Superfície contínua. Bordas suaves. Um objeto que também faz parte do seu jeito de vestir." : "Janelas de sensores na face interna. O contato com o dedo é o ponto de partida para acompanhar sinais do corpo." }, b)
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-life r-container", id: "vida", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "r-life-heading", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "NÃO É SÓ SOBRE TREINAR." }),
        /* @__PURE__ */ i.jsxs("h2", { children: [
          "É sobre ",
          /* @__PURE__ */ i.jsx("em", { children: "viver bem." })
        ] }),
        /* @__PURE__ */ i.jsxs("p", { children: [
          "O movimento. A pausa.",
          /* @__PURE__ */ i.jsx("br", {}),
          "Tudo o que existe entre os dois."
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-life-grid", children: [
        /* @__PURE__ */ i.jsxs("figure", { className: "r-life-sport", children: [
          /* @__PURE__ */ i.jsx("img", { src: Tt("sport-life.webp"), alt: "Anel dourado no dedo de uma tenista durante uma pausa na quadra", loading: "lazy" }),
          /* @__PURE__ */ i.jsxs("figcaption", { children: [
            /* @__PURE__ */ i.jsx("span", { children: "01 / EM MOVIMENTO" }),
            /* @__PURE__ */ i.jsxs("h3", { children: [
              "Mais presente.",
              /* @__PURE__ */ i.jsx("br", {}),
              /* @__PURE__ */ i.jsx("em", { children: "Em cada ponto." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("figure", { className: "r-life-daily", children: [
          /* @__PURE__ */ i.jsx("img", { src: Tt("daily-life.webp"), alt: "Anel prata na mão, em um momento de descanso depois do treino", loading: "lazy" }),
          /* @__PURE__ */ i.jsxs("figcaption", { children: [
            /* @__PURE__ */ i.jsx("span", { children: "02 / NO SEU TEMPO" }),
            /* @__PURE__ */ i.jsxs("h3", { children: [
              "A pausa também",
              /* @__PURE__ */ i.jsx("br", {}),
              /* @__PURE__ */ i.jsx("em", { children: "faz parte." })
            ] })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx(Pv, {}),
    /* @__PURE__ */ i.jsxs("section", { className: "r-finishes r-container", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "r-section-title", children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "O MESMO RITMO. O SEU JEITO." }),
          /* @__PURE__ */ i.jsxs("h2", { children: [
            "Qual é ",
            /* @__PURE__ */ i.jsx("em", { children: "o seu?" })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("p", { children: [
          "Três acabamentos.",
          /* @__PURE__ */ i.jsx("br", {}),
          "Uma escolha que é sua."
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: "r-finish-grid", children: cs.map((E) => /* @__PURE__ */ i.jsxs("a", { href: "/pages/rheo-ring", className: `r-finish-card ${E.id}`, children: [
        /* @__PURE__ */ i.jsx("img", { src: E.image, alt: `Rheo Ring ${E.name}`, loading: "lazy" }),
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("h3", { children: E.name }),
          /* @__PURE__ */ i.jsx(Ne, { size: 22 })
        ] }),
        /* @__PURE__ */ i.jsx("span", { children: E.description })
      ] }, E.id)) })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-fit-band", children: [
      /* @__PURE__ */ i.jsx("img", { src: Tt("sizing.webp"), alt: "Medição da circunferência do dedo com papel", loading: "lazy" }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "UM DETALHE ESSENCIAL." }),
        /* @__PURE__ */ i.jsxs("h2", { children: [
          "O seu ritmo.",
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("em", { children: "O seu ajuste." })
        ] }),
        /* @__PURE__ */ i.jsx("p", { children: "Descubra seu tamanho com um guia em centímetros, passo a passo." }),
        /* @__PURE__ */ i.jsxs("button", { className: "r-button r-button-dark", onClick: x, children: [
          "Descobrir meu tamanho ",
          /* @__PURE__ */ i.jsx(Ot, { size: 18 })
        ] }),
        /* @__PURE__ */ i.jsx("small", { children: "A medição com papel é uma estimativa." })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx(Mm, { onSize: x })
  ] });
}
function a1({
  finish: r,
  setFinish: x,
  size: m,
  setSize: o,
  onSize: b,
  onAdd: M,
  onZoom: p,
  commerce: E
}) {
  const A = V.useRef(null), S = V.useRef(null), [q, _] = V.useState(0), [k, L] = V.useState(""), [ne, ce] = V.useState(!1), ve = cs.find((H) => H.id === r), I = [{
    src: ve.image,
    label: `${ve.name} · Vista do anel`
  }, ...r === "silver" ? [{
    src: Tt("ring-macro.webp"),
    label: "Prata · Interior em detalhe"
  }, {
    src: Tt("daily-life.webp"),
    label: "Prata · No dia a dia"
  }] : r === "gold" ? [{
    src: Tt("sport-life.webp"),
    label: "Dourado · Em movimento"
  }] : []];
  V.useEffect(() => {
    _(0);
  }, [r]);
  const ee = I[q] || I[0], oe = (H) => {
    o(H), ce(!1);
  }, Me = () => {
    if (!m) {
      ce(!0), L("choose"), requestAnimationFrame(() => {
        var H;
        return (H = document.getElementById("r-sizes")) == null ? void 0 : H.focus();
      });
      return;
    }
    M();
  }, w = () => {
    L("choose"), ce(!1), requestAnimationFrame(() => {
      var H, Y;
      (H = S.current) == null || H.focus({
        preventScroll: !0
      }), (Y = S.current) == null || Y.scrollIntoView({
        block: "start",
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
      });
    });
  };
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs("div", { className: "r-breadcrumb r-container", children: [
      /* @__PURE__ */ i.jsx("a", { href: "/", children: "Rheo" }),
      /* @__PURE__ */ i.jsx(qa, { size: 13 }),
      /* @__PURE__ */ i.jsx("span", { children: "Rheo Ring" })
    ] }),
    /* @__PURE__ */ i.jsxs("section", { className: "r-pdp r-container", id: "comprar", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "r-gallery", children: [
        /* @__PURE__ */ i.jsxs("div", { className: `r-gallery-stage ${q > 0 ? "editorial" : ""}`, children: [
          /* @__PURE__ */ i.jsx("img", { src: ee.src, alt: ee.label, fetchPriority: "high" }, ee.src),
          /* @__PURE__ */ i.jsxs("span", { className: "r-gallery-number", children: [
            "0",
            q + 1,
            " / 0",
            I.length
          ] }),
          /* @__PURE__ */ i.jsx(Ft, { label: "Ampliar imagem do anel", onClick: () => p(ee), children: /* @__PURE__ */ i.jsx(rs, { size: 19 }) }),
          I.length > 1 && /* @__PURE__ */ i.jsxs("div", { className: "r-gallery-arrows", children: [
            /* @__PURE__ */ i.jsx(Ft, { label: "Imagem anterior", onClick: () => _((q + I.length - 1) % I.length), children: /* @__PURE__ */ i.jsx(Xc, { size: 20 }) }),
            /* @__PURE__ */ i.jsx(Ft, { label: "Próxima imagem", onClick: () => _((q + 1) % I.length), children: /* @__PURE__ */ i.jsx(qa, { size: 20 }) })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "r-gallery-bottom", children: [
          /* @__PURE__ */ i.jsx("span", { children: ee.label }),
          /* @__PURE__ */ i.jsx("span", { children: "COLEÇÃO 01" })
        ] }),
        /* @__PURE__ */ i.jsx("div", { className: "r-thumbnails", role: "group", "aria-label": "Galeria do produto", children: I.map((H, Y) => /* @__PURE__ */ i.jsx("button", { "aria-label": `Ver ${H.label}`, "aria-pressed": q === Y, onClick: () => _(Y), children: /* @__PURE__ */ i.jsx("img", { src: H.src, alt: "" }) }, H.src)) }),
        /* @__PURE__ */ i.jsx("p", { className: "r-gallery-note", children: "Imagens conceituais do produto. Detalhes sujeitos à validação do modelo final." })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "r-config", children: [
        /* @__PURE__ */ i.jsx("span", { className: "r-kicker", children: "SAÚDE. LIFESTYLE. VOCÊ." }),
        /* @__PURE__ */ i.jsx("h1", { children: "Rheo Ring" }),
        /* @__PURE__ */ i.jsx("p", { className: "r-product-subtitle", children: "Encontre o seu ritmo. Leve com você." }),
        /* @__PURE__ */ i.jsx("p", { className: "ps-purchase-copy", children: "Um anel discreto. Um novo olhar para o seu dia. Sono, movimento e sinais do corpo reunidos em uma experiência pensada para a vida real." }),
        /* @__PURE__ */ i.jsxs("div", { className: "r-price", children: [
          /* @__PURE__ */ i.jsx("strong", { children: (E == null ? void 0 : E.price) || "Em breve" }),
          /* @__PURE__ */ i.jsx("span", { children: E != null && E.price ? "Preço do produto" : "Preço no lançamento" })
        ] }),
        /* @__PURE__ */ i.jsxs("fieldset", { className: "r-color-picker", ref: S, tabIndex: -1, children: [
          /* @__PURE__ */ i.jsxs("legend", { children: [
            "Acabamento ",
            /* @__PURE__ */ i.jsx("span", { children: ve.name })
          ] }),
          /* @__PURE__ */ i.jsx("div", { className: "r-swatches", children: cs.map((H) => /* @__PURE__ */ i.jsxs("button", { "aria-label": H.name, "aria-pressed": r === H.id, title: H.name, style: {
            "--finish": H.color
          }, onClick: () => {
            x(H.id);
            const Y = new URL(window.location);
            Y.searchParams.set("cor", H.id), history.replaceState(history.state, "", Y);
          }, children: [
            /* @__PURE__ */ i.jsx("span", {}),
            r === H.id && /* @__PURE__ */ i.jsx(Ll, { size: 17 })
          ] }, H.id)) })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "r-size-heading", children: [
          /* @__PURE__ */ i.jsx("h2", { children: "Tamanho" }),
          /* @__PURE__ */ i.jsx("button", { "aria-label": "Informações sobre tamanho", title: "Informações sobre tamanho", onClick: b, children: /* @__PURE__ */ i.jsx(Jc, { size: 18 }) })
        ] }),
        /* @__PURE__ */ i.jsx("p", { className: "r-fit-help", children: "O ajuste certo faz toda a diferença." }),
        /* @__PURE__ */ i.jsxs("div", { className: "r-size-methods", children: [
          /* @__PURE__ */ i.jsxs("button", { className: "r-measure-choice", onClick: () => {
            L("measure"), b();
          }, children: [
            /* @__PURE__ */ i.jsx(Ot, { size: 21 }),
            /* @__PURE__ */ i.jsxs("span", { children: [
              /* @__PURE__ */ i.jsx("strong", { children: "Descobrir meu tamanho" }),
              /* @__PURE__ */ i.jsx("small", { children: "Guia visual · Medidas em centímetros" })
            ] }),
            /* @__PURE__ */ i.jsx(Ne, { size: 18 })
          ] }),
          /* @__PURE__ */ i.jsxs("div", { className: `r-known-size ${k === "choose" ? "open" : ""}`, children: [
            /* @__PURE__ */ i.jsxs("button", { className: "r-size-toggle", "aria-expanded": k === "choose", onClick: () => L(k === "choose" ? "" : "choose"), children: [
              /* @__PURE__ */ i.jsxs("span", { children: [
                /* @__PURE__ */ i.jsx("strong", { children: "Já sei meu tamanho" }),
                /* @__PURE__ */ i.jsx("small", { children: m ? `Tamanho ${m} selecionado` : "Escolha o tamanho do seu anel" })
              ] }),
              k === "choose" ? /* @__PURE__ */ i.jsx(Ll, { size: 18 }) : /* @__PURE__ */ i.jsx(Hl, { size: 18 })
            ] }),
            k === "choose" && /* @__PURE__ */ i.jsxs("div", { className: "r-size-body", children: [
              /* @__PURE__ */ i.jsx("div", { id: "r-sizes", role: "group", tabIndex: "-1", "aria-label": "Escolha o tamanho", className: "r-sizes", children: ((E == null ? void 0 : E.sizes) || Yn).map((H) => /* @__PURE__ */ i.jsx("button", { "aria-pressed": m === H.size, onClick: () => oe(H.size), children: H.size }, H.size)) }),
              /* @__PURE__ */ i.jsx("p", { children: "Numeração do anel. Não equivale automaticamente ao aro brasileiro." })
            ] })
          ] })
        ] }),
        ne && !m && /* @__PURE__ */ i.jsx("p", { className: "input-error", role: "alert", children: "Escolha um tamanho para continuar." }),
        /* @__PURE__ */ i.jsx("p", { className: "r-size-disclaimer", children: "Tabela demonstrativa. As medidas serão confirmadas antes da venda." }),
        /* @__PURE__ */ i.jsxs("button", { ref: A, className: "r-button r-button-dark r-add", onClick: Me, disabled: E && (!E.enabled || E.busy || m && !E.available), children: [
          E != null && E.busy ? "Adicionando..." : E && !E.enabled ? "Em breve" : E && m && !E.available ? "Indisponível nesta combinação" : "Adicionar ao carrinho",
          " ",
          /* @__PURE__ */ i.jsx(Zc, { size: 19 })
        ] }),
        /* @__PURE__ */ i.jsx("p", { className: "r-checkout-note", children: (E == null ? void 0 : E.error) || (E != null && E.enabled ? "Revise acabamento e tamanho antes de continuar." : "Prévia da coleção. Sem cobrança ou reserva.") }),
        /* @__PURE__ */ i.jsxs("div", { className: "r-included", children: [
          /* @__PURE__ */ i.jsx("span", { className: "r-included-icon", children: /* @__PURE__ */ i.jsx(Zc, { size: 24, strokeWidth: 1.2 }) }),
          /* @__PURE__ */ i.jsxs("div", { children: [
            /* @__PURE__ */ i.jsx("strong", { children: "Um novo começo, por inteiro." }),
            /* @__PURE__ */ i.jsx("p", { children: "Anel e estojo de carregamento previstos na coleção." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "r-product-accordions", children: [
          /* @__PURE__ */ i.jsxs("details", { children: [
            /* @__PURE__ */ i.jsxs("summary", { children: [
              "Sobre o Rheo Ring ",
              /* @__PURE__ */ i.jsx(Hl, { size: 16 })
            ] }),
            /* @__PURE__ */ i.jsx("p", { children: "Um anel inteligente e uma experiência própria em desenvolvimento, pensados para conectar sono, movimento e sinais do corpo à sua rotina." })
          ] }),
          /* @__PURE__ */ i.jsxs("details", { children: [
            /* @__PURE__ */ i.jsxs("summary", { children: [
              "Entrega e trocas ",
              /* @__PURE__ */ i.jsx(Hl, { size: 16 })
            ] }),
            /* @__PURE__ */ i.jsx("p", { children: "Prazos, custos de envio e política de troca de tamanho serão informados antes do início das vendas. Esta prévia não aceita pedidos." })
          ] }),
          /* @__PURE__ */ i.jsxs("details", { children: [
            /* @__PURE__ */ i.jsxs("summary", { children: [
              "Compatibilidade e recursos ",
              /* @__PURE__ */ i.jsx(Hl, { size: 16 })
            ] }),
            /* @__PURE__ */ i.jsx("p", { children: "Aplicativo planejado para iOS e Android. Recursos e compatibilidade serão confirmados após a integração com o hardware. Não se destina a diagnóstico médico." })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i.jsx(Zv, { onSize: b, finish: ve }),
    /* @__PURE__ */ i.jsx(Mm, { onSize: b }),
    /* @__PURE__ */ i.jsx(Om, { triggerRef: A, finish: ve, size: m, onConfigure: w, price: E == null ? void 0 : E.price })
  ] });
}
function t1(r, x, m) {
  var b;
  const o = {
    silver: "prata",
    gold: "dourado",
    black: "preto"
  }[x];
  return (b = r == null ? void 0 : r.variants) == null ? void 0 : b.find((M) => M.options.some((p) => String(p).toLowerCase() === o) && M.options.some((p) => String(p) === String(m)));
}
function l1(r) {
  var m;
  const x = (m = r == null ? void 0 : r.options) == null ? void 0 : m.find((o) => /tamanho|size/i.test(o.name));
  return ((x == null ? void 0 : x.values) || []).filter((o) => /^\d+$/.test(o)).map((o) => ({
    size: Number(o)
  }));
}
function os(r, x = "BRL") {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: x
  }).format(Number(r) / 100);
}
async function Rm(r, x, m = "/") {
  const o = await fetch(`${m}cart/${r}.js`, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(x)
  }), b = await o.json();
  if (!o.ok) throw new Error(b.description || b.message || "Não foi possível atualizar o carrinho. Tente novamente.");
  return b;
}
function xm({
  kind: r,
  slug: x,
  config: m = {}
}) {
  const [o, b] = V.useState(null), [M, p] = V.useState(null), [E, A] = V.useState("silver"), [S, q] = V.useState(null), [_, k] = V.useState(!1), [L, ne] = V.useState(""), [ce, ve] = V.useState(!1), I = m.product, ee = t1(I, E, S), oe = !!m.salesEnabled && !!I && I.price > 0;
  V.useEffect(() => {
    var Ha;
    ve(!0);
    const Y = new URLSearchParams(location.search), Le = (Ha = I == null ? void 0 : I.variants) == null ? void 0 : Ha.find((We) => String(We.id) === Y.get("variant"));
    if (Le) {
      const We = {
        prata: "silver",
        dourado: "gold",
        preto: "black"
      };
      A(Le.options.map((Ye) => We[String(Ye).toLowerCase()]).find(Boolean) || "silver"), q(Number(Le.options.find((Ye) => /^\d+$/.test(Ye))) || null);
    } else ["silver", "gold", "black"].includes(Y.get("cor")) && A(Y.get("cor"));
    const na = () => b("size");
    return document.addEventListener("rheo:open-size", na), () => document.removeEventListener("rheo:open-size", na);
  }, []), V.useEffect(() => {
    if (r !== "product") return;
    const Y = new URL(location.href);
    ee ? Y.searchParams.set("variant", ee.id) : Y.searchParams.delete("variant"), history.replaceState(history.state, "", Y), ne("");
  }, [E, S]);
  async function Me() {
    if (!(!oe || !(ee != null && ee.available) || ee.price <= 0 || _)) {
      k(!0), ne("");
      try {
        await Rm("add", {
          items: [{
            id: ee.id,
            quantity: 1
          }]
        }, m.root), document.dispatchEvent(new CustomEvent("rheo:cart-open"));
      } catch (Y) {
        ne(Y.message);
      } finally {
        k(!1);
      }
    }
  }
  const w = {
    onSize: () => b("size"),
    onFilm: () => b("film")
  }, H = ms.find((Y) => Y.slug === x);
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    r === "home" ? /* @__PURE__ */ i.jsx(e1, { ...w, campaign: m.campaign, price: ce && oe ? os(I.price, m.currency) : null }) : r === "product" ? /* @__PURE__ */ i.jsx(a1, { finish: E, setFinish: A, size: S, setSize: q, onSize: w.onSize, onAdd: Me, onZoom: (Y) => {
      p(Y), b("zoom");
    }, commerce: {
      enabled: oe,
      available: !!(ee != null && ee.available) && ee.price > 0,
      sizes: I ? l1(I) : void 0,
      price: oe ? os((ee == null ? void 0 : ee.price) ?? I.price, m.currency) : null,
      busy: _,
      error: L
    } }) : r === "application" ? /* @__PURE__ */ i.jsx(kv, {}) : r === "lifestyle" ? /* @__PURE__ */ i.jsx(wv, {}) : r === "sizing" ? /* @__PURE__ */ i.jsx(Kv, { ...w }) : r === "support" ? /* @__PURE__ */ i.jsx(Jv, {}) : r === "article" && H ? /* @__PURE__ */ i.jsx($v, { article: H, ...w }) : /* @__PURE__ */ i.jsx(Wv, {}),
    o === "size" && /* @__PURE__ */ i.jsx(_v, { onClose: () => b(null), onSelect: (Y) => {
      b(null), m.salesEnabled || q(Y);
    } }),
    o === "zoom" && /* @__PURE__ */ i.jsx(Yl, { title: M.label, wide: !0, type: "zoom-dialog", onClose: () => b(null), children: /* @__PURE__ */ i.jsx("img", { src: M.src, alt: M.label }) }),
    o === "film" && /* @__PURE__ */ i.jsx(Yl, { title: "Rheo Ring · De perto", wide: !0, type: "r-film-dialog", onClose: () => b(null), children: /* @__PURE__ */ i.jsx("video", { src: globalThis.rheoAsset("ring-film.mp4"), poster: globalThis.rheoAsset("silver-hero.webp"), controls: !0, autoPlay: !matchMedia("(prefers-reduced-motion: reduce)").matches, muted: !0, playsInline: !0 }) })
  ] });
}
function n1({
  config: r
}) {
  const [x, m] = V.useState(!1), [o, b] = V.useState(null), [M, p] = V.useState(!1), [E, A] = V.useState(""), S = r.root || "/";
  function q(L) {
    b(L), document.querySelectorAll("[data-cart-count]").forEach((ne) => {
      ne.textContent = L.item_count || "", ne.hidden = !L.item_count;
    }), document.querySelectorAll("[data-open-cart]").forEach((ne) => ne.setAttribute("aria-label", `Abrir carrinho, ${L.item_count} itens`));
  }
  async function _() {
    p(!0), A("");
    try {
      const L = await fetch(`${S}cart.js`, {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      });
      if (!L.ok) throw new Error("Não foi possível carregar o carrinho.");
      q(await L.json());
    } catch (L) {
      A(L.message);
    } finally {
      p(!1);
    }
  }
  V.useEffect(() => {
    const L = () => {
      m(!0), _();
    }, ne = (ce) => {
      ce.target.closest("[data-open-cart]") && (ce.preventDefault(), L());
    };
    return document.addEventListener("rheo:cart-open", L), document.addEventListener("click", ne), () => {
      document.removeEventListener("rheo:cart-open", L), document.removeEventListener("click", ne);
    };
  }, []);
  async function k(L, ne) {
    if (!M) {
      p(!0), A("");
      try {
        q(await Rm("change", {
          id: L.key,
          quantity: ne
        }, S));
      } catch (ce) {
        A(ce.message);
      } finally {
        p(!1);
      }
    }
  }
  return x ? /* @__PURE__ */ i.jsx(Yl, { title: "Seu carrinho", type: "cart-dialog", onClose: () => m(!1), children: /* @__PURE__ */ i.jsxs("div", { className: "st-cart", "aria-busy": M, children: [
    E && /* @__PURE__ */ i.jsxs("div", { role: "alert", children: [
      /* @__PURE__ */ i.jsx("p", { children: E }),
      /* @__PURE__ */ i.jsx("button", { className: "r-text-link", onClick: _, children: "Tentar novamente" })
    ] }),
    !o && M && /* @__PURE__ */ i.jsx("p", { role: "status", children: "Carregando seu carrinho..." }),
    o && !o.item_count && /* @__PURE__ */ i.jsxs("div", { className: "st-empty", children: [
      /* @__PURE__ */ i.jsx(Zc, { size: 40, strokeWidth: 1 }),
      /* @__PURE__ */ i.jsxs("h2", { children: [
        "Seu próximo ",
        /* @__PURE__ */ i.jsx("em", { children: "começo." })
      ] }),
      /* @__PURE__ */ i.jsx("p", { children: "Seu carrinho ainda está vazio." }),
      /* @__PURE__ */ i.jsxs("a", { href: "/products/rheo-ring", className: "r-button r-button-dark", children: [
        "Explorar o Ring ",
        /* @__PURE__ */ i.jsx(Ra, { size: 18 })
      ] })
    ] }),
    o == null ? void 0 : o.items.map((L) => /* @__PURE__ */ i.jsxs("article", { className: "st-cart-item", children: [
      L.image && /* @__PURE__ */ i.jsx("img", { src: L.image, alt: L.product_title, width: "100", height: "120" }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("a", { href: L.url, children: /* @__PURE__ */ i.jsx("strong", { children: L.product_title }) }),
        /* @__PURE__ */ i.jsx("p", { children: L.variant_title }),
        /* @__PURE__ */ i.jsx("strong", { children: os(L.final_line_price, o.currency) }),
        /* @__PURE__ */ i.jsxs("div", { className: "st-quantity", children: [
          /* @__PURE__ */ i.jsx(Ft, { label: `Diminuir quantidade de ${L.variant_title}`, disabled: M || L.quantity <= 1, onClick: () => k(L, L.quantity - 1), children: /* @__PURE__ */ i.jsx(jv, { size: 15 }) }),
          /* @__PURE__ */ i.jsx("span", { "aria-live": "polite", children: L.quantity }),
          /* @__PURE__ */ i.jsx(Ft, { label: `Aumentar quantidade de ${L.variant_title}`, disabled: M, onClick: () => k(L, L.quantity + 1), children: /* @__PURE__ */ i.jsx(Hl, { size: 15 }) }),
          /* @__PURE__ */ i.jsx(Ft, { label: `Remover ${L.variant_title}`, disabled: M, onClick: () => k(L, 0), children: /* @__PURE__ */ i.jsx(Mv, { size: 16 }) })
        ] })
      ] })
    ] }, L.key)),
    !!(o != null && o.item_count) && /* @__PURE__ */ i.jsxs("div", { className: "st-cart-total", children: [
      /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx("span", { children: "Subtotal" }),
        /* @__PURE__ */ i.jsx("strong", { children: os(o.total_price, o.currency) })
      ] }),
      /* @__PURE__ */ i.jsx("p", { children: "Frete e condições finais serão apresentados antes do pagamento." }),
      r.salesEnabled && r.checkoutEnabled ? /* @__PURE__ */ i.jsxs("a", { className: "r-button r-button-dark", href: `${S}checkout`, children: [
        "Continuar para pagamento ",
        /* @__PURE__ */ i.jsx(Ra, { size: 18 })
      ] }) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("button", { className: "r-button r-button-dark", disabled: !0, children: "Checkout ainda não disponível" }),
        /* @__PURE__ */ i.jsx("p", { children: "Não há cobrança ou pedido confirmado nesta etapa." })
      ] })
    ] })
  ] }) }) : null;
}
const Vn = /* @__PURE__ */ new Map();
function Dm(r = document) {
  r.querySelectorAll("[data-rheo-section]").forEach((x) => {
    var M;
    if (Vn.has(x)) return;
    const m = {
      ...window.RheoTheme,
      ...JSON.parse(((M = x.querySelector("[data-rheo-props]")) == null ? void 0 : M.textContent) || "{}")
    }, o = x.querySelector("[data-rheo-content]"), b = {
      kind: x.dataset.kind,
      slug: x.dataset.slug,
      config: m
    };
    if (b.kind === "product" || b.kind === "support") {
      const p = Qc.createRoot(o);
      p.render(/* @__PURE__ */ i.jsx(xm, { ...b })), Vn.set(x, p);
    } else Vn.set(x, Qc.hydrateRoot(o, /* @__PURE__ */ i.jsx(xm, { ...b })));
  });
}
Dm();
const gm = document.getElementById("rheo-cart-root");
gm && Qc.createRoot(gm).render(/* @__PURE__ */ i.jsx(n1, { config: window.RheoTheme }));
document.addEventListener("shopify:section:load", (r) => Dm(r.target.parentElement));
document.addEventListener("shopify:section:unload", (r) => {
  r.target.querySelectorAll("[data-rheo-section]").forEach((x) => {
    var m;
    (m = Vn.get(x)) == null || m.unmount(), Vn.delete(x);
  });
});
document.addEventListener("click", (r) => {
  const x = r.target.closest("[data-menu-toggle]");
  if (x) {
    const m = document.getElementById("r-mobile-navigation");
    m.hidden = !m.hidden, x.setAttribute("aria-expanded", String(!m.hidden)), x.setAttribute("aria-label", m.hidden ? "Abrir menu" : "Fechar menu");
  }
});
document.addEventListener("keydown", (r) => {
  const x = document.getElementById("r-mobile-navigation");
  if (r.key === "Escape" && x && !x.hidden) {
    x.hidden = !0;
    const m = document.querySelector("[data-menu-toggle]");
    m == null || m.setAttribute("aria-expanded", "false"), m == null || m.setAttribute("aria-label", "Abrir menu"), m == null || m.focus({
      preventScroll: !0
    });
  }
});
